// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"7Uw6j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "configureMonkeyFetch", ()=>configureMonkeyFetch);
var _monkeyFetch = require("@timwheeler/monkey-fetch");
var _getMsalObj = require("./getMsalObj");
var _msalBrowser = require("@azure/msal-browser");
const ONEWAY_STATEMENTS_URL_PROD_PREFIX = "/oneway-internals/restriction-statements-from-csv-";
const ONEWAY_STATEMENTS_URL_DEV_PREFIX = "/oneway-internals/restriction-statements-from-csv-dev-";
const HDLANERESTRICTION_STATEMENTS_URL_PROD_PREFIX = "/laneres-internals/hdlaneres-statements-from-csv-";
const SDLANERESTRICTION_STATEMENTS_URL_PROD_PREFIX = "/sdlaneres-internals/sdlaneres-statements-from-csv-";
const GENESIS_CURVATURES_URL = "/genesis-curvatures/genesis-curvatures-from-csv.fgb";
const GENESIS_GRADIENT_URL = "/genesis-gradient/genesis-gradient-from-csv.fgb";
const ONEWAY_MODERATIONS_URL = "/oneway-internals/moderations.fgb";
const LANERES_MODERATIONS_URL = "/laneres-internals/moderations.fgb";
const DEM_GRADIENT_URL = "/dem-internals/dem-gradient-from-csv.fgb";
const SDLANERES_MODERATIONS_URL = "/sdlaneres-internals/moderations.fgb";
const BINDING_REPORTS_URL = "/binding-reports";
const MOMA_TRACES_URL = "/moma-traces";
function configureMonkeyFetch() {
    const monkeyFetch = new (0, _monkeyFetch.MonkeyFetch)();
    monkeyFetch.configure({
        request: (resource, options)=>{
            if (!resource.startsWith(ONEWAY_STATEMENTS_URL_PROD_PREFIX) && !resource.startsWith(ONEWAY_STATEMENTS_URL_DEV_PREFIX) && !resource.startsWith(HDLANERESTRICTION_STATEMENTS_URL_PROD_PREFIX) && !resource.startsWith(SDLANERESTRICTION_STATEMENTS_URL_PROD_PREFIX) && !resource.startsWith(GENESIS_CURVATURES_URL) && !resource.startsWith(GENESIS_GRADIENT_URL) && !resource.startsWith(ONEWAY_MODERATIONS_URL) && !resource.startsWith(LANERES_MODERATIONS_URL) && !resource.startsWith(SDLANERES_MODERATIONS_URL) && !resource.startsWith(DEM_GRADIENT_URL) && !resource.startsWith(BINDING_REPORTS_URL) && !(MOMA_TRACES_URL && resource.startsWith(MOMA_TRACES_URL)) && !resource.includes(".blob.core.windows.net")) return Promise.resolve([
                resource,
                options
            ]);
            // flatgeobuf 4 passes a Headers object; spreading it would drop Range.
            const newOptions = {
                ...options,
                headers: new Headers(options?.headers)
            };
            return (0, _getMsalObj.getMsalObjPromise)().then((msalObj)=>{
                const account = msalObj.getAllAccounts()[0];
                const request = {
                    account: account,
                    scopes: [
                        "https://storage.azure.com/user_impersonation"
                    ]
                };
                return msalObj.acquireTokenSilent(request).then(function(tokenResponse) {
                    if (resource.includes(".blob.core.windows.net")) {
                        newOptions.headers.set("Authorization", `Bearer ${tokenResponse.accessToken}`);
                        newOptions.headers.set("x-ms-version", "2020-04-08");
                    } else newOptions.headers.set("Authorization", `Bearer ${tokenResponse.idToken}`);
                    return Promise.resolve([
                        resource,
                        newOptions
                    ]);
                }).catch(function(error) {
                    if (error instanceof (0, _msalBrowser.InteractionRequiredAuthError) || error instanceof (0, _msalBrowser.BrowserAuthError)) return msalObj.acquireTokenRedirect(request);
                    return Promise.reject();
                });
            });
        },
        requestError: (error)=>{
            return Promise.reject(error);
        },
        response: (response)=>{
            // check if response is a 401, if so
            // reject and invoke response error handler
            if (response.status === 401) return Promise.reject(response);
            return Promise.resolve(response);
        },
        responseError: async (response)=>{
            // add custom response error handling
            return Promise.reject(response);
        }
    });
}

},{"@timwheeler/monkey-fetch":"7qfuo","./getMsalObj":"hTW2R","@azure/msal-browser":[["BrowserAuthError","k9YIy"],["InteractionRequiredAuthError","jiVlC"]],"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7qfuo":[function(require,module,exports,__globalThis) {
"use strict";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MonkeyFetch = void 0;
class MonkeyFetch {
    constructor(){
        this.debug = false;
        this.interceptors = {
            request: (resource, options)=>Promise.resolve([
                    resource,
                    options
                ]),
            requestError: (error)=>Promise.reject(error),
            response: (response)=>Promise.resolve(response),
            responseError: (response)=>Promise.reject(response)
        };
        this.getCurrentRuntimeContext();
    }
    /**
     * @description Determine the current JS runtime context, either Browser or Node.js
     */ getCurrentRuntimeContext() {
        const isBrowserExecutionContext = typeof window !== 'undefined';
        this.debugLog(isBrowserExecutionContext ? 'Browser runtime' : 'Node Runtime');
        if (isBrowserExecutionContext) require("f9da432c79853978");
        else require("23a7685465292f26");
    }
    /**
     * @description Applies the default or user-supplied `request` and/or the `requestError` interceptors
     * @param {[(RequestInfo | URL), RequestInit]} args - the request arguments used to create the monkey-patched request
     * @returns {Promise<IMonkeyFetchResponse>} - the Promise containing the request arguments after interceptors have been applied
     */ applyRequestInterceptors(args) {
        return __awaiter(this, void 0, void 0, function*() {
            this.debugLog('Initial Request Args:', args);
            const { request, requestError } = this.interceptors;
            try {
                return request(...args);
            } catch (err) {
                return requestError(err);
            }
        });
    }
    /**
     * @description Returns the monkey-patched promise that was either resolved or rejected
     * @param {Function} fetch - the Fetch API for the current JavaScript runtime context
     * @param {[(RequestInfo | URL), RequestInit]} args - the request arguments used to create the monkey-patched request
     * @returns {Promise<IMonkeyFetchResponse>} - the Promise containing the response with interceptors applied
     */ sendInterceptedRequest(fetch, args) {
        return __awaiter(this, void 0, void 0, function*() {
            const interceptedRequest = new Request(...args);
            try {
                const resolvedResponse = yield fetch(interceptedRequest);
                resolvedResponse.request = interceptedRequest;
                this.debugLog('Intercepted Request:', interceptedRequest);
                this.debugLog('Resolved Response:', resolvedResponse);
                return resolvedResponse;
            } catch (error) {
                error.request = interceptedRequest;
                return error;
            }
        });
    }
    /**
     * @description Applies the default or user-supplied `response` and `responseError` interceptors
     * @param {IMonkeyFetchResponse} initialResponse - the initial, unaltered response before interceptors are applied
     * @returns {Promise<IMonkeyFetchResponse>} - the response with interceptors applied
     */ applyResponseInterceptors(initialResponse) {
        return __awaiter(this, void 0, void 0, function*() {
            const { response, responseError } = this.interceptors;
            try {
                const interceptedResponse = response(initialResponse);
                this.debugLog('Intercepted Response:', interceptedResponse);
                return yield interceptedResponse;
            } catch (err) {
                return yield responseError(err);
            }
        });
    }
    /**
     * @description Applies all interceptors to the request and response objects
     * @param {Function} fetch - the Fetch API for the current JavaScript runtime context
     * @param {[(RequestInfo | URL), RequestInit]} args - the request arguments used to create the monkey-patched request
     * @returns {Promise<IMonkeyFetchResponse>} - the response with all interceptors applied
     */ applyInterceptors(fetch, ...args) {
        return __awaiter(this, void 0, void 0, function*() {
            const monkeyFetchRequestOptions = yield this.applyRequestInterceptors(args);
            const responseWithoutInterceptors = yield this.sendInterceptedRequest(fetch, monkeyFetchRequestOptions);
            return yield this.applyResponseInterceptors(responseWithoutInterceptors);
        });
    }
    /**
     * Debugging tool for internal logging
     * @param {any} args - Arbitrary arguments to be emitted via logger
     * @returns {void}
     */ debugLog(...args) {
        if (this.debug) console.warn(`[DEBUG] @timwheeler/monkey-fetch | `, ...args);
    }
    /**
     * @description Custom, user-supplied configuration that is applied to `MonkeyFetch`
     * @param {IMonkeyFetchConfiguration} configuration - Custom configuration applied to all requests and responses
     * @returns {void}
     */ configure(configuration) {
        for(let configurationKey in configuration)if (configurationKey in this.interceptors) this.interceptors[configurationKey] = configuration[configurationKey];
        else this[configurationKey] = configuration[configurationKey];
        globalThis.fetch = ((fetch)=>(...args)=>this.applyInterceptors(fetch, ...args))(globalThis.fetch);
    }
}
exports.MonkeyFetch = MonkeyFetch;

},{"f9da432c79853978":"jR8EP","23a7685465292f26":"hCuoO"}],"jR8EP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Headers", ()=>Headers);
parcelHelpers.export(exports, "Request", ()=>Request);
parcelHelpers.export(exports, "Response", ()=>Response);
parcelHelpers.export(exports, "DOMException", ()=>DOMException);
parcelHelpers.export(exports, "fetch", ()=>fetch);
var global = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || typeof global !== 'undefined' && global;
var support = {
    searchParams: 'URLSearchParams' in global,
    iterable: 'Symbol' in global && 'iterator' in Symbol,
    blob: 'FileReader' in global && 'Blob' in global && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: 'FormData' in global,
    arrayBuffer: 'ArrayBuffer' in global
};
function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if (support.arrayBuffer) {
    var viewClasses = [
        '[object Int8Array]',
        '[object Uint8Array]',
        '[object Uint8ClampedArray]',
        '[object Int16Array]',
        '[object Uint16Array]',
        '[object Int32Array]',
        '[object Uint32Array]',
        '[object Float32Array]',
        '[object Float64Array]'
    ];
    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function normalizeName(name) {
    if (typeof name !== 'string') name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function normalizeValue(value) {
    if (typeof value !== 'string') value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if (support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function Headers(headers) {
    this.map = {};
    if (headers instanceof Headers) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
};
Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
};
Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name));
};
Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
};
Headers.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return iteratorFor(items);
};
Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return iteratorFor(items);
};
Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return iteratorFor(items);
};
if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
function consumed(body) {
    if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
    body.bodyUsed = true;
}
function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise;
}
function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join('');
}
function bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) this._bodyText = '';
        else if (typeof body === 'string') this._bodyText = body;
        else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if (support.arrayBuffer && support.blob && isDataView(body)) {
            this._bodyArrayBuffer = bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get('content-type')) {
            if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
            else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
    };
    if (support.blob) {
        this.blob = function() {
            var rejected = consumed(this);
            if (rejected) return rejected;
            if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
            else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                this._bodyArrayBuffer
            ]));
            else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
            else return Promise.resolve(new Blob([
                this._bodyText
            ]));
        };
        this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
                var isConsumed = consumed(this);
                if (isConsumed) return isConsumed;
                if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                else return Promise.resolve(this._bodyArrayBuffer);
            } else return this.blob().then(readBlobAsArrayBuffer);
        };
    }
    this.text = function() {
        var rejected = consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error('could not read FormData body as text');
        else return Promise.resolve(this._bodyText);
    };
    if (support.formData) this.formData = function() {
        return this.text().then(decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var methods = [
    'DELETE',
    'GET',
    'HEAD',
    'OPTIONS',
    'POST',
    'PUT'
];
function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method;
}
function Request(input, options) {
    if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof Request) {
        if (input.bodyUsed) throw new TypeError('Already read');
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new Headers(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) this.headers = new Headers(options.headers);
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;
    if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
    this._initBody(body);
    if (this.method === 'GET' || this.method === 'HEAD') {
        if (options.cache === 'no-store' || options.cache === 'no-cache') {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
            }
        }
    }
}
Request.prototype.clone = function() {
    return new Request(this, {
        body: this._bodyInit
    });
};
function decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split('=');
            var name = split.shift().replace(/\+/g, ' ');
            var value = split.join('=').replace(/\+/g, ' ');
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split('\r').map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(':').trim();
            headers.append(key, value);
        }
    });
    return headers;
}
Body.call(Request.prototype);
function Response(bodyInit, options) {
    if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
}
Body.call(Response.prototype);
Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new Headers(this.headers),
        url: this.url
    });
};
Response.error = function() {
    var response = new Response(null, {
        status: 0,
        statusText: ''
    });
    response.type = 'error';
    return response;
};
var redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
    return new Response(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var DOMException = global.DOMException;
try {
    new DOMException();
} catch (err) {
    DOMException = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    DOMException.prototype = Object.create(Error.prototype);
    DOMException.prototype.constructor = DOMException;
}
function fetch(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new Request(input, init);
        if (request.signal && request.signal.aborted) return reject(new DOMException('Aborted', 'AbortError'));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                status: xhr.status,
                statusText: xhr.statusText,
                headers: parseHeaders(xhr.getAllResponseHeaders() || '')
            };
            options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
            var body = 'response' in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new Response(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError('Network request failed'));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError('Network request failed'));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new DOMException('Aborted', 'AbortError'));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === '' && global.location.href ? global.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === 'include') xhr.withCredentials = true;
        else if (request.credentials === 'omit') xhr.withCredentials = false;
        if ('responseType' in xhr) {
            if (support.blob) xhr.responseType = 'blob';
            else if (support.arrayBuffer && request.headers.get('Content-Type') && request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1) xhr.responseType = 'arraybuffer';
        }
        if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers)) Object.getOwnPropertyNames(init.headers).forEach(function(name) {
            xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
        });
        else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener('abort', abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
}
fetch.polyfill = true;
if (!global.fetch) {
    global.fetch = fetch;
    global.Headers = Headers;
    global.Request = Request;
    global.Response = Response;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hCuoO":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const node_fetch_1 = require("aef4bcdf1e1aacd3");
globalThis.fetch = node_fetch_1.default;
globalThis.Headers = node_fetch_1.Headers;
globalThis.Request = node_fetch_1.Request;
globalThis.Response = node_fetch_1.Response;
globalThis.Blob = node_fetch_1.Blob;
globalThis.blobFrom = node_fetch_1.blobFrom;
globalThis.blobFromSync = node_fetch_1.blobFromSync;
globalThis.File = node_fetch_1.File;
globalThis.fileFrom = node_fetch_1.fileFrom;
globalThis.fileFromSync = node_fetch_1.fileFromSync;
globalThis.FormData = node_fetch_1.FormData;

},{"aef4bcdf1e1aacd3":"bRc2L"}],"bRc2L":[function(require,module,exports,__globalThis) {
"use strict";
// ref: https://github.com/tc39/proposal-global
var getGlobal = function() {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof global !== 'undefined') return global;
    throw new Error('unable to locate global object');
};
var global = getGlobal();
module.exports = exports = global.fetch;
// Needed for TypeScript and Webpack.
if (global.fetch) exports.default = global.fetch.bind(global);
exports.Headers = global.Headers;
exports.Request = global.Request;
exports.Response = global.Response;

},{}],"gl3dx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addSDOLayersAndControls", ()=>addSDOLayersAndControls);
var _select = require("ol/interaction/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _condition = require("ol/events/condition");
var _sdocontrol = require("../controls/SDOControl");
var _sdolayer = require("../layers/SDOLayer");
function addSDOLayersAndControls(map, azureLoginControl, dateInputControl, target) {
    // Initialization of the SDO checkbox control.
    const sdoControl = new (0, _sdocontrol.SDOControl)({
        target: target
    });
    // Initialization of the OpenLayers layer that will be added to the Map.
    // This layer contains all the traffic signs (SDOs).
    const sdoLayer = (0, _sdolayer.getSDOLayer)(dateInputControl, sdoControl, azureLoginControl);
    map.addLayer(sdoLayer);
    map.addControl(sdoControl);
    // These are some forced updates that trigger certain onpropertychange events in getSDOLayer and SDOControl.
    // Default behaviour: SDO is turned on and should therefore be set immediately when the page is loaded.
    // The bbox is set before the sdoToggle because otherwise the propertychange listener in getSDOLayer would have
    // an undefined bbox.
    sdoControl.set("bbox", map.getView().calculateExtent(map.getSize()));
    sdoControl.set("sdoToggle", false);
    // Main viewer: the Overlays section shows SDO's status and sign input only while
    // it is on (CSS on `.sidebar-section-body.sdo-off`).
    const syncSdoOff = ()=>target.classList.toggle("sdo-off", sdoControl.get("sdoToggle") !== true);
    syncSdoOff();
    sdoControl.on("change:sdoToggle", syncSdoOff);
    // The on moveend event listener fires when the mouse is released or the scroll wheel is used to zoom in/out.
    // We only want this on moveend and not on every change, because then the API would get flooded with useless
    // and aborted calls.
    map.on("moveend", function(event) {
        // Because the map has changed after a moveevent, the bounding box of the map is set as a property of sdoControl
        // which can then be used in the API call.
        sdoControl.set("bbox", event.target.getView().calculateExtent(event.target.getSize()));
    });
    // The SDO layer is also add statically to every TrafficSign instance, to be able
    // to force the layer to rerender when the scale of an object has changed.
    (0, _sdolayer.TrafficSign).sdoLayer = sdoLayer;
    // This Select Interaction is used to check for hover updates of the SDO objects.
    let hoverSelect = new (0, _selectDefault.default)({
        condition: (0, _condition.pointerMove)
    });
    // This line is used to be able to get the styles of the features that were selected and deselected by the mouse pointer.
    // ! Weird: see https://github.com/openlayers/openlayers/issues/10131.
    hoverSelect.style_ = null;
    hoverSelect.on("select", (0, _sdolayer.TrafficSign).hoverSelectHandler);
    map.addInteraction(hoverSelect);
}

},{"ol/interaction/Select":"1uL1O","ol/events/condition":"2tMOf","../controls/SDOControl":"1rKl0","../layers/SDOLayer":"hgUxd","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1uL1O":[function(require,module,exports,__globalThis) {
/**
 * @module ol/interaction/Select
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A function that takes a {@link module:ol/Feature~Feature} and returns `true` if the feature may be
 * selected or `false` otherwise.
 * @typedef {function(import("../Feature.js").default, import("../layer/Layer.js").default<import("../source/Source.js").default> | undefined):boolean} FilterFunction
 */ /**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [addCondition] A function
 * that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * By default, this is {@link module:ol/events/condition.never}. Use this if you
 * want to use different events for add and remove instead of `toggle`.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. This is the event
 * for the selected features as a whole. By default, this is
 * {@link module:ol/events/condition.singleClick}. Clicking on a feature selects that
 * feature and removes any that were in the selection. Clicking outside any
 * feature removes all from the selection.
 * See `toggle`, `add`, `remove` options for adding/removing extra features to/
 * from the selection.
 * @property {Array<import("../layer/Layer.js").default>|function(import("../layer/Layer.js").default<import("../source/Source.js").default>): boolean} [layers]
 * A list of layers from which features should be selected. Alternatively, a
 * filter function can be provided. The function will be called for each layer
 * in the map and should return `true` for layers that you want to be
 * selectable. If the option is absent, all visible layers will be considered
 * selectable.
 * @property {import("../style/Style.js").StyleLike|null} [style]
 * Style for the selected features. By default the default edit style is used
 * (see {@link module:ol/style/Style~Style}). Set to `null` if this interaction should not apply
 * any style changes for selected features.
 * If set to a falsey value, the selected feature's style will not change.
 * @property {import("../events/condition.js").Condition} [removeCondition] A function
 * that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * By default, this is {@link module:ol/events/condition.never}. Use this if you
 * want to use different events for add and remove instead of `toggle`.
 * @property {import("../events/condition.js").Condition} [toggleCondition] A function
 * that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. This is in addition
 * to the `condition` event. By default,
 * {@link module:ol/events/condition.shiftKeyOnly}, i.e. pressing `shift` as
 * well as the `condition` event, adds that feature to the current selection if
 * it is not currently selected, and removes it if it is. See `add` and `remove`
 * if you want to use different events instead of a toggle.
 * @property {boolean} [multi=false] A boolean that determines if the default
 * behaviour should select only single features or all (overlapping) features at
 * the clicked map position. The default of `false` means single select.
 * @property {Collection<Feature>} [features]
 * Collection where the interaction will place selected features. Optional. If
 * not set the interaction will create a collection. In any case the collection
 * used by the interaction is returned by
 * {@link module:ol/interaction/Select~Select#getFeatures}.
 * @property {FilterFunction} [filter] A function
 * that takes a {@link module:ol/Feature~Feature} and a
 * {@link module:ol/layer/Layer~Layer} and returns `true` if the feature may be
 * selected or `false` otherwise.
 * @property {number} [hitTolerance=0] Hit-detection tolerance. Pixels inside
 * the radius around the given position will be checked for features.
 */ /**
 * @classdesc
 * Events emitted by {@link module:ol/interaction/Select~Select} instances are instances of
 * this type.
 */ parcelHelpers.export(exports, "SelectEvent", ()=>SelectEvent);
var _collectionJs = require("../Collection.js");
var _collectionJsDefault = parcelHelpers.interopDefault(_collectionJs);
var _collectionEventTypeJs = require("../CollectionEventType.js");
var _collectionEventTypeJsDefault = parcelHelpers.interopDefault(_collectionEventTypeJs);
var _featureJs = require("../Feature.js");
var _featureJsDefault = parcelHelpers.interopDefault(_featureJs);
var _arrayJs = require("../array.js");
var _eventJs = require("../events/Event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
var _conditionJs = require("../events/condition.js");
var _functionsJs = require("../functions.js");
var _vectorJs = require("../layer/Vector.js");
var _vectorJsDefault = parcelHelpers.interopDefault(_vectorJs);
var _styleJs = require("../style/Style.js");
var _utilJs = require("../util.js");
var _interactionJs = require("./Interaction.js");
var _interactionJsDefault = parcelHelpers.interopDefault(_interactionJs);
/**
 * @enum {string}
 */ const SelectEventType = {
    /**
   * Triggered when feature(s) has been (de)selected.
   * @event SelectEvent#select
   * @api
   */ SELECT: 'select'
};
class SelectEvent extends (0, _eventJsDefault.default) {
    /**
   * @param {SelectEventType} type The event type.
   * @param {Array<import("../Feature.js").default>} selected Selected features.
   * @param {Array<import("../Feature.js").default>} deselected Deselected features.
   * @param {import("../MapBrowserEvent.js").default|undefined} mapBrowserEvent Associated
   *     {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   */ constructor(type, selected, deselected, mapBrowserEvent){
        super(type);
        /**
     * Selected features array.
     * @type {Array<import("../Feature.js").default>}
     * @api
     */ this.selected = selected;
        /**
     * Deselected features array.
     * @type {Array<import("../Feature.js").default>}
     * @api
     */ this.deselected = deselected;
        /**
     * Associated {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
     * @type {import("../MapBrowserEvent.js").default|undefined}
     * @api
     */ this.mapBrowserEvent = mapBrowserEvent;
    }
}
/**
 * Original feature styles to reset to when features are no longer selected.
 * @type {Object<string, import("../style/Style.js").default|Array<import("../style/Style.js").default>|import("../style/Style.js").StyleFunction|null|undefined>}
 */ const originalFeatureStyles = {};
/***
 * @template Return
 * @typedef {import("../Observable.js").OnSignature<import("../Observable.js").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable.js").OnSignature<import("../ObjectEventType.js").Types|
 *     'change:active', import("../Object.js").ObjectEvent, Return> &
 *   import("../Observable.js").OnSignature<'select', SelectEvent, Return> &
 *   import("../Observable.js").CombinedOnSignature<import("../Observable.js").EventTypes|import("../ObjectEventType.js").Types|
 *     'change:active'|'select', Return>} SelectOnSignature
 */ /**
 * @classdesc
 * Interaction for selecting vector features. By default, selected features are
 * styled differently, so this interaction can be used for visual highlighting,
 * as well as selecting features for other actions, such as modification or
 * output. There are three ways of controlling which features are selected:
 * using the browser event as defined by the `condition` and optionally the
 * `toggle`, `add`/`remove`, and `multi` options; a `layers` filter; and a
 * further feature filter using the `filter` option.
 *
 * @fires SelectEvent
 * @api
 */ class Select extends (0, _interactionJsDefault.default) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        /***
     * @type {SelectOnSignature<import("../events.js").EventsKey>}
     */ this.on;
        /***
     * @type {SelectOnSignature<import("../events.js").EventsKey>}
     */ this.once;
        /***
     * @type {SelectOnSignature<void>}
     */ this.un;
        options = options ? options : {};
        /**
     * @private
     */ this.boundAddFeature_ = this.addFeature_.bind(this);
        /**
     * @private
     */ this.boundRemoveFeature_ = this.removeFeature_.bind(this);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, _conditionJs.singleClick);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.addCondition_ = options.addCondition ? options.addCondition : (0, _conditionJs.never);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.removeCondition_ = options.removeCondition ? options.removeCondition : (0, _conditionJs.never);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.toggleCondition_ = options.toggleCondition ? options.toggleCondition : (0, _conditionJs.shiftKeyOnly);
        /**
     * @private
     * @type {boolean}
     */ this.multi_ = options.multi ? options.multi : false;
        /**
     * @private
     * @type {FilterFunction}
     */ this.filter_ = options.filter ? options.filter : (0, _functionsJs.TRUE);
        /**
     * @private
     * @type {number}
     */ this.hitTolerance_ = options.hitTolerance ? options.hitTolerance : 0;
        /**
     * @private
     * @type {import("../style/Style.js").default|Array<import("../style/Style.js").default>|import("../style/Style.js").StyleFunction|null}
     */ this.style_ = options.style !== undefined ? options.style : getDefaultStyleFunction();
        /**
     * @private
     * @type {Collection<Feature>}
     */ this.features_ = options.features || new (0, _collectionJsDefault.default)();
        /** @type {function(import("../layer/Layer.js").default<import("../source/Source.js").default>): boolean} */ let layerFilter;
        if (options.layers) {
            if (typeof options.layers === 'function') layerFilter = options.layers;
            else {
                const layers = options.layers;
                layerFilter = function(layer) {
                    return layers.includes(layer);
                };
            }
        } else layerFilter = (0, _functionsJs.TRUE);
        /**
     * @private
     * @type {function(import("../layer/Layer.js").default<import("../source/Source.js").default>): boolean}
     */ this.layerFilter_ = layerFilter;
        /**
     * An association between selected feature (key)
     * and layer (value)
     * @private
     * @type {Object<string, import("../layer/Layer.js").default>}
     */ this.featureLayerAssociation_ = {};
    }
    /**
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("../layer/Layer.js").default} layer Layer.
   * @private
   */ addFeatureLayerAssociation_(feature, layer) {
        this.featureLayerAssociation_[(0, _utilJs.getUid)(feature)] = layer;
    }
    /**
   * Get the selected features.
   * @return {Collection<Feature>} Features collection.
   * @api
   */ getFeatures() {
        return this.features_;
    }
    /**
   * Returns the Hit-detection tolerance.
   * @return {number} Hit tolerance in pixels.
   * @api
   */ getHitTolerance() {
        return this.hitTolerance_;
    }
    /**
   * Returns the associated {@link module:ol/layer/Vector~VectorLayer vector layer} of
   * a selected feature.
   * @param {import("../Feature.js").default} feature Feature
   * @return {import('../layer/Vector.js').default} Layer.
   * @api
   */ getLayer(feature) {
        return /** @type {import('../layer/Vector.js').default} */ this.featureLayerAssociation_[(0, _utilJs.getUid)(feature)];
    }
    /**
   * Hit-detection tolerance. Pixels inside the radius around the given position
   * will be checked for features.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @api
   */ setHitTolerance(hitTolerance) {
        this.hitTolerance_ = hitTolerance;
    }
    /**
   * Remove the interaction from its current map, if any,  and attach it to a new
   * map, if any. Pass `null` to just remove the interaction from the current map.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   * @override
   */ setMap(map) {
        const currentMap = this.getMap();
        if (currentMap && this.style_) this.features_.forEach(this.restorePreviousStyle_.bind(this));
        super.setMap(map);
        if (map) {
            this.features_.addEventListener((0, _collectionEventTypeJsDefault.default).ADD, /** @type {import("../events.js").Listener} */ this.boundAddFeature_);
            this.features_.addEventListener((0, _collectionEventTypeJsDefault.default).REMOVE, /** @type {import("../events.js").Listener} */ this.boundRemoveFeature_);
            if (this.style_) this.features_.forEach(this.applySelectedStyle_.bind(this));
        } else {
            this.features_.removeEventListener((0, _collectionEventTypeJsDefault.default).ADD, /** @type {import("../events.js").Listener} */ this.boundAddFeature_);
            this.features_.removeEventListener((0, _collectionEventTypeJsDefault.default).REMOVE, /** @type {import("../events.js").Listener} */ this.boundRemoveFeature_);
        }
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<Feature>} evt Event.
   * @private
   */ addFeature_(evt) {
        const feature = evt.element;
        if (this.style_) this.applySelectedStyle_(feature);
        if (!this.getLayer(feature)) {
            const layer = this.findLayerOfFeature_(feature);
            if (layer) this.addFeatureLayerAssociation_(feature, layer);
        }
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<Feature>} evt Event.
   * @private
   */ removeFeature_(evt) {
        if (this.style_) this.restorePreviousStyle_(evt.element);
        this.removeFeatureLayerAssociation_(evt.element);
    }
    /**
   * @param {Feature} feature Feature of which to get the layer
   * @return {VectorLayer|undefined} layer, if one was found.
   * @private
   */ findLayerOfFeature_(feature) {
        const map = this.getMap();
        if (!map) return undefined;
        const layer = /** @type {VectorLayer|undefined} */ map.getAllLayers().find(function(layer) {
            if (layer instanceof (0, _vectorJsDefault.default) && layer.getSource() && layer.getSource().hasFeature(feature)) return layer;
        });
        return layer;
    }
    /**
   * @return {import("../style/Style.js").StyleLike|null} Select style.
   */ getStyle() {
        return this.style_;
    }
    /**
   * @param {Feature} feature Feature
   * @private
   */ applySelectedStyle_(feature) {
        const key = (0, _utilJs.getUid)(feature);
        if (!(key in originalFeatureStyles)) originalFeatureStyles[key] = feature.getStyle();
        feature.setStyle(this.style_);
    }
    /**
   * @param {Feature} feature Feature
   * @private
   */ restorePreviousStyle_(feature) {
        const map = this.getMap();
        if (!map) return;
        const interactions = map.getInteractions().getArray();
        for(let i = interactions.length - 1; i >= 0; --i){
            const interaction = interactions[i];
            if (interaction !== this && interaction instanceof Select && interaction.getStyle() && interaction.getFeatures().getArray().lastIndexOf(feature) !== -1) {
                feature.setStyle(interaction.getStyle());
                return;
            }
        }
        const key = (0, _utilJs.getUid)(feature);
        feature.setStyle(originalFeatureStyles[key]);
        delete originalFeatureStyles[key];
    }
    /**
   * @param {Feature} feature Feature.
   * @private
   */ removeFeatureLayerAssociation_(feature) {
        delete this.featureLayerAssociation_[(0, _utilJs.getUid)(feature)];
    }
    /**
   * Try to select a feature as if it was clicked and `addCondition` evaluated to True.
   * Unlike modifying `select.getFeatures()` directly, this respects the `filter` and `layers` options (except `multi`, which is ignored).
   * The {@link module:ol/interaction/Select~SelectEvent} fired by this won't have a mapBrowserEvent property
   * @param {Feature} feature The feature to select
   * @return {boolean} True if the feature was selected
   * @api
   */ selectFeature(feature) {
        const layer = this.findLayerOfFeature_(feature);
        if (!layer || !this.layerFilter_(layer) || !this.filter_(feature, layer)) return false;
        const features = this.getFeatures();
        if (features.getArray().includes(feature)) return false;
        this.addFeatureLayerAssociation_(feature, layer);
        features.push(feature);
        this.dispatchEvent(new SelectEvent(SelectEventType.SELECT, [
            feature
        ], [], undefined));
        return true;
    }
    /**
   * Try to deselect a feature as if it was clicked.
   * Compared to `select.getFeatures().remove(feature)` this causes a SelectEvent.
   * The {@link module:ol/interaction/Select~SelectEvent} fired by this won't have a mapBrowserEvent property
   * @param {Feature} feature The feature to deselect
   * @return {boolean} True if the feature was deselected
   * @api
   */ deselectFeature(feature) {
        const features = this.getFeatures();
        const index = features.getArray().indexOf(feature);
        if (index === -1) return false;
        features.removeAt(index);
        this.dispatchEvent(new SelectEvent(SelectEventType.SELECT, [], [
            feature
        ], undefined));
        return true;
    }
    /**
   * Try to toggle a feature as if it was clicked and `toggleCondition` was True.
   * Unlike modifying `select.getFeatures()` directly, this respects the `filter` and `layers` options (except `multi`, which is ignored).
   * The {@link module:ol/interaction/Select~SelectEvent} fired by this won't have a mapBrowserEvent property
   * @param {Feature} feature The feature to deselect
   * @api
   */ toggleFeature(feature) {
        if (!this.deselectFeature(feature)) this.selectFeature(feature);
    }
    /**
   * Deselect all features as if a user deselected them.
   * Compared to `select.getFeatures().clear()` this causes a SelectEvent.
   * The {@link module:ol/interaction/Select~SelectEvent} fired by this won't have a mapBrowserEvent property
   * @api
   */ clearSelection() {
        const features = this.getFeatures();
        if (features.getLength() !== 0) {
            const deselected = features.getArray().slice(); // shallow copy
            features.clear();
            this.dispatchEvent(new SelectEvent(SelectEventType.SELECT, [], deselected, undefined));
        }
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may change the
   * selected state of features.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        if (!this.condition_(mapBrowserEvent)) return true;
        const add = this.addCondition_(mapBrowserEvent);
        const remove = this.removeCondition_(mapBrowserEvent);
        const toggle = this.toggleCondition_(mapBrowserEvent);
        const set = !add && !remove && !toggle;
        const map = mapBrowserEvent.map;
        const features = this.getFeatures();
        /**
     * @type {Array<Feature>}
     */ const deselected = [];
        /**
     * @type {Array<Feature>}
     */ const selected = [];
        if (set) {
            // Replace the currently selected feature(s) with the feature(s) at the
            // pixel, or clear the selected feature(s) if there is no feature at
            // the pixel.
            map.forEachFeatureAtPixel(mapBrowserEvent.pixel, (feature, layer)=>{
                if (!(feature instanceof (0, _featureJsDefault.default)) || !this.filter_(feature, layer)) return;
                this.addFeatureLayerAssociation_(feature, layer);
                selected.push(feature);
                return !this.multi_;
            }, {
                layerFilter: this.layerFilter_,
                hitTolerance: this.hitTolerance_
            });
            for(let i = features.getLength() - 1; i >= 0; --i){
                const feature = features.item(i);
                const index = selected.indexOf(feature);
                if (index === -1) {
                    features.removeAt(i);
                    deselected.push(feature);
                } else // feature is already selected
                selected.splice(index, 1);
            }
            if (selected.length !== 0) features.extend(selected);
        } else {
            // Modify the currently selected feature(s).
            map.forEachFeatureAtPixel(mapBrowserEvent.pixel, (feature, layer)=>{
                if (!(feature instanceof (0, _featureJsDefault.default)) || !this.filter_(feature, layer)) return;
                const hasFeature = features.getArray().includes(feature);
                if (hasFeature && (remove || toggle)) deselected.push(feature);
                else if (!hasFeature && (add || toggle)) {
                    this.addFeatureLayerAssociation_(feature, layer);
                    selected.push(feature);
                }
                return !this.multi_; // stop if not multi
            }, {
                layerFilter: this.layerFilter_,
                hitTolerance: this.hitTolerance_
            });
            for(let j = deselected.length - 1; j >= 0; --j)features.remove(deselected[j]);
            features.extend(selected);
        }
        if (selected.length > 0 || deselected.length > 0) this.dispatchEvent(new SelectEvent(SelectEventType.SELECT, selected, deselected, mapBrowserEvent));
        return true;
    }
}
/**
 * @return {import("../style/Style.js").StyleFunction} Styles.
 */ function getDefaultStyleFunction() {
    const styles = (0, _styleJs.createEditingStyle)();
    (0, _arrayJs.extend)(styles['Polygon'], styles['LineString']);
    (0, _arrayJs.extend)(styles['GeometryCollection'], styles['LineString']);
    return function(feature) {
        const geometry = feature.getGeometry();
        if (!geometry) return null;
        return styles[geometry.getType()];
    };
}
exports.default = Select;

},{"../Collection.js":"8dtMA","../CollectionEventType.js":"jVYia","../Feature.js":"iVSSP","../array.js":"2IuG2","../events/Event.js":"5kI1G","../events/condition.js":"2tMOf","../functions.js":"5nAKV","../layer/Vector.js":"7ga2c","../style/Style.js":"gqpPW","../util.js":"9Y20j","./Interaction.js":"1QCYK","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1rKl0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SDOControl", ()=>SDOControl);
var _control = require("ol/control/Control");
var _controlDefault = parcelHelpers.interopDefault(_control);
var _sdotrafficSigns = require("../SDOTrafficSigns");
class SDOControl extends (0, _controlDefault.default) {
    constructor(opt_options){
        const options = opt_options || {};
        const div = document.createElement("div");
        super({
            element: div,
            target: options.target
        });
        const this_ = this;
        div.className = "sdo-input";
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.className = "sdo-checkbox";
        checkbox.id = "sdo-input";
        checkbox.checked = false;
        checkbox.addEventListener("change", function() {
            this_.set("sdoToggle", checkbox.checked);
        });
        const label = document.createElement("label");
        label.htmlFor = "sdo-input";
        label.className = "sdo-text";
        label.innerText = "SDO";
        const area = document.createElement("p");
        area.className = "sdo-area";
        area.innerText = "Area too large";
        const signSearch = document.createElement("div");
        signSearch.className = "sdo-sign-search";
        const dataList = document.createElement("datalist");
        dataList.id = "sign-selection";
        const dataListInput = document.createElement("input");
        dataListInput.className = "sdo-datalist";
        dataListInput.autocomplete = "on";
        dataListInput.placeholder = "Select a sign type";
        dataListInput.setAttribute("list", "sign-selection");
        dataListInput.addEventListener("change", function(e) {
            if ((0, _sdotrafficSigns.UNUSED_SIGN_TYPES).includes(e.target.value)) {
                (0, _sdotrafficSigns.UNUSED_SIGN_TYPES).splice((0, _sdotrafficSigns.UNUSED_SIGN_TYPES).indexOf(e.target.value), 1);
                (0, _sdotrafficSigns.USED_SIGN_TYPES).push(e.target.value);
                this_.set("add_sign", e.target.value + String(Math.random()));
                renderSignTypes();
            }
            dataListInput.value = "";
            dataListInput.blur();
        });
        const dataListDiv = document.createElement("div");
        dataListDiv.appendChild(dataList);
        dataListDiv.appendChild(dataListInput);
        div.appendChild(checkbox);
        div.appendChild(label);
        div.appendChild(area);
        div.appendChild(dataListDiv);
        div.appendChild(signSearch);
        this.on("propertychange", function(e) {
            switch(e.key){
                case "tooLarge":
                    if (this_.get("tooLarge") === true) area.innerText = "Area too large!";
                    else area.innerText = "";
                    break;
                case "loading":
                    if (this_.get("loading") === true) area.innerText = "Fetching data...";
                    else area.innerText = "";
                    break;
                case "idTokenSet":
                    if (this_.get("idTokenSet") === false) area.innerText = "Not yet logged in.";
            }
        });
        (0, _sdotrafficSigns.USED_SIGN_TYPES).map(function(value) {
            if ((0, _sdotrafficSigns.UNUSED_SIGN_TYPES).includes(value)) (0, _sdotrafficSigns.UNUSED_SIGN_TYPES).splice((0, _sdotrafficSigns.UNUSED_SIGN_TYPES).indexOf(value), 1);
        });
        renderSignTypes();
        function renderSignTypes() {
            dataList.innerHTML = "";
            (0, _sdotrafficSigns.UNUSED_SIGN_TYPES).sort();
            (0, _sdotrafficSigns.UNUSED_SIGN_TYPES).map(function(value) {
                const option = document.createElement("option");
                option.value = value;
                option.innerHTML = value;
                dataList.appendChild(option);
            });
            signSearch.innerHTML = "";
            (0, _sdotrafficSigns.USED_SIGN_TYPES).sort();
            (0, _sdotrafficSigns.USED_SIGN_TYPES).map(function(value) {
                const removeButton = document.createElement("a");
                removeButton.className = "sdo-sign-button";
                removeButton.addEventListener("click", function(e) {
                    if ((0, _sdotrafficSigns.USED_SIGN_TYPES).includes(e.target.value)) {
                        (0, _sdotrafficSigns.USED_SIGN_TYPES).splice((0, _sdotrafficSigns.USED_SIGN_TYPES).indexOf(e.target.value), 1);
                        (0, _sdotrafficSigns.UNUSED_SIGN_TYPES).push(e.target.value);
                        this_.set("remove_sign", e.target.value + String(Math.random()));
                        renderSignTypes();
                    }
                });
                removeButton.innerHTML = "X";
                removeButton.value = value;
                const signSpan = document.createElement("span");
                signSpan.innerHTML = value + " ";
                const signSpanDiv = document.createElement("div");
                signSpanDiv.className = "sdo-sign-span-div";
                signSpanDiv.value = value;
                signSpanDiv.appendChild(signSpan);
                signSpanDiv.appendChild(removeButton);
                signSearch.appendChild(signSpanDiv);
            });
        }
    }
}

},{"ol/control/Control":"8KSMn","../SDOTrafficSigns":"2bXw4","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2bXw4":[function(require,module,exports,__globalThis) {
// List of traffic signs: https://github.com/tomtom-internal/fcd-trace/blob/edi-develop/trace-fcd/src/main/java/com/tomtom/trace/fcd/event/TrafficSign.java
// List of traffic sign icons: https://github.com/tomtom-internal/fcd-trace/tree/edi-develop/trace-render/src/main/resources/public/tomtom/icons/signs
// ! Change this array to set the default TrafficSigns to fetch from the API.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNUSED_SIGN_TYPES", ()=>UNUSED_SIGN_TYPES);
parcelHelpers.export(exports, "USED_SIGN_TYPES", ()=>USED_SIGN_TYPES);
var UNUSED_SIGN_TYPES = [
    "SPEED_LIMIT",
    "SPEED_LIMIT_END",
    "SPEED_LIMIT_CHANGE_UPCOMING",
    "NO_OVERTAKING",
    "NO_OVERTAKING_END",
    "NO_OVERTAKING_TRUCK",
    "NO_OVERTAKING_TRUCK_END",
    "ALL_RESTRICTIONS_END",
    "CITY_START",
    "CITY_END",
    "HIGHWAY",
    "HIGHWAY_END",
    "MOTORWAY",
    "MOTORWAY_END",
    "CONSTRUCTION",
    "CONSTRUCTION_END",
    "LANE_MERGE_ON_RIGHT",
    "LANE_MERGE_ON_LEFT",
    "RAILWAY_CROSSING_GENERAL",
    "RAILWAY_CROSSING_PROTECTED",
    "RAILWAY_CROSSING_UNPROTECTED",
    "ROAD_NARROWS",
    "ROAD_NARROWS_LEFT",
    "ROAD_NARROWS_RIGHT",
    "SHARP_CURVE_LEFT",
    "SHARP_CURVE_RIGHT",
    "WINDING_ROAD",
    "WINDING_ROAD_STARTING_LEFT",
    "WINDING_ROAD_STARTING_RIGHT",
    "STEEP_HILL_UPWARDS",
    "STEEP_HILL_DOWNWARDS",
    "STOP_SIGN",
    "LATERAL_WIND",
    "GENERAL_WARNING",
    "ANIMAL",
    "ICY_CONDITIONS",
    "SLIPPERY_ROAD",
    "UNEVEN_ROAD",
    "SCHOOL_ZONE",
    "CONGESTION_HAZARD",
    "ACCIDENT_HAZARD",
    "BICYCLE_CROSSING",
    "PRIORITY_OVER_ONCOMING_TRAFFIC",
    "YIELD",
    "PRIORITY_ROAD",
    "PRIORITY_ROAD_END",
    "TRAFFIC_CALMING",
    "TRAFFIC_CALMING_END",
    "ENVIRONMENTAL_AREA",
    "ENVIRONMENTAL_AREA_END",
    "INTERSECTION",
    "ROUNDABOUT",
    "PASSING_ON_LEFT",
    "PASSING_ON_RIGHT",
    "PASSING_ON_LEFT_OR_RIGHT",
    "MANDATORY_TURN_RIGHT_ONLY",
    "MANDATORY_TURN_LEFT_ONLY",
    "MANDATORY_STRAIGHT_ONLY",
    "MANDATORY_TURN_LEFT_OR_RIGHT",
    "MANDATORY_STRAIGHT_OR_LEFT",
    "MANDATORY_STRAIGHT_OR_RIGHT",
    "NO_LEFT_TURN",
    "NO_RIGHT_TURN",
    "NO_U_TURN",
    "U_TURN_ALLOWED",
    "NO_ENTRY",
    "DEAD_END",
    "HIGH_OCCUPANCY_VEHICLE_LANE",
    "TOLL",
    "SHOULDER_OPEN_FOR_TRAFFIC",
    "SHOULDER_CLOSED_FOR_TRAFFIC",
    "LANE_CLOSED",
    "LANE_CLOSED_RIGHT_MOST_LANE",
    "LANE_CLOSED_LEFT_MOST_LANE",
    "WARNING_PEDESTRIAN",
    "WARNING_CHILDREN",
    "WARNING_BUS",
    "PUBLIC_TRANSPORTATION_STOP",
    "PEDESTRIAN_CROSSING",
    "WEIGHT_RESTRICTION",
    "HEIGHT_RESTRICTION",
    "WIDTH_RESTRICTION",
    "WARNING_TRUCK_ROLLOVER",
    "SIGNAL_AHEAD",
    "NO_AGRICULTUR_VEHICLE",
    "NO_BICYCLE",
    "NO_BUS",
    "NO_HAUL_EXPLOSIVES",
    "NO_HAUL_HARMFUL_TO_WATER",
    "NO_HAUL_HAZARDOUS_MATERIAL",
    "NO_MOTORCYCLE",
    "ROAD_DISTANCE",
    "EMERGENCY_PHONE",
    "BOARD_DIRECTION",
    "TRUCK_SPEED_LIMIT",
    "TRUCK_SPEED_LIMIT_END",
    "SPEED_LIMIT_NIGHT",
    "SPEED_LIMIT_NIGHT_END",
    "MINIMUM_SPEED",
    "PEDESTRIAN_PATH",
    "PEDESTRIAN_BICYCLE_PATH",
    "BICYCLE_PATH",
    "BICYCLE_PATH_END",
    "BICYCLE_STREET",
    "BICYCLE_STREET_END",
    "CURVE_LEFT_THEN_RIGHT",
    "CURVE_RIGHT_THEN_LEFT",
    "NO_HORSE_RIDING",
    "FALLING_ROCKS",
    "YIELD_TO_ONCOMING_TRAFFIC",
    "ONEWAY_TRAFFIC",
    "ONEWAY_TRAFFIC_TO_LEFT",
    "ONEWAY_TRAFFIC_TO_RIGHT",
    "NO_VEHICLE",
    "NO_MOTOR_VEHICLE",
    "NO_PEDESTRIAN",
    "TIRE_CHAINS_MANDATORY",
    "TUNNEL",
    "NARROW_BRIDGE",
    "HUMPBACK_BRIDGE",
    "EMBANKMENT",
    "CROSSING_WITH_PRIORITY_OVER_MINOR_ROAD",
    "BRANCH_TO_THE_LEFT",
    "BRANCH_TO_THE_RIGHT",
    "TWO_WAY_TRAFFIC",
    "BUMP",
    "DIP",
    "MOVABLE_BRIDGE",
    "SLOW_DOWN",
    "INTERSECTION_T_LEFT",
    "INTERSECTION_T_RIGHT",
    "INTERSECTION_T_LEFT_RIGHT",
    "INTERSECTION_Y",
    "HONKING_PROHIBITED",
    "HIGHWAY_MARKER_1_STRIPE",
    "HIGHWAY_MARKER_2_STRIPES",
    "HIGHWAY_MARKER_3_STRIPES",
    "DIVERSION_ROUTE_END",
    "NO_STOPPING",
    "NO_STOPPING_LEFT_AND_RIGHT",
    "NO_PARKING",
    "NO_PARKING_LEFT_AND_RIGHT",
    "NO_TURN_ON_RED",
    "SPEED_LIMIT_ZONE",
    "SPEED_LIMIT_ZONE_END",
    "NO_PARKING_ZONE_END",
    "PARKING",
    "SAFETY_DISTANCE",
    "DETOUR",
    "MOTORWAY_EXIT",
    "HIGHWAY_EXIT",
    "LOW_FLYING",
    "LANE_SHIFT",
    "LANE_SHIFT_TO_LEFT",
    "LANE_SHIFT_TO_RIGHT",
    "BUS_LANE",
    "PEDESTRIAN_BICYCLE_SHARED_PATH",
    "OVERHEAD_LANE_CONTROL_CLOSING_LEFT",
    "TRINATURE",
    "GRAVEL",
    "WARNING_RIDER",
    "STOP_AHEAD",
    "YIELD_AHEAD",
    "NO_CAR_OR_BIKE",
    "ROUNDABOUT_AHEAD",
    "MANDATORY_LEFT_OR_STRAIGHT_OR_RIGHT",
    "AXLE_WEIGHT_RESTRICTION",
    "TOLL_END",
    "CHILDREN_END_TT",
    "FIRESTATION_TT",
    "NO_OUTLET_TT",
    "CANCELED_SIGN_TT",
    "EXIT_RIGHT_TT",
    "CAMERA_TT",
    "LANE_SPLIT_RIGHT_TT",
    "LOOSE_SHOULDER_TT",
    "BRIDGE_ICE_TT",
    "SCHOOL_ZONE_END_TT",
    "BUILT_UP_AREA_TT",
    "BUILT_UP_AREA_END_TT",
    "NO_PEDESTRIAN_CYCLING_TT",
    "ROAD_NUMBER_TT",
    "TUNNEL_EXIT_TT",
    "NO_TRACTOR_HORSE_TT",
    "TRAM_LANE_TT",
    "BUS_LANE_END_TT",
    "HIGH_BEAM_TT",
    "NO_HAUL_HAZARDOUS_MATERIAL_END_TT",
    "CONSTRUCTION_RIGHT_TT",
    "CONSTRUCTION_LEFT_TT",
    "LANES_TOPOLOGY_TT",
    "LANE_OPEN_TT",
    "EXIT_LEFT_TT",
    "FLAGGERS_AHEAD_TT",
    "PLAYGROUND_TT",
    "UNEVEN_LANES_TT",
    "SCHOOL_BUS_STOP_AHEAD_TT",
    "FLOOD_AREA_TT",
    "BE_PREPARED_TO_STOP_TT",
    "HIDDEN_DRIVEWAY_TT",
    "SPECIAL_NEEDS_CHILD_AREA_TT",
    "TRUCK_CROSSING_TT",
    "HAIRPIN_TURN_LEFT_TT",
    "HAIRPIN_TURN_RIGHT_TT",
    "LANE_SPLIT_LEFT_TT",
    "ENTRANCE_LEFT_TT",
    "ENTRANCE_RIGHT_TT",
    "RAILWAY_CROSSING_LEFT_TT",
    "RAILWAY_CROSSING_RIGHT_TT",
    "THRU_TRAFFIC_MERGE_LEFT_TT",
    "THRU_TRAFFIC_MERGE_RIGHT_TT",
    "SHARED_ROAD_PEDESTRIANS_BICYCLE_TT",
    "SHARED_ROAD_CARS_BICYCLE_TT",
    "DIVIDED_HIGHWAY_TT",
    "DIVIDED_HIGHWAY_END_TT",
    "AUTONOMOUS_VEHICLE_TT",
    "MULTI_SPEED_SIGN_TT",
    "TEXT_ONLY_TT",
    "ELECTRONIC_OFF_TT",
    "CONSTRUCTION_WITH_DIST_TT",
    "PEDESTRIAN_AND_BIKE_CROSSING_TT",
    "RAILWAY_CROSSING_1_TT",
    "RAILWAY_CROSSING_2_TT",
    "RAILWAY_CROSSING_3_TT",
    "WATER_COURSE_TT",
    "PARKING_BAY_TT",
    "NO_TURN_TT",
    "END_HIGH_FINE_ZONE_TT",
    "NO_LEFT_OR_RIGHT_TT",
    "NEW_LANE_RIGHT_TT",
    "NEW_LANE_LEFT_TT",
    "SHOULDER_MERGE_TT",
    "ADD_LEFT_TT",
    "ADD_RIGHT_TT",
    "ADD_FROM_LEFT_TT",
    "ADD_FROM_RIGHT_TT",
    "WRONG_WAY_TT",
    "NO_STRAIGHT_TT",
    "TRUCK_LANE_TT",
    "INTERCHANGE_TT",
    "OBSTRUCTION_ABOVE_TT",
    "BOARD_DIRECTION_ADVANCE_TT",
    "BOARD_DIRECTION_COMBINED_TT",
    "SHARED_ROAD_PEDESTRIANS_TT",
    "GATE_TT",
    "EMERGENCY_BAY_TT",
    "INTERSECTION_WITH_RAILWAY_TT",
    "LEFT_ABOVE_TFL_TT",
    "RIGHT_ABOVE_TFL_TT",
    "ALL_WAY_TT",
    "FOUR_WAY_TT",
    "SPLIT_RIGHT_TT",
    "SPLIT_LEFT_TT",
    "ROAD_H_TT",
    "DISABLED_TT",
    "SINGLE_WALKING_MAN_TT",
    "SINGLE_TT",
    "TRUCK_LIMIT_TT",
    "CITY_START_END_TT",
    "U_TURN_RIGHT_TT",
    "U_TURN_LEFT_TT",
    "ONEWAY_TRAFFIC_END_TT",
    "OBSTRUCTION_FISHBONE_LEFT_TT",
    "OBSTRUCTION_FISHBONE_RIGHT_TT",
    "OBSTRUCTION_LEFT_TT",
    "OBSTRUCTION_RIGHT_TT",
    "SHORT_POLE_TT",
    "BARREL_TT",
    "CONE_TT",
    "MANHOLE_TT",
    "LAMP_TT",
    "REFLECTOR_TT",
    "VEHICLE_LANE_TT",
    "SUPP_RECTANGULAR_EU_TT",
    "TRAFFIC_LIGHT_STRUCT_LEFT_TT",
    "TRAFFIC_LIGHT_STRUCT_RIGHT_TT",
    "TRAFFIC_LIGHT_STRUCT_BACK_TT",
    "GREEN_TFL_ARROW_TT",
    "PARKING_NOT_ALLOWED_TT",
    "PRIORITY_TURN_LEFT_TT",
    "GIVE_WAY_LEFT_TT",
    "PRIORITY_TURN_RIGHT_TT",
    "GIVE_WAY_RIGHT_TT",
    "ARROW_RECTANGULAR_TT",
    "CIRCULAR_UNKNOWN_TT",
    "BACK_OF_SIGN_TT",
    "NO_PARKING_START_TT",
    "NO_PARKING_END_TT",
    "NO_STOPPING_START_TT",
    "NO_STOPPING_END_TT",
    "STAGGERED_JUNCTION_LEFT_RIGHT_TT",
    "STAGGERED_JUNCTION_RIGHT_LEFT_TT",
    "MINOR_ROAD_CROSSING_PRIORITY_TT",
    "CURVE_LEFT_TT",
    "CURVE_RIGHT_TT",
    "DEVIATION_RIGHT_TT",
    "DEVIATION_LEFT_TT",
    "ROAD_DIAMOND_TT",
    "ROAD_X_TT",
    "ONEWAY_TRAFFIC_TOPOLOGY_TT",
    "TWO_WAY_TRAFFIC_TOPOLOGY_TT",
    "LANE_SPLIT_LEFT_TOPOLOGY_TT",
    "LANE_SPLIT_RIGHT_TOPOLOGY_TT",
    "LANE_MERGE_ON_LEFT_TOPOLOGY_TT",
    "LANE_MERGE_ON_RIGHT_TOPOLOGY_TT",
    "MERGE_TO_MAIN_FROM_LEFT_TT",
    "MERGE_TO_MAIN_FROM_RIGHT_TT",
    "AT_PEDESTRIAN_AND_BIKE_CROSSING_TT"
];
var USED_SIGN_TYPES = [];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hgUxd":[function(require,module,exports,__globalThis) {
// Everything from OpenLayers
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TrafficSign", ()=>TrafficSign);
/**
 * @param {DateInputControl} dateInputControl
 * @param {SDOControl} sdoControl
 * @param {AzureLoginControl} azureLoginControl
 * @returns
 */ parcelHelpers.export(exports, "getSDOLayer", ()=>getSDOLayer);
var _feature = require("ol/Feature");
var _featureDefault = parcelHelpers.interopDefault(_feature);
var _point = require("ol/geom/Point");
var _pointDefault = parcelHelpers.interopDefault(_point);
var _style = require("ol/style");
var _text = require("ol/style/Text");
var _textDefault = parcelHelpers.interopDefault(_text);
var _vector = require("ol/source/Vector");
var _vectorDefault = parcelHelpers.interopDefault(_vector);
var _vector1 = require("ol/layer/Vector");
var _vectorDefault1 = parcelHelpers.interopDefault(_vector1);
var _proj = require("ol/proj");
var _render = require("ol/render");
var _polygon = require("ol/geom/Polygon");
var _polygonDefault = parcelHelpers.interopDefault(_polygon);
// Everything from luxon
var _luxon = require("luxon");
var _sdotrafficSigns = require("../SDOTrafficSigns");
// API parameters
const SIGN_URL = "/data/signs";
const DATA_SOURCE = "sdo";
const TIMEOUT_MILLIS = 0;
// Change CLUSTERING to true if you want UNCLUSTERED signs.
const CLUSTERING = true;
const CLUSTER_RADIUS = 30;
const SRS = "EPSG:900913";
const VERSION = "1.3";
const PLACEMENT_TYPE = "";
// Some parameters used to render the dial and bearing used to show the direction of the sign.
const DIAL_THICKNESS = 3;
const DIAL_LENGTH = 8;
const DIAL_BORDER = 2;
const DEG_TO_RADIANS = Math.PI / 180;
const BEARING_DIAL_Y_SHIFT = 24;
const BEARING_NEEDLE_POLY = [
    [
        0,
        0
    ],
    [
        0,
        DIAL_LENGTH
    ],
    [
        DIAL_THICKNESS,
        DIAL_LENGTH
    ],
    [
        DIAL_THICKNESS,
        0
    ],
    [
        0,
        0
    ]
];
const IMAGE_SIZE = 20;
const IMAGE_SIZE_LARGER = 30;
const CLUSTERED_ZINDEX = 9;
const UNCLUSTERED_ZINDEX = 8;
const TEXT_OFFSET = 10;
// Global variables used to abort API calls because the user has changed the map.
let abortController, signal;
class TrafficSign {
    /**
   * @param {JSON} feature The JSON object returned by the API call.
   */ constructor(feature){
        this.feature = feature;
        this.sign = feature.properties.sign;
        this.placement = feature.properties.placement;
        this.bearing = feature.properties.bearing; // Optional
        // Clustered traffic sign
        if (feature.geometry.coordinates) {
            this.coordinates = feature.geometry.coordinates;
            this.zIndex = CLUSTERED_ZINDEX;
            this.clusterSize = feature.properties.CLUSTER_SIZE;
        } else if (feature.geometry.geometries[0].coordinates) {
            this.coordinates = feature.geometry.geometries[0].coordinates;
            this.zIndex = UNCLUSTERED_ZINDEX; // We want these to be layered underneath the clustered signs
        }
        this.createSignFeature();
    }
    createSignFeature() {
        this.styles = [];
        this.signFeature = new (0, _featureDefault.default)({
            geometry: new (0, _pointDefault.default)((0, _proj.fromLonLat)(this.coordinates))
        });
        // SignStyle -- The TrafficSign icon.
        const signStyle = this.createSignStyle(), signIcon = signStyle.getImage(), signImage = signIcon.getImage();
        if (signImage.width) signIcon.setScale(IMAGE_SIZE / TrafficSign.calculateLargest(signImage.width, signImage.height));
        signImage.addEventListener("load", function() {
            signIcon.setScale(IMAGE_SIZE / TrafficSign.calculateLargest(signImage.width, signImage.height));
        });
        this.styles.push(signStyle);
        // ClusterStyle -- The cluster number.
        if (this.clusterSize) this.styles.push(this.createClusterStyle());
        // BearingStyle -- The bearing added to show the direction of the sign (hover only).
        if (this.bearing) this.styles = this.styles.concat(this.createBearingStyles());
        // InfoStyle -- The name of the sign (hover only).
        this.styles.push(this.createInfoStyle());
        this.signFeature.setStyle(this.styles);
    }
    createSignStyle() {
        const signStyle = new (0, _style.Style)({
            image: new (0, _style.Icon)({
                src: this.sign + ".png",
                // src: signIcons[this.sign] ? signIcons[this.sign] : signIcons["UNKNOWN"],
                // The initial scale is set to zero, because the size of the image is not known yet.
                scale: 0
            }),
            zIndex: this.zIndex
        });
        signStyle.type = "sign";
        return signStyle;
    }
    createClusterStyle() {
        const clusterStyle = new (0, _style.Style)({
            // The cluster style should always be layered on top of the sign icon.
            zIndex: this.zIndex + 1,
            image: new (0, _style.Circle)({
                fill: new (0, _style.Fill)({
                    color: "#526A8F"
                }),
                stroke: new (0, _style.Stroke)({
                    color: "#FFFFFF",
                    width: 1.25
                }),
                // TODO Add as constants
                radius: 8,
                displacement: [
                    10,
                    -10
                ],
                scale: 1
            }),
            text: new (0, _textDefault.default)({
                text: String(this.clusterSize),
                fill: new (0, _style.Fill)({
                    color: "#FFFFFF"
                }),
                scale: 1,
                offsetX: TEXT_OFFSET,
                offsetY: TEXT_OFFSET
            })
        });
        clusterStyle.type = "cluster";
        return clusterStyle;
    }
    createBearingStyles() {
        const theta = this.bearing * DEG_TO_RADIANS;
        // Creation of the rectangle of the dial.
        let canvas = document.createElement("canvas");
        let vectorContext = (0, _render.toContext)(canvas.getContext("2d"), {
            size: [
                DIAL_THICKNESS,
                DIAL_LENGTH
            ],
            pixelRatio: 1
        });
        vectorContext.setStyle(new (0, _style.Style)({
            fill: new (0, _style.Fill)({
                color: "#006E00"
            })
        }));
        vectorContext.drawGeometry(new (0, _polygonDefault.default)([
            BEARING_NEEDLE_POLY
        ]));
        const dialStyle = new (0, _style.Style)({
            zIndex: CLUSTERED_ZINDEX + 2,
            image: new (0, _style.Circle)({
                radius: DIAL_LENGTH,
                fill: new (0, _style.Fill)({
                    color: "#B4FAB4"
                }),
                stroke: new (0, _style.Stroke)({
                    color: "#009600",
                    width: DIAL_BORDER
                }),
                displacement: [
                    0,
                    24
                ],
                scale: 0
            })
        });
        dialStyle.type = "dial";
        const needleStyle = new (0, _style.Style)({
            zIndex: CLUSTERED_ZINDEX + 5,
            image: new (0, _style.Icon)({
                img: canvas,
                imgSize: [
                    DIAL_THICKNESS,
                    DIAL_LENGTH
                ],
                rotation: theta,
                anchorOrigin: "bottom-left",
                offsetOrigin: "bottom-left",
                anchor: [
                    0.5,
                    0
                ],
                // Because the displacement happens in the direction of the orientation, theta has to be accounted for
                // when placing the needle in the middle of the dial.
                displacement: [
                    -BEARING_DIAL_Y_SHIFT * Math.sin(theta),
                    BEARING_DIAL_Y_SHIFT * Math.cos(theta)
                ],
                scale: 0
            })
        });
        needleStyle.type = "needle";
        return [
            dialStyle,
            needleStyle
        ];
    }
    createInfoStyle() {
        const InfoStyle = new (0, _style.Style)({
            text: new (0, _textDefault.default)({
                text: `${this.sign} (${this.placement})`,
                offsetX: 0,
                offsetY: -50,
                scale: 0,
                fill: new (0, _style.Fill)({
                    color: "#FFFFFF"
                }),
                backgroundFill: new (0, _style.Fill)({
                    color: "rgba(0, 0, 0, 0.4)"
                }),
                padding: 0
            })
        });
        InfoStyle.type = "info";
        return InfoStyle;
    }
    /**
   * @param {number} width Width in pixels
   * @param {number} height Height in pixels
   */ static calculateLargest(width, height) {
        let largest = Math.max(width, height);
        if (Math.min(width, height) <= largest / 2) largest *= 0.75;
        return largest;
    }
    /**
   * @param {SelectEvent} e
   */ static hoverSelectHandler(e) {
        if (e.selected.length !== 0) {
            if (e.selected[0] instanceof (0, _featureDefault.default)) TrafficSign.changeFeatureScale(e.selected[0], true);
        }
        if (e.deselected.length !== 0) {
            if (e.deselected[0] instanceof (0, _featureDefault.default)) TrafficSign.changeFeatureScale(e.deselected[0], false);
        }
        // Force the layer to rerender.
        TrafficSign.sdoLayer.getSource().changed();
    }
    /**
   * @param {Feature} feature
   * @param {boolean} hover
   */ static changeFeatureScale(feature, hover) {
        var featureStyle = feature.getStyle();
        let icon, image;
        // This should only apply to WKT objects, as the SDO features should have styles.
        if (featureStyle == null) return;
        // Forcefully change featureStyle to an array if the feature only has one style.
        // This way, the following map function always succeeds.
        if (!Array.isArray(featureStyle)) featureStyle = [
            featureStyle
        ];
        // This is a useless check but allows the map function to understand the type of 'style'.
        if (Array.isArray(featureStyle)) featureStyle.map(function(style) {
            switch(style.type){
                case "sign":
                    icon = style.getImage();
                    image = icon.getImage();
                    icon.setScale((hover ? IMAGE_SIZE_LARGER : IMAGE_SIZE) / TrafficSign.calculateLargest(image.width, image.height));
                    break;
                case "cluster":
                    icon = style.getImage();
                    icon.setScale(hover ? 1.3 : 1);
                    style.getText().setScale(hover ? 1.3 : 1);
                    style.getText().setOffsetX((hover ? 1.3 : Math.pow(1.3, -1)) * style.getText().getOffsetX());
                    style.getText().setOffsetY((hover ? 1.3 : Math.pow(1.3, -1)) * style.getText().getOffsetY());
                    break;
                case "dial":
                case "needle":
                    icon = style.getImage();
                    icon.setScale(hover ? 1 : 0);
                    break;
                case "info":
                    style.getText().setScale(hover ? 1 : 0);
                    style.getText().setPadding(hover ? [
                        8,
                        8,
                        8,
                        8
                    ] : null);
                    break;
            }
            if (typeof style.getZIndex === "function") style.setZIndex(hover ? style.getZIndex() + 3 : style.getZIndex() - 3);
        });
    }
}
/**
 * @param {string} startDate
 * @param {string} endDate
 */ function convertDateAndTime(startDate, endDate) {
    // https://confluence.tomtomgroup.com/display/FCD/GeoJSON+Observations for date and time formats.
    const TIME = (0, _luxon.DateTime).fromISO(startDate).toISODate() + "/" + (0, _luxon.DateTime).fromISO(endDate).toISODate();
    return {
        TIME: TIME
    };
}
/**
 * @param {SDOControl} sdoControl
 */ function calculateArea(sdoControl) {
    const bbox = sdoControl.get("bbox");
    return Math.abs((bbox[0] - bbox[2]) * Math.abs(bbox[1] - bbox[3]));
}
/**
 * @param {DateInputControl} dateInputControl
 * @param {SDOControl} sdoControl
 * @param {AzureLoginControl} azureLoginControl
 * @param {VectorSource} vectorSource
 * @param {VectorLayer} vectorLayer
 */ function propertyChangeHandler(dateInputControl, sdoControl, azureLoginControl, vectorSource, vectorLayer) {
    if (!azureLoginControl.get("idToken")) {
        vectorLayer.setVisible(false);
        sdoControl.set("idTokenSet", false);
    } else {
        sdoControl.set("idTokenSet", true);
        if (sdoControl.get("sdoToggle") == true) {
            vectorLayer.setVisible(true);
            updateTrafficSigns(dateInputControl, sdoControl, azureLoginControl, vectorSource, vectorLayer);
        } else // When sdoToggle is not set, the checkbox is not checked, and so the layer is made invisible.
        vectorLayer.setVisible(false);
    }
}
/**
 * @param {DateInputControl} dateInputControl
 * @param {SDOControl} sdoControl
 * @param {AzureLoginControl} azureLoginControl
 * @param {VectorSource} vectorSource
 * @param {VectorLayer} vectorLayer
 */ function updateTrafficSigns(dateInputControl, sdoControl, azureLoginControl, vectorSource, vectorLayer) {
    if (abortController) abortController.abort();
    // 'signal' is a global variable used to abort fetch requests when a new request is already made.
    // The API is rather slow, so it would be a waste of recourses to let the fetch continue to work
    // after a new move on the map was made.
    abortController = new AbortController();
    signal = abortController.signal;
    // The area for the traffic signs can be 12 km2 maximum.
    if (calculateArea(sdoControl) <= 12 * Math.pow(10, 6)) {
        if (vectorLayer) vectorLayer.setVisible(true);
        sdoControl.set("tooLarge", false);
        sdoControl.set("loading", true);
        const dateAndTimeParams = convertDateAndTime(dateInputControl.get("startDate"), dateInputControl.get("endDate"));
        const searchParams = new URLSearchParams();
        searchParams.set("DATA_SOURCE", DATA_SOURCE);
        searchParams.set("TIMEOUT_MILLIS", TIMEOUT_MILLIS);
        searchParams.set("SIGN_TYPE", (0, _sdotrafficSigns.USED_SIGN_TYPES));
        searchParams.set("CLUSTERING", CLUSTERING);
        searchParams.set("CLUSTER_RADIUS", CLUSTER_RADIUS);
        searchParams.set("TIME", dateAndTimeParams.TIME);
        searchParams.set("bbox", sdoControl.get("bbox"));
        searchParams.set("SRS", SRS);
        searchParams.set("VERSION", VERSION);
        searchParams.set("PLACEMENT_TYPE", PLACEMENT_TYPE);
        const headers = {
            Authorization: "Bearer " + azureLoginControl.get("idToken")
        };
        fetch(SIGN_URL + "?" + searchParams.toString(), {
            signal,
            headers
        }).then(function(response) {
            return response.json();
        }).then(function(jsonResponse) {
            // All TrafficSigns are removed from the map upon a new JSON response from the API.
            vectorSource.clear();
            jsonResponse.features.map(function(feature) {
                const trafficSign = new TrafficSign(feature, vectorSource);
                vectorSource.addFeature(trafficSign.signFeature);
            });
            sdoControl.set("loading", false);
        }).catch(function(error) {
            if (error.name === "AbortError") ;
            else if (error.name === "SyntaxError") {
                // No data is available.
                console.error("No SDO data is available for this date range.");
                sdoControl.set("loading", false);
            } else console.error(error);
        });
    } else {
        sdoControl.set("loading", false);
        sdoControl.set("tooLarge", true);
        if (vectorLayer) vectorLayer.setVisible(false);
    }
}
function getSDOLayer(dateInputControl, sdoControl, azureLoginControl) {
    const vectorSource = new (0, _vectorDefault.default)({
        features: []
    });
    const vectorLayer = new (0, _vectorDefault1.default)({
        source: vectorSource,
        zIndex: 10
    });
    sdoControl.on("propertychange", function(e) {
        if (e.key !== "loading" && e.key !== "tooLarge") propertyChangeHandler(dateInputControl, sdoControl, azureLoginControl, vectorSource, vectorLayer);
    });
    dateInputControl.on("propertychange", function() {
        propertyChangeHandler(dateInputControl, sdoControl, azureLoginControl, vectorSource, vectorLayer);
    });
    azureLoginControl.on("propertychange", function() {
        propertyChangeHandler(dateInputControl, sdoControl, azureLoginControl, vectorSource, vectorLayer);
    });
    return vectorLayer;
}

},{"ol/Feature":"iVSSP","ol/geom/Point":"95T6m","ol/style":[["Circle","3Wl62","default"],["Fill","24G0i","default"],["Icon","ib4Ft","default"],["Stroke","cese4","default"],["Style","gqpPW","default"]],"ol/style/Text":"118sC","ol/source/Vector":"7zHxp","ol/layer/Vector":"7ga2c","ol/proj":"gN0IK","ol/render":"ao3FA","ol/geom/Polygon":"3zws5","luxon":"6apd3","../SDOTrafficSigns":"2bXw4","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ao3FA":[function(require,module,exports,__globalThis) {
/**
 * @module ol/render
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @typedef {Object} State
 * @property {CanvasRenderingContext2D} context Canvas context that the layer is being rendered to.
 * @property {import("./Feature.js").FeatureLike} feature Feature.
 * @property {import("./geom/SimpleGeometry.js").default} geometry Geometry.
 * @property {number} pixelRatio Pixel ratio used by the layer renderer.
 * @property {number} resolution Resolution that the render batch was created and optimized for.
 * This is not the view's resolution that is being rendered.
 * @property {number} rotation Rotation of the rendered layer in radians.
 */ /**
 * A function to be used when sorting features before rendering.
 * It takes two instances of {@link module:ol/Feature~Feature} or
 * {@link module:ol/render/Feature~RenderFeature} and returns a `{number}`.
 *
 * @typedef {function(import("./Feature.js").FeatureLike, import("./Feature.js").FeatureLike):number} OrderFunction
 */ /**
 * @typedef {Object} ToContextOptions
 * @property {import("./size.js").Size} [size] Desired size of the canvas in css
 * pixels. When provided, both canvas and css size will be set according to the
 * `pixelRatio`. If not provided, the current canvas and css sizes will not be
 * altered.
 * @property {number} [pixelRatio=window.devicePixelRatio] Pixel ratio (canvas
 * pixel to css pixel ratio) for the canvas.
 */ /**
 * Binds a Canvas Immediate API to a canvas context, to allow drawing geometries
 * to the context's canvas.
 *
 * The units for geometry coordinates are css pixels relative to the top left
 * corner of the canvas element.
 * ```js
 * import {toContext} from 'ol/render.js';
 * import Fill from 'ol/style/Fill.js';
 * import Polygon from 'ol/geom/Polygon.js';
 *
 * const canvas = document.createElement('canvas');
 * const render = toContext(
 *     canvas.getContext('2d'),
 *     {size: [100, 100]}
 * );
 * render.setFillStrokeStyle(new Fill({ color: blue }));
 * render.drawPolygon(
 *     new Polygon([[[0, 0], [100, 100], [100, 0], [0, 0]]])
 * );
 * ```
 *
 * @param {CanvasRenderingContext2D} context Canvas context.
 * @param {ToContextOptions} [options] Options.
 * @return {CanvasImmediateRenderer} Canvas Immediate.
 * @api
 */ parcelHelpers.export(exports, "toContext", ()=>toContext);
/**
 * Gets a vector context for drawing to the event's canvas.
 * @param {import("./render/Event.js").default} event Render event.
 * @return {CanvasImmediateRenderer} Vector context.
 * @api
 */ parcelHelpers.export(exports, "getVectorContext", ()=>getVectorContext);
/**
 * Gets the pixel of the event's canvas context from the map viewport's CSS pixel.
 * @param {import("./render/Event.js").default} event Render event.
 * @param {import("./pixel.js").Pixel} pixel CSS pixel relative to the top-left
 * corner of the map viewport.
 * @return {import("./pixel.js").Pixel} Pixel on the event's canvas context.
 * @api
 */ parcelHelpers.export(exports, "getRenderPixel", ()=>getRenderPixel);
var _hasJs = require("./has.js");
var _projJs = require("./proj.js");
var _immediateJs = require("./render/canvas/Immediate.js");
var _immediateJsDefault = parcelHelpers.interopDefault(_immediateJs);
var _vectorJs = require("./renderer/vector.js");
var _transformJs = require("./transform.js");
function toContext(context, options) {
    const canvas = context.canvas;
    options = options ? options : {};
    const pixelRatio = options.pixelRatio || (0, _hasJs.DEVICE_PIXEL_RATIO);
    const size = options.size;
    if (size) {
        canvas.width = size[0] * pixelRatio;
        canvas.height = size[1] * pixelRatio;
        canvas.style.width = size[0] + 'px';
        canvas.style.height = size[1] + 'px';
    }
    const extent = [
        0,
        0,
        canvas.width,
        canvas.height
    ];
    const transform = (0, _transformJs.scale)((0, _transformJs.create)(), pixelRatio, pixelRatio);
    const squaredTolerance = (0, _vectorJs.getSquaredTolerance)(1, pixelRatio);
    return new (0, _immediateJsDefault.default)(context, pixelRatio, extent, transform, 0, squaredTolerance);
}
function getVectorContext(event) {
    if (!(event.context instanceof CanvasRenderingContext2D)) throw new Error('Only works for render events from Canvas 2D layers');
    // canvas may be at a different pixel ratio than frameState.pixelRatio
    const inversePixelTransform = event.inversePixelTransform;
    const frameState = event.frameState;
    if (!inversePixelTransform || !frameState) throw new Error('Only works for render events from Canvas 2D layers');
    const extent = frameState.extent;
    if (!extent) throw new Error('Missing frame extent');
    const a = inversePixelTransform[0];
    const b = inversePixelTransform[1];
    const canvasPixelRatio = Math.sqrt(a * a + b * b);
    const transform = (0, _transformJs.multiply)(inversePixelTransform.slice(), frameState.coordinateToPixelTransform);
    const squaredTolerance = (0, _vectorJs.getSquaredTolerance)(frameState.viewState.resolution, canvasPixelRatio);
    let userTransform;
    const userProjection = (0, _projJs.getUserProjection)();
    if (userProjection) userTransform = (0, _projJs.getTransformFromProjections)(userProjection, frameState.viewState.projection);
    return new (0, _immediateJsDefault.default)(event.context, canvasPixelRatio, extent, transform, frameState.viewState.rotation, squaredTolerance, userTransform || undefined);
}
function getRenderPixel(event, pixel) {
    const inversePixelTransform = event.inversePixelTransform;
    if (!inversePixelTransform) throw new Error('Missing inversePixelTransform');
    return (0, _transformJs.apply)(inversePixelTransform, pixel.slice(0));
}

},{"./has.js":"hbGE6","./proj.js":"gN0IK","./render/canvas/Immediate.js":"fx7AZ","./renderer/vector.js":"fFxjb","./transform.js":"7TqcG","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6apd3":[function(require,module,exports,__globalThis) {
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateTime", ()=>DateTime);
parcelHelpers.export(exports, "Duration", ()=>Duration);
parcelHelpers.export(exports, "FixedOffsetZone", ()=>FixedOffsetZone);
parcelHelpers.export(exports, "IANAZone", ()=>IANAZone);
parcelHelpers.export(exports, "Info", ()=>Info);
parcelHelpers.export(exports, "Interval", ()=>Interval);
parcelHelpers.export(exports, "InvalidZone", ()=>InvalidZone);
parcelHelpers.export(exports, "Settings", ()=>Settings);
parcelHelpers.export(exports, "SystemZone", ()=>SystemZone);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
parcelHelpers.export(exports, "Zone", ()=>Zone);
class LuxonError extends Error {
}
/**
 * @private
 */ class InvalidDateTimeError extends LuxonError {
    constructor(reason){
        super(`Invalid DateTime: ${reason.toMessage()}`);
    }
}
/**
 * @private
 */ class InvalidIntervalError extends LuxonError {
    constructor(reason){
        super(`Invalid Interval: ${reason.toMessage()}`);
    }
}
/**
 * @private
 */ class InvalidDurationError extends LuxonError {
    constructor(reason){
        super(`Invalid Duration: ${reason.toMessage()}`);
    }
}
/**
 * @private
 */ class ConflictingSpecificationError extends LuxonError {
}
/**
 * @private
 */ class InvalidUnitError extends LuxonError {
    constructor(unit){
        super(`Invalid unit ${unit}`);
    }
}
/**
 * @private
 */ class InvalidArgumentError extends LuxonError {
}
/**
 * @private
 */ class ZoneIsAbstractError extends LuxonError {
    constructor(){
        super("Zone is an abstract class");
    }
}
/**
 * @private
 */ const n = "numeric", s = "short", l = "long";
const DATE_SHORT = {
    year: n,
    month: n,
    day: n
};
const DATE_MED = {
    year: n,
    month: s,
    day: n
};
const DATE_MED_WITH_WEEKDAY = {
    year: n,
    month: s,
    day: n,
    weekday: s
};
const DATE_FULL = {
    year: n,
    month: l,
    day: n
};
const DATE_HUGE = {
    year: n,
    month: l,
    day: n,
    weekday: l
};
const TIME_SIMPLE = {
    hour: n,
    minute: n
};
const TIME_WITH_SECONDS = {
    hour: n,
    minute: n,
    second: n
};
const TIME_WITH_SHORT_OFFSET = {
    hour: n,
    minute: n,
    second: n,
    timeZoneName: s
};
const TIME_WITH_LONG_OFFSET = {
    hour: n,
    minute: n,
    second: n,
    timeZoneName: l
};
const TIME_24_SIMPLE = {
    hour: n,
    minute: n,
    hourCycle: "h23"
};
const TIME_24_WITH_SECONDS = {
    hour: n,
    minute: n,
    second: n,
    hourCycle: "h23"
};
const TIME_24_WITH_SHORT_OFFSET = {
    hour: n,
    minute: n,
    second: n,
    hourCycle: "h23",
    timeZoneName: s
};
const TIME_24_WITH_LONG_OFFSET = {
    hour: n,
    minute: n,
    second: n,
    hourCycle: "h23",
    timeZoneName: l
};
const DATETIME_SHORT = {
    year: n,
    month: n,
    day: n,
    hour: n,
    minute: n
};
const DATETIME_SHORT_WITH_SECONDS = {
    year: n,
    month: n,
    day: n,
    hour: n,
    minute: n,
    second: n
};
const DATETIME_MED = {
    year: n,
    month: s,
    day: n,
    hour: n,
    minute: n
};
const DATETIME_MED_WITH_SECONDS = {
    year: n,
    month: s,
    day: n,
    hour: n,
    minute: n,
    second: n
};
const DATETIME_MED_WITH_WEEKDAY = {
    year: n,
    month: s,
    day: n,
    weekday: s,
    hour: n,
    minute: n
};
const DATETIME_FULL = {
    year: n,
    month: l,
    day: n,
    hour: n,
    minute: n,
    timeZoneName: s
};
const DATETIME_FULL_WITH_SECONDS = {
    year: n,
    month: l,
    day: n,
    hour: n,
    minute: n,
    second: n,
    timeZoneName: s
};
const DATETIME_HUGE = {
    year: n,
    month: l,
    day: n,
    weekday: l,
    hour: n,
    minute: n,
    timeZoneName: l
};
const DATETIME_HUGE_WITH_SECONDS = {
    year: n,
    month: l,
    day: n,
    weekday: l,
    hour: n,
    minute: n,
    second: n,
    timeZoneName: l
};
/**
 * @interface
 */ class Zone {
    /**
   * The type of zone
   * @abstract
   * @type {string}
   */ get type() {
        throw new ZoneIsAbstractError();
    }
    /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */ get name() {
        throw new ZoneIsAbstractError();
    }
    /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */ get ianaName() {
        return this.name;
    }
    /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */ get isUniversal() {
        throw new ZoneIsAbstractError();
    }
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ offsetName(ts, opts) {
        throw new ZoneIsAbstractError();
    }
    /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ formatOffset(ts, format) {
        throw new ZoneIsAbstractError();
    }
    /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */ offset(ts) {
        throw new ZoneIsAbstractError();
    }
    /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ equals(otherZone) {
        throw new ZoneIsAbstractError();
    }
    /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */ get isValid() {
        throw new ZoneIsAbstractError();
    }
}
let singleton$1 = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */ class SystemZone extends Zone {
    /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */ static get instance() {
        if (singleton$1 === null) singleton$1 = new SystemZone();
        return singleton$1;
    }
    /** @override **/ get type() {
        return "system";
    }
    /** @override **/ get name() {
        return new Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    /** @override **/ get isUniversal() {
        return false;
    }
    /** @override **/ offsetName(ts, { format, locale }) {
        return parseZoneInfo(ts, format, locale);
    }
    /** @override **/ formatOffset(ts, format) {
        return formatOffset(this.offset(ts), format);
    }
    /** @override **/ offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    }
    /** @override **/ equals(otherZone) {
        return otherZone.type === "system";
    }
    /** @override **/ get isValid() {
        return true;
    }
}
const dtfCache = new Map();
function makeDTF(zoneName) {
    let dtf = dtfCache.get(zoneName);
    if (dtf === undefined) {
        dtf = new Intl.DateTimeFormat("en-US", {
            hour12: false,
            timeZone: zoneName,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            era: "short"
        });
        dtfCache.set(zoneName, dtf);
    }
    return dtf;
}
const typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
};
function hackyOffset(dtf, date) {
    const formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = parsed;
    return [
        fYear,
        fMonth,
        fDay,
        fadOrBc,
        fHour,
        fMinute,
        fSecond
    ];
}
function partsOffset(dtf, date) {
    const formatted = dtf.formatToParts(date);
    const filled = [];
    for(let i = 0; i < formatted.length; i++){
        const { type, value } = formatted[i];
        const pos = typeToPos[type];
        if (type === "era") filled[pos] = value;
        else if (!isUndefined(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
const ianaZoneCache = new Map();
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */ class IANAZone extends Zone {
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ static create(name) {
        let zone = ianaZoneCache.get(name);
        if (zone === undefined) ianaZoneCache.set(name, zone = new IANAZone(name));
        return zone;
    }
    /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ static resetCache() {
        ianaZoneCache.clear();
        dtfCache.clear();
    }
    /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */ static isValidSpecifier(s) {
        return this.isValidZone(s);
    }
    /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */ static isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    }
    constructor(name){
        super();
        /** @private **/ this.zoneName = name;
        /** @private **/ this.valid = IANAZone.isValidZone(name);
    }
    /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */ get type() {
        return "iana";
    }
    /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */ get name() {
        return this.zoneName;
    }
    /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */ get isUniversal() {
        return false;
    }
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ offsetName(ts, { format, locale }) {
        return parseZoneInfo(ts, format, locale, this.name);
    }
    /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ formatOffset(ts, format) {
        return formatOffset(this.offset(ts), format);
    }
    /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */ offset(ts) {
        if (!this.valid) return NaN;
        const date = new Date(ts);
        if (isNaN(date)) return NaN;
        const dtf = makeDTF(this.name);
        let [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date);
        if (adOrBc === "BC") year = -Math.abs(year) + 1;
        // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        const adjustedHour = hour === 24 ? 0 : hour;
        const asUTC = objToLocalTS({
            year,
            month,
            day,
            hour: adjustedHour,
            minute,
            second,
            millisecond: 0
        });
        let asTS = +date;
        const over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    }
    /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    }
    /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */ get isValid() {
        return this.valid;
    }
}
// todo - remap caching
let intlLFCache = {};
function getCachedLF(locString, opts = {}) {
    const key = JSON.stringify([
        locString,
        opts
    ]);
    let dtf = intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        intlLFCache[key] = dtf;
    }
    return dtf;
}
const intlDTCache = new Map();
function getCachedDTF(locString, opts = {}) {
    const key = JSON.stringify([
        locString,
        opts
    ]);
    let dtf = intlDTCache.get(key);
    if (dtf === undefined) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        intlDTCache.set(key, dtf);
    }
    return dtf;
}
const intlNumCache = new Map();
function getCachedINF(locString, opts = {}) {
    const key = JSON.stringify([
        locString,
        opts
    ]);
    let inf = intlNumCache.get(key);
    if (inf === undefined) {
        inf = new Intl.NumberFormat(locString, opts);
        intlNumCache.set(key, inf);
    }
    return inf;
}
const intlRelCache = new Map();
function getCachedRTF(locString, opts = {}) {
    const { base, ...cacheKeyOpts } = opts; // exclude `base` from the options
    const key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    let inf = intlRelCache.get(key);
    if (inf === undefined) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        intlRelCache.set(key, inf);
    }
    return inf;
}
let sysLocaleCache = null;
function systemLocale() {
    if (sysLocaleCache) return sysLocaleCache;
    else {
        sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return sysLocaleCache;
    }
}
const intlResolvedOptionsCache = new Map();
function getCachedIntResolvedOptions(locString) {
    let opts = intlResolvedOptionsCache.get(locString);
    if (opts === undefined) {
        opts = new Intl.DateTimeFormat(locString).resolvedOptions();
        intlResolvedOptionsCache.set(locString, opts);
    }
    return opts;
}
const weekInfoCache = new Map();
function getCachedWeekInfo(locString) {
    let data = weekInfoCache.get(locString);
    if (!data) {
        const locale = new Intl.Locale(locString);
        // browsers currently implement this as a property, but spec says it should be a getter function
        data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
        // minimalDays was removed from WeekInfo: https://github.com/tc39/proposal-intl-locale-info/issues/86
        if (!("minimalDays" in data)) data = {
            ...fallbackWeekSettings,
            ...data
        };
        weekInfoCache.set(locString, data);
    }
    return data;
}
function parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    // private subtags and unicode subtags have ordering requirements,
    // and we're not properly parsing this, so just strip out the
    // private ones if they exist.
    const xIndex = localeStr.indexOf("-x-");
    if (xIndex !== -1) localeStr = localeStr.substring(0, xIndex);
    const uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        let options;
        let selectedStr;
        try {
            options = getCachedDTF(localeStr).resolvedOptions();
            selectedStr = localeStr;
        } catch (e) {
            const smaller = localeStr.substring(0, uIndex);
            options = getCachedDTF(smaller).resolvedOptions();
            selectedStr = smaller;
        }
        const { numberingSystem, calendar } = options;
        return [
            selectedStr,
            numberingSystem,
            calendar
        ];
    }
}
function intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        if (!localeStr.includes("-u-")) localeStr += "-u";
        if (outputCalendar) localeStr += `-ca-${outputCalendar}`;
        if (numberingSystem) localeStr += `-nu-${numberingSystem}`;
        return localeStr;
    } else return localeStr;
}
function mapMonths(f) {
    const ms = [];
    for(let i = 1; i <= 12; i++){
        const dt = DateTime.utc(2009, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function mapWeekdays(f) {
    const ms = [];
    for(let i = 1; i <= 7; i++){
        const dt = DateTime.utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function listStuff(loc, length, englishFn, intlFn) {
    const mode = loc.listingMode();
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || getCachedIntResolvedOptions(loc.locale).numberingSystem === "latn";
}
/**
 * @private
 */ class PolyNumberFormatter {
    constructor(intl, forceSimple, opts){
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        const { padTo, floor, ...otherOpts } = opts;
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            const intlOpts = {
                useGrouping: false,
                ...opts
            };
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = getCachedINF(intl, intlOpts);
        }
    }
    format(i) {
        if (this.inf) {
            const fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            const fixed = this.floor ? Math.floor(i) : roundTo(i, 3);
            return padStart(fixed, this.padTo);
        }
    }
}
/**
 * @private
 */ class PolyDateFormatter {
    constructor(dt, intl, opts){
        this.opts = opts;
        this.originalZone = undefined;
        let z = undefined;
        if (this.opts.timeZone) // Don't apply any workarounds if a timeZone is explicitly provided in opts
        this.dt = dt;
        else if (dt.zone.type === "fixed") {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            const gmtOffset = -1 * (dt.offset / 60);
            const offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
            if (dt.offset !== 0 && IANAZone.create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
                // we manually apply the offset and substitute the zone as needed.
                z = "UTC";
                this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
                    minutes: dt.offset
                });
                this.originalZone = dt.zone;
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else if (dt.zone.type === "iana") {
            this.dt = dt;
            z = dt.zone.name;
        } else {
            // Custom zones can have any offset / offsetName so we just manually
            // apply the offset and substitute the zone as needed.
            z = "UTC";
            this.dt = dt.setZone("UTC").plus({
                minutes: dt.offset
            });
            this.originalZone = dt.zone;
        }
        const intlOpts = {
            ...this.opts
        };
        intlOpts.timeZone = intlOpts.timeZone || z;
        this.dtf = getCachedDTF(intl, intlOpts);
    }
    format() {
        if (this.originalZone) // If we have to substitute in the actual zone name, we have to use
        // formatToParts so that the timezone can be replaced.
        return this.formatToParts().map(({ value })=>value).join("");
        return this.dtf.format(this.dt.toJSDate());
    }
    formatToParts() {
        const parts = this.dtf.formatToParts(this.dt.toJSDate());
        if (this.originalZone) return parts.map((part)=>{
            if (part.type === "timeZoneName") {
                const offsetName = this.originalZone.offsetName(this.dt.ts, {
                    locale: this.dt.locale,
                    format: this.opts.timeZoneName
                });
                return {
                    ...part,
                    value: offsetName
                };
            } else return part;
        });
        return parts;
    }
    resolvedOptions() {
        return this.dtf.resolvedOptions();
    }
}
/**
 * @private
 */ class PolyRelFormatter {
    constructor(intl, isEnglish, opts){
        this.opts = {
            style: "long",
            ...opts
        };
        if (!isEnglish && hasRelative()) this.rtf = getCachedRTF(intl, opts);
    }
    format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
    formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    }
}
const fallbackWeekSettings = {
    firstDay: 1,
    minimalDays: 4,
    weekend: [
        6,
        7
    ]
};
/**
 * @private
 */ class Locale {
    static fromOpts(opts) {
        return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.weekSettings, opts.defaultToEN);
    }
    static create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN = false) {
        const specifiedLocale = locale || Settings.defaultLocale;
        // the system locale is useful for human-readable strings but annoying for parsing/formatting known formats
        const localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale());
        const numberingSystemR = numberingSystem || Settings.defaultNumberingSystem;
        const outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
        const weekSettingsR = validateWeekSettings(weekSettings) || Settings.defaultWeekSettings;
        return new Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
    }
    static resetCache() {
        sysLocaleCache = null;
        intlDTCache.clear();
        intlNumCache.clear();
        intlRelCache.clear();
        intlResolvedOptionsCache.clear();
        weekInfoCache.clear();
    }
    static fromObject({ locale, numberingSystem, outputCalendar, weekSettings } = {}) {
        return Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
    }
    constructor(locale, numbering, outputCalendar, weekSettings, specifiedLocale){
        const [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = parseLocaleString(locale);
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.weekSettings = weekSettings;
        this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    get fastNumbers() {
        if (this.fastNumbersCached == null) this.fastNumbersCached = supportsFastNumbers(this);
        return this.fastNumbersCached;
    }
    listingMode() {
        const isActuallyEn = this.isEnglish();
        const hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    }
    clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, validateWeekSettings(alts.weekSettings) || this.weekSettings, alts.defaultToEN || false);
    }
    redefaultToEN(alts = {}) {
        return this.clone({
            ...alts,
            defaultToEN: true
        });
    }
    redefaultToSystem(alts = {}) {
        return this.clone({
            ...alts,
            defaultToEN: false
        });
    }
    months(length, format = false) {
        return listStuff(this, length, months, ()=>{
            // Workaround for "ja" locale: formatToParts does not label all parts of the month
            // as "month" and for this locale there is no difference between "format" and "non-format".
            // As such, just use format() instead of formatToParts() and take the whole string
            const monthSpecialCase = this.intl === "ja" || this.intl.startsWith("ja-");
            format &= !monthSpecialCase;
            const intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!this.monthsCache[formatStr][length]) {
                const mapper = !monthSpecialCase ? (dt)=>this.extract(dt, intl, "month") : (dt)=>this.dtFormatter(dt, intl).format();
                this.monthsCache[formatStr][length] = mapMonths(mapper);
            }
            return this.monthsCache[formatStr][length];
        });
    }
    weekdays(length, format = false) {
        return listStuff(this, length, weekdays, ()=>{
            const intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!this.weekdaysCache[formatStr][length]) this.weekdaysCache[formatStr][length] = mapWeekdays((dt)=>this.extract(dt, intl, "weekday"));
            return this.weekdaysCache[formatStr][length];
        });
    }
    meridiems() {
        return listStuff(this, undefined, ()=>meridiems, ()=>{
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!this.meridiemCache) {
                const intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                this.meridiemCache = [
                    DateTime.utc(2016, 11, 13, 9),
                    DateTime.utc(2016, 11, 13, 19)
                ].map((dt)=>this.extract(dt, intl, "dayperiod"));
            }
            return this.meridiemCache;
        });
    }
    eras(length) {
        return listStuff(this, length, eras, ()=>{
            const intl = {
                era: length
            };
            // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!this.eraCache[length]) this.eraCache[length] = [
                DateTime.utc(-40, 1, 1),
                DateTime.utc(2017, 1, 1)
            ].map((dt)=>this.extract(dt, intl, "era"));
            return this.eraCache[length];
        });
    }
    extract(dt, intlOpts, field) {
        const df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find((m)=>m.type.toLowerCase() === field);
        return matching ? matching.value : null;
    }
    numberFormatter(opts = {}) {
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    }
    dtFormatter(dt, intlOpts = {}) {
        return new PolyDateFormatter(dt, this.intl, intlOpts);
    }
    relFormatter(opts = {}) {
        return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
    }
    listFormatter(opts = {}) {
        return getCachedLF(this.intl, opts);
    }
    isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || getCachedIntResolvedOptions(this.intl).locale.startsWith("en-us");
    }
    getWeekSettings() {
        if (this.weekSettings) return this.weekSettings;
        else if (!hasLocaleWeekInfo()) return fallbackWeekSettings;
        else return getCachedWeekInfo(this.locale);
    }
    getStartOfWeek() {
        return this.getWeekSettings().firstDay;
    }
    getMinDaysInFirstWeek() {
        return this.getWeekSettings().minimalDays;
    }
    getWeekendDays() {
        return this.getWeekSettings().weekend;
    }
    equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    }
    toString() {
        return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
    }
}
let singleton = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */ class FixedOffsetZone extends Zone {
    /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */ static get utcInstance() {
        if (singleton === null) singleton = new FixedOffsetZone(0);
        return singleton;
    }
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ static instance(offset) {
        return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    }
    /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */ static parseSpecifier(s) {
        if (s) {
            const r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new FixedOffsetZone(signedOffset(r[1], r[2]));
        }
        return null;
    }
    constructor(offset){
        super();
        /** @private **/ this.fixed = offset;
    }
    /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */ get type() {
        return "fixed";
    }
    /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */ get name() {
        return this.fixed === 0 ? "UTC" : `UTC${formatOffset(this.fixed, "narrow")}`;
    }
    /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */ get ianaName() {
        if (this.fixed === 0) return "Etc/UTC";
        else return `Etc/GMT${formatOffset(-this.fixed, "narrow")}`;
    }
    /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */ offsetName() {
        return this.name;
    }
    /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ formatOffset(ts, format) {
        return formatOffset(this.fixed, format);
    }
    /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */ get isUniversal() {
        return true;
    }
    /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */ offset() {
        return this.fixed;
    }
    /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    }
    /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */ get isValid() {
        return true;
    }
}
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */ class InvalidZone extends Zone {
    constructor(zoneName){
        super();
        /**  @private */ this.zoneName = zoneName;
    }
    /** @override **/ get type() {
        return "invalid";
    }
    /** @override **/ get name() {
        return this.zoneName;
    }
    /** @override **/ get isUniversal() {
        return false;
    }
    /** @override **/ offsetName() {
        return null;
    }
    /** @override **/ formatOffset() {
        return "";
    }
    /** @override **/ offset() {
        return NaN;
    }
    /** @override **/ equals() {
        return false;
    }
    /** @override **/ get isValid() {
        return false;
    }
}
/**
 * @private
 */ function normalizeZone(input, defaultZone) {
    if (isUndefined(input) || input === null) return defaultZone;
    else if (input instanceof Zone) return input;
    else if (isString(input)) {
        const lowered = input.toLowerCase();
        if (lowered === "default") return defaultZone;
        else if (lowered === "local" || lowered === "system") return SystemZone.instance;
        else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;
        else return FixedOffsetZone.parseSpecifier(lowered) || IANAZone.create(input);
    } else if (isNumber(input)) return FixedOffsetZone.instance(input);
    else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new InvalidZone(input);
}
const numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
const numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
const hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function parseDigits(str) {
    let value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(let i = 0; i < str.length; i++){
            const code = str.charCodeAt(i);
            if (str[i].search(numberingSystems.hanidec) !== -1) value += hanidecChars.indexOf(str[i]);
            else for(const key in numberingSystemsUTF16){
                const [min, max] = numberingSystemsUTF16[key];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
// cache of {numberingSystem: {append: regex}}
const digitRegexCache = new Map();
function resetDigitRegexCache() {
    digitRegexCache.clear();
}
function digitRegex({ numberingSystem }, append = "") {
    const ns = numberingSystem || "latn";
    let appendCache = digitRegexCache.get(ns);
    if (appendCache === undefined) {
        appendCache = new Map();
        digitRegexCache.set(ns, appendCache);
    }
    let regex = appendCache.get(append);
    if (regex === undefined) {
        regex = new RegExp(`${numberingSystems[ns]}${append}`);
        appendCache.set(append, regex);
    }
    return regex;
}
let now = ()=>Date.now(), defaultZone = "system", defaultLocale = null, defaultNumberingSystem = null, defaultOutputCalendar = null, twoDigitCutoffYear = 60, throwOnInvalid, defaultWeekSettings = null;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */ class Settings {
    /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */ static get now() {
        return now;
    }
    /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */ static set now(n) {
        now = n;
    }
    /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */ static set defaultZone(zone) {
        defaultZone = zone;
    }
    /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */ static get defaultZone() {
        return normalizeZone(defaultZone, SystemZone.instance);
    }
    /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static get defaultLocale() {
        return defaultLocale;
    }
    /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static set defaultLocale(locale) {
        defaultLocale = locale;
    }
    /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static get defaultNumberingSystem() {
        return defaultNumberingSystem;
    }
    /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static set defaultNumberingSystem(numberingSystem) {
        defaultNumberingSystem = numberingSystem;
    }
    /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static get defaultOutputCalendar() {
        return defaultOutputCalendar;
    }
    /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static set defaultOutputCalendar(outputCalendar) {
        defaultOutputCalendar = outputCalendar;
    }
    /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */ /**
   * @return {WeekSettings|null}
   */ static get defaultWeekSettings() {
        return defaultWeekSettings;
    }
    /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */ static set defaultWeekSettings(weekSettings) {
        defaultWeekSettings = validateWeekSettings(weekSettings);
    }
    /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */ static get twoDigitCutoffYear() {
        return twoDigitCutoffYear;
    }
    /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */ static set twoDigitCutoffYear(cutoffYear) {
        twoDigitCutoffYear = cutoffYear % 100;
    }
    /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */ static get throwOnInvalid() {
        return throwOnInvalid;
    }
    /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */ static set throwOnInvalid(t) {
        throwOnInvalid = t;
    }
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ static resetCaches() {
        Locale.resetCache();
        IANAZone.resetCache();
        DateTime.resetCache();
        resetDigitRegexCache();
    }
}
class Invalid {
    constructor(reason, explanation){
        this.reason = reason;
        this.explanation = explanation;
    }
    toMessage() {
        if (this.explanation) return `${this.reason}: ${this.explanation}`;
        else return this.reason;
    }
}
const nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function unitOutOfRange(unit, value) {
    return new Invalid("unit out of range", `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`);
}
function dayOfWeek(year, month, day) {
    const d = new Date(Date.UTC(year, month - 1, day));
    if (year < 100 && year >= 0) d.setUTCFullYear(d.getUTCFullYear() - 1900);
    const js = d.getUTCDay();
    return js === 0 ? 7 : js;
}
function computeOrdinal(year, month, day) {
    return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}
function uncomputeOrdinal(year, ordinal) {
    const table = isLeapYear(year) ? leapLadder : nonLeapLadder, month0 = table.findIndex((i)=>i < ordinal), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day
    };
}
function isoWeekdayToLocal(isoWeekday, startOfWeek) {
    return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
/**
 * @private
 */ function gregorianToWeek(gregObj, minDaysInFirstWeek = 4, startOfWeek = 1) {
    const { year, month, day } = gregObj, ordinal = computeOrdinal(year, month, day), weekday = isoWeekdayToLocal(dayOfWeek(year, month, day), startOfWeek);
    let weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
    } else if (weekNumber > weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return {
        weekYear,
        weekNumber,
        weekday,
        ...timeObject(gregObj)
    };
}
function weekToGregorian(weekData, minDaysInFirstWeek = 4, startOfWeek = 1) {
    const { weekYear, weekNumber, weekday } = weekData, weekdayOfJan4 = isoWeekdayToLocal(dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = daysInYear(weekYear);
    let ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += daysInYear(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= daysInYear(weekYear);
    } else year = weekYear;
    const { month, day } = uncomputeOrdinal(year, ordinal);
    return {
        year,
        month,
        day,
        ...timeObject(weekData)
    };
}
function gregorianToOrdinal(gregData) {
    const { year, month, day } = gregData;
    const ordinal = computeOrdinal(year, month, day);
    return {
        year,
        ordinal,
        ...timeObject(gregData)
    };
}
function ordinalToGregorian(ordinalData) {
    const { year, ordinal } = ordinalData;
    const { month, day } = uncomputeOrdinal(year, ordinal);
    return {
        year,
        month,
        day,
        ...timeObject(ordinalData)
    };
}
/**
 * Check if local week units like localWeekday are used in obj.
 * If so, validates that they are not mixed with ISO week units and then copies them to the normal week unit properties.
 * Modifies obj in-place!
 * @param obj the object values
 */ function usesLocalWeekValues(obj, loc) {
    const hasLocaleWeekData = !isUndefined(obj.localWeekday) || !isUndefined(obj.localWeekNumber) || !isUndefined(obj.localWeekYear);
    if (hasLocaleWeekData) {
        const hasIsoWeekData = !isUndefined(obj.weekday) || !isUndefined(obj.weekNumber) || !isUndefined(obj.weekYear);
        if (hasIsoWeekData) throw new ConflictingSpecificationError("Cannot mix locale-based week fields with ISO-based week fields");
        if (!isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
        if (!isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
        if (!isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
        delete obj.localWeekday;
        delete obj.localWeekNumber;
        delete obj.localWeekYear;
        return {
            minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
            startOfWeek: loc.getStartOfWeek()
        };
    } else return {
        minDaysInFirstWeek: 4,
        startOfWeek: 1
    };
}
function hasInvalidWeekData(obj, minDaysInFirstWeek = 4, startOfWeek = 1) {
    const validYear = isInteger(obj.weekYear), validWeek = integerBetween(obj.weekNumber, 1, weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)), validWeekday = integerBetween(obj.weekday, 1, 7);
    if (!validYear) return unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return unitOutOfRange("week", obj.weekNumber);
    else if (!validWeekday) return unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function hasInvalidOrdinalData(obj) {
    const validYear = isInteger(obj.year), validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));
    if (!validYear) return unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function hasInvalidGregorianData(obj) {
    const validYear = isInteger(obj.year), validMonth = integerBetween(obj.month, 1, 12), validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));
    if (!validYear) return unitOutOfRange("year", obj.year);
    else if (!validMonth) return unitOutOfRange("month", obj.month);
    else if (!validDay) return unitOutOfRange("day", obj.day);
    else return false;
}
function hasInvalidTimeData(obj) {
    const { hour, minute, second, millisecond } = obj;
    const validHour = integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = integerBetween(minute, 0, 59), validSecond = integerBetween(second, 0, 59), validMillisecond = integerBetween(millisecond, 0, 999);
    if (!validHour) return unitOutOfRange("hour", hour);
    else if (!validMinute) return unitOutOfRange("minute", minute);
    else if (!validSecond) return unitOutOfRange("second", second);
    else if (!validMillisecond) return unitOutOfRange("millisecond", millisecond);
    else return false;
}
/*
  This is just a junk drawer, containing anything used across multiple classes.
  Because Luxon is small(ish), this should stay small and we won't worry about splitting
  it up into, say, parsingUtil.js and basicUtil.js and so on. But they are divided up by feature area.
*/ /**
 * @private
 */ // TYPES
function isUndefined(o) {
    return typeof o === "undefined";
}
function isNumber(o) {
    return typeof o === "number";
}
function isInteger(o) {
    return typeof o === "number" && o % 1 === 0;
}
function isString(o) {
    return typeof o === "string";
}
function isDate(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
}
// CAPABILITIES
function hasRelative() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
}
function hasLocaleWeekInfo() {
    try {
        return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
    } catch (e) {
        return false;
    }
}
// OBJECTS AND ARRAYS
function maybeArray(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function bestBy(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce((best, next)=>{
        const pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function pick(obj, keys) {
    return keys.reduce((a, k)=>{
        a[k] = obj[k];
        return a;
    }, {});
}
function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function validateWeekSettings(settings) {
    if (settings == null) return null;
    else if (typeof settings !== "object") throw new InvalidArgumentError("Week settings must be an object");
    else {
        if (!integerBetween(settings.firstDay, 1, 7) || !integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some((v)=>!integerBetween(v, 1, 7))) throw new InvalidArgumentError("Invalid week settings");
        return {
            firstDay: settings.firstDay,
            minimalDays: settings.minimalDays,
            weekend: Array.from(settings.weekend)
        };
    }
}
// NUMBERS AND STRINGS
function integerBetween(thing, bottom, top) {
    return isInteger(thing) && thing >= bottom && thing <= top;
}
// x % n but takes the sign of n instead of x
function floorMod(x, n) {
    return x - n * Math.floor(x / n);
}
function padStart(input, n = 2) {
    const isNeg = input < 0;
    let padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function parseInteger(string) {
    if (isUndefined(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function parseFloating(string) {
    if (isUndefined(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function parseMillis(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if (isUndefined(fraction) || fraction === null || fraction === "") return undefined;
    else {
        const f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function roundTo(number, digits, rounding = "round") {
    const factor = 10 ** digits;
    switch(rounding){
        case "expand":
            return number > 0 ? Math.ceil(number * factor) / factor : Math.floor(number * factor) / factor;
        case "trunc":
            return Math.trunc(number * factor) / factor;
        case "round":
            return Math.round(number * factor) / factor;
        case "floor":
            return Math.floor(number * factor) / factor;
        case "ceil":
            return Math.ceil(number * factor) / factor;
        default:
            throw new RangeError(`Value rounding ${rounding} is out of range`);
    }
}
// DATE BASICS
function isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}
function daysInMonth(year, month) {
    const modMonth = floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return isLeapYear(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
}
// convert a calendar object to a local timestamp (epoch, but with the offset baked in)
function objToLocalTS(obj) {
    let d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
    // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
        // so if obj.year is in 99, but obj.day makes it roll over into year 100,
        // the calculations done by Date.UTC are using year 2000 - which is incorrect
        d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
    }
    return +d;
}
// adapted from moment.js: https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/units/week-calendar-utils.js
function firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
    const fwdlw = isoWeekdayToLocal(dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
    return -fwdlw + minDaysInFirstWeek - 1;
}
function weeksInWeekYear(weekYear, minDaysInFirstWeek = 4, startOfWeek = 1) {
    const weekOffset = firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
    const weekOffsetNext = firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
    return (daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function untruncateYear(year) {
    if (year > 99) return year;
    else return year > Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}
// PARSING
function parseZoneInfo(ts, offsetFormat, locale, timeZone = null) {
    const date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    const modified = {
        timeZoneName: offsetFormat,
        ...intlOpts
    };
    const parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find((m)=>m.type.toLowerCase() === "timezonename");
    return parsed ? parsed.value : null;
}
// signedOffset('-5', '30') -> -330
function signedOffset(offHourStr, offMinuteStr) {
    let offHour = parseInt(offHourStr, 10);
    // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    const offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
}
// COERCION
function asNumber(value) {
    const numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || !Number.isFinite(numericValue)) throw new InvalidArgumentError(`Invalid unit value ${value}`);
    return numericValue;
}
function normalizeObject(obj, normalizer) {
    const normalized = {};
    for(const u in obj)if (hasOwnProperty(obj, u)) {
        const v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = asNumber(v);
    }
    return normalized;
}
/**
 * Returns the offset's value as a string
 * @param {number} ts - Epoch milliseconds for which to get the offset
 * @param {string} format - What style of offset to return.
 *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
 * @return {string}
 */ function formatOffset(offset, format) {
    const hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return `${sign}${padStart(hours, 2)}:${padStart(minutes, 2)}`;
        case "narrow":
            return `${sign}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
        case "techie":
            return `${sign}${padStart(hours, 2)}${padStart(minutes, 2)}`;
        default:
            throw new RangeError(`Value format ${format} is out of range for property format`);
    }
}
function timeObject(obj) {
    return pick(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
/**
 * @private
 */ const monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const monthsNarrow = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function months(length) {
    switch(length){
        case "narrow":
            return [
                ...monthsNarrow
            ];
        case "short":
            return [
                ...monthsShort
            ];
        case "long":
            return [
                ...monthsLong
            ];
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
const weekdaysLong = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
const weekdaysShort = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
const weekdaysNarrow = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function weekdays(length) {
    switch(length){
        case "narrow":
            return [
                ...weekdaysNarrow
            ];
        case "short":
            return [
                ...weekdaysShort
            ];
        case "long":
            return [
                ...weekdaysLong
            ];
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
const meridiems = [
    "AM",
    "PM"
];
const erasLong = [
    "Before Christ",
    "Anno Domini"
];
const erasShort = [
    "BC",
    "AD"
];
const erasNarrow = [
    "B",
    "A"
];
function eras(length) {
    switch(length){
        case "narrow":
            return [
                ...erasNarrow
            ];
        case "short":
            return [
                ...erasShort
            ];
        case "long":
            return [
                ...erasLong
            ];
        default:
            return null;
    }
}
function meridiemForDateTime(dt) {
    return meridiems[dt.hour < 12 ? 0 : 1];
}
function weekdayForDateTime(dt, length) {
    return weekdays(length)[dt.weekday - 1];
}
function monthForDateTime(dt, length) {
    return months(length)[dt.month - 1];
}
function eraForDateTime(dt, length) {
    return eras(length)[dt.year < 0 ? 0 : 1];
}
function formatRelativeTime(unit, count, numeric = "always", narrow = false) {
    const units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    const lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        const isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : `next ${units[unit][0]}`;
            case -1:
                return isDay ? "yesterday" : `last ${units[unit][0]}`;
            case 0:
                return isDay ? "today" : `this ${units[unit][0]}`;
        }
    }
    const isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}
function stringifyTokens(splits, tokenToString) {
    let s = "";
    for (const token of splits)if (token.literal) s += token.val;
    else s += tokenToString(token.val);
    return s;
}
const macroTokenToFormatOpts = {
    D: DATE_SHORT,
    DD: DATE_MED,
    DDD: DATE_FULL,
    DDDD: DATE_HUGE,
    t: TIME_SIMPLE,
    tt: TIME_WITH_SECONDS,
    ttt: TIME_WITH_SHORT_OFFSET,
    tttt: TIME_WITH_LONG_OFFSET,
    T: TIME_24_SIMPLE,
    TT: TIME_24_WITH_SECONDS,
    TTT: TIME_24_WITH_SHORT_OFFSET,
    TTTT: TIME_24_WITH_LONG_OFFSET,
    f: DATETIME_SHORT,
    ff: DATETIME_MED,
    fff: DATETIME_FULL,
    ffff: DATETIME_HUGE,
    F: DATETIME_SHORT_WITH_SECONDS,
    FF: DATETIME_MED_WITH_SECONDS,
    FFF: DATETIME_FULL_WITH_SECONDS,
    FFFF: DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */ class Formatter {
    static create(locale, opts = {}) {
        return new Formatter(locale, opts);
    }
    static parseFormat(fmt) {
        // white-space is always considered a literal in user-provided formats
        // the " " token has a special meaning (see unitForToken)
        let current = null, currentFull = "", bracketed = false;
        const splits = [];
        for(let i = 0; i < fmt.length; i++){
            const c = fmt.charAt(i);
            if (c === "'") {
                // turn '' into a literal signal quote instead of just skipping the empty literal
                if (currentFull.length > 0 || bracketed) splits.push({
                    literal: bracketed || /^\s+$/.test(currentFull),
                    val: currentFull === "" ? "'" : currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: /^\s+$/.test(currentFull),
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
        });
        return splits;
    }
    static macroTokenToFormatOpts(token) {
        return macroTokenToFormatOpts[token];
    }
    constructor(locale, formatOpts){
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        const df = this.systemLoc.dtFormatter(dt, {
            ...this.opts,
            ...opts
        });
        return df.format();
    }
    dtFormatter(dt, opts = {}) {
        return this.loc.dtFormatter(dt, {
            ...this.opts,
            ...opts
        });
    }
    formatDateTime(dt, opts) {
        return this.dtFormatter(dt, opts).format();
    }
    formatDateTimeParts(dt, opts) {
        return this.dtFormatter(dt, opts).formatToParts();
    }
    formatInterval(interval, opts) {
        const df = this.dtFormatter(interval.start, opts);
        return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
    }
    resolvedOptions(dt, opts) {
        return this.dtFormatter(dt, opts).resolvedOptions();
    }
    num(n, p = 0, signDisplay) {
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return padStart(n, p);
        const opts = {
            ...this.opts
        };
        if (p > 0) opts.padTo = p;
        if (signDisplay) opts.signDisplay = signDisplay;
        return this.loc.numberFormatter(opts).format(n);
    }
    formatDateTimeFromString(dt, fmt) {
        const knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = (opts, extract)=>this.loc.extract(dt, opts, extract), formatOffset = (opts)=>{
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = ()=>knownEnglish ? meridiemForDateTime(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod"), month = (length, standalone)=>knownEnglish ? monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month"), weekday = (length, standalone)=>knownEnglish ? weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday"), maybeMacro = (token)=>{
            const formatOpts = Formatter.macroTokenToFormatOpts(token);
            if (formatOpts) return this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = (length)=>knownEnglish ? eraForDateTime(dt, length) : string({
                era: length
            }, "era"), tokenToString = (token)=>{
            // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
            switch(token){
                // ms
                case "S":
                    return this.num(dt.millisecond);
                case "u":
                // falls through
                case "SSS":
                    return this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return this.num(dt.second);
                case "ss":
                    return this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return this.num(dt.minute);
                case "mm":
                    return this.num(dt.minute, 2);
                // hours
                case "h":
                    return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return this.num(dt.hour);
                case "HH":
                    return this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return this.num(dt.weekYear, 4);
                case "W":
                    return this.num(dt.weekNumber);
                case "WW":
                    return this.num(dt.weekNumber, 2);
                case "n":
                    return this.num(dt.localWeekNumber);
                case "nn":
                    return this.num(dt.localWeekNumber, 2);
                case "ii":
                    return this.num(dt.localWeekYear.toString().slice(-2), 2);
                case "iiii":
                    return this.num(dt.localWeekYear, 4);
                case "o":
                    return this.num(dt.ordinal);
                case "ooo":
                    return this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return this.num(dt.quarter);
                case "qq":
                    // like 01
                    return this.num(dt.quarter, 2);
                case "X":
                    return this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
    }
    formatDurationFromString(dur, fmt) {
        const invertLargest = this.opts.signMode === "negativeLargestOnly" ? -1 : 1;
        const tokenToField = (token)=>{
            switch(token[0]){
                case "S":
                    return "milliseconds";
                case "s":
                    return "seconds";
                case "m":
                    return "minutes";
                case "h":
                    return "hours";
                case "d":
                    return "days";
                case "w":
                    return "weeks";
                case "M":
                    return "months";
                case "y":
                    return "years";
                default:
                    return null;
            }
        }, tokenToString = (lildur, info)=>(token)=>{
                const mapped = tokenToField(token);
                if (mapped) {
                    const inversionFactor = info.isNegativeDuration && mapped !== info.largestUnit ? invertLargest : 1;
                    let signDisplay;
                    if (this.opts.signMode === "negativeLargestOnly" && mapped !== info.largestUnit) signDisplay = "never";
                    else if (this.opts.signMode === "all") signDisplay = "always";
                    else // "auto" and "negative" are the same, but "auto" has better support
                    signDisplay = "auto";
                    return this.num(lildur.get(mapped) * inversionFactor, token.length, signDisplay);
                } else return token;
            }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce((found, { literal, val })=>literal ? found : found.concat(val), []), collapsed = dur.shiftTo(...realTokens.map(tokenToField).filter((t)=>t)), durationInfo = {
            isNegativeDuration: collapsed < 0,
            // this relies on "collapsed" being based on "shiftTo", which builds up the object
            // in order
            largestUnit: Object.keys(collapsed.values)[0]
        };
        return stringifyTokens(tokens, tokenToString(collapsed, durationInfo));
    }
}
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ const ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function combineRegexes(...regexes) {
    const full = regexes.reduce((f, r)=>f + r.source, "");
    return RegExp(`^${full}$`);
}
function combineExtractors(...extractors) {
    return (m)=>extractors.reduce(([mergedVals, mergedZone, cursor], ex)=>{
            const [val, zone, next] = ex(m, cursor);
            return [
                {
                    ...mergedVals,
                    ...val
                },
                zone || mergedZone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
}
function parse(s, ...patterns) {
    if (s == null) return [
        null,
        null
    ];
    for (const [regex, extractor] of patterns){
        const m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function simpleParse(...keys) {
    return (match, cursor)=>{
        const ret = {};
        let i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = parseInteger(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
}
// ISO and SQL parsing
const offsetRegex = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/;
const isoExtendedZone = `(?:${offsetRegex.source}?(?:\\[(${ianaRegex.source})\\])?)?`;
const isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
const isoTimeRegex = RegExp(`${isoTimeBaseRegex.source}${isoExtendedZone}`);
const isoTimeExtensionRegex = RegExp(`(?:[Tt]${isoTimeRegex.source})?`);
const isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
const isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
const isoOrdinalRegex = /(\d{4})-?(\d{3})/;
const extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay");
const extractISOOrdinalData = simpleParse("year", "ordinal");
const sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
const sqlTimeRegex = RegExp(`${isoTimeBaseRegex.source} ?(?:${offsetRegex.source}|(${ianaRegex.source}))?`);
const sqlTimeExtensionRegex = RegExp(`(?: ${sqlTimeRegex.source})?`);
function int(match, pos, fallback) {
    const m = match[pos];
    return isUndefined(m) ? fallback : parseInteger(m);
}
function extractISOYmd(match, cursor) {
    const item = {
        year: int(match, cursor),
        month: int(match, cursor + 1, 1),
        day: int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function extractISOTime(match, cursor) {
    const item = {
        hours: int(match, cursor, 0),
        minutes: int(match, cursor + 1, 0),
        seconds: int(match, cursor + 2, 0),
        milliseconds: parseMillis(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function extractISOOffset(match, cursor) {
    const local = !match[cursor] && !match[cursor + 1], fullOffset = signedOffset(match[cursor + 1], match[cursor + 2]), zone = local ? null : FixedOffsetZone.instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function extractIANAZone(match, cursor) {
    const zone = match[cursor] ? IANAZone.create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
}
// ISO time parsing
const isoTimeOnly = RegExp(`^T?${isoTimeBaseRegex.source}$`);
// ISO duration parsing
const isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function extractISODuration(match) {
    const [s, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] = match;
    const hasNegativePrefix = s[0] === "-";
    const negativeSeconds = secondStr && secondStr[0] === "-";
    const maybeNegate = (num, force = false)=>num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    return [
        {
            years: maybeNegate(parseFloating(yearStr)),
            months: maybeNegate(parseFloating(monthStr)),
            weeks: maybeNegate(parseFloating(weekStr)),
            days: maybeNegate(parseFloating(dayStr)),
            hours: maybeNegate(parseFloating(hourStr)),
            minutes: maybeNegate(parseFloating(minuteStr)),
            seconds: maybeNegate(parseFloating(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds)
        }
    ];
}
// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
const obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    const result = {
        year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
        month: monthsShort.indexOf(monthStr) + 1,
        day: parseInteger(dayStr),
        hour: parseInteger(hourStr),
        minute: parseInteger(minuteStr)
    };
    if (secondStr) result.second = parseInteger(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
}
// RFC 2822/5322
const rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function extractRFC2822(match) {
    const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr, obsOffset, milOffset, offHourStr, offMinuteStr] = match, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    let offset;
    if (obsOffset) offset = obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = signedOffset(offHourStr, offMinuteStr);
    return [
        result,
        new FixedOffsetZone(offset)
    ];
}
function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
// http date
const rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function extractRFC1123Or850(match) {
    const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        FixedOffsetZone.utcInstance
    ];
}
function extractASCII(match) {
    const [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match, result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        FixedOffsetZone.utcInstance
    ];
}
const isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
const isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
const isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
const isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
const extractISOYmdTimeAndOffset = combineExtractors(extractISOYmd, extractISOTime, extractISOOffset, extractIANAZone);
const extractISOWeekTimeAndOffset = combineExtractors(extractISOWeekData, extractISOTime, extractISOOffset, extractIANAZone);
const extractISOOrdinalDateAndTime = combineExtractors(extractISOOrdinalData, extractISOTime, extractISOOffset, extractIANAZone);
const extractISOTimeAndOffset = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
/*
 * @private
 */ function parseISODate(s) {
    return parse(s, [
        isoYmdWithTimeExtensionRegex,
        extractISOYmdTimeAndOffset
    ], [
        isoWeekWithTimeExtensionRegex,
        extractISOWeekTimeAndOffset
    ], [
        isoOrdinalWithTimeExtensionRegex,
        extractISOOrdinalDateAndTime
    ], [
        isoTimeCombinedRegex,
        extractISOTimeAndOffset
    ]);
}
function parseRFC2822Date(s) {
    return parse(preprocessRFC2822(s), [
        rfc2822,
        extractRFC2822
    ]);
}
function parseHTTPDate(s) {
    return parse(s, [
        rfc1123,
        extractRFC1123Or850
    ], [
        rfc850,
        extractRFC1123Or850
    ], [
        ascii,
        extractASCII
    ]);
}
function parseISODuration(s) {
    return parse(s, [
        isoDuration,
        extractISODuration
    ]);
}
const extractISOTimeOnly = combineExtractors(extractISOTime);
function parseISOTimeOnly(s) {
    return parse(s, [
        isoTimeOnly,
        extractISOTimeOnly
    ]);
}
const sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
const sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);
const extractISOTimeOffsetAndIANAZone = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
function parseSQL(s) {
    return parse(s, [
        sqlYmdWithTimeExtensionRegex,
        extractISOYmdTimeAndOffset
    ], [
        sqlTimeCombinedRegex,
        extractISOTimeOffsetAndIANAZone
    ]);
}
const INVALID$2 = "Invalid Duration";
// unit conversion constants
const lowOrderMatrix = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, casualMatrix = {
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    },
    ...lowOrderMatrix
}, daysInYearAccurate = 365.2425, daysInMonthAccurate = 30.436875, accurateMatrix = {
    years: {
        quarters: 4,
        months: 12,
        weeks: daysInYearAccurate / 7,
        days: daysInYearAccurate,
        hours: daysInYearAccurate * 24,
        minutes: daysInYearAccurate * 1440,
        seconds: daysInYearAccurate * 86400,
        milliseconds: daysInYearAccurate * 86400000
    },
    quarters: {
        months: 3,
        weeks: daysInYearAccurate / 28,
        days: daysInYearAccurate / 4,
        hours: daysInYearAccurate * 24 / 4,
        minutes: daysInYearAccurate * 1440 / 4,
        seconds: daysInYearAccurate * 86400 / 4,
        milliseconds: daysInYearAccurate * 86400000 / 4
    },
    months: {
        weeks: daysInMonthAccurate / 7,
        days: daysInMonthAccurate,
        hours: daysInMonthAccurate * 24,
        minutes: daysInMonthAccurate * 1440,
        seconds: daysInMonthAccurate * 86400,
        milliseconds: daysInMonthAccurate * 86400000
    },
    ...lowOrderMatrix
};
// units ordered by size
const orderedUnits$1 = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
const reverseUnits = orderedUnits$1.slice(0).reverse();
// clone really means "create another instance just like this one, but with these changes"
function clone$1(dur, alts, clear = false) {
    // deep merge for vals
    const conf = {
        values: clear ? alts.values : {
            ...dur.values,
            ...alts.values || {}
        },
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
        matrix: alts.matrix || dur.matrix
    };
    return new Duration(conf);
}
function durationToMillis(matrix, vals) {
    let sum = vals.milliseconds ?? 0;
    for (const unit of reverseUnits.slice(1))if (vals[unit]) sum += vals[unit] * matrix[unit]["milliseconds"];
    return sum;
}
// NB: mutates parameters
function normalizeValues(matrix, vals) {
    // the logic below assumes the overall value of the duration is positive
    // if this is not the case, factor is used to make it so
    const factor = durationToMillis(matrix, vals) < 0 ? -1 : 1;
    orderedUnits$1.reduceRight((previous, current)=>{
        if (!isUndefined(vals[current])) {
            if (previous) {
                const previousVal = vals[previous] * factor;
                const conv = matrix[current][previous];
                // if (previousVal < 0):
                // lower order unit is negative (e.g. { years: 2, days: -2 })
                // normalize this by reducing the higher order unit by the appropriate amount
                // and increasing the lower order unit
                // this can never make the higher order unit negative, because this function only operates
                // on positive durations, so the amount of time represented by the lower order unit cannot
                // be larger than the higher order unit
                // else:
                // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
                // in this case we attempt to convert as much as possible from the lower order unit into
                // the higher order one
                //
                // Math.floor takes care of both of these cases, rounding away from 0
                // if previousVal < 0 it makes the absolute value larger
                // if previousVal >= it makes the absolute value smaller
                const rollUp = Math.floor(previousVal / conv);
                vals[current] += rollUp * factor;
                vals[previous] -= rollUp * conv * factor;
            }
            return current;
        } else return previous;
    }, null);
    // try to convert any decimals into smaller units if possible
    // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
    orderedUnits$1.reduce((previous, current)=>{
        if (!isUndefined(vals[current])) {
            if (previous) {
                const fraction = vals[previous] % 1;
                vals[previous] -= fraction;
                vals[current] += fraction * matrix[previous][current];
            }
            return current;
        } else return previous;
    }, null);
}
// Remove all properties with a value of 0 from an object
function removeZeroes(vals) {
    const newVals = {};
    for (const [key, value] of Object.entries(vals))if (value !== 0) newVals[key] = value;
    return newVals;
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */ class Duration {
    /**
   * @private
   */ constructor(config){
        const accurate = config.conversionAccuracy === "longterm" || false;
        let matrix = accurate ? accurateMatrix : casualMatrix;
        if (config.matrix) matrix = config.matrix;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || Locale.create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = matrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ static fromMillis(count, opts) {
        return Duration.fromObject({
            milliseconds: count
        }, opts);
    }
    /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */ static fromObject(obj, opts = {}) {
        if (obj == null || typeof obj !== "object") throw new InvalidArgumentError(`Duration.fromObject: argument expected to be an object, got ${obj === null ? "null" : typeof obj}`);
        return new Duration({
            values: normalizeObject(obj, Duration.normalizeUnit),
            loc: Locale.fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy,
            matrix: opts.matrix
        });
    }
    /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */ static fromDurationLike(durationLike) {
        if (isNumber(durationLike)) return Duration.fromMillis(durationLike);
        else if (Duration.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return Duration.fromObject(durationLike);
        else throw new InvalidArgumentError(`Unknown duration argument ${durationLike} of type ${typeof durationLike}`);
    }
    /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */ static fromISO(text, opts) {
        const [parsed] = parseISODuration(text);
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
    /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */ static fromISOTime(text, opts) {
        const [parsed] = parseISOTimeOnly(text);
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
    /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */ static invalid(reason, explanation = null) {
        if (!reason) throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
        const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
        if (Settings.throwOnInvalid) throw new InvalidDurationError(invalid);
        else return new Duration({
            invalid
        });
    }
    /**
   * @private
   */ static normalizeUnit(unit) {
        const normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new InvalidUnitError(unit);
        return normalized;
    }
    /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ static isDuration(o) {
        return o && o.isLuxonDuration || false;
    }
    /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */ get locale() {
        return this.isValid ? this.loc.locale : null;
    }
    /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */ get numberingSystem() {
        return this.isValid ? this.loc.numberingSystem : null;
    }
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @param {'negative'|'all'|'negativeLargestOnly'} [opts.signMode=negative] - How to handle signs
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @example Duration.fromObject({ days: 6, seconds: 2 }).toFormat("d s", { signMode: "all" }) //=> "+6 +2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "all" }) //=> "-6 -2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "negativeLargestOnly" }) //=> "-6 2"
   * @return {string}
   */ toFormat(fmt, opts = {}) {
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        const fmtOpts = {
            ...opts,
            floor: opts.round !== false && opts.floor !== false
        };
        return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID$2;
    }
    /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @param {boolean} [opts.showZeros=true] - Show all units previously used by the duration even if they are zero
   * @example
   * ```js
   * var dur = Duration.fromObject({ months: 1, weeks: 0, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 month, 0 weeks, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 month, 0 weeks, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 mth, 0 wks, 5 hr, 6 min'
   * dur.toHuman({ showZeros: false }) //=> '1 month, 5 hours, 6 minutes'
   * ```
   */ toHuman(opts = {}) {
        if (!this.isValid) return INVALID$2;
        const showZeros = opts.showZeros !== false;
        const l = orderedUnits$1.map((unit)=>{
            const val = this.values[unit];
            if (isUndefined(val) || val === 0 && !showZeros) return null;
            return this.loc.numberFormatter({
                style: "unit",
                unitDisplay: "long",
                ...opts,
                unit: unit.slice(0, -1)
            }).format(val);
        }).filter((n)=>n);
        return this.loc.listFormatter({
            type: "conjunction",
            style: opts.listStyle || "narrow",
            ...opts
        }).format(l);
    }
    /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */ toObject() {
        if (!this.isValid) return {};
        return {
            ...this.values
        };
    }
    /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */ toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        let s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
        // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    }
    /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */ toISOTime(opts = {}) {
        if (!this.isValid) return null;
        const millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = {
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended",
            ...opts,
            includeOffset: false
        };
        const dateTime = DateTime.fromMillis(millis, {
            zone: "UTC"
        });
        return dateTime.toISOTime(opts);
    }
    /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */ toJSON() {
        return this.toISO();
    }
    /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */ toString() {
        return this.toISO();
    }
    /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */ [Symbol.for("nodejs.util.inspect.custom")]() {
        if (this.isValid) return `Duration { values: ${JSON.stringify(this.values)} }`;
        else return `Duration { Invalid, reason: ${this.invalidReason} }`;
    }
    /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */ toMillis() {
        if (!this.isValid) return NaN;
        return durationToMillis(this.matrix, this.values);
    }
    /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */ valueOf() {
        return this.toMillis();
    }
    /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ plus(duration) {
        if (!this.isValid) return this;
        const dur = Duration.fromDurationLike(duration), result = {};
        for (const k of orderedUnits$1)if (hasOwnProperty(dur.values, k) || hasOwnProperty(this.values, k)) result[k] = dur.get(k) + this.get(k);
        return clone$1(this, {
            values: result
        }, true);
    }
    /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ minus(duration) {
        if (!this.isValid) return this;
        const dur = Duration.fromDurationLike(duration);
        return this.plus(dur.negate());
    }
    /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */ mapUnits(fn) {
        if (!this.isValid) return this;
        const result = {};
        for (const k of Object.keys(this.values))result[k] = asNumber(fn(this.values[k], k));
        return clone$1(this, {
            values: result
        }, true);
    }
    /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */ get(unit) {
        return this[Duration.normalizeUnit(unit)];
    }
    /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */ set(values) {
        if (!this.isValid) return this;
        const mixed = {
            ...this.values,
            ...normalizeObject(values, Duration.normalizeUnit)
        };
        return clone$1(this, {
            values: mixed
        });
    }
    /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */ reconfigure({ locale, numberingSystem, conversionAccuracy, matrix } = {}) {
        const loc = this.loc.clone({
            locale,
            numberingSystem
        });
        const opts = {
            loc,
            matrix,
            conversionAccuracy
        };
        return clone$1(this, opts);
    }
    /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */ as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    }
    /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */ normalize() {
        if (!this.isValid) return this;
        const vals = this.toObject();
        normalizeValues(this.matrix, vals);
        return clone$1(this, {
            values: vals
        }, true);
    }
    /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */ rescale() {
        if (!this.isValid) return this;
        const vals = removeZeroes(this.normalize().shiftToAll().toObject());
        return clone$1(this, {
            values: vals
        }, true);
    }
    /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */ shiftTo(...units) {
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map((u)=>Duration.normalizeUnit(u));
        const built = {}, accumulated = {}, vals = this.toObject();
        let lastUnit;
        for (const k of orderedUnits$1){
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                let own = 0;
                // anything we haven't boiled down yet should get boiled to this unit
                for(const ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                }
                // plus anything that's already in this unit
                if (isNumber(vals[k])) own += vals[k];
                // only keep the integer part for now in the hopes of putting any decimal part
                // into a smaller unit later
                const i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000;
            // otherwise, keep it in the wings to boil it later
            } else if (isNumber(vals[k])) accumulated[k] = vals[k];
        }
        // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(const key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        normalizeValues(this.matrix, built);
        return clone$1(this, {
            values: built
        }, true);
    }
    /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */ shiftToAll() {
        if (!this.isValid) return this;
        return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
    }
    /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */ negate() {
        if (!this.isValid) return this;
        const negated = {};
        for (const k of Object.keys(this.values))negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        return clone$1(this, {
            values: negated
        }, true);
    }
    /**
   * Removes all units with values equal to 0 from this Duration.
   * @example Duration.fromObject({ years: 2, days: 0, hours: 0, minutes: 0 }).removeZeros().toObject() //=> { years: 2 }
   * @return {Duration}
   */ removeZeros() {
        if (!this.isValid) return this;
        const vals = removeZeroes(this.values);
        return clone$1(this, {
            values: vals
        }, true);
    }
    /**
   * Get the years.
   * @type {number}
   */ get years() {
        return this.isValid ? this.values.years || 0 : NaN;
    }
    /**
   * Get the quarters.
   * @type {number}
   */ get quarters() {
        return this.isValid ? this.values.quarters || 0 : NaN;
    }
    /**
   * Get the months.
   * @type {number}
   */ get months() {
        return this.isValid ? this.values.months || 0 : NaN;
    }
    /**
   * Get the weeks
   * @type {number}
   */ get weeks() {
        return this.isValid ? this.values.weeks || 0 : NaN;
    }
    /**
   * Get the days.
   * @type {number}
   */ get days() {
        return this.isValid ? this.values.days || 0 : NaN;
    }
    /**
   * Get the hours.
   * @type {number}
   */ get hours() {
        return this.isValid ? this.values.hours || 0 : NaN;
    }
    /**
   * Get the minutes.
   * @type {number}
   */ get minutes() {
        return this.isValid ? this.values.minutes || 0 : NaN;
    }
    /**
   * Get the seconds.
   * @return {number}
   */ get seconds() {
        return this.isValid ? this.values.seconds || 0 : NaN;
    }
    /**
   * Get the milliseconds.
   * @return {number}
   */ get milliseconds() {
        return this.isValid ? this.values.milliseconds || 0 : NaN;
    }
    /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */ get isValid() {
        return this.invalid === null;
    }
    /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */ get invalidReason() {
        return this.invalid ? this.invalid.reason : null;
    }
    /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */ get invalidExplanation() {
        return this.invalid ? this.invalid.explanation : null;
    }
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for (const u of orderedUnits$1){
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    }
}
const INVALID$1 = "Invalid Interval";
// checks if the start is equal to or before the end
function validateStartEnd(start, end) {
    if (!start || !start.isValid) return Interval.invalid("missing or invalid start");
    else if (!end || !end.isValid) return Interval.invalid("missing or invalid end");
    else if (end < start) return Interval.invalid("end before start", `The end of an interval must be after its start, but you had start=${start.toISO()} and end=${end.toISO()}`);
    else return null;
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */ class Interval {
    /**
   * @private
   */ constructor(config){
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ static invalid(reason, explanation = null) {
        if (!reason) throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
        const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
        if (Settings.throwOnInvalid) throw new InvalidIntervalError(invalid);
        else return new Interval({
            invalid
        });
    }
    /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */ static fromDateTimes(start, end) {
        const builtStart = friendlyDateTime(start), builtEnd = friendlyDateTime(end);
        const validateError = validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new Interval({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    }
    /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ static after(start, duration) {
        const dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(start);
        return Interval.fromDateTimes(dt, dt.plus(dur));
    }
    /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ static before(end, duration) {
        const dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(end);
        return Interval.fromDateTimes(dt.minus(dur), dt);
    }
    /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */ static fromISO(text, opts) {
        const [s, e] = (text || "").split("/", 2);
        if (s && e) {
            let start, startIsValid;
            try {
                start = DateTime.fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            let end, endIsValid;
            try {
                end = DateTime.fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return Interval.fromDateTimes(start, end);
            if (startIsValid) {
                const dur = Duration.fromISO(e, opts);
                if (dur.isValid) return Interval.after(start, dur);
            } else if (endIsValid) {
                const dur = Duration.fromISO(s, opts);
                if (dur.isValid) return Interval.before(end, dur);
            }
        }
        return Interval.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
    /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ static isInterval(o) {
        return o && o.isLuxonInterval || false;
    }
    /**
   * Returns the start of the Interval
   * @type {DateTime}
   */ get start() {
        return this.isValid ? this.s : null;
    }
    /**
   * Returns the end of the Interval. This is the first instant which is not part of the interval
   * (Interval is half-open).
   * @type {DateTime}
   */ get end() {
        return this.isValid ? this.e : null;
    }
    /**
   * Returns the last DateTime included in the interval (since end is not part of the interval)
   * @type {DateTime}
   */ get lastDateTime() {
        return this.isValid ? this.e ? this.e.minus(1) : null : null;
    }
    /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */ get isValid() {
        return this.invalidReason === null;
    }
    /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */ get invalidReason() {
        return this.invalid ? this.invalid.reason : null;
    }
    /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */ get invalidExplanation() {
        return this.invalid ? this.invalid.explanation : null;
    }
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ length(unit = "milliseconds") {
        return this.isValid ? this.toDuration(...[
            unit
        ]).get(unit) : NaN;
    }
    /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */ count(unit = "milliseconds", opts) {
        if (!this.isValid) return NaN;
        const start = this.start.startOf(unit, opts);
        let end;
        if (opts?.useLocaleWeeks) end = this.end.reconfigure({
            locale: start.locale
        });
        else end = this.end;
        end = end.startOf(unit, opts);
        return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
    }
    /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */ hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    }
    /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */ isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    }
    /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    }
    /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    }
    /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    }
    /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */ set({ start, end } = {}) {
        if (!this.isValid) return this;
        return Interval.fromDateTimes(start || this.s, end || this.e);
    }
    /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */ splitAt(...dateTimes) {
        if (!this.isValid) return [];
        const sorted = dateTimes.map(friendlyDateTime).filter((d)=>this.contains(d)).sort((a, b)=>a.toMillis() - b.toMillis()), results = [];
        let { s } = this, i = 0;
        while(s < this.e){
            const added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    }
    /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */ splitBy(duration) {
        const dur = Duration.fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        let { s } = this, idx = 1, next;
        const results = [];
        while(s < this.e){
            const added = this.start.plus(dur.mapUnits((x)=>x * idx));
            next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    }
    /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */ divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    }
    /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */ overlaps(other) {
        return this.e > other.s && this.s < other.e;
    }
    /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */ abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    }
    /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */ abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    }
    /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */ engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    }
    /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */ equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    }
    /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */ intersection(other) {
        if (!this.isValid) return this;
        const s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return Interval.fromDateTimes(s, e);
    }
    /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */ union(other) {
        if (!this.isValid) return this;
        const s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return Interval.fromDateTimes(s, e);
    }
    /**
   * Merge an array of Intervals into an equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * The resulting array will contain the Intervals in ascending order, that is, starting with the earliest Interval
   * and ending with the latest.
   *
   * @param {Array} intervals
   * @return {Array}
   */ static merge(intervals) {
        const [found, final] = intervals.sort((a, b)=>a.s - b.s).reduce(([sofar, current], item)=>{
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]);
        if (final) found.push(final);
        return found;
    }
    /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ static xor(intervals) {
        let start = null, currentCount = 0;
        const results = [], ends = intervals.map((i)=>[
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ]), flattened = Array.prototype.concat(...ends), arr = flattened.sort((a, b)=>a.time - b.time);
        for (const i of arr){
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push(Interval.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return Interval.merge(results);
    }
    /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */ difference(...intervals) {
        return Interval.xor([
            this
        ].concat(intervals)).map((i)=>this.intersection(i)).filter((i)=>i && !i.isEmpty());
    }
    /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */ toString() {
        if (!this.isValid) return INVALID$1;
        return `[${this.s.toISO()} \u{2013} ${this.e.toISO()})`;
    }
    /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */ [Symbol.for("nodejs.util.inspect.custom")]() {
        if (this.isValid) return `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }`;
        else return `Interval { Invalid, reason: ${this.invalidReason} }`;
    }
    /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */ toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
        return this.isValid ? Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : INVALID$1;
    }
    /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ toISO(opts) {
        if (!this.isValid) return INVALID$1;
        return `${this.s.toISO(opts)}/${this.e.toISO(opts)}`;
    }
    /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */ toISODate() {
        if (!this.isValid) return INVALID$1;
        return `${this.s.toISODate()}/${this.e.toISODate()}`;
    }
    /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ toISOTime(opts) {
        if (!this.isValid) return INVALID$1;
        return `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}`;
    }
    /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */ toFormat(dateFormat, { separator = " \u2013 " } = {}) {
        if (!this.isValid) return INVALID$1;
        return `${this.s.toFormat(dateFormat)}${separator}${this.e.toFormat(dateFormat)}`;
    }
    /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */ toDuration(unit, opts) {
        if (!this.isValid) return Duration.invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    }
    /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */ mapEndpoints(mapFn) {
        return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
    }
}
/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */ class Info {
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ static hasDST(zone = Settings.defaultZone) {
        const proto = DateTime.now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    }
    /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */ static isValidIANAZone(zone) {
        return IANAZone.isValidZone(zone);
    }
    /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */ static normalizeZone(input) {
        return normalizeZone(input, Settings.defaultZone);
    }
    /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */ static getStartOfWeek({ locale = null, locObj = null } = {}) {
        return (locObj || Locale.create(locale)).getStartOfWeek();
    }
    /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */ static getMinimumDaysInFirstWeek({ locale = null, locObj = null } = {}) {
        return (locObj || Locale.create(locale)).getMinDaysInFirstWeek();
    }
    /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */ static getWeekendWeekdays({ locale = null, locObj = null } = {}) {
        // copy the array, because we cache it internally
        return (locObj || Locale.create(locale)).getWeekendDays().slice();
    }
    /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */ static months(length = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
        return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    }
    /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */ static monthsFormat(length = "long", { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}) {
        return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    }
    /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */ static weekdays(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
        return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
    }
    /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */ static weekdaysFormat(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
        return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    }
    /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */ static meridiems({ locale = null } = {}) {
        return Locale.create(locale).meridiems();
    }
    /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */ static eras(length = "short", { locale = null } = {}) {
        return Locale.create(locale, null, "gregory").eras(length);
    }
    /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */ static features() {
        return {
            relative: hasRelative(),
            localeWeek: hasLocaleWeekInfo()
        };
    }
}
function dayDiff(earlier, later) {
    const utcDayStart = (dt)=>dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf(), ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor(Duration.fromMillis(ms).as("days"));
}
function highOrderDiffs(cursor, later, units) {
    const differs = [
        [
            "years",
            (a, b)=>b.year - a.year
        ],
        [
            "quarters",
            (a, b)=>b.quarter - a.quarter + (b.year - a.year) * 4
        ],
        [
            "months",
            (a, b)=>b.month - a.month + (b.year - a.year) * 12
        ],
        [
            "weeks",
            (a, b)=>{
                const days = dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            dayDiff
        ]
    ];
    const results = {};
    const earlier = cursor;
    let lowestOrder, highWater;
    /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */ for (const [unit, differ] of differs)if (units.indexOf(unit) >= 0) {
        lowestOrder = unit;
        results[unit] = differ(cursor, later);
        highWater = earlier.plus(results);
        if (highWater > later) {
            // we overshot the end point, backtrack cursor by 1
            results[unit]--;
            cursor = earlier.plus(results);
            // if we are still overshooting now, we need to backtrack again
            // this happens in certain situations when diffing times in different zones,
            // because this calculation ignores time zones
            if (cursor > later) {
                // keep the "overshot by 1" around as highWater
                highWater = cursor;
                // backtrack cursor by 1
                results[unit]--;
                cursor = earlier.plus(results);
            }
        } else cursor = highWater;
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function diff(earlier, later, units, opts) {
    let [cursor, results, highWater, lowestOrder] = highOrderDiffs(earlier, later, units);
    const remainingMillis = later - cursor;
    const lowerOrderUnits = units.filter((u)=>[
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0);
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) highWater = cursor.plus({
            [lowestOrder]: 1
        });
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    const duration = Duration.fromObject(results, opts);
    if (lowerOrderUnits.length > 0) return Duration.fromMillis(remainingMillis, opts).shiftTo(...lowerOrderUnits).plus(duration);
    else return duration;
}
const MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function intUnit(regex, post = (i)=>i) {
    return {
        regex,
        deser: ([s])=>post(parseDigits(s))
    };
}
const NBSP = String.fromCharCode(160);
const spaceOrNBSP = `[ ${NBSP}]`;
const spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");
function fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}
function stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace(spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map(fixListRegex).join("|")),
        deser: ([s])=>strings.findIndex((i)=>stripInsensitivities(s) === stripInsensitivities(i)) + startIndex
    };
}
function offset(regex, groups) {
    return {
        regex,
        deser: ([, h, m])=>signedOffset(h, m),
        groups
    };
}
function simple(regex) {
    return {
        regex,
        deser: ([s])=>s
    };
}
function escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
/**
 * @param token
 * @param {Locale} loc
 */ function unitForToken(token, loc) {
    const one = digitRegex(loc), two = digitRegex(loc, "{2}"), three = digitRegex(loc, "{3}"), four = digitRegex(loc, "{4}"), six = digitRegex(loc, "{6}"), oneOrTwo = digitRegex(loc, "{1,2}"), oneToThree = digitRegex(loc, "{1,3}"), oneToSix = digitRegex(loc, "{1,6}"), oneToNine = digitRegex(loc, "{1,9}"), twoToFour = digitRegex(loc, "{2,4}"), fourToSix = digitRegex(loc, "{4,6}"), literal = (t)=>({
            regex: RegExp(escapeToken(t.val)),
            deser: ([s])=>s,
            literal: true
        }), unitate = (t)=>{
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return oneOf(loc.eras("short"), 0);
            case "GG":
                return oneOf(loc.eras("long"), 0);
            // years
            case "y":
                return intUnit(oneToSix);
            case "yy":
                return intUnit(twoToFour, untruncateYear);
            case "yyyy":
                return intUnit(four);
            case "yyyyy":
                return intUnit(fourToSix);
            case "yyyyyy":
                return intUnit(six);
            // months
            case "M":
                return intUnit(oneOrTwo);
            case "MM":
                return intUnit(two);
            case "MMM":
                return oneOf(loc.months("short", true), 1);
            case "MMMM":
                return oneOf(loc.months("long", true), 1);
            case "L":
                return intUnit(oneOrTwo);
            case "LL":
                return intUnit(two);
            case "LLL":
                return oneOf(loc.months("short", false), 1);
            case "LLLL":
                return oneOf(loc.months("long", false), 1);
            // dates
            case "d":
                return intUnit(oneOrTwo);
            case "dd":
                return intUnit(two);
            // ordinals
            case "o":
                return intUnit(oneToThree);
            case "ooo":
                return intUnit(three);
            // time
            case "HH":
                return intUnit(two);
            case "H":
                return intUnit(oneOrTwo);
            case "hh":
                return intUnit(two);
            case "h":
                return intUnit(oneOrTwo);
            case "mm":
                return intUnit(two);
            case "m":
                return intUnit(oneOrTwo);
            case "q":
                return intUnit(oneOrTwo);
            case "qq":
                return intUnit(two);
            case "s":
                return intUnit(oneOrTwo);
            case "ss":
                return intUnit(two);
            case "S":
                return intUnit(oneToThree);
            case "SSS":
                return intUnit(three);
            case "u":
                return simple(oneToNine);
            case "uu":
                return simple(oneOrTwo);
            case "uuu":
                return intUnit(one);
            // meridiem
            case "a":
                return oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return intUnit(four);
            case "kk":
                return intUnit(twoToFour, untruncateYear);
            // weekNumber (W)
            case "W":
                return intUnit(oneOrTwo);
            case "WW":
                return intUnit(two);
            // weekdays
            case "E":
            case "c":
                return intUnit(one);
            case "EEE":
                return oneOf(loc.weekdays("short", false), 1);
            case "EEEE":
                return oneOf(loc.weekdays("long", false), 1);
            case "ccc":
                return oneOf(loc.weekdays("short", true), 1);
            case "cccc":
                return oneOf(loc.weekdays("long", true), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return offset(new RegExp(`([+-]${oneOrTwo.source})(?::(${two.source}))?`), 2);
            case "ZZZ":
                return offset(new RegExp(`([+-]${oneOrTwo.source})(${two.source})?`), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return simple(/[a-z_+-/]{1,256}?/i);
            // this special-case "token" represents a place where a macro-token expanded into a white-space literal
            // in this case we accept any non-newline white-space
            case " ":
                return simple(/[^\S\n\r]/);
            default:
                return literal(t);
        }
    };
    const unit = unitate(token) || {
        invalidReason: MISSING_FTP
    };
    unit.token = token;
    return unit;
}
const partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour12: {
        numeric: "h",
        "2-digit": "hh"
    },
    hour24: {
        numeric: "H",
        "2-digit": "HH"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    },
    timeZoneName: {
        long: "ZZZZZ",
        short: "ZZZ"
    }
};
function tokenForPart(part, formatOpts, resolvedOpts) {
    const { type, value } = part;
    if (type === "literal") {
        const isSpace = /^\s+$/.test(value);
        return {
            literal: !isSpace,
            val: isSpace ? " " : value
        };
    }
    const style = formatOpts[type];
    // The user might have explicitly specified hour12 or hourCycle
    // if so, respect their decision
    // if not, refer back to the resolvedOpts, which are based on the locale
    let actualType = type;
    if (type === "hour") {
        if (formatOpts.hour12 != null) actualType = formatOpts.hour12 ? "hour12" : "hour24";
        else if (formatOpts.hourCycle != null) {
            if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") actualType = "hour12";
            else actualType = "hour24";
        } else // tokens only differentiate between 24 hours or not,
        // so we do not need to check hourCycle here, which is less supported anyways
        actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
    let val = partTypeStyleToTokenVal[actualType];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val
    };
    return undefined;
}
function buildRegex(units) {
    const re = units.map((u)=>u.regex).reduce((f, r)=>`${f}(${r.source})`, "");
    return [
        `^${re}$`,
        units
    ];
}
function match(input, regex, handlers) {
    const matches = input.match(regex);
    if (matches) {
        const all = {};
        let matchIndex = 1;
        for(const i in handlers)if (hasOwnProperty(handlers, i)) {
            const h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function dateTimeFromMatches(matches) {
    const toField = (token)=>{
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    let zone = null;
    let specificOffset;
    if (!isUndefined(matches.z)) zone = IANAZone.create(matches.z);
    if (!isUndefined(matches.Z)) {
        if (!zone) zone = new FixedOffsetZone(matches.Z);
        specificOffset = matches.Z;
    }
    if (!isUndefined(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!isUndefined(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!isUndefined(matches.u)) matches.S = parseMillis(matches.u);
    const vals = Object.keys(matches).reduce((r, k)=>{
        const f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
let dummyDateTimeCache = null;
function getDummyDateTime() {
    if (!dummyDateTimeCache) dummyDateTimeCache = DateTime.fromMillis(1555555555555);
    return dummyDateTimeCache;
}
function maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    const formatOpts = Formatter.macroTokenToFormatOpts(token.val);
    const tokens = formatOptsToTokens(formatOpts, locale);
    if (tokens == null || tokens.includes(undefined)) return token;
    return tokens;
}
function expandMacroTokens(tokens, locale) {
    return Array.prototype.concat(...tokens.map((t)=>maybeExpandMacroToken(t, locale)));
}
/**
 * @private
 */ class TokenParser {
    constructor(locale, format){
        this.locale = locale;
        this.format = format;
        this.tokens = expandMacroTokens(Formatter.parseFormat(format), locale);
        this.units = this.tokens.map((t)=>unitForToken(t, locale));
        this.disqualifyingUnit = this.units.find((t)=>t.invalidReason);
        if (!this.disqualifyingUnit) {
            const [regexString, handlers] = buildRegex(this.units);
            this.regex = RegExp(regexString, "i");
            this.handlers = handlers;
        }
    }
    explainFromTokens(input) {
        if (!this.isValid) return {
            input,
            tokens: this.tokens,
            invalidReason: this.invalidReason
        };
        else {
            const [rawMatches, matches] = match(input, this.regex, this.handlers), [result, zone, specificOffset] = matches ? dateTimeFromMatches(matches) : [
                null,
                null,
                undefined
            ];
            if (hasOwnProperty(matches, "a") && hasOwnProperty(matches, "H")) throw new ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
            return {
                input,
                tokens: this.tokens,
                regex: this.regex,
                rawMatches,
                matches,
                result,
                zone,
                specificOffset
            };
        }
    }
    get isValid() {
        return !this.disqualifyingUnit;
    }
    get invalidReason() {
        return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
    }
}
function explainFromTokens(locale, input, format) {
    const parser = new TokenParser(locale, format);
    return parser.explainFromTokens(input);
}
function parseFromTokens(locale, input, format) {
    const { result, zone, specificOffset, invalidReason } = explainFromTokens(locale, input, format);
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}
function formatOptsToTokens(formatOpts, locale) {
    if (!formatOpts) return null;
    const formatter = Formatter.create(locale, formatOpts);
    const df = formatter.dtFormatter(getDummyDateTime());
    const parts = df.formatToParts();
    const resolvedOpts = df.resolvedOptions();
    return parts.map((p)=>tokenForPart(p, formatOpts, resolvedOpts));
}
const INVALID = "Invalid DateTime";
const MAX_DATE = 8.64e15;
function unsupportedZone(zone) {
    return new Invalid("unsupported zone", `the zone "${zone.name}" is not supported`);
}
// we cache week data on the DT object and this intermediates the cache
/**
 * @param {DateTime} dt
 */ function possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = gregorianToWeek(dt.c);
    return dt.weekData;
}
/**
 * @param {DateTime} dt
 */ function possiblyCachedLocalWeekData(dt) {
    if (dt.localWeekData === null) dt.localWeekData = gregorianToWeek(dt.c, dt.loc.getMinDaysInFirstWeek(), dt.loc.getStartOfWeek());
    return dt.localWeekData;
}
// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function clone(inst, alts) {
    const current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new DateTime({
        ...current,
        ...alts,
        old: current
    });
}
// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    let utcGuess = localTS - o * 60000;
    // Test whether the zone matches the offset for this ts
    const o2 = tz.offset(utcGuess);
    // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
    // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000;
    // If that gives us the local time we want, we're done
    const o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
    // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
}
// convert an epoch timestamp into a calendar object with the given offset
function tsToObj(ts, offset) {
    ts += offset * 60000;
    const d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
}
// convert a calendar object to a epoch timestamp
function objToTS(obj, offset, zone) {
    return fixOffset(objToLocalTS(obj), offset, zone);
}
// create a new DT instance by adding a duration, adjusting for DSTs
function adjustTime(inst, dur) {
    const oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = {
        ...inst.c,
        year,
        month,
        day: Math.min(inst.c.day, daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }, millisToAdd = Duration.fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = objToLocalTS(c);
    let [ts, o] = fixOffset(localTS, oPre, inst.zone);
    if (millisToAdd !== 0) {
        ts += millisToAdd;
        // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts,
        o
    };
}
// helper useful in turning the results of parsing into real dates
// by handling the zone options
function parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    const { setZone, zone } = opts;
    if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
        const interpretationZone = parsedZone || zone, inst = DateTime.fromObject(parsed, {
            ...opts,
            zone: interpretationZone,
            specificOffset
        });
        return setZone ? inst : inst.setZone(zone);
    } else return DateTime.invalid(new Invalid("unparsable", `the input "${text}" can't be parsed as ${format}`));
}
// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function toTechFormat(dt, format, allowZ = true) {
    return dt.isValid ? Formatter.create(Locale.create("en-US"), {
        allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function toISODate(o, extended, precision) {
    const longFormat = o.c.year > 9999 || o.c.year < 0;
    let c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += padStart(o.c.year, longFormat ? 6 : 4);
    if (precision === "year") return c;
    if (extended) {
        c += "-";
        c += padStart(o.c.month);
        if (precision === "month") return c;
        c += "-";
    } else {
        c += padStart(o.c.month);
        if (precision === "month") return c;
    }
    c += padStart(o.c.day);
    return c;
}
function toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision) {
    let showSeconds = !suppressSeconds || o.c.millisecond !== 0 || o.c.second !== 0, c = "";
    switch(precision){
        case "day":
        case "month":
        case "year":
            break;
        default:
            c += padStart(o.c.hour);
            if (precision === "hour") break;
            if (extended) {
                c += ":";
                c += padStart(o.c.minute);
                if (precision === "minute") break;
                if (showSeconds) {
                    c += ":";
                    c += padStart(o.c.second);
                }
            } else {
                c += padStart(o.c.minute);
                if (precision === "minute") break;
                if (showSeconds) c += padStart(o.c.second);
            }
            if (precision === "second") break;
            if (showSeconds && (!suppressMilliseconds || o.c.millisecond !== 0)) {
                c += ".";
                c += padStart(o.c.millisecond, 3);
            }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0 && !extendedZone) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += padStart(Math.trunc(-o.o / 60));
            c += ":";
            c += padStart(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += padStart(Math.trunc(o.o / 60));
            c += ":";
            c += padStart(Math.trunc(o.o % 60));
        }
    }
    if (extendedZone) c += "[" + o.zone.ianaName + "]";
    return c;
}
// defaults for unspecified units in the supported calendars
const defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
};
// Units in the supported calendars, sorted by bigness
const orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
];
// standardize case and plurality in units
function normalizeUnit(unit) {
    const normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new InvalidUnitError(unit);
    return normalized;
}
function normalizeUnitWithLocalWeeks(unit) {
    switch(unit.toLowerCase()){
        case "localweekday":
        case "localweekdays":
            return "localWeekday";
        case "localweeknumber":
        case "localweeknumbers":
            return "localWeekNumber";
        case "localweekyear":
        case "localweekyears":
            return "localWeekYear";
        default:
            return normalizeUnit(unit);
    }
}
// cache offsets for zones based on the current timestamp when this function is
// first called. When we are handling a datetime from components like (year,
// month, day, hour) in a time zone, we need a guess about what the timezone
// offset is so that we can convert into a UTC timestamp. One way is to find the
// offset of now in the zone. The actual date may have a different offset (for
// example, if we handle a date in June while we're in December in a zone that
// observes DST), but we can check and adjust that.
//
// When handling many dates, calculating the offset for now every time is
// expensive. It's just a guess, so we can cache the offset to use even if we
// are right on a time change boundary (we'll just correct in the other
// direction). Using a timestamp from first read is a slight optimization for
// handling dates close to the current date, since those dates will usually be
// in the same offset (we could set the timestamp statically, instead). We use a
// single timestamp for all zones to make things a bit more predictable.
//
// This is safe for quickDT (used by local() and utc()) because we don't fill in
// higher-order units from tsNow (as we do in fromObject, this requires that
// offset is calculated from tsNow).
/**
 * @param {Zone} zone
 * @return {number}
 */ function guessOffsetForZone(zone) {
    if (zoneOffsetTs === undefined) zoneOffsetTs = Settings.now();
    // Do not cache anything but IANA zones, because it is not safe to do so.
    // Guessing an offset which is not present in the zone can cause wrong results from fixOffset
    if (zone.type !== "iana") return zone.offset(zoneOffsetTs);
    const zoneName = zone.name;
    let offsetGuess = zoneOffsetGuessCache.get(zoneName);
    if (offsetGuess === undefined) {
        offsetGuess = zone.offset(zoneOffsetTs);
        zoneOffsetGuessCache.set(zoneName, offsetGuess);
    }
    return offsetGuess;
}
// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function quickDT(obj, opts) {
    const zone = normalizeZone(opts.zone, Settings.defaultZone);
    if (!zone.isValid) return DateTime.invalid(unsupportedZone(zone));
    const loc = Locale.fromObject(opts);
    let ts, o;
    // assume we have the higher-order units
    if (!isUndefined(obj.year)) {
        for (const u of orderedUnits)if (isUndefined(obj[u])) obj[u] = defaultUnitValues[u];
        const invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
        if (invalid) return DateTime.invalid(invalid);
        const offsetProvis = guessOffsetForZone(zone);
        [ts, o] = objToTS(obj, offsetProvis, zone);
    } else ts = Settings.now();
    return new DateTime({
        ts,
        zone,
        loc,
        o
    });
}
function diffRelative(start, end, opts) {
    const round = isUndefined(opts.round) ? true : opts.round, rounding = isUndefined(opts.rounding) ? "trunc" : opts.rounding, format = (c, unit)=>{
        c = roundTo(c, round || opts.calendary ? 0 : 2, opts.calendary ? "round" : rounding);
        const formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = (unit)=>{
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for (const unit of opts.units){
        const count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function lastOpts(argList) {
    let opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
/**
 * Timestamp to use for cached zone offset guesses (exposed for test)
 */ let zoneOffsetTs;
/**
 * Cache for zone offset guesses (exposed for test).
 *
 * This optimizes quickDT via guessOffsetForZone to avoid repeated calls of
 * zone.offset().
 */ const zoneOffsetGuessCache = new Map();
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */ class DateTime {
    /**
   * @access private
   */ constructor(config){
        const zone = config.zone || Settings.defaultZone;
        let invalid = config.invalid || (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) || (!zone.isValid ? unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;
        let c = null, o = null;
        if (!invalid) {
            const unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) [c, o] = [
                config.old.c,
                config.old.o
            ];
            else {
                // If an offset has been passed and we have not been called from
                // clone(), we can trust it and avoid the offset calculation.
                const ot = isNumber(config.o) && !config.old ? config.o : zone.offset(this.ts);
                c = tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new Invalid("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || Locale.create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.localWeekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    }
    // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ static now() {
        return new DateTime({});
    }
    /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */ static local() {
        const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
        return quickDT({
            year,
            month,
            day,
            hour,
            minute,
            second,
            millisecond
        }, opts);
    }
    /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */ static utc() {
        const [opts, args] = lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
        opts.zone = FixedOffsetZone.utcInstance;
        return quickDT({
            year,
            month,
            day,
            hour,
            minute,
            second,
            millisecond
        }, opts);
    }
    /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */ static fromJSDate(date, options = {}) {
        const ts = isDate(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return DateTime.invalid("invalid input");
        const zoneToUse = normalizeZone(options.zone, Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid(unsupportedZone(zoneToUse));
        return new DateTime({
            ts: ts,
            zone: zoneToUse,
            loc: Locale.fromObject(options)
        });
    }
    /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */ static fromMillis(milliseconds, options = {}) {
        if (!isNumber(milliseconds)) throw new InvalidArgumentError(`fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`);
        else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) // this isn't perfect because we can still end up out of range because of additional shifting, but it's a start
        return DateTime.invalid("Timestamp out of range");
        else return new DateTime({
            ts: milliseconds,
            zone: normalizeZone(options.zone, Settings.defaultZone),
            loc: Locale.fromObject(options)
        });
    }
    /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */ static fromSeconds(seconds, options = {}) {
        if (!isNumber(seconds)) throw new InvalidArgumentError("fromSeconds requires a numerical input");
        else return new DateTime({
            ts: seconds * 1000,
            zone: normalizeZone(options.zone, Settings.defaultZone),
            loc: Locale.fromObject(options)
        });
    }
    /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */ static fromObject(obj, opts = {}) {
        obj = obj || {};
        const zoneToUse = normalizeZone(opts.zone, Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid(unsupportedZone(zoneToUse));
        const loc = Locale.fromObject(opts);
        const normalized = normalizeObject(obj, normalizeUnitWithLocalWeeks);
        const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, loc);
        const tsNow = Settings.now(), offsetProvis = !isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        const useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
        // configure ourselves to deal with gregorian dates or week stuff
        let units, defaultValues, objNow = tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = orderedWeekUnits;
            defaultValues = defaultWeekUnitValues;
            objNow = gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
        } else if (containsOrdinal) {
            units = orderedOrdinalUnits;
            defaultValues = defaultOrdinalUnitValues;
            objNow = gregorianToOrdinal(objNow);
        } else {
            units = orderedUnits;
            defaultValues = defaultUnitValues;
        }
        // set default values for missing stuff
        let foundFirst = false;
        for (const u of units){
            const v = normalized[u];
            if (!isUndefined(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        }
        // make sure the values we have are in range
        const higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || hasInvalidTimeData(normalized);
        if (invalid) return DateTime.invalid(invalid);
        // compute the actual time
        const gregorian = useWeekData ? weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? ordinalToGregorian(normalized) : normalized, [tsFinal, offsetFinal] = objToTS(gregorian, offsetProvis, zoneToUse), inst = new DateTime({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc
        });
        // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return DateTime.invalid("mismatched weekday", `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`);
        if (!inst.isValid) return DateTime.invalid(inst.invalid);
        return inst;
    }
    /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */ static fromISO(text, opts = {}) {
        const [vals, parsedZone] = parseISODate(text);
        return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    }
    /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */ static fromRFC2822(text, opts = {}) {
        const [vals, parsedZone] = parseRFC2822Date(text);
        return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    }
    /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */ static fromHTTP(text, opts = {}) {
        const [vals, parsedZone] = parseHTTPDate(text);
        return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    }
    /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */ static fromFormat(text, fmt, opts = {}) {
        if (isUndefined(text) || isUndefined(fmt)) throw new InvalidArgumentError("fromFormat requires an input string and a format");
        const { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({
            locale,
            numberingSystem,
            defaultToEN: true
        }), [vals, parsedZone, specificOffset, invalid] = parseFromTokens(localeToUse, text, fmt);
        if (invalid) return DateTime.invalid(invalid);
        else return parseDataToDateTime(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
    }
    /**
   * @deprecated use fromFormat instead
   */ static fromString(text, fmt, opts = {}) {
        return DateTime.fromFormat(text, fmt, opts);
    }
    /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */ static fromSQL(text, opts = {}) {
        const [vals, parsedZone] = parseSQL(text);
        return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    }
    /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */ static invalid(reason, explanation = null) {
        if (!reason) throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
        const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
        if (Settings.throwOnInvalid) throw new InvalidDateTimeError(invalid);
        else return new DateTime({
            invalid
        });
    }
    /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ static isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    }
    /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */ static parseFormatForOpts(formatOpts, localeOpts = {}) {
        const tokenList = formatOptsToTokens(formatOpts, Locale.fromObject(localeOpts));
        return !tokenList ? null : tokenList.map((t)=>t ? t.val : null).join("");
    }
    /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */ static expandFormat(fmt, localeOpts = {}) {
        const expanded = expandMacroTokens(Formatter.parseFormat(fmt), Locale.fromObject(localeOpts));
        return expanded.map((t)=>t.val).join("");
    }
    static resetCache() {
        zoneOffsetTs = undefined;
        zoneOffsetGuessCache.clear();
    }
    // INFO
    /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */ get(unit) {
        return this[unit];
    }
    /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */ get isValid() {
        return this.invalid === null;
    }
    /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */ get invalidReason() {
        return this.invalid ? this.invalid.reason : null;
    }
    /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */ get invalidExplanation() {
        return this.invalid ? this.invalid.explanation : null;
    }
    /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */ get locale() {
        return this.isValid ? this.loc.locale : null;
    }
    /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */ get numberingSystem() {
        return this.isValid ? this.loc.numberingSystem : null;
    }
    /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */ get outputCalendar() {
        return this.isValid ? this.loc.outputCalendar : null;
    }
    /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */ get zone() {
        return this._zone;
    }
    /**
   * Get the name of the time zone.
   * @type {string}
   */ get zoneName() {
        return this.isValid ? this.zone.name : null;
    }
    /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */ get year() {
        return this.isValid ? this.c.year : NaN;
    }
    /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */ get quarter() {
        return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
    }
    /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */ get month() {
        return this.isValid ? this.c.month : NaN;
    }
    /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */ get day() {
        return this.isValid ? this.c.day : NaN;
    }
    /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */ get hour() {
        return this.isValid ? this.c.hour : NaN;
    }
    /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */ get minute() {
        return this.isValid ? this.c.minute : NaN;
    }
    /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */ get second() {
        return this.isValid ? this.c.second : NaN;
    }
    /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */ get millisecond() {
        return this.isValid ? this.c.millisecond : NaN;
    }
    /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */ get weekYear() {
        return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
    }
    /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */ get weekNumber() {
        return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
    }
    /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */ get weekday() {
        return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
    }
    /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */ get isWeekend() {
        return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
    }
    /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */ get localWeekday() {
        return this.isValid ? possiblyCachedLocalWeekData(this).weekday : NaN;
    }
    /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */ get localWeekNumber() {
        return this.isValid ? possiblyCachedLocalWeekData(this).weekNumber : NaN;
    }
    /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */ get localWeekYear() {
        return this.isValid ? possiblyCachedLocalWeekData(this).weekYear : NaN;
    }
    /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */ get ordinal() {
        return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
    }
    /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */ get monthShort() {
        return this.isValid ? Info.months("short", {
            locObj: this.loc
        })[this.month - 1] : null;
    }
    /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */ get monthLong() {
        return this.isValid ? Info.months("long", {
            locObj: this.loc
        })[this.month - 1] : null;
    }
    /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */ get weekdayShort() {
        return this.isValid ? Info.weekdays("short", {
            locObj: this.loc
        })[this.weekday - 1] : null;
    }
    /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */ get weekdayLong() {
        return this.isValid ? Info.weekdays("long", {
            locObj: this.loc
        })[this.weekday - 1] : null;
    }
    /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */ get offset() {
        return this.isValid ? +this.o : NaN;
    }
    /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */ get offsetNameShort() {
        if (this.isValid) return this.zone.offsetName(this.ts, {
            format: "short",
            locale: this.locale
        });
        else return null;
    }
    /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */ get offsetNameLong() {
        if (this.isValid) return this.zone.offsetName(this.ts, {
            format: "long",
            locale: this.locale
        });
        else return null;
    }
    /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */ get isOffsetFixed() {
        return this.isValid ? this.zone.isUniversal : null;
    }
    /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */ get isInDST() {
        if (this.isOffsetFixed) return false;
        else return this.offset > this.set({
            month: 1,
            day: 1
        }).offset || this.offset > this.set({
            month: 5
        }).offset;
    }
    /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */ getPossibleOffsets() {
        if (!this.isValid || this.isOffsetFixed) return [
            this
        ];
        const dayMs = 86400000;
        const minuteMs = 60000;
        const localTS = objToLocalTS(this.c);
        const oEarlier = this.zone.offset(localTS - dayMs);
        const oLater = this.zone.offset(localTS + dayMs);
        const o1 = this.zone.offset(localTS - oEarlier * minuteMs);
        const o2 = this.zone.offset(localTS - oLater * minuteMs);
        if (o1 === o2) return [
            this
        ];
        const ts1 = localTS - o1 * minuteMs;
        const ts2 = localTS - o2 * minuteMs;
        const c1 = tsToObj(ts1, o1);
        const c2 = tsToObj(ts2, o2);
        if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) return [
            clone(this, {
                ts: ts1
            }),
            clone(this, {
                ts: ts2
            })
        ];
        return [
            this
        ];
    }
    /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */ get isInLeapYear() {
        return isLeapYear(this.year);
    }
    /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */ get daysInMonth() {
        return daysInMonth(this.year, this.month);
    }
    /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */ get daysInYear() {
        return this.isValid ? daysInYear(this.year) : NaN;
    }
    /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */ get weeksInWeekYear() {
        return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
    }
    /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */ get weeksInLocalWeekYear() {
        return this.isValid ? weeksInWeekYear(this.localWeekYear, this.loc.getMinDaysInFirstWeek(), this.loc.getStartOfWeek()) : NaN;
    }
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ resolvedLocaleOptions(opts = {}) {
        const { locale, numberingSystem, calendar } = Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this);
        return {
            locale,
            numberingSystem,
            outputCalendar: calendar
        };
    }
    // TRANSFORM
    /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */ toUTC(offset = 0, opts = {}) {
        return this.setZone(FixedOffsetZone.instance(offset), opts);
    }
    /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */ toLocal() {
        return this.setZone(Settings.defaultZone);
    }
    /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */ setZone(zone, { keepLocalTime = false, keepCalendarTime = false } = {}) {
        zone = normalizeZone(zone, Settings.defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return DateTime.invalid(unsupportedZone(zone));
        else {
            let newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                const offsetGuess = zone.offset(this.ts);
                const asObj = this.toObject();
                [newTS] = objToTS(asObj, offsetGuess, zone);
            }
            return clone(this, {
                ts: newTS,
                zone
            });
        }
    }
    /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */ reconfigure({ locale, numberingSystem, outputCalendar } = {}) {
        const loc = this.loc.clone({
            locale,
            numberingSystem,
            outputCalendar
        });
        return clone(this, {
            loc
        });
    }
    /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */ setLocale(locale) {
        return this.reconfigure({
            locale
        });
    }
    /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */ set(values) {
        if (!this.isValid) return this;
        const normalized = normalizeObject(values, normalizeUnitWithLocalWeeks);
        const { minDaysInFirstWeek, startOfWeek } = usesLocalWeekValues(normalized, this.loc);
        const settingWeekStuff = !isUndefined(normalized.weekYear) || !isUndefined(normalized.weekNumber) || !isUndefined(normalized.weekday), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        let mixed;
        if (settingWeekStuff) mixed = weekToGregorian({
            ...gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek),
            ...normalized
        }, minDaysInFirstWeek, startOfWeek);
        else if (!isUndefined(normalized.ordinal)) mixed = ordinalToGregorian({
            ...gregorianToOrdinal(this.c),
            ...normalized
        });
        else {
            mixed = {
                ...this.toObject(),
                ...normalized
            };
            // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if (isUndefined(normalized.day)) mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
        }
        const [ts, o] = objToTS(mixed, this.o, this.zone);
        return clone(this, {
            ts,
            o
        });
    }
    /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */ plus(duration) {
        if (!this.isValid) return this;
        const dur = Duration.fromDurationLike(duration);
        return clone(this, adjustTime(this, dur));
    }
    /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */ minus(duration) {
        if (!this.isValid) return this;
        const dur = Duration.fromDurationLike(duration).negate();
        return clone(this, adjustTime(this, dur));
    }
    /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */ startOf(unit, { useLocaleWeeks = false } = {}) {
        if (!this.isValid) return this;
        const o = {}, normalizedUnit = Duration.normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
        }
        if (normalizedUnit === "weeks") {
            if (useLocaleWeeks) {
                const startOfWeek = this.loc.getStartOfWeek();
                const { weekday } = this;
                if (weekday < startOfWeek) o.weekNumber = this.weekNumber - 1;
                o.weekday = startOfWeek;
            } else o.weekday = 1;
        }
        if (normalizedUnit === "quarters") {
            const q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    }
    /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */ endOf(unit, opts) {
        return this.isValid ? this.plus({
            [unit]: 1
        }).startOf(unit, opts).minus(1) : this;
    }
    // OUTPUT
    /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */ toFormat(fmt, opts = {}) {
        return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID;
    }
    /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */ toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
        return this.isValid ? Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : INVALID;
    }
    /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */ toLocaleParts(opts = {}) {
        return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    }
    /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'years', 'months', 'days', 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @example DateTime.now().toISO({ precision: 'day' }) //=> '2017-04-22Z'
   * @example DateTime.now().toISO({ precision: 'minute' }) //=> '2017-04-22T20:47Z'
   * @return {string|null}
   */ toISO({ format = "extended", suppressSeconds = false, suppressMilliseconds = false, includeOffset = true, extendedZone = false, precision = "milliseconds" } = {}) {
        if (!this.isValid) return null;
        precision = normalizeUnit(precision);
        const ext = format === "extended";
        let c = toISODate(this, ext, precision);
        if (orderedUnits.indexOf(precision) >= 3) c += "T";
        c += toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision);
        return c;
    }
    /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='day'] - truncate output to desired precision: 'years', 'months', or 'days'.
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @example DateTime.utc(1982, 5, 25).toISODate({ precision: 'month' }) //=> '1982-05'
   * @return {string|null}
   */ toISODate({ format = "extended", precision = "day" } = {}) {
        if (!this.isValid) return null;
        return toISODate(this, format === "extended", normalizeUnit(precision));
    }
    /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */ toISOWeekDate() {
        return toTechFormat(this, "kkkk-'W'WW-c");
    }
    /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @param {string} [opts.precision='milliseconds'] - truncate output to desired presicion: 'hours', 'minutes', 'seconds' or 'milliseconds'. When precision and suppressSeconds or suppressMilliseconds are used together, precision sets the maximum unit shown in the output, however seconds or milliseconds will still be suppressed if they are 0.
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, second: 56 }).toISOTime({ precision: 'minute' }) //=> '07:34Z'
   * @return {string}
   */ toISOTime({ suppressMilliseconds = false, suppressSeconds = false, includeOffset = true, includePrefix = false, extendedZone = false, format = "extended", precision = "milliseconds" } = {}) {
        if (!this.isValid) return null;
        precision = normalizeUnit(precision);
        let c = includePrefix && orderedUnits.indexOf(precision) >= 3 ? "T" : "";
        return c + toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision);
    }
    /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */ toRFC2822() {
        return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    }
    /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */ toHTTP() {
        return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    }
    /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string|null}
   */ toSQLDate() {
        if (!this.isValid) return null;
        return toISODate(this, true);
    }
    /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */ toSQLTime({ includeOffset = true, includeZone = false, includeOffsetSpace = true } = {}) {
        let fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return toTechFormat(this, fmt, true);
    }
    /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */ toSQL(opts = {}) {
        if (!this.isValid) return null;
        return `${this.toSQLDate()} ${this.toSQLTime(opts)}`;
    }
    /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */ toString() {
        return this.isValid ? this.toISO() : INVALID;
    }
    /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */ [Symbol.for("nodejs.util.inspect.custom")]() {
        if (this.isValid) return `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }`;
        else return `DateTime { Invalid, reason: ${this.invalidReason} }`;
    }
    /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */ valueOf() {
        return this.toMillis();
    }
    /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */ toMillis() {
        return this.isValid ? this.ts : NaN;
    }
    /**
   * Returns the epoch seconds (including milliseconds in the fractional part) of this DateTime.
   * @return {number}
   */ toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    }
    /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */ toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    }
    /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */ toJSON() {
        return this.toISO();
    }
    /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */ toBSON() {
        return this.toJSDate();
    }
    /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */ toObject(opts = {}) {
        if (!this.isValid) return {};
        const base = {
            ...this.c
        };
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    }
    /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */ toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    }
    // COMPARE
    /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */ diff(otherDateTime, unit = "milliseconds", opts = {}) {
        if (!this.isValid || !otherDateTime.isValid) return Duration.invalid("created by diffing an invalid DateTime");
        const durOpts = {
            locale: this.locale,
            numberingSystem: this.numberingSystem,
            ...opts
        };
        const units = maybeArray(unit).map(Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = diff(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    }
    /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ diffNow(unit = "milliseconds", opts = {}) {
        return this.diff(DateTime.now(), unit, opts);
    }
    /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval|DateTime}
   */ until(otherDateTime) {
        return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
    }
    /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */ hasSame(otherDateTime, unit, opts) {
        if (!this.isValid) return false;
        const inputMs = otherDateTime.valueOf();
        const adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
    }
    /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */ equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    }
    /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds towards zero by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {string} [options.rounding="trunc"] - rounding method to use when rounding the numbers in the output. Can be "trunc" (toward zero), "expand" (away from zero), "round", "floor", or "ceil".
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */ toRelative(options = {}) {
        if (!this.isValid) return null;
        const base = options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        let units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        let unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return diffRelative(base, this.plus(padding), {
            ...options,
            numeric: "always",
            units,
            unit
        });
    }
    /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */ toRelativeCalendar(options = {}) {
        if (!this.isValid) return null;
        return diffRelative(options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), this, {
            ...options,
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        });
    }
    /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */ static min(...dateTimes) {
        if (!dateTimes.every(DateTime.isDateTime)) throw new InvalidArgumentError("min requires all arguments be DateTimes");
        return bestBy(dateTimes, (i)=>i.valueOf(), Math.min);
    }
    /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */ static max(...dateTimes) {
        if (!dateTimes.every(DateTime.isDateTime)) throw new InvalidArgumentError("max requires all arguments be DateTimes");
        return bestBy(dateTimes, (i)=>i.valueOf(), Math.max);
    }
    // MISC
    /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */ static fromFormatExplain(text, fmt, options = {}) {
        const { locale = null, numberingSystem = null } = options, localeToUse = Locale.fromOpts({
            locale,
            numberingSystem,
            defaultToEN: true
        });
        return explainFromTokens(localeToUse, text, fmt);
    }
    /**
   * @deprecated use fromFormatExplain instead
   */ static fromStringExplain(text, fmt, options = {}) {
        return DateTime.fromFormatExplain(text, fmt, options);
    }
    /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */ static buildFormatParser(fmt, options = {}) {
        const { locale = null, numberingSystem = null } = options, localeToUse = Locale.fromOpts({
            locale,
            numberingSystem,
            defaultToEN: true
        });
        return new TokenParser(localeToUse, fmt);
    }
    /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */ static fromFormatParser(text, formatParser, opts = {}) {
        if (isUndefined(text) || isUndefined(formatParser)) throw new InvalidArgumentError("fromFormatParser requires an input string and a format parser");
        const { locale = null, numberingSystem = null } = opts, localeToUse = Locale.fromOpts({
            locale,
            numberingSystem,
            defaultToEN: true
        });
        if (!localeToUse.equals(formatParser.locale)) throw new InvalidArgumentError(`fromFormatParser called with a locale of ${localeToUse}, ` + `but the format parser was created for ${formatParser.locale}`);
        const { result, zone, specificOffset, invalidReason } = formatParser.explainFromTokens(text);
        if (invalidReason) return DateTime.invalid(invalidReason);
        else return parseDataToDateTime(result, zone, opts, `format ${formatParser.format}`, text, specificOffset);
    }
    // FORMAT PRESETS
    /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */ static get DATE_SHORT() {
        return DATE_SHORT;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */ static get DATE_MED() {
        return DATE_MED;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */ static get DATE_MED_WITH_WEEKDAY() {
        return DATE_MED_WITH_WEEKDAY;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */ static get DATE_FULL() {
        return DATE_FULL;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */ static get DATE_HUGE() {
        return DATE_HUGE;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get TIME_SIMPLE() {
        return TIME_SIMPLE;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get TIME_WITH_SECONDS() {
        return TIME_WITH_SECONDS;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get TIME_WITH_SHORT_OFFSET() {
        return TIME_WITH_SHORT_OFFSET;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get TIME_WITH_LONG_OFFSET() {
        return TIME_WITH_LONG_OFFSET;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */ static get TIME_24_SIMPLE() {
        return TIME_24_SIMPLE;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */ static get TIME_24_WITH_SECONDS() {
        return TIME_24_WITH_SECONDS;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */ static get TIME_24_WITH_SHORT_OFFSET() {
        return TIME_24_WITH_SHORT_OFFSET;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */ static get TIME_24_WITH_LONG_OFFSET() {
        return TIME_24_WITH_LONG_OFFSET;
    }
    /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_SHORT() {
        return DATETIME_SHORT;
    }
    /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_SHORT_WITH_SECONDS() {
        return DATETIME_SHORT_WITH_SECONDS;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_MED() {
        return DATETIME_MED;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_MED_WITH_SECONDS() {
        return DATETIME_MED_WITH_SECONDS;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_MED_WITH_WEEKDAY() {
        return DATETIME_MED_WITH_WEEKDAY;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_FULL() {
        return DATETIME_FULL;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_FULL_WITH_SECONDS() {
        return DATETIME_FULL_WITH_SECONDS;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_HUGE() {
        return DATETIME_HUGE;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_HUGE_WITH_SECONDS() {
        return DATETIME_HUGE_WITH_SECONDS;
    }
}
/**
 * @private
 */ function friendlyDateTime(dateTimeish) {
    if (DateTime.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) return DateTime.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return DateTime.fromObject(dateTimeish);
    else throw new InvalidArgumentError(`Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`);
}
const VERSION = "3.7.2";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"76s4u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addLatLongControl", ()=>addLatLongControl);
var _proj = require("ol/proj");
var _latLongControl = require("../controls/LatLongControl");
function addLatLongControl(map, view, target) {
    const latLongControl = new (0, _latLongControl.LatLongControl)(view, {
        target: target
    });
    view.on("change:center", (event)=>{
        const lonLatCenter = (0, _proj.toLonLat)(event.target.getCenter(), event.target.getProjection());
        latLongControl.set("latLong", `${lonLatCenter[1].toFixed(7)}, ${lonLatCenter[0].toFixed(7)}`);
    });
    map.addControl(latLongControl);
}

},{"ol/proj":"gN0IK","../controls/LatLongControl":"2xqhH","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2xqhH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LatLongControl", ()=>LatLongControl);
var _control = require("ol/control/Control");
var _controlDefault = parcelHelpers.interopDefault(_control);
var _proj = require("ol/proj");
class LatLongControl extends (0, _controlDefault.default) {
    constructor(view, opt_options){
        const options = opt_options || {};
        const element = document.createElement("ul");
        super({
            element: element,
            target: options.target
        });
        const this_ = this;
        element.className = "lat-long-input ol-unselectable";
        const latLongInput = document.createElement("input");
        element.appendChild(latLongInput);
        const swapBtn = document.createElement("button");
        swapBtn.type = "button";
        swapBtn.className = "swap-coords-btn";
        swapBtn.textContent = "\u21C4";
        swapBtn.title = "Swap coordinate order and recenter";
        swapBtn.addEventListener("click", ()=>{
            const val = latLongInput.value;
            const match = val.match(/^\s*(-?\d*(?:\.\d+)?)\s*([,\s])\s*(-?\d*(?:\.\d+)?)\s*$/);
            if (!match) return;
            const sep = match[2] === "," ? ", " : " ";
            const newLat = Number(match[3]);
            const newLon = Number(match[1]);
            latLongInput.value = match[3] + sep + match[1];
            if (Number.isFinite(newLat) && Number.isFinite(newLon)) view.setCenter((0, _proj.transform)([
                newLon,
                newLat
            ], "EPSG:4326", "EPSG:3857"));
        });
        element.appendChild(swapBtn);
        const cajBtn = document.createElement("button");
        cajBtn.type = "button";
        cajBtn.className = "caj-nav-btn";
        cajBtn.style.marginLeft = "auto";
        cajBtn.textContent = "CaJ";
        cajBtn.title = "Open this view in the CaJ editor";
        cajBtn.addEventListener("click", ()=>{
            const center = view.getCenter();
            const zoom = view.getZoom();
            if (!center || zoom == null) return;
            const [lon, lat] = (0, _proj.toLonLat)(center);
            const params = new URLSearchParams();
            params.set("center", `${lon.toFixed(6)},${lat.toFixed(6)}`);
            params.set("zoom", zoom.toFixed(4));
            // APIM serves /caj-editor from the caj-editor.html blob; the Parcel
            // dev server doesn't do that stripping, so fall back to the extension
            // locally.
            const path = window.location.hostname === "localhost" ? "caj-editor.html" : "/caj-editor";
            window.location.href = `${path}?${params.toString()}`;
        });
        element.appendChild(cajBtn);
        const vertexBtn = document.createElement("button");
        vertexBtn.type = "button";
        vertexBtn.className = "caj-nav-btn";
        vertexBtn.textContent = "Vertex";
        vertexBtn.title = "Open this view in Vertex";
        vertexBtn.addEventListener("click", ()=>{
            const center = view.getCenter();
            const zoom = view.getZoom();
            if (!center || zoom == null) return;
            const [lon, lat] = (0, _proj.toLonLat)(center);
            window.open(`https://orbis.vertex.tomtom.com/#map=${zoom.toFixed(2)}/${lat.toFixed(6)}/${lon.toFixed(6)}`, "_blank", "noopener,noreferrer");
        });
        element.appendChild(vertexBtn);
        const ndsBtn = document.createElement("button");
        ndsBtn.type = "button";
        ndsBtn.className = "caj-nav-btn";
        ndsBtn.textContent = "NDS";
        ndsBtn.title = "Open this view in NDS.live viewer";
        ndsBtn.addEventListener("click", ()=>{
            const center = view.getCenter();
            const zoom = view.getZoom();
            if (!center || zoom == null) return;
            const [lon, lat] = (0, _proj.toLonLat)(center);
            // Calibrated from two data points: zoom 10→alt 185697, zoom 19→alt 226
            const alt = Math.round(Math.exp(19.59 - 0.746 * zoom));
            const params = new URLSearchParams();
            params.set("lon", lon.toFixed(6));
            params.set("lat", lat.toFixed(6));
            params.set("alt", alt);
            params.set("m2d", "1");
            window.open(`https://mapviewer.delivery-umd-acc.maps.az.tt3.com/?${params.toString()}`, "_blank", "noopener,noreferrer");
        });
        element.appendChild(ndsBtn);
        latLongInput.addEventListener("keyup", function(event) {
            if (event.code === "Enter") {
                let pattern = new RegExp("^\\s*-?\\d*(?:\\.\\d+)?\\s*([,\\s])\\s*-?\\d*(?:\\.\\d+)?\\s*$", "m");
                let inputValue = latLongInput.value;
                if (pattern.test(inputValue)) {
                    let delimiter = inputValue.match(pattern)[1];
                    let [lat, ...long] = inputValue.trimStart().split(delimiter);
                    let latLong = [
                        lat,
                        long.join("")
                    ].map(Number);
                    view.setCenter((0, _proj.transform)([
                        latLong[1],
                        latLong[0]
                    ], "EPSG:4326", "EPSG:3857"));
                    view.setZoom(20);
                } else {
                    alert("Please enter latlong in format: lat, long");
                    latLongInput.focus();
                }
            }
        });
        // listen to changes
        this.on("propertychange", ()=>{
            latLongInput.value = this_.get("latLong");
        });
    }
}

},{"ol/control/Control":"8KSMn","ol/proj":"gN0IK","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9IQmt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addBoundaryCodesControl", ()=>addBoundaryCodesControl);
var _proj = require("ol/proj");
var _boundaryCodesControl = require("../controls/BoundaryCodesControl");
async function fetchBoundaryCodes(lon, lat, idToken) {
    const url = `${"/boundary-codes-prod"}?lon=${lon}&lat=${lat}`;
    const headers = idToken ? {
        Authorization: `Bearer ${idToken}`
    } : {};
    const response = await fetch(url, {
        headers
    });
    if (!response.ok) throw new Error(`Failed to fetch boundary codes: ${response.statusText}`);
    return await response.text();
}
function addBoundaryCodesControl(map, view, target, azureLoginControl) {
    const boundaryCodesControl = new (0, _boundaryCodesControl.BoundaryCodesControl)({
        target: target
    });
    let debounceTimer;
    view.on("change:center", (event)=>{
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(async ()=>{
            const lonLatCenter = (0, _proj.toLonLat)(event.target.getCenter(), event.target.getProjection());
            const lon = lonLatCenter[0].toFixed(7);
            const lat = lonLatCenter[1].toFixed(7);
            try {
                const idToken = azureLoginControl?.get("idToken");
                // Only fetch if we have a valid token
                if (!idToken) {
                    console.warn("No authentication token available");
                    boundaryCodesControl.setError("Not authenticated");
                    return;
                }
                const codes = await fetchBoundaryCodes(lon, lat, idToken);
                boundaryCodesControl.setBoundaryCodes(codes);
            } catch (error) {
                console.error("Error fetching boundary codes:", error);
                boundaryCodesControl.setError(error.message);
            }
        }, 1000);
    });
    map.addControl(boundaryCodesControl);
}

},{"ol/proj":"gN0IK","../controls/BoundaryCodesControl":"dtoAa","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"dtoAa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BoundaryCodesControl", ()=>BoundaryCodesControl);
var _control = require("ol/control/Control");
var _controlDefault = parcelHelpers.interopDefault(_control);
class BoundaryCodesControl extends (0, _controlDefault.default) {
    constructor(opt_options){
        const options = opt_options || {};
        const element = document.createElement("ul");
        super({
            element: element,
            target: options.target
        });
        element.className = "boundary-codes-display ol-unselectable";
        const codesDiv = document.createElement("div");
        codesDiv.className = "boundary-codes-list";
        element.appendChild(codesDiv);
        this.codesDiv = codesDiv;
    }
    setBoundaryCodes(codes) {
        if (codes && codes.length > 0) {
            this.codesDiv.textContent = codes;
            this.codesDiv.style.display = "block";
        } else this.codesDiv.style.display = "none";
    }
    setError(errorMessage) {
        // Silently hide on error - no error messages shown
        console.error("Boundary codes error:", errorMessage);
        this.codesDiv.style.display = "none";
    }
}

},{"ol/control/Control":"8KSMn","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gEHhK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addDateInputControl", ()=>addDateInputControl);
var _handleURL = require("../handleURL");
var _dateInputControl = require("../controls/DateInputControl");
var _urlstateManager = require("../state/URLStateManager");
function addDateInputControl(map, target) {
    const dateInputControl = new (0, _dateInputControl.DateInputControl)({
        target: target
    });
    map.addControl(dateInputControl);
    (0, _handleURL.handleURLForDate)(dateInputControl);
    (0, _urlstateManager.registerDateControl)(dateInputControl);
    return dateInputControl;
}

},{"../handleURL":"53YIf","../controls/DateInputControl":"8OG6J","../state/URLStateManager":"7Lluw","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"53YIf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleURLForWKT", ()=>handleURLForWKT);
parcelHelpers.export(exports, "handleURLForDate", ()=>handleURLForDate);
function handleURLForWKT(wktInputControl) {
    const wkt = getWKTURL();
    if (wkt != null && wkt != "") {
        // If the URL has no center/zoom, zoom to the WKT extent so the feature
        // is visible. When the URL also specifies a view, respect it instead.
        const params = new URLSearchParams(window.location.search);
        if (!params.get("center") || !params.get("zoom")) wktInputControl.set("zoomToExtent", true);
        wktInputControl.set("wkt", wkt);
    }
}
function handleURLForDate(dateInputControl) {
    if (getStartDateURL() != null && getEndDateURL() != null) dateInputControl.setProperties({
        startDate: getStartDateURL(),
        endDate: getEndDateURL()
    });
}
function getWKTURL() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("wkt");
}
function getStartDateURL() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("startDate");
}
function getEndDateURL() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("endDate");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8OG6J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateInputControl", ()=>DateInputControl);
var _control = require("ol/control/Control");
var _controlDefault = parcelHelpers.interopDefault(_control);
var _luxon = require("luxon");
class DateInputControl extends (0, _controlDefault.default) {
    constructor(opt_options){
        const options = opt_options || {};
        const element = document.createElement("ul");
        super({
            element: element,
            target: options.target
        });
        const this_ = this;
        element.className = "date-input ol-unselectable";
        let li;
        // dates
        const inputStart = document.createElement("input");
        inputStart.type = "date";
        inputStart.value = (0, _luxon.DateTime).utc().startOf("month").minus({
            weeks: 1
        }).toISODate();
        li = document.createElement("li");
        li.appendChild(inputStart);
        element.appendChild(li);
        const inputEnd = document.createElement("input");
        inputEnd.type = "date";
        inputEnd.value = (0, _luxon.DateTime).utc().startOf("month").toISODate();
        li = document.createElement("li");
        li.appendChild(inputEnd);
        element.appendChild(li);
        const button = document.createElement("button");
        button.innerHTML = "Update";
        button.addEventListener("click", function() {
            this_.setProperties({
                startDate: inputStart.value,
                endDate: inputEnd.value
            });
        }, false);
        li = document.createElement("li");
        li.appendChild(button);
        element.appendChild(li);
        // initialize values
        this.setProperties({
            startDate: inputStart.value,
            endDate: inputEnd.value
        });
        // listen to changes
        this.on("propertychange", ()=>{
            inputStart.value = this_.get("startDate");
            inputEnd.value = this_.get("endDate");
        });
    }
}

},{"ol/control/Control":"8KSMn","luxon":"6apd3","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2FOUV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addHeatmapLayersAndControls", ()=>addHeatmapLayersAndControls);
var _directionalHeatmapControl = require("../controls/DirectionalHeatmapControl");
var _dataSourceControl = require("../controls/DataSourceControl");
var _directionalLayers = require("../layers/DirectionalLayers");
var _directionalMotion = require("../layers/DirectionalMotion");
var _colorScale = require("../layers/style/util/colorScale");
var _urlstateManager = require("../state/URLStateManager");
function addHeatmapLayersAndControls(map, azureLoginControl, dateInputControl, target, layerGroup, featureInfoControl) {
    // Heatmap layer Controls
    const directionalHeatmapControl = new (0, _directionalHeatmapControl.DirectionalHeatmapControl)({
        target: target
    });
    const dataSourceControl = new (0, _dataSourceControl.DataSourceControl)({
        target: target
    });
    map.addControl(directionalHeatmapControl);
    map.addControl(dataSourceControl);
    directionalHeatmapControl.restoreState((0, _urlstateManager.getFCDToggleFromURL)(), (0, _urlstateManager.getFCDModeFromURL)(), (0, _urlstateManager.getFCDDirectionsFromURL)());
    (0, _urlstateManager.registerHeatmapControl)(directionalHeatmapControl);
    // Main viewer: the Overlays section shows FCD's options only while it is on
    // (CSS on `.sidebar-section-body.fcd-off`). Applied after the URL restore too.
    const syncFcdOff = ()=>target.classList.toggle("fcd-off", directionalHeatmapControl.get("heatmapToggle") !== true);
    syncFcdOff();
    directionalHeatmapControl.on("change:heatmapToggle", syncFcdOff);
    const fcdDataSource = (0, _urlstateManager.getFCDDataSourceFromURL)();
    if (fcdDataSource != null) dataSourceControl.set("dataSource", fcdDataSource);
    (0, _urlstateManager.registerDataSourceControl)(dataSourceControl);
    // Created once: AzureLoginControl refreshes the token every few minutes and
    // the WMS loader reads it per request, so a refresh must not rebuild layers.
    let directionalLayers;
    azureLoginControl.on("propertychange", function() {
        const authorized = azureLoginControl.get("idToken") && azureLoginControl.get("idTokenClaims") && azureLoginControl.get("idTokenClaims").roles && azureLoginControl.get("idTokenClaims").roles.includes("FCD.Reader");
        if (authorized && !directionalLayers) {
            directionalLayers = (0, _directionalLayers.getDirectionalLayers)(dateInputControl, azureLoginControl, dataSourceControl, directionalHeatmapControl);
            directionalHeatmapControl.set("directionalLayers", directionalLayers);
            const isMotionMode = ()=>directionalHeatmapControl.get("displayMode") === "motion";
            directionalLayers.forEach(function(layer) {
                (0, _directionalMotion.attachMotionRecolor)(layer, isMotionMode);
                layerGroup.getLayers().push(layer);
            });
            layerGroup.getLayers().push((0, _directionalMotion.createMotionOverlayLayer)(directionalLayers, map, isMotionMode));
        }
    });
    map.on("moveend", function() {
        directionalHeatmapControl.set("zoom", map.getView().getZoom());
        dataSourceControl.set("zoom", map.getView().getZoom());
    });
    let hoverFrame = null;
    let lastSpeedsKey = null;
    map.on("pointermove", function(e) {
        if (e.dragging || e.originalEvent.target.tagName !== "CANVAS") return;
        if (hoverFrame !== null) return;
        hoverFrame = requestAnimationFrame(function() {
            hoverFrame = null;
            // Motion mode also renders the WMS speed image, so it can be sampled.
            const mode = directionalHeatmapControl.get("displayMode");
            const inSpeedMode = mode === "speed" || mode === "motion";
            const fcdOn = directionalHeatmapControl.get("heatmapToggle") === true;
            const active = directionalHeatmapControl.get("active") === true;
            let speeds = null;
            if (inSpeedMode && fcdOn && active && directionalLayers) {
                const sampled = {};
                directionalLayers.forEach(function(layer, id) {
                    if (!layer.getVisible() || layer.getOpacity() === 0) return;
                    const data = layer.getData(e.pixel);
                    if (!data || data[3] === 0) return;
                    sampled[id] = (0, _colorScale.interpolatedSpeedFromColor)([
                        data[0],
                        data[1],
                        data[2]
                    ], (0, _directionalLayers.SPEED_BREAKPOINTS));
                });
                if (Object.keys(sampled).length > 0) speeds = sampled;
            }
            const key = speeds === null ? null : Object.keys(speeds).map(Number).sort((a, b)=>a - b).map((id)=>id + ":" + speeds[id]).join(",");
            if (key === lastSpeedsKey) return;
            lastSpeedsKey = key;
            featureInfoControl.set("fcdSpeeds", speeds);
        });
    });
}

},{"../controls/DirectionalHeatmapControl":"hO7Hz","../controls/DataSourceControl":"fXIgK","../layers/DirectionalLayers":"ffH8s","../layers/DirectionalMotion":"eKqIN","../layers/style/util/colorScale":"dOPOB","../state/URLStateManager":"7Lluw","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hO7Hz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DirectionalHeatmapControl", ()=>DirectionalHeatmapControl);
var _control = require("ol/control/Control");
var _controlDefault = parcelHelpers.interopDefault(_control);
var _directionalLayers = require("../layers/DirectionalLayers");
var _directionalMotion = require("../layers/DirectionalMotion");
var _colorScale = require("../layers/style/util/colorScale");
class DirectionalHeatmapControl extends (0, _controlDefault.default) {
    constructor(opt_options){
        const options = opt_options || {};
        const element = document.createElement("div");
        super({
            element: element,
            target: options.target
        });
        const this_ = this;
        element.className = "directional-control ol-unselectable ol-control";
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.className = "heatmap-checkbox";
        checkbox.id = "heatmap-input";
        checkbox.checked = false;
        const label = document.createElement("label");
        label.htmlFor = "heatmap-input";
        label.className = "heatmap-text";
        label.innerText = "FCD";
        checkbox.addEventListener("change", function() {
            this_.set("heatmapToggle", checkbox.checked);
        });
        this_.set("heatmapToggle", checkbox.checked);
        let _pendingDirections = null;
        function updateActiveDirections() {
            const layers = this_.get("directionalLayers");
            if (!layers) return;
            const active = [];
            layers.forEach(function(layer, id) {
                if (layer.getOpacity() > 0) active.push(id);
            });
            this_.set("activeDirections", active.join(","));
        }
        this.restoreState = function(fcdToggle, fcdMode, fcdDirs) {
            if (fcdToggle) {
                checkbox.checked = true;
                this_.set("heatmapToggle", true);
            }
            if (fcdMode === "speed") {
                speedRadio.checked = true;
                onModeChange();
            } else if (fcdMode === "motion") {
                motionRadio.checked = true;
                onModeChange();
            }
            if (fcdDirs) _pendingDirections = fcdDirs;
        };
        const modeContainer = document.createElement("div");
        modeContainer.className = "fcd-modes";
        const densityRadio = document.createElement("input");
        densityRadio.type = "radio";
        densityRadio.name = "fcd-mode";
        densityRadio.id = "fcd-mode-density";
        densityRadio.value = "density";
        densityRadio.checked = true;
        const densityLabel = document.createElement("label");
        densityLabel.htmlFor = "fcd-mode-density";
        densityLabel.innerText = "Density";
        const speedRadio = document.createElement("input");
        speedRadio.type = "radio";
        speedRadio.name = "fcd-mode";
        speedRadio.id = "fcd-mode-speed";
        speedRadio.value = "speed";
        const speedLabel = document.createElement("label");
        speedLabel.htmlFor = "fcd-mode-speed";
        speedLabel.innerText = "Speed";
        const motionRadio = document.createElement("input");
        motionRadio.type = "radio";
        motionRadio.name = "fcd-mode";
        motionRadio.id = "fcd-mode-motion";
        motionRadio.value = "motion";
        const motionLabel = document.createElement("label");
        motionLabel.htmlFor = "fcd-mode-motion";
        motionLabel.innerText = "Motion";
        modeContainer.appendChild(densityRadio);
        modeContainer.appendChild(densityLabel);
        modeContainer.appendChild(speedRadio);
        modeContainer.appendChild(speedLabel);
        modeContainer.appendChild(motionRadio);
        modeContainer.appendChild(motionLabel);
        const speedLegend = document.createElement("div");
        speedLegend.style.cssText = "display:none; flex-direction:column; margin-left:4px; padding-top:4px;";
        const legendWrapper = document.createElement("div");
        legendWrapper.style.cssText = "display:flex; align-items:stretch;";
        const gradientBar = document.createElement("div");
        gradientBar.style.cssText = "width:10px; height:140px;background: " + (0, _colorScale.speedGradient)("to top", (0, _directionalLayers.SPEED_BREAKPOINTS)) + ";";
        const legendLabels = document.createElement("div");
        legendLabels.style.cssText = "position:relative; margin-left:2px; font-size:9px; height:140px; width:1.6em;";
        const minSpeed = (0, _directionalLayers.SPEED_BREAKPOINTS)[0];
        const maxSpeed = (0, _directionalLayers.SPEED_BREAKPOINTS)[(0, _directionalLayers.SPEED_BREAKPOINTS).length - 1];
        const speedRange = maxSpeed - minSpeed;
        (0, _directionalLayers.SPEED_BREAKPOINTS).forEach(function(speed, i) {
            const topPct = (maxSpeed - speed) / speedRange * 100;
            const span = document.createElement("span");
            span.style.cssText = "position:absolute; left:0; top:" + topPct.toFixed(2) + "%; transform:translateY(-50%);";
            span.innerText = i === (0, _directionalLayers.SPEED_BREAKPOINTS).length - 1 ? speed + "+" : speed;
            legendLabels.appendChild(span);
        });
        const legendUnit = document.createElement("div");
        legendUnit.style.cssText = "font-size:9px; text-align:center; margin-top:2px;";
        legendUnit.innerText = "km/h";
        legendWrapper.appendChild(gradientBar);
        legendWrapper.appendChild(legendLabels);
        speedLegend.appendChild(legendWrapper);
        speedLegend.appendChild(legendUnit);
        const modeOpacity = {
            density: (0, _directionalLayers.DIRECTIONAL_OPACITY),
            speed: (0, _directionalLayers.SPEED_OPACITY),
            motion: (0, _directionalMotion.MOTION_OPACITY)
        };
        function currentOpacity() {
            return modeOpacity[this_.get("displayMode")];
        }
        function wheelFill(mode, i) {
            if (mode === "speed") return "#808080";
            if (mode === "motion") return 0, _directionalMotion.MOTION_COLOR;
            return originalFills[i];
        }
        function onModeChange() {
            const mode = [
                densityRadio,
                speedRadio,
                motionRadio
            ].find((radio)=>radio.checked).value;
            this_.set("displayMode", mode);
            speedLegend.style.display = mode === "speed" ? "flex" : "none";
            const opacity = modeOpacity[mode];
            [
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ].forEach(function(i) {
                wheel.getElementById("svg-" + i).setAttribute("fill", wheelFill(mode, i));
            });
            const layers = this_.get("directionalLayers");
            if (layers) layers.forEach(function(layer) {
                if (layer.getOpacity() > 0) layer.setOpacity(opacity);
            });
        }
        densityRadio.addEventListener("change", onModeChange);
        speedRadio.addEventListener("change", onModeChange);
        motionRadio.addEventListener("change", onModeChange);
        this_.set("displayMode", "density");
        const wheel = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        wheel.style.display = "block";
        wheel.setAttribute("width", 150);
        wheel.setAttribute("heigth", 150);
        wheel.innerHTML = `
       <g transform="translate(80,80) rotate(90)">
        <circle id="svg-1" fill="#FFFF00" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(-43.10070037841797,0)"></circle>
        <circle id="svg-2" fill="#FF8000" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(-37.32630144861153,-21.55035018920898)"></circle>
        <circle id="svg-3" fill="#FF0000" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(-21.550350189208988,-37.326301448611524)"></circle>
        <circle id="svg-4" fill="#FF0080" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(-2.639156737971934e-15,-43.10070037841797)"></circle>
        <circle id="svg-5" fill="#FF00FF" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(21.550350189208974,-37.32630144861153)"></circle>
        <circle id="svg-6" fill="#8000FF" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(37.32630144861153,-21.55035018920898)"></circle>
        <circle id="svg-7" fill="#0000FF" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(43.10070037841797,-5.278313475943868e-15)"></circle>
        <circle id="svg-8" fill="#0080FF" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(37.326301448611524,21.550350189208988)"></circle>
        <circle id="svg-9" fill="#00FFFF" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(21.550350189209002,37.326301448611524)"></circle>
        <circle id="svg-10" fill="#00FF80" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(7.917470213915802e-15,43.10070037841797)"></circle>
        <circle id="svg-11" fill="#00FF00" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(-21.550350189208988,37.326301448611524)"></circle>
        <circle id="svg-12" fill="#80FF00" stroke-width="2" stroke="black" r="8.620140075683594" transform="translate(-37.32630144861152,21.550350189209002)"></circle>
        <text refx="50%" refy="50%" id="select-clear-svg" class="select-clear" transform="rotate(-90)" style="text-anchor: middle;">Clear All</text>
        <text id="N-pole-svg" class="pole" transform="translate(-66.99347993601923,0) rotate(-90)" style="text-anchor: middle;">N</text>
        <text id="E-pole-svg" class="pole" transform="translate(-4.102167538369419e-15,-66.99347993601923) rotate(-90)" style="text-anchor: middle;">E</text>
        <text id="S-pole-svg" class="pole" transform="translate(66.99347993601923,-8.204335076738838e-15) rotate(-90)" style="text-anchor: middle;">S</text>
        <text id="W-pole-svg" class="pole" transform="translate(1.2306502615108255e-14,66.99347993601923) rotate(-90)" style="text-anchor: middle;">W</text>
      </g>`;
        function buttonCleared(button) {
            button.setAttribute("fill-opacity", 0.2);
            button.setAttribute("stroke-width", 0);
        }
        function buttonSelected(button) {
            button.setAttribute("fill-opacity", 1);
            button.setAttribute("stroke-width", 2);
        }
        function toggleDirectionalHeatmap(button) {
            const layer = button._layer;
            if (layer.getOpacity() > 0) {
                layer.setOpacity(0);
                buttonCleared(button);
            } else {
                layer.setOpacity(currentOpacity());
                buttonSelected(button);
            }
            updateActiveDirections();
        }
        [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ].forEach(function(i) {
            const button = wheel.getElementById("svg-" + i);
            button.addEventListener("click", toggleDirectionalHeatmap.bind(null, button), false);
        });
        const originalFills = {};
        [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ].forEach(function(i) {
            originalFills[i] = wheel.getElementById("svg-" + i).getAttribute("fill");
        });
        const wheelRow = document.createElement("div");
        wheelRow.className = "fcd-wheel";
        wheelRow.style.cssText = "display:flex; align-items:flex-start;";
        wheelRow.appendChild(wheel);
        wheelRow.appendChild(speedLegend);
        this.on("propertychange", function(e) {
            const buttons = [];
            function selectClear(el, buttons, directionalLayers) {
                if (el.textContent == "Clear All") {
                    for (const id of directionalLayers.keys())directionalLayers.get(id).setOpacity(0);
                    buttons.forEach((button)=>buttonCleared(button));
                    el.textContent = "Select All";
                } else {
                    for (const id of directionalLayers.keys())directionalLayers.get(id).setOpacity(currentOpacity());
                    buttons.forEach((button)=>buttonSelected(button));
                    el.textContent = "Clear All";
                }
                updateActiveDirections();
            }
            if (e.key === "zoom") {
                const zoom = e.target.get("zoom");
                if (zoom >= 17) this_.set("active", true);
                else this_.set("active", false);
            }
            const layers = this_.get("directionalLayers");
            if (layers !== undefined) layers.forEach(function(layer, i) {
                const button = wheel.getElementById("svg-" + i);
                buttons.push(button);
                if (this_.get("heatmapToggle") === false) layer.setVisible(false);
                else {
                    layer.setVisible(true);
                    layer.changed();
                }
                button._layer = layer;
                layer.getSource().on("imageloadstart", ()=>{
                    button.setAttribute("stroke", "white");
                });
                layer.on("rendercomplete", ()=>{
                    button.setAttribute("stroke", "black");
                });
                layer.getSource().on("imageloaderror", ()=>{
                    button.setAttribute("stroke", "red");
                });
                layer.on("change", ()=>{
                    button.setAttribute("stroke", "black");
                });
            });
            if (_pendingDirections && layers) {
                const opacity = currentOpacity();
                const activeSet = new Set(_pendingDirections);
                layers.forEach(function(layer, id) {
                    const button = wheel.getElementById("svg-" + id);
                    if (!activeSet.has(id)) {
                        layer.setOpacity(0);
                        buttonCleared(button);
                    } else layer.setOpacity(opacity);
                });
                _pendingDirections = null;
                updateActiveDirections();
            } else if (layers && this_.get("displayMode") !== "density") {
                const opacity = currentOpacity();
                layers.forEach(function(layer) {
                    if (layer.getOpacity() > 0) layer.setOpacity(opacity);
                });
            }
            if (this_.get("active")) {
                label.style.color = "black";
                wheel.style.opacity = "100%";
            } else {
                label.style.color = "grey";
                wheel.style.opacity = "20%";
            }
            // Clear all, select all
            const selectClearButton = wheel.getElementById("select-clear-svg");
            selectClearButton.addEventListener("click", selectClear.bind(null, selectClearButton, buttons, this_.get("directionalLayers")), false);
            element.appendChild(checkbox);
            element.appendChild(label);
            element.appendChild(modeContainer);
            element.appendChild(wheelRow);
        });
    }
}

},{"ol/control/Control":"8KSMn","../layers/DirectionalLayers":"ffH8s","../layers/DirectionalMotion":"eKqIN","../layers/style/util/colorScale":"dOPOB","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ffH8s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DIRECTIONAL_OPACITY", ()=>DIRECTIONAL_OPACITY);
parcelHelpers.export(exports, "SPEED_OPACITY", ()=>SPEED_OPACITY);
parcelHelpers.export(exports, "SPEED_BREAKPOINTS", ()=>SPEED_BREAKPOINTS);
parcelHelpers.export(exports, "getDirectionalLayers", ()=>getDirectionalLayers);
var _imageWMS = require("ol/source/ImageWMS");
var _imageWMSDefault = parcelHelpers.interopDefault(_imageWMS);
var _image = require("ol/layer/Image");
var _imageDefault = parcelHelpers.interopDefault(_image);
var _proj = require("ol/proj");
var _luxon = require("luxon");
var _colorScale = require("./style/util/colorScale");
const DIRECTIONAL_OPACITY = 0.4;
const SPEED_OPACITY = 0.99;
const SPEED_BREAKPOINTS = [
    0,
    15,
    30,
    50,
    70,
    90,
    120,
    130
];
const imageURLMap = {};
function getParams(direction, startDateISO, endDateISO, dataSource, displayMode) {
    // Motion mode animates at the FCD speed, so it needs the speed image too.
    if (displayMode === "speed" || displayMode === "motion") return {
        LAYERS: "speed",
        SPEED_STYLE: (0, _colorScale.wmsSpeedStyle)(SPEED_BREAKPOINTS),
        STYLES: null,
        VERSION: "1.1.1",
        TIME: `${startDateISO}/${endDateISO}`,
        DATE_RANGE: null,
        ONLY_ALLOW_DIRECTIONS: "" + direction,
        DATA_SOURCE: dataSource
    };
    const startDate = (0, _luxon.DateTime).fromISO(startDateISO).toFormat("yyooo");
    const endDate = (0, _luxon.DateTime).fromISO(endDateISO).toFormat("yyooo");
    return {
        LAYERS: "averagedtrf",
        VERSION: "1.1.1",
        DATE_RANGE: `${startDate}-${endDate}`,
        TIME: null,
        SPEED_STYLE: null,
        STYLES: null,
        ONLY_ALLOW_DIRECTIONS: "" + direction,
        DATA_SOURCE: dataSource
    };
}
function getImageWMS(direction, startDateISO, endDateISO, azureLoginControl, dataSource) {
    return new (0, _imageWMSDefault.default)({
        url: "/wms/multi?",
        params: getParams(direction, startDateISO, endDateISO, dataSource, "density"),
        ratio: 1,
        projection: (0, _proj.get)("EPSG:900913"),
        imageLoadFunction: function(image, url) {
            // Read per request: the token is refreshed periodically and the layers
            // are created only once.
            const headers = {
                Authorization: "Bearer " + azureLoginControl.get("idToken")
            };
            fetch(url, {
                headers
            }).then((response)=>response.blob().then((imageData)=>{
                    let objectUrl = window.URL.createObjectURL(imageData);
                    image.getImage().src = objectUrl;
                    // cleanup
                    if (imageURLMap[direction]) window.URL.revokeObjectURL(imageURLMap[direction]);
                    imageURLMap[direction] = objectUrl;
                }));
            image.getImage().onchange = function(event) {
                console.log("change on heatmap layer event: " + event);
            };
        }
    });
}
function updateLayer(layer, direction, dateInputControl, dataSourceControl, directionalHeatmapControl) {
    layer.getSource().updateParams(getParams(direction, dateInputControl.get("startDate"), dateInputControl.get("endDate"), dataSourceControl.get("dataSource"), directionalHeatmapControl.get("displayMode")));
    layer.getSource().refresh();
}
function getDirectionalLayers(dateInputControl, azureLoginControl, dataSourceControl, directionalHeatmapControl) {
    var layers = new Map();
    for(var direction = 1; direction < 13; direction++){
        const layer = new (0, _imageDefault.default)({
            // Unique className = own canvas per direction, required by the motion
            // mode's per-layer `source-atop` compositing (see DirectionalMotion.js).
            className: "ol-layer fcd-direction-" + direction,
            opacity: DIRECTIONAL_OPACITY,
            minZoom: 17,
            source: getImageWMS(direction, dateInputControl.get("startDate"), dateInputControl.get("endDate"), azureLoginControl, dataSourceControl.get("dataSource"))
        });
        layers.set(direction + "", layer);
        const boundUpdate = updateLayer.bind(this, layer, direction, dateInputControl, dataSourceControl, directionalHeatmapControl);
        dateInputControl.on("propertychange", boundUpdate);
        dataSourceControl.on("propertychange", boundUpdate);
        directionalHeatmapControl.on("propertychange", boundUpdate);
    }
    return layers;
}

},{"ol/source/ImageWMS":"6M5Jy","ol/layer/Image":"516lS","ol/proj":"gN0IK","luxon":"6apd3","./style/util/colorScale":"dOPOB","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6M5Jy":[function(require,module,exports,__globalThis) {
/**
 * @module ol/source/ImageWMS
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _imageJs = require("../Image.js");
var _projJs = require("../proj.js");
var _reprojJs = require("../reproj.js");
var _imageJs1 = require("./Image.js");
var _imageJsDefault = parcelHelpers.interopDefault(_imageJs1);
var _wmsJs = require("./wms.js");
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {ReferrerPolicy} [referrerPolicy] The `referrerPolicy` property for loaded images.
 * @property {boolean} [hidpi=true] Use the `ol/Map#pixelRatio` value when requesting
 * the image from the remote server.
 * @property {import("./wms.js").ServerType} [serverType] The type of
 * the remote WMS server: `mapserver`, `geoserver`, `carmentaserver`, or `qgis`.
 * Only needed if `hidpi` is `true`.
 * @property {import("../Image.js").LoadFunction} [imageLoadFunction] Optional function to load an image given a URL.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {Object<string,*>} [params] WMS request parameters.
 * At least a `LAYERS` param is required. `STYLES` is
 * `''` by default. `VERSION` is `1.3.0` by default. `WIDTH`, `HEIGHT`, `BBOX`
 * and `CRS` (`SRS` for WMS version < 1.3.0) will be set dynamically.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [ratio=1.5] Ratio. `1` means image requests are the size of the map viewport, `2` means
 * twice the width and height of the map viewport, and so on. Must be `1` or higher.
 * @property {Array<number>} [resolutions] Resolutions.
 * If specified, requests will be made for these resolutions only.
 * @property {string} [url] WMS service URL.
 */ /**
 * @classdesc
 * Source for WMS servers providing single, untiled images.
 *
 * @fires module:ol/source/Image.ImageSourceEvent
 * @api
 */ class ImageWMS extends (0, _imageJsDefault.default) {
    /**
   * @param {Options} [options] ImageWMS options.
   */ constructor(options){
        options = options ? options : {};
        super({
            attributions: options.attributions,
            interpolate: options.interpolate,
            projection: options.projection,
            resolutions: options.resolutions
        });
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
     * @private
     * @type {ReferrerPolicy|undefined}
     */ this.referrerPolicy_ = options.referrerPolicy;
        /**
     * @private
     * @type {string|undefined}
     */ this.url_ = options.url;
        /**
     * @private
     * @type {import("../Image.js").LoadFunction}
     */ this.imageLoadFunction_ = options.imageLoadFunction !== undefined ? options.imageLoadFunction : (0, _imageJs1.defaultImageLoadFunction);
        /**
     * @private
     * @type {!Object}
     */ this.params_ = Object.assign({}, options.params);
        /**
     * @private
     * @type {import("./wms.js").ServerType|undefined}
     */ this.serverType_ = options.serverType;
        /**
     * @private
     * @type {boolean}
     */ this.hidpi_ = options.hidpi !== undefined ? options.hidpi : true;
        /**
     * @private
     * @type {number}
     */ this.renderedRevision_ = 0;
        /**
     * @private
     * @type {number}
     */ this.ratio_ = options.ratio !== undefined ? options.ratio : 1.5;
        /**
     * @private
     * @type {import("../proj/Projection.js").default|undefined}
     */ this.loaderProjection_ = undefined;
    }
    /**
   * Return the GetFeatureInfo URL for the passed coordinate, resolution, and
   * projection. Return `undefined` if the GetFeatureInfo URL cannot be
   * constructed.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {import("../proj.js").ProjectionLike} projection Projection.
   * @param {!Object} params GetFeatureInfo params. `INFO_FORMAT` at least should
   *     be provided. If `QUERY_LAYERS` is not provided then the layers specified
   *     in the `LAYERS` parameter will be used. `VERSION` should not be
   *     specified here.
   * @return {string|undefined} GetFeatureInfo URL.
   * @api
   */ getFeatureInfoUrl(coordinate, resolution, projection, params) {
        const projectionObj = /** @type {import("../proj/Projection.js").default} */ (0, _projJs.get)(projection);
        const sourceProjectionObj = this.getProjection();
        if (sourceProjectionObj && sourceProjectionObj !== projectionObj) {
            resolution = (0, _reprojJs.calculateSourceResolution)(sourceProjectionObj, projectionObj, coordinate, resolution);
            coordinate = (0, _projJs.transform)(coordinate, projectionObj, sourceProjectionObj);
        }
        const url = this.url_;
        if (!url) return undefined;
        const options = {
            url: url,
            params: {
                ...this.params_,
                ...params
            },
            projection: sourceProjectionObj || projectionObj
        };
        return (0, _wmsJs.getFeatureInfoUrl)(options, coordinate, resolution);
    }
    /**
   * Return the GetLegendGraphic URL, optionally optimized for the passed
   * resolution and possibly including any passed specific parameters. Returns
   * `undefined` if the GetLegendGraphic URL cannot be constructed.
   *
   * @param {number} [resolution] Resolution. If set to undefined, `SCALE`
   *     will not be calculated and included in URL.
   * @param {Object} [params] GetLegendGraphic params. If `LAYER` is set, the
   *     request is generated for this wms layer, else it will try to use the
   *     configured wms layer. Default `FORMAT` is `image/png`.
   *     `VERSION` should not be specified here.
   * @return {string|undefined} GetLegendGraphic URL.
   * @api
   */ getLegendUrl(resolution, params) {
        const url = this.url_;
        if (!url) return undefined;
        return (0, _wmsJs.getLegendUrl)({
            url: url,
            params: {
                ...this.params_,
                ...params
            }
        }, resolution);
    }
    /**
   * Get the user-provided params, i.e. those passed to the constructor through
   * the "params" option, and possibly updated using the updateParams method.
   * @return {Object} Params.
   * @api
   */ getParams() {
        return this.params_;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../Image.js").default|null} Single image.
   * @override
   */ getImageInternal(extent, resolution, pixelRatio, projection) {
        if (this.url_ === undefined) return null;
        if (!this.loader || this.loaderProjection_ !== projection) {
            // Lazily create loader to pick up the view projection and to allow `params` updates
            this.loaderProjection_ = projection;
            this.loader = (0, _wmsJs.createLoader)({
                crossOrigin: this.crossOrigin_,
                referrerPolicy: this.referrerPolicy_,
                params: this.params_,
                projection: projection,
                serverType: this.serverType_,
                hidpi: this.hidpi_,
                url: this.url_,
                ratio: this.ratio_,
                load: (image, src)=>{
                    const wrapper = this.image;
                    if (wrapper) {
                        wrapper.setImage(image);
                        this.imageLoadFunction_(wrapper, src);
                    }
                    return (0, _imageJs.decode)(image);
                }
            });
        }
        return super.getImageInternal(extent, resolution, pixelRatio, projection);
    }
    /**
   * Return the image load function of the source.
   * @return {import("../Image.js").LoadFunction} The image load function.
   * @api
   */ getImageLoadFunction() {
        return this.imageLoadFunction_;
    }
    /**
   * Return the URL used for this WMS source.
   * @return {string|undefined} URL.
   * @api
   */ getUrl() {
        return this.url_;
    }
    /**
   * Set the image load function of the source.
   * @param {import("../Image.js").LoadFunction} imageLoadFunction Image load function.
   * @api
   */ setImageLoadFunction(imageLoadFunction) {
        this.imageLoadFunction_ = imageLoadFunction;
        this.changed();
    }
    /**
   * Set the URL to use for requests.
   * @param {string|undefined} url URL.
   * @api
   */ setUrl(url) {
        if (url != this.url_) {
            this.url_ = url;
            this.loader = null;
            this.changed();
        }
    }
    /**
   * Set the user-provided params.
   * @param {Object} params Params.
   * @api
   */ setParams(params) {
        this.params_ = Object.assign({}, params);
        // Reset loader to pick up new params
        this.loader = null;
        this.changed();
    }
    /**
   * Update the user-provided params.
   * @param {Object} params Params.
   * @api
   */ updateParams(params) {
        Object.assign(this.params_, params);
        this.changed();
    }
    /**
   * @override
   */ changed() {
        this.image = null;
        super.changed();
    }
}
exports.default = ImageWMS;

},{"../Image.js":"dfn7g","../proj.js":"gN0IK","../reproj.js":"3M9kW","./Image.js":"enYGk","./wms.js":"e24t4","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"e24t4":[function(require,module,exports,__globalThis) {
/**
 * @module ol/source/wms
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_VERSION", ()=>DEFAULT_VERSION);
/**
 * @api
 * @typedef {'carmentaserver' | 'geoserver' | 'mapserver' | 'qgis'} ServerType
 * Set the server type to use implementation-specific parameters beyond the WMS specification.
 *  - `'carmentaserver'`: HiDPI support for [Carmenta Server](https://www.carmenta.com/en/products/carmenta-server)
 *  - `'geoserver'`: HiDPI support for [GeoServer](https://geoserver.org/)
 *  - `'mapserver'`: HiDPI support for [MapServer](https://mapserver.org/)
 *  - `'qgis'`: HiDPI support for [QGIS](https://qgis.org/)
 */ /**
 * @param {string} baseUrl Base URL.
 * @param {import("../extent.js").Extent} extent Extent.
 * @param {import("../size.js").Size} size Size.
 * @param {import("../proj/Projection.js").default} projection Projection.
 * @param {Object<string, *>} params WMS params. Will be modified in place.
 * @return {string} Request URL.
 */ parcelHelpers.export(exports, "getRequestUrl", ()=>getRequestUrl);
/**
 * @param {import("../extent.js").Extent} extent Extent.
 * @param {number} resolution Resolution.
 * @param {number} pixelRatio pixel ratio.
 * @param {import("../proj.js").Projection} projection Projection.
 * @param {string} url WMS service url.
 * @param {Object<string, *>} params WMS params.
 * @param {import("./wms.js").ServerType} serverType The type of the remote WMS server.
 * @return {string} Image src.
 */ parcelHelpers.export(exports, "getImageSrc", ()=>getImageSrc);
/**
 * @param {Object<string, *>} params WMS params.
 * @param {string} request WMS `REQUEST`.
 * @return {Object<string, *>} WMS params with required properties set.
 */ parcelHelpers.export(exports, "getRequestParams", ()=>getRequestParams);
/**
 * @typedef {Object} LoaderOptions
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {ReferrerPolicy} [referrerPolicy] The `referrerPolicy` property for loaded images.
 * @property {boolean} [hidpi=true] Use the `ol/Map#pixelRatio` value when requesting
 * the image from the remote server.
 * @property {Object<string,*>} [params] WMS request parameters.
 * At least a `LAYERS` param is required. `STYLES` is
 * `''` by default. `VERSION` is `1.3.0` by default. `WIDTH`, `HEIGHT` and `BBOX` will be set
 * dynamically. `CRS` (`SRS` for WMS version < 1.3.0) will is derived from the `proection` config.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is 'EPSG:3857'.
 * @property {number} [ratio=1.5] Ratio. `1` means image requests are the size of the map viewport, `2` means
 * twice the width and height of the map viewport, and so on. Must be `1` or higher.
 * @property {import("./wms.js").ServerType} [serverType] The type of
 * the remote WMS server: `mapserver`, `geoserver`, `carmentaserver`, or `qgis`.
 * Only needed if `hidpi` is `true`.
 * @property {string} url WMS service URL.
 * @property {function(HTMLImageElement, string): Promise<import('../DataTile.js').ImageLike>} [load] Function
 * to perform loading of the image. Receives the created `HTMLImageElement` and the desired `src` as argument and
 * returns a promise resolving to the loaded or decoded image. Default is {@link module:ol/Image.decode}.
 */ /**
 * Creates a loader for WMS images.
 * @param {LoaderOptions} options Loader options.
 * @return {import("../Image.js").ImageObjectPromiseLoader} Loader.
 * @api
 */ parcelHelpers.export(exports, "createLoader", ()=>createLoader);
/**
 * Get the GetFeatureInfo URL for the passed coordinate and resolution. Returns `undefined` if the
 * GetFeatureInfo URL cannot be constructed.
 * @param {LoaderOptions} options Options passed the `createWMSLoader()` function. In addition to
 * the params required by the loader, `INFO_FORMAT` should be specified, it defaults to
 * `application/json`. If `QUERY_LAYERS` is not provided, then the layers specified in the `LAYERS`
 * parameter will be used.
 * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
 * @param {number} resolution Resolution.
 * @return {string|undefined} GetFeatureInfo URL.
 * @api
 */ parcelHelpers.export(exports, "getFeatureInfoUrl", ()=>getFeatureInfoUrl);
/**
 * Get the GetLegendGraphic URL, optionally optimized for the passed resolution and possibly
 * including any passed specific parameters. Returns `undefined` if the GetLegendGraphic URL
 * cannot be constructed.
 *
 * @param {LoaderOptions} options Options passed the `createWMSLoader()` function.
 * @param {number} [resolution] Resolution. If not provided, `SCALE` will not be calculated and
 * included in URL.
 * @return {string|undefined} GetLegendGraphic URL.
 * @api
 */ parcelHelpers.export(exports, "getLegendUrl", ()=>getLegendUrl);
var _imageJs = require("../Image.js");
var _extentJs = require("../extent.js");
var _mathJs = require("../math.js");
var _projJs = require("../proj.js");
var _stringJs = require("../string.js");
var _uriJs = require("../uri.js");
var _imageJs1 = require("./Image.js");
var _commonJs = require("./common.js");
const DEFAULT_VERSION = '1.3.0';
/**
 * @const
 * @type {import("../size.js").Size}
 */ const GETFEATUREINFO_IMAGE_SIZE = [
    101,
    101
];
function getRequestUrl(baseUrl, extent, size, projection, params) {
    params['WIDTH'] = size[0];
    params['HEIGHT'] = size[1];
    const axisOrientation = projection.getAxisOrientation();
    const v13 = (0, _stringJs.compareVersions)(params['VERSION'], '1.3') >= 0;
    params[v13 ? 'CRS' : 'SRS'] = projection.getCode();
    const bbox = v13 && axisOrientation.startsWith('ne') ? [
        extent[1],
        extent[0],
        extent[3],
        extent[2]
    ] : extent;
    params['BBOX'] = bbox.join(',');
    return (0, _uriJs.appendParams)(baseUrl, params);
}
function getImageSrc(extent, resolution, pixelRatio, projection, url, params, serverType) {
    params = Object.assign({
        REQUEST: 'GetMap'
    }, params);
    const imageResolution = resolution / pixelRatio;
    const imageSize = [
        (0, _mathJs.round)((0, _extentJs.getWidth)(extent) / imageResolution, (0, _commonJs.DECIMALS)),
        (0, _mathJs.round)((0, _extentJs.getHeight)(extent) / imageResolution, (0, _commonJs.DECIMALS))
    ];
    if (pixelRatio != 1) switch(serverType){
        case 'geoserver':
            const dpi = 90 * pixelRatio + 0.5 | 0;
            if ('FORMAT_OPTIONS' in params) params['FORMAT_OPTIONS'] += ';dpi:' + dpi;
            else params['FORMAT_OPTIONS'] = 'dpi:' + dpi;
            break;
        case 'mapserver':
            params['MAP_RESOLUTION'] = 90 * pixelRatio;
            break;
        case 'carmentaserver':
        case 'qgis':
            params['DPI'] = 90 * pixelRatio;
            break;
        default:
            throw new Error('Unknown `serverType` configured');
    }
    const src = getRequestUrl(url, extent, imageSize, projection, params);
    return src;
}
function getRequestParams(params, request) {
    return Object.assign({
        'REQUEST': request,
        'SERVICE': 'WMS',
        'VERSION': DEFAULT_VERSION,
        'FORMAT': 'image/png',
        'STYLES': '',
        'TRANSPARENT': 'TRUE'
    }, params || {});
}
function createLoader(options) {
    const hidpi = options.hidpi === undefined ? true : options.hidpi;
    const projection = /** @type {import("../proj/Projection.js").default} */ (0, _projJs.get)(options.projection || 'EPSG:3857');
    const ratio = options.ratio || 1.5;
    const load = options.load || (0, _imageJs.decode);
    const crossOrigin = options.crossOrigin ?? null;
    const referrerPolicy = options.referrerPolicy;
    return (extent, resolution, pixelRatio)=>{
        extent = (0, _imageJs1.getRequestExtent)(extent, resolution, pixelRatio, ratio);
        if (pixelRatio != 1 && (!hidpi || options.serverType === undefined)) pixelRatio = 1;
        const src = getImageSrc(extent, resolution, pixelRatio, projection, options.url, getRequestParams(options.params || {}, 'GetMap'), /** @type {import("./wms.js").ServerType} */ options.serverType);
        const image = new Image();
        image.crossOrigin = crossOrigin;
        if (referrerPolicy !== undefined) image.referrerPolicy = referrerPolicy;
        return load(image, src).then((image)=>({
                image,
                extent,
                pixelRatio
            }));
    };
}
function getFeatureInfoUrl(options, coordinate, resolution) {
    if (options.url === undefined) return undefined;
    const projectionObj = /** @type {import("../proj/Projection.js").default} */ (0, _projJs.get)(options.projection || 'EPSG:3857');
    const params = options.params || {};
    const extent = (0, _extentJs.getForViewAndSize)(coordinate, resolution, 0, GETFEATUREINFO_IMAGE_SIZE);
    /** @type {Object<string, *>} */ const baseParams = {
        'QUERY_LAYERS': params['LAYERS'],
        'INFO_FORMAT': 'application/json'
    };
    Object.assign(baseParams, getRequestParams(params, 'GetFeatureInfo'), params);
    const x = (0, _mathJs.floor)((coordinate[0] - extent[0]) / resolution, (0, _commonJs.DECIMALS));
    const y = (0, _mathJs.floor)((extent[3] - coordinate[1]) / resolution, (0, _commonJs.DECIMALS));
    const v13 = (0, _stringJs.compareVersions)(baseParams['VERSION'], '1.3') >= 0;
    baseParams[v13 ? 'I' : 'X'] = x;
    baseParams[v13 ? 'J' : 'Y'] = y;
    return getRequestUrl(options.url, extent, GETFEATUREINFO_IMAGE_SIZE, projectionObj, baseParams);
}
function getLegendUrl(options, resolution) {
    if (options.url === undefined) return undefined;
    /** @type {Object<string, *>} */ const baseParams = {
        'SERVICE': 'WMS',
        'VERSION': DEFAULT_VERSION,
        'REQUEST': 'GetLegendGraphic',
        'FORMAT': 'image/png'
    };
    if (resolution !== undefined) {
        const projection = /** @type {import("../proj/Projection.js").default} */ (0, _projJs.get)(options.projection || 'EPSG:3857');
        const mpu = projection.getMetersPerUnit() || 1;
        const pixelSize = 0.00028;
        baseParams['SCALE'] = resolution * mpu / pixelSize;
    }
    Object.assign(baseParams, options.params || {});
    if (options.params !== undefined && baseParams['LAYER'] === undefined) {
        const layers = baseParams['LAYERS'];
        const isSingleLayer = !Array.isArray(layers) || layers.length !== 1;
        if (!isSingleLayer) return undefined;
        baseParams['LAYER'] = layers;
    }
    return (0, _uriJs.appendParams)(options.url, baseParams);
}

},{"../Image.js":"dfn7g","../extent.js":"MPjK5","../math.js":"b3dOZ","../proj.js":"gN0IK","../string.js":"ladmP","../uri.js":"4bdXc","./Image.js":"enYGk","./common.js":"eDS8y","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"516lS":[function(require,module,exports,__globalThis) {
/**
 * @module ol/layer/Image
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _imageLayerJs = require("../renderer/canvas/ImageLayer.js");
var _imageLayerJsDefault = parcelHelpers.interopDefault(_imageLayerJs);
var _baseImageJs = require("./BaseImage.js");
var _baseImageJsDefault = parcelHelpers.interopDefault(_baseImageJs);
/**
 * @classdesc
 * Server-rendered images that are available for arbitrary extents and
 * resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Image.js").default} ImageSourceType
 * @extends {BaseImageLayer<ImageSourceType, CanvasImageLayerRenderer>}
 * @api
 */ class ImageLayer extends (0, _baseImageJsDefault.default) {
    /**
   * @param {import("./BaseImage.js").Options<ImageSourceType>} [options] Layer options.
   */ constructor(options){
        super(options);
    }
    /**
   * @override
   */ createRenderer() {
        return new (0, _imageLayerJsDefault.default)(this);
    }
    /**
   * Get data for a pixel location.  A four element RGBA array will be returned.  For requests outside the
   * layer extent, `null` will be returned.  Data for an image can only be retrieved if the
   * source's `crossOrigin` property is set.
   *
   * ```js
   * // display layer data on every pointer move
   * map.on('pointermove', (event) => {
   *   console.log(layer.getData(event.pixel));
   * });
   * ```
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   * @api
   * @override
   */ getData(pixel) {
        return super.getData(pixel);
    }
}
exports.default = ImageLayer;

},{"../renderer/canvas/ImageLayer.js":"5fH6H","./BaseImage.js":"ihijF","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5fH6H":[function(require,module,exports,__globalThis) {
/**
 * @module ol/renderer/canvas/ImageLayer
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _imageStateJs = require("../../ImageState.js");
var _imageStateJsDefault = parcelHelpers.interopDefault(_imageStateJs);
var _viewHintJs = require("../../ViewHint.js");
var _viewHintJsDefault = parcelHelpers.interopDefault(_viewHintJs);
var _extentJs = require("../../extent.js");
var _projJs = require("../../proj.js");
var _transformJs = require("../../transform.js");
var _layerJs = require("./Layer.js");
var _layerJsDefault = parcelHelpers.interopDefault(_layerJs);
/**
 * @classdesc
 * Canvas renderer for image layers.
 * @api
 * @extends {CanvasLayerRenderer<import("../../layer/Image.js").default<import("../../source/Image.js").default>>}
 */ class CanvasImageLayerRenderer extends (0, _layerJsDefault.default) {
    /**
   * @param {import("../../layer/Image.js").default<import("../../source/Image.js").default>} imageLayer Image layer.
   */ constructor(imageLayer){
        super(imageLayer);
        /**
     * @protected
     * @type {?import("../../Image.js").default}
     */ this.image = null;
        /**
     * @private
     * @type {number}
     */ this.renderedSourceRevision_ = 0;
        /**
     * Rotation baked into the current image.
     * @protected
     * @type {number}
     */ this.renderedRotation = 0;
    }
    /**
   * @return {import('../../DataTile.js').ImageLike|null} Image.
   */ getImage() {
        return !this.image ? null : this.image.getImage();
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */ prepareFrame(frameState) {
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const pixelRatio = frameState.pixelRatio;
        const viewState = frameState.viewState;
        const viewResolution = viewState.resolution;
        const imageSource = this.getLayer().getSource();
        const hints = frameState.viewHints;
        let renderedExtent = /** @type {import("../../extent.js").Extent} */ frameState.extent;
        if (layerState.extent !== undefined) renderedExtent = (0, _extentJs.getIntersection)(renderedExtent, (0, _projJs.fromUserExtent)(layerState.extent, viewState.projection));
        if (!hints[(0, _viewHintJsDefault.default).ANIMATING] && !hints[(0, _viewHintJsDefault.default).INTERACTING] && !(0, _extentJs.isEmpty)(renderedExtent)) {
            if (imageSource) {
                if (!/** @type {unknown} */ this.getLayer().rendered && this.renderedSourceRevision_ !== imageSource.getRevision()) this.image = null;
                this.renderedSourceRevision_ = imageSource.getRevision();
                const projection = viewState.projection;
                const image = imageSource.getImage(renderedExtent, viewResolution, pixelRatio, projection);
                if (image) {
                    if (this.loadImage(image)) {
                        this.image = image;
                        this.renderedRotation = this.sourceRotates() ? viewState.rotation : 0;
                    } else if (image.getState() === (0, _imageStateJsDefault.default).EMPTY) this.image = null;
                }
            } else this.image = null;
        }
        return !!this.image;
    }
    /**
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|null} Data at the pixel location.
   * @override
   */ getData(pixel) {
        const frameState = this.frameState;
        if (!frameState || !this.image) return null;
        const layer = this.getLayer();
        const coordinate = (0, _transformJs.apply)(frameState.pixelToCoordinateTransform, pixel.slice());
        const layerExtent = layer.getExtent();
        if (layerExtent) {
            if (!(0, _extentJs.containsCoordinate)(layerExtent, coordinate)) return null;
        }
        const imageExtent = this.image.getExtent();
        const img = this.image.getImage();
        if (!img) return null;
        const imageRotation = this.renderedRotation;
        if (imageRotation !== 0) {
            const imageCenter = (0, _extentJs.getCenter)(imageExtent);
            const cosRotation = Math.cos(-imageRotation);
            const sinRotation = Math.sin(-imageRotation);
            const deltaX = coordinate[0] - imageCenter[0];
            const deltaY = coordinate[1] - imageCenter[1];
            coordinate[0] = imageCenter[0] + cosRotation * deltaX - sinRotation * deltaY;
            coordinate[1] = imageCenter[1] + sinRotation * deltaX + cosRotation * deltaY;
        }
        const imageMapWidth = (0, _extentJs.getWidth)(imageExtent);
        const col = Math.floor(img.width * ((coordinate[0] - imageExtent[0]) / imageMapWidth));
        if (col < 0 || col >= img.width) return null;
        const imageMapHeight = (0, _extentJs.getHeight)(imageExtent);
        const row = Math.floor(img.height * ((imageExtent[3] - coordinate[1]) / imageMapHeight));
        if (row < 0 || row >= img.height) return null;
        return this.getImageData(img, col, row);
    }
    /**
   * Render the layer.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   * @override
   */ renderFrame(frameState, target) {
        const image = this.image;
        if (!image) return this.getContainerElement();
        const imageExtent = image.getExtent();
        const imageResolution = image.getResolution();
        const [imageResolutionX, imageResolutionY] = Array.isArray(imageResolution) ? imageResolution : [
            imageResolution,
            imageResolution
        ];
        const imagePixelRatio = image.getPixelRatio();
        const imageRotation = this.renderedRotation;
        const imageSource = this.getLayer().getSource();
        const sourceRotates = this.sourceRotates();
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const pixelRatio = frameState.pixelRatio;
        const viewState = frameState.viewState;
        const viewCenter = viewState.center;
        const viewResolution = viewState.resolution;
        const viewRotation = viewState.rotation;
        const scaleX = pixelRatio * imageResolutionX / (viewResolution * imagePixelRatio);
        const scaleY = pixelRatio * imageResolutionY / (viewResolution * imagePixelRatio);
        this.prepareContainer(frameState, target);
        // desired dimensions of the canvas in pixels
        const width = this.getCanvasContext().canvas.width;
        const height = this.getCanvasContext().canvas.height;
        const context = this.getRenderContext(frameState);
        // clipped rendering if layer extent is set
        let clipped = false;
        let render = true;
        if (layerState.extent) {
            const layerExtent = (0, _projJs.fromUserExtent)(layerState.extent, viewState.projection);
            const frameExtent = /** @type {import("../../extent.js").Extent} */ frameState.extent;
            render = (0, _extentJs.intersects)(layerExtent, frameExtent);
            clipped = render && !(0, _extentJs.containsExtent)(layerExtent, frameExtent);
            if (clipped) this.clipUnrotated(context, frameState, layerExtent);
        }
        const img = image.getImage();
        if (!img) return this.getContainerElement();
        let transform, dw, dh;
        if (!sourceRotates) {
            transform = (0, _transformJs.compose)(this.tempTransform, width / 2, height / 2, scaleX, scaleY, 0, imagePixelRatio * (imageExtent[0] - viewCenter[0]) / imageResolutionX, imagePixelRatio * (viewCenter[1] - imageExtent[3]) / imageResolutionY);
            dw = img.width * transform[0];
            dh = img.height * transform[3];
        } else {
            // The image content is already rotated by imageRotation. Rotate by the
            // remaining delta around the image center; when the view is settled at
            // the image's rotation this reduces to a whole-pixel translation.
            const scale = pixelRatio / viewResolution;
            const cosRotation = Math.cos(viewRotation);
            const sinRotation = Math.sin(viewRotation);
            const imageCenter = (0, _extentJs.getCenter)(imageExtent);
            const centerX = imageCenter[0] - viewCenter[0];
            const centerY = imageCenter[1] - viewCenter[1];
            transform = (0, _transformJs.compose)(this.tempTransform, width / 2 + scale * (cosRotation * centerX + sinRotation * centerY), height / 2 + scale * (sinRotation * centerX - cosRotation * centerY), scaleX, scaleY, viewRotation - imageRotation, -img.width / 2, -img.height / 2);
            // The transform diagonal shrinks with the rotation delta; guard the draw
            // with the true scale instead.
            dw = img.width * scaleX;
            dh = img.height * scaleY;
        }
        this.renderedResolution = imageResolutionY * pixelRatio / imagePixelRatio;
        if (!imageSource?.getInterpolate() && (!sourceRotates || viewRotation === imageRotation)) context.imageSmoothingEnabled = false;
        this.preRender(context, frameState);
        if (render && dw >= 0.5 && dh >= 0.5) {
            const opacity = layerState.opacity;
            if (!sourceRotates) {
                const dx = transform[4];
                const dy = transform[5];
                if (opacity !== 1) {
                    context.save();
                    context.globalAlpha = opacity;
                }
                context.drawImage(img, 0, 0, img.width, img.height, dx, dy, dw, dh);
                if (opacity !== 1) context.restore();
            } else {
                context.save();
                if (opacity !== 1) context.globalAlpha = opacity;
                context.setTransform(transform[0], transform[1], transform[2], transform[3], transform[4], transform[5]);
                context.drawImage(img, 0, 0);
                context.restore();
            }
        }
        this.postRender(this.getCanvasContext(), frameState);
        if (clipped) context.restore();
        context.imageSmoothingEnabled = true;
        return this.getContainerElement();
    }
}
exports.default = CanvasImageLayerRenderer;

},{"../../ImageState.js":"7kySV","../../ViewHint.js":"fb2qR","../../extent.js":"MPjK5","../../proj.js":"gN0IK","../../transform.js":"7TqcG","./Layer.js":"h3JnK","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ihijF":[function(require,module,exports,__globalThis) {
/**
 * @module ol/layer/BaseImage
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _layerJs = require("./Layer.js");
var _layerJsDefault = parcelHelpers.interopDefault(_layerJs);
/**
 * @template {import("../source/Image.js").default} ImageSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../Map.js").default#addLayer map.addLayer()}.
 * @property {ImageSourceType} [source] Source for this layer.
 * @property {import('./Base.js').BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Server-rendered images that are available for arbitrary extents and
 * resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Image.js").default} ImageSourceType
 * @template {import("../renderer/Layer.js").default<*>} RendererType
 * @extends {Layer<ImageSourceType, RendererType>}
 * @api
 */ class BaseImageLayer extends (0, _layerJsDefault.default) {
    /**
   * @param {Options<ImageSourceType>} [options] Layer options.
   */ constructor(options){
        options = options ? options : {};
        super(options);
    }
}
exports.default = BaseImageLayer;

},{"./Layer.js":"aZQOw","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"eKqIN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MOTION_COLOR", ()=>MOTION_COLOR);
parcelHelpers.export(exports, "MOTION_OPACITY", ()=>MOTION_OPACITY);
// Recolors a directional FCD layer to a single color. Each layer has its own
// canvas (unique className), so `source-atop` only paints that layer's pixels.
parcelHelpers.export(exports, "attachMotionRecolor", ()=>attachMotionRecolor);
// A single overlay layer above the 12 directional layers that draws white
// stripes moving along each direction, at a pace set by each pixel's FCD speed
// band. Motion mode requests the WMS *speed* image for the directional layers,
// so their pixels give both the road mask and the speed.
parcelHelpers.export(exports, "createMotionOverlayLayer", ()=>createMotionOverlayLayer);
var _layer = require("ol/layer/Layer");
var _layerDefault = parcelHelpers.interopDefault(_layer);
var _imageState = require("ol/ImageState");
var _imageStateDefault = parcelHelpers.interopDefault(_imageState);
var _directionalLayers = require("./DirectionalLayers");
var _colorScale = require("./style/util/colorScale");
var _directionalMotionGeometryMjs = require("./directionalMotionGeometry.mjs");
const MOTION_COLOR = "#1e5aff";
const MOTION_OPACITY = 0.6;
// CSS pixels / CSS pixels per second
const STRIPE_SPACING = 28;
const STRIPE_HEAD = 6;
const STRIPE_SPEED_AT_50_KMH = 35;
const STRIPE_MIN_SPEED = 4;
const PROFILE_SAMPLES_PER_PX = 4;
const BANDS = (0, _directionalMotionGeometryMjs.speedBands)((0, _directionalLayers.SPEED_BREAKPOINTS));
const BAND_PX_PER_SEC = BANDS.map((band)=>(0, _directionalMotionGeometryMjs.stripeSpeedForKmh)(band.kmh, STRIPE_SPEED_AT_50_KMH, STRIPE_MIN_SPEED));
const PROFILE = (0, _directionalMotionGeometryMjs.stripeProfile)(STRIPE_SPACING, STRIPE_HEAD, PROFILE_SAMPLES_PER_PX);
function attachMotionRecolor(layer, isMotionMode) {
    layer.on("postrender", function(event) {
        if (!isMotionMode() || layer.getOpacity() === 0) return;
        const context = event.context;
        context.save();
        context.globalCompositeOperation = "source-atop";
        context.setTransform(1, 0, 0, 1, 0, 0);
        context.fillStyle = MOTION_COLOR;
        context.fillRect(0, 0, context.canvas.width, context.canvas.height);
        context.restore();
    });
}
const speedByColor = new Map();
function speedForColor(r, g, b) {
    const key = r << 16 | g << 8 | b;
    let speed = speedByColor.get(key);
    if (speed === undefined) {
        speed = (0, _colorScale.interpolatedSpeedFromColor)([
            r,
            g,
            b
        ], (0, _directionalLayers.SPEED_BREAKPOINTS));
        speedByColor.set(key, speed);
    }
    return speed;
}
// Per loaded WMS speed image: its non-transparent pixels with their speed band,
// sampled at ~CSS resolution (every `step`-th pixel on hidpi images). Built
// once per image; the per-frame loop only touches these pixels.
const roadPixelsCache = new WeakMap();
function getRoadPixels(image) {
    let cached = roadPixelsCache.get(image);
    if (cached) return cached;
    const img = image.getImage();
    const step = Math.max(1, Math.round(image.getPixelRatio()));
    const width = Math.floor(img.width / step);
    const height = Math.floor(img.height / step);
    if (width === 0 || height === 0) return null;
    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    const context = canvas.getContext("2d", {
        willReadFrequently: true
    });
    context.drawImage(img, 0, 0);
    const rgba = context.getImageData(0, 0, img.width, img.height).data;
    const xs = [];
    const ys = [];
    const alphas = [];
    const bands = [];
    for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
        const i = (y * step * img.width + x * step) * 4;
        const alpha = rgba[i + 3];
        if (alpha === 0) continue;
        xs.push(x);
        ys.push(y);
        alphas.push(alpha);
        bands.push((0, _directionalMotionGeometryMjs.bandIndexForSpeed)(BANDS, speedForColor(rgba[i], rgba[i + 1], rgba[i + 2])));
    }
    const extent = image.getExtent();
    cached = {
        width,
        height,
        extent,
        // map units per sampled pixel
        unit: step * image.getResolution() / image.getPixelRatio(),
        key: extent.join(",") + "|" + width + "x" + height,
        xs: Uint16Array.from(xs),
        ys: Uint16Array.from(ys),
        alphas: Uint8Array.from(alphas),
        bands: Uint8Array.from(bands)
    };
    roadPixelsCache.set(image, cached);
    return cached;
}
// One stripe buffer per image geometry. All 12 directions are normally
// requested for the same view and share one; mid-reload they can briefly differ.
function getBuffer(buffers, pixels) {
    let buffer = buffers.get(pixels.key);
    if (!buffer) {
        const canvas = document.createElement("canvas");
        canvas.width = pixels.width;
        canvas.height = pixels.height;
        const imageData = new ImageData(pixels.width, pixels.height);
        buffer = {
            pixels,
            canvas,
            imageData,
            data32: new Uint32Array(imageData.data.buffer)
        };
        buffers.set(pixels.key, buffer);
    }
    return buffer;
}
function paintStripes(buffer, pixels, frameState, heading) {
    const T = frameState.coordinateToPixelTransform;
    const { kx, ky } = (0, _directionalMotionGeometryMjs.stripeAxis)(T, heading);
    const unit = pixels.unit;
    // Along-heading distance of sampled pixel (x, y) = s0 + x * sx + y * sy.
    const s0 = kx * (pixels.extent[0] + unit / 2) + ky * (pixels.extent[3] - unit / 2);
    const sx = kx * unit;
    const sy = -ky * unit;
    const timeSec = frameState.time / 1000;
    const bandShift = BAND_PX_PER_SEC.map((pxPerSec)=>(0, _directionalMotionGeometryMjs.wrap)(timeSec * pxPerSec, STRIPE_SPACING));
    const { xs, ys, alphas, bands } = pixels;
    const data32 = buffer.data32;
    const width = pixels.width;
    for(let i = 0; i < xs.length; i++){
        const s = s0 + xs[i] * sx + ys[i] * sy - bandShift[bands[i]];
        const phase = (0, _directionalMotionGeometryMjs.wrap)(s, STRIPE_SPACING);
        const intensity = PROFILE[phase * PROFILE_SAMPLES_PER_PX | 0];
        if (intensity === 0) continue;
        const alpha = intensity * alphas[i] | 0;
        const idx = ys[i] * width + xs[i];
        // Overlapping directions: keep the brightest stripe (little-endian ABGR).
        if (alpha > data32[idx] >>> 24) data32[idx] = (alpha << 24 | 0xffffff) >>> 0;
    }
}
function createMotionOverlayLayer(directionalLayers, map, isMotionMode) {
    const canvas = document.createElement("canvas");
    canvas.style.cssText = "position:absolute; left:0; top:0; width:100%; height:100%;";
    const context = canvas.getContext("2d");
    const buffers = new Map();
    return new (0, _layerDefault.default)({
        minZoom: 17,
        render: function(frameState) {
            const pixelRatio = frameState.pixelRatio;
            const width = Math.round(frameState.size[0] * pixelRatio);
            const height = Math.round(frameState.size[1] * pixelRatio);
            if (canvas.width !== width || canvas.height !== height) {
                canvas.width = width;
                canvas.height = height;
            } else context.clearRect(0, 0, width, height);
            if (!isMotionMode()) return canvas;
            const used = new Set();
            directionalLayers.forEach(function(layer, id) {
                if (!layer.getVisible() || layer.getOpacity() === 0) return;
                const image = layer.getRenderer().image;
                if (!image || image.getState() !== (0, _imageStateDefault.default).LOADED) return;
                const pixels = getRoadPixels(image);
                if (!pixels) return;
                const buffer = getBuffer(buffers, pixels);
                if (!used.has(buffer)) {
                    buffer.data32.fill(0);
                    used.add(buffer);
                }
                paintStripes(buffer, pixels, frameState, (0, _directionalMotionGeometryMjs.directionHeadingRadians)(Number(id)));
            });
            const T = frameState.coordinateToPixelTransform;
            used.forEach(function(buffer) {
                const { extent, unit } = buffer.pixels;
                buffer.canvas.getContext("2d").putImageData(buffer.imageData, 0, 0);
                // sampled pixel -> device px
                context.setTransform(pixelRatio * T[0] * unit, pixelRatio * T[1] * unit, -pixelRatio * T[2] * unit, -pixelRatio * T[3] * unit, pixelRatio * (T[0] * extent[0] + T[2] * extent[3] + T[4]), pixelRatio * (T[1] * extent[0] + T[3] * extent[3] + T[5]));
                context.drawImage(buffer.canvas, 0, 0);
            });
            context.setTransform(1, 0, 0, 1, 0, 0);
            // Drop buffers for geometries no longer on screen.
            buffers.forEach(function(buffer, key) {
                if (!used.has(buffer)) buffers.delete(key);
            });
            if (used.size > 0) map.render();
            return canvas;
        }
    });
}

},{"ol/layer/Layer":"aZQOw","ol/ImageState":"7kySV","./DirectionalLayers":"ffH8s","./style/util/colorScale":"dOPOB","./directionalMotionGeometry.mjs":"8JFqg","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8JFqg":[function(require,module,exports,__globalThis) {
// Pure geometry for the FCD "motion" mode: stripes perpendicular to a driving
// heading that travel along it, at a pace set by the FCD speed. Kept free of OpenLayers imports so it can be
// unit-tested with `node --test`.
// FCD direction ids 1..12 are 30° heading buckets clockwise from north, matching
// the layout of the DirectionalHeatmapControl wheel (1 = N, 4 = E, 7 = S, 10 = W).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "directionHeadingRadians", ()=>directionHeadingRadians);
// Projection onto the on-screen driving direction.
//   T        OL coordinateToPixelTransform [a, b, c, d, e, f] (map -> CSS px;
//            carries view rotation and the y flip)
//   heading  driving heading in radians, clockwise from north
// Returns the screen unit vector `dir` and `kx`, `ky` such that
// `kx * X + ky * Y` is the CSS-pixel distance along `dir` of map coordinate
// (X, Y), measured from the map origin. Measuring from the origin (not the
// viewport) keeps the stripes attached to the roads while panning.
parcelHelpers.export(exports, "stripeAxis", ()=>stripeAxis);
parcelHelpers.export(exports, "wrap", ()=>wrap);
// Stripe intensity (0..1) over one period of `spacing` CSS px, sampled
// `samplesPerPx` times per px: a fading tail then a bright `head` at the
// leading (+dir) end, so the stripe reads as moving forward.
parcelHelpers.export(exports, "stripeProfile", ()=>stripeProfile);
// Speed bands between consecutive breakpoints plus an open-ended top band.
// Stripes animate per band rather than per pixel: a per-pixel speed would shear
// the stripe pattern more every second, a band only breaks it at band edges.
parcelHelpers.export(exports, "speedBands", ()=>speedBands);
parcelHelpers.export(exports, "bandIndexForSpeed", ()=>bandIndexForSpeed);
// Screen speed of the stripes: proportional to km/h (`pxPerSecAt50` at 50 km/h)
// with a floor so standing traffic still visibly crawls.
parcelHelpers.export(exports, "stripeSpeedForKmh", ()=>stripeSpeedForKmh);
function directionHeadingRadians(direction) {
    return (direction - 1) * Math.PI / 6;
}
function stripeAxis(T, heading) {
    const ux = Math.sin(heading);
    const uy = Math.cos(heading);
    const vx = T[0] * ux + T[2] * uy;
    const vy = T[1] * ux + T[3] * uy;
    const len = Math.hypot(vx, vy);
    const dx = vx / len;
    const dy = vy / len;
    return {
        dir: [
            dx,
            dy
        ],
        kx: T[0] * dx + T[1] * dy,
        ky: T[2] * dx + T[3] * dy
    };
}
function wrap(value, period) {
    const r = value % period;
    return r < 0 ? r + period : r;
}
function stripeProfile(spacing, head, samplesPerPx) {
    const n = spacing * samplesPerPx;
    const profile = new Float32Array(n);
    const tailStart = spacing * 0.4;
    const headStart = spacing - head;
    for(let i = 0; i < n; i++){
        const px = i / samplesPerPx;
        if (px >= headStart) profile[i] = 0.95;
        else if (px >= tailStart) profile[i] = 0.55 * (px - tailStart) / (headStart - tailStart);
    }
    return profile;
}
function speedBands(breakpoints) {
    const bands = [];
    for(let i = 0; i < breakpoints.length - 1; i++){
        const min = breakpoints[i];
        const max = breakpoints[i + 1];
        bands.push({
            min,
            max,
            kmh: (min + max) / 2
        });
    }
    const top = breakpoints[breakpoints.length - 1];
    bands.push({
        min: top,
        max: Infinity,
        kmh: top
    });
    return bands;
}
function bandIndexForSpeed(bands, kmh) {
    for(let i = 0; i < bands.length; i++){
        if (kmh < bands[i].max) return i;
    }
    return bands.length - 1;
}
function stripeSpeedForKmh(kmh, pxPerSecAt50, minPxPerSec) {
    return Math.max(minPxPerSec, kmh / 50 * pxPerSecAt50);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fXIgK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DataSourceControl", ()=>DataSourceControl);
var _control = require("ol/control/Control");
var _controlDefault = parcelHelpers.interopDefault(_control);
class DataSourceControl extends (0, _controlDefault.default) {
    constructor(opt_options){
        const options = opt_options || {};
        const div = document.createElement("div");
        super({
            element: div,
            target: options.target
        });
        const this_ = this;
        div.className = "data-source";
        const label = document.createElement("p");
        label.innerText = "Data source selection";
        label.className = "data-source-label";
        div.appendChild(label);
        const radios = [];
        for(let i = 0; i < 6; i++){
            const radio = document.createElement("input");
            radio.type = "radio";
            radio.name = "data-source";
            radio.value = i;
            radio.id = "radio-" + i;
            radios.push(radio);
            if (i == 4) {
                radio.checked = true;
                this_.set("dataSource", i);
            }
            radio.addEventListener("change", function() {
                this_.set("dataSource", i);
            });
            const radioLabel = document.createElement("label");
            radioLabel.htmlFor = "radio-" + i;
            radioLabel.innerText = i;
            div.appendChild(radio);
            div.appendChild(radioLabel);
        }
        this.on("propertychange", function(e) {
            if (e.key === "dataSource") {
                const val = this_.get("dataSource");
                radios.forEach(function(r, i) {
                    r.checked = i === val;
                });
            }
        });
    }
}

},{"ol/control/Control":"8KSMn","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6bJVZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addGeocoderControl", ()=>addGeocoderControl);
var _olGeocoder = require("ol-geocoder");
var _olGeocoderDefault = parcelHelpers.interopDefault(_olGeocoder);
function addGeocoderControl(map) {
    const geocoder = new (0, _olGeocoderDefault.default)("nominatim", {
        provider: "osm",
        lang: "en",
        targetType: "glass-button",
        placeholder: "Search for ...",
        limit: 5,
        debug: false,
        autoComplete: true,
        keepOpen: false,
        preventMarker: true
    });
    map.addControl(geocoder);
}

},{"ol-geocoder":"1bUp3","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1bUp3":[function(require,module,exports,__globalThis) {
/*!
 * ol-geocoder - v4.3.3
 * A geocoder extension compatible with OpenLayers v6.x to v9.0
 * https://github.com/Dominique92/ol-geocoder
 * Built: 15/03/2024 08:57:04
 */ !function(e, t) {
    module.exports = t(require("d44e0263994d8518"), require("e7c81622ced83b7e"), require("f8b796a0e43051de"), require("ad8d699790cf7c67"), require("81f5340139bc0735"), require("cdb3cbf620ffc78"), require("7a530b3a437d556a"), require("1f8863aa812eebec"));
}(this, function(e, t, s, r, n, o, a, i) {
    "use strict";
    function l(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    function c(e) {
        if (e && e.__esModule) return e;
        var t = Object.create(null);
        return e && Object.keys(e).forEach(function(s) {
            if ("default" !== s) {
                var r = Object.getOwnPropertyDescriptor(e, s);
                Object.defineProperty(t, s, r.get ? r : {
                    enumerable: !0,
                    get: function() {
                        return e[s];
                    }
                });
            }
        }), t.default = e, Object.freeze(t);
    }
    var d = l(e), u = l(t), p = l(s), h = l(r), g = l(n), m = l(o), y = l(a), f = c(i), b = "gcd-container", v = "gcd-button-control", w = "gcd-input-query", x = "gcd-input-label", $ = "gcd-input-search", k = {
        namespace: "ol-geocoder",
        spin: "gcd-pseudo-rotate",
        hidden: "gcd-hidden",
        address: "gcd-address",
        country: "gcd-country",
        city: "gcd-city",
        road: "gcd-road",
        olControl: "ol-control",
        glass: {
            container: "gcd-gl-container",
            control: "gcd-gl-control",
            button: "gcd-gl-btn",
            input: "gcd-gl-input",
            expanded: "gcd-gl-expanded",
            search: "gcd-gl-search",
            result: "gcd-gl-result"
        },
        inputText: {
            container: "gcd-txt-container",
            control: "gcd-txt-control",
            label: "gcd-txt-label",
            input: "gcd-txt-input",
            search: "gcd-txt-search",
            icon: "gcd-txt-glass",
            result: "gcd-txt-result"
        }
    }, S = {
        containerId: b,
        buttonControlId: v,
        inputQueryId: w,
        inputLabelId: x,
        inputSearchId: $,
        cssClasses: k
    };
    const q = Object.freeze({
        __proto__: null,
        containerId: b,
        buttonControlId: v,
        inputQueryId: w,
        inputLabelId: x,
        inputSearchId: $,
        cssClasses: k,
        default: S
    }), L = "addresschosen", C = "nominatim", E = "reverse", T = "glass-button", j = "text-input", I = "bing", N = "mapquest", P = "opencage", A = "osm", R = "photon", F = "https://dev.virtualearth.net/REST/v1/Locations", _ = "https://nominatim.openstreetmap.org/search", M = "https://api.opencagedata.com/geocode/v1/json?", O = "https://nominatim.openstreetmap.org/search", D = "https://photon.komoot.io/api/", V = {
        provider: A,
        label: "",
        placeholder: "Search for an address",
        featureStyle: null,
        targetType: T,
        lang: "en-US",
        limit: 5,
        keepOpen: !1,
        preventDefault: !1,
        preventPanning: !1,
        preventMarker: !1,
        defaultFlyResolution: 10,
        debug: !1
    };
    function B(e, t = "Assertion failed") {
        if (!e) {
            if ("undefined" != typeof Error) throw new Error(t);
            throw t;
        }
    }
    function U(e) {
        const t = (function() {
            if ("performance" in window == 0 && (window.performance = {}), "now" in window.performance == 0) {
                let e = Date.now();
                performance.timing && performance.timing.navigationStart && (e = performance.timing.navigationStart), window.performance.now = ()=>Date.now() - e;
            }
            return window.performance.now();
        })().toString(36);
        return e ? e + t : t;
    }
    function G(e) {
        return /^\d+$/u.test(e);
    }
    function Q(e, t, s) {
        if (Array.isArray(e)) return void e.forEach((e)=>Q(e, t));
        const r = Array.isArray(t) ? t : t.split(/\s+/u);
        let n = r.length;
        for(; n--;)H(e, r[n]) || Y(e, r[n], s);
    }
    function z(e, t, s) {
        if (Array.isArray(e)) return void e.forEach((e)=>z(e, t, s));
        const r = Array.isArray(t) ? t : t.split(/\s+/u);
        let n = r.length;
        for(; n--;)H(e, r[n]) && Z(e, r[n], s);
    }
    function H(e, t) {
        return e.classList ? e.classList.contains(t) : X(t).test(e.className);
    }
    function K(e) {
        for(; e.firstChild;)e.firstChild.remove();
    }
    function J(e, t) {
        return e.replace(/\{\s*([\w-]+)\s*\}/gu, (e, s)=>{
            const r = void 0 === t[s] ? "" : t[s];
            return String(r).replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;").replaceAll('"', "&quot;").replaceAll("'", "&#039;");
        });
    }
    function W(e, t) {
        let s;
        if (Array.isArray(e)) {
            if (s = document.createElement(e[0]), e[1].id && (s.id = e[1].id), e[1].classname && (s.className = e[1].classname), e[1].attr) {
                const { attr: t } = e[1];
                if (Array.isArray(t)) {
                    let e = -1;
                    for(; ++e < t.length;)s.setAttribute(t[e].name, t[e].value);
                } else s.setAttribute(t.name, t.value);
            }
        } else s = document.createElement(e);
        s.innerHTML = t;
        const r = document.createDocumentFragment();
        for(; s.childNodes[0];)r.append(s.childNodes[0]);
        return s.append(r), s;
    }
    function X(e) {
        return new RegExp(`(^|\\s+) ${e} (\\s+|$)`, "u");
    }
    function Y(e, t, s) {
        e.classList ? e.classList.add(t) : e.className = `${e.className} ${t}`.trim(), s && G(s) && window.setTimeout(()=>Z(e, t), s);
    }
    function Z(e, t, s) {
        e.classList ? e.classList.remove(t) : e.className = e.className.replace(X(t), " ").trim(), s && G(s) && window.setTimeout(()=>Y(e, t), s);
    }
    const ee = q.cssClasses;
    class te {
        constructor(e){
            this.options = e, this.els = this.createControl();
        }
        createControl() {
            let e, t, s;
            return this.options.targetType === j ? (t = `${ee.namespace} ${ee.inputText.container}`, e = W([
                "div",
                {
                    id: q.containerId,
                    classname: t
                }
            ], te.input), s = {
                container: e,
                control: e.querySelector(`.${ee.inputText.control}`),
                label: e.querySelector(`.${ee.inputText.label}`),
                input: e.querySelector(`.${ee.inputText.input}`),
                search: e.querySelector(`.${ee.inputText.search}`),
                result: e.querySelector(`.${ee.inputText.result}`)
            }, s.label.innerHTML = this.options.label) : (t = `${ee.namespace} ${ee.glass.container}`, e = W([
                "div",
                {
                    id: q.containerId,
                    classname: t
                }
            ], te.glass), s = {
                container: e,
                control: e.querySelector(`.${ee.glass.control}`),
                button: e.querySelector(`.${ee.glass.button}`),
                input: e.querySelector(`.${ee.glass.input}`),
                search: e.querySelector(`.${ee.glass.search}`),
                result: e.querySelector(`.${ee.glass.result}`)
            }), s.input.placeholder = this.options.placeholder, s;
        }
    }
    function se(e) {
        return new Promise((t, s)=>{
            const r = function(e, t) {
                t && "object" == typeof t && (e += (/\?/u.test(e) ? "&" : "?") + re(t));
                return e;
            }(e.url, e.data), n = {
                method: "GET",
                mode: "cors",
                credentials: "same-origin"
            };
            e.jsonp ? function(e, t, s) {
                const { head: r } = document, n = document.createElement("script"), o = `f${Math.round(Math.random() * Date.now())}`;
                n.setAttribute("src", `${e + (e.indexOf("?") > 0 ? "&" : "?") + t}=${o}`), window[o] = (e)=>{
                    window[o] = void 0, setTimeout(()=>r.removeChild(n), 0), s(e);
                }, r.append(n);
            }(r, e.callbackName, t) : fetch(r, n).then((e)=>e.json()).then(t).catch(s);
        });
    }
    function re(e) {
        return Object.keys(e).reduce((t, s)=>(t.push("object" == typeof e[s] ? re(e[s]) : `${encodeURIComponent(s)}=${encodeURIComponent(e[s])}`), t), []).join("&");
    }
    te.glass = `\n  <div class="${ee.glass.control} ${ee.olControl}">\n    <button type="button" id="${q.buttonControlId}" class="${ee.glass.button}"></button>\n    <input type="text" id="${q.inputQueryId}" class="${ee.glass.input}" autocomplete="off" placeholder="Search ...">\n    <a id="${q.inputSearchId}" class="${ee.glass.search} ${ee.hidden}"></a>\n  </div>\n  <ul class="${ee.glass.result}"></ul>\n`, te.input = `\n  <div class="${ee.inputText.control}">\n    <label type="button" id="${q.inputSearchId}" class="${ee.inputText.label}"></label>\n    <input type="text" id="${q.inputQueryId}" class="${ee.inputText.input}" autocomplete="off" placeholder="Search ...">\n    <span class="${ee.inputText.icon}"></span>\n    <button type="button" id="${q.inputSearchId}" class="${ee.inputText.search} ${ee.hidden}"></button>\n  </div>\n  <ul class="${ee.inputText.result}"></ul>\n`;
    class ne {
        constructor(){
            this.settings = {
                url: D,
                params: {
                    q: "",
                    limit: 10,
                    lang: "en"
                },
                langs: [
                    "de",
                    "it",
                    "fr",
                    "en"
                ]
            };
        }
        getParameters(e) {
            return e.lang = e.lang.toLowerCase(), {
                url: this.settings.url,
                params: {
                    q: e.query,
                    limit: e.limit || this.settings.params.limit,
                    lang: this.settings.langs.includes(e.lang) ? e.lang : this.settings.params.lang
                }
            };
        }
        handleResponse(e) {
            return 0 === e.features.length ? [] : e.features.map((e)=>({
                    lon: e.geometry.coordinates[0],
                    lat: e.geometry.coordinates[1],
                    address: {
                        name: e.properties.name,
                        postcode: e.properties.postcode,
                        city: e.properties.city,
                        state: e.properties.state,
                        country: e.properties.country
                    },
                    original: {
                        formatted: e.properties.name,
                        details: e.properties
                    }
                }));
        }
    }
    class oe {
        constructor(e){
            this.settings = {
                url: O,
                ...e,
                params: {
                    q: "",
                    format: "json",
                    addressdetails: 1,
                    limit: 10,
                    countrycodes: "",
                    viewbox: "",
                    "accept-language": "en-US"
                }
            };
        }
        getParameters(e) {
            return {
                url: this.settings.url,
                params: {
                    q: e.query,
                    format: this.settings.params.format,
                    addressdetails: this.settings.params.addressdetails,
                    limit: e.limit || this.settings.params.limit,
                    countrycodes: e.countrycodes || this.settings.params.countrycodes,
                    viewbox: e.viewbox || this.settings.params.viewbox,
                    "accept-language": e.lang || this.settings.params["accept-language"]
                }
            };
        }
        handleResponse(e) {
            return 0 === e.length ? [] : e.map((e)=>({
                    lon: e.lon,
                    lat: e.lat,
                    bbox: e.boundingbox,
                    address: {
                        name: e.display_name,
                        road: e.address.road || "",
                        houseNumber: e.address.house_number || "",
                        postcode: e.address.postcode,
                        city: e.address.city || e.address.town,
                        state: e.address.state,
                        country: e.address.country
                    },
                    original: {
                        formatted: e.display_name,
                        details: e.address
                    }
                }));
        }
    }
    class ae {
        constructor(){
            this.settings = {
                url: _,
                params: {
                    q: "",
                    key: "",
                    format: "json",
                    addressdetails: 1,
                    limit: 10,
                    countrycodes: "",
                    "accept-language": "en-US"
                }
            };
        }
        getParameters(e) {
            return {
                url: this.settings.url,
                params: {
                    q: e.query,
                    key: e.key,
                    format: "json",
                    addressdetails: 1,
                    limit: e.limit || this.settings.params.limit,
                    countrycodes: e.countrycodes || this.settings.params.countrycodes,
                    "accept-language": e.lang || this.settings.params["accept-language"]
                }
            };
        }
        handleResponse(e) {
            return 0 === e.length ? [] : e.map((e)=>({
                    lon: e.lon,
                    lat: e.lat,
                    address: {
                        name: e.address.neighbourhood || "",
                        road: e.address.road || "",
                        postcode: e.address.postcode,
                        city: e.address.city || e.address.town,
                        state: e.address.state,
                        country: e.address.country
                    },
                    original: {
                        formatted: e.display_name,
                        details: e.address
                    }
                }));
        }
    }
    class ie {
        constructor(){
            this.settings = {
                url: F,
                callbackName: "jsonp",
                params: {
                    query: "",
                    key: "",
                    includeNeighborhood: 0,
                    maxResults: 10
                }
            };
        }
        getParameters(e) {
            return {
                url: this.settings.url,
                callbackName: this.settings.callbackName,
                params: {
                    query: e.query,
                    key: e.key,
                    includeNeighborhood: e.includeNeighborhood || this.settings.params.includeNeighborhood,
                    maxResults: e.maxResults || this.settings.params.maxResults
                }
            };
        }
        handleResponse(e) {
            const { resources: t } = e.resourceSets[0];
            return 0 === t.length ? [] : t.map((e)=>({
                    lon: e.point.coordinates[1],
                    lat: e.point.coordinates[0],
                    address: {
                        name: e.name
                    },
                    original: {
                        formatted: e.address.formattedAddress,
                        details: e.address
                    }
                }));
        }
    }
    class le {
        constructor(){
            this.settings = {
                url: M,
                params: {
                    q: "",
                    key: "",
                    limit: 10,
                    countrycode: "",
                    pretty: 1,
                    no_annotations: 1
                }
            };
        }
        getParameters(e) {
            return {
                url: this.settings.url,
                params: {
                    q: e.query,
                    key: e.key,
                    limit: e.limit || this.settings.params.limit,
                    countrycode: e.countrycodes || this.settings.params.countrycodes
                }
            };
        }
        handleResponse(e) {
            return 0 === e.results.length ? [] : e.results.map((e)=>({
                    lon: e.geometry.lng,
                    lat: e.geometry.lat,
                    address: {
                        name: e.components.house_number || "",
                        road: e.components.road || "",
                        postcode: e.components.postcode,
                        city: e.components.city || e.components.town,
                        state: e.components.state,
                        country: e.components.country
                    },
                    original: {
                        formatted: e.formatted,
                        details: e.components
                    }
                }));
        }
    }
    const ce = q.cssClasses;
    class de {
        constructor(e, t){
            this.Base = e, this.layerName = U("geocoder-layer-"), this.layer = new h.default({
                background: "transparent",
                name: this.layerName,
                source: new g.default,
                displayInLayerSwitcher: !1
            }), this.options = e.options, this.options.provider = "string" == typeof this.options.provider ? this.options.provider.toLowerCase() : this.options.provider, this.provider = this.newProvider(), this.els = t, this.container = this.els.container, this.registeredListeners = {
                mapClick: !1
            }, this.setListeners();
        }
        setListeners() {
            const e = (e)=>{
                e.stopPropagation(), H(this.els.control, ce.glass.expanded) ? this.collapse() : this.expand();
            };
            this.els.input.addEventListener("keypress", (e)=>{
                const t = e.target.value.trim();
                (e.key ? "Enter" === e.key : e.which ? 13 === e.which : !!e.keyCode && 13 === e.keyCode) && (e.preventDefault(), this.query(t));
            }, !1), this.els.input.addEventListener("click", (e)=>e.stopPropagation(), !1), this.els.input.addEventListener("input", (e)=>{
                0 !== e.target.value.trim().length ? z(this.els.search, ce.hidden) : Q(this.els.search, ce.hidden);
            }, !1), this.els.search.addEventListener("click", ()=>{
                this.els.input.focus(), this.query(this.els.input.value);
            }, !1), this.options.targetType === T && this.els.button.addEventListener("click", e, !1);
        }
        query(e) {
            this.provider || (this.provider = this.newProvider());
            const t = this.provider.getParameters({
                query: e,
                key: this.options.key,
                lang: this.options.lang,
                countrycodes: this.options.countrycodes,
                viewbox: this.options.viewbox,
                limit: this.options.limit
            });
            this.clearResults(!1 === this.options.keepOpen), Q(this.els.search, ce.spin);
            const s = {
                url: t.url,
                data: t.params
            };
            t.callbackName && (s.jsonp = !0, s.callbackName = t.callbackName), se(s).then((e)=>{
                this.options.debug && console.info(e), z(this.els.search, ce.spin);
                const t = this.provider.handleResponse(e);
                t && (this.createList(t), this.listenMapClick());
            }).catch(()=>{
                z(this.els.search, ce.spin);
                const e = W("li", "<h5>Error! No internet connection?</h5>");
                this.els.result.append(e);
            });
        }
        createList(e) {
            const t = this.els.result;
            e.forEach((s)=>{
                let r;
                if (this.options.provider === A) r = `<span class="${ce.road}">${s.address.name}</span>`;
                else r = this.addressTemplate(s.address);
                if (1 == e.length) this.chosen(s, r, s.address, s.original);
                else {
                    const e = W("li", `<a href="#">${r}</a>`);
                    e.addEventListener("click", (e)=>{
                        e.preventDefault(), this.chosen(s, r, s.address, s.original);
                    }, !1), t.append(e);
                }
            });
        }
        chosen(e, t, s, r) {
            const n = this.Base.getMap(), o = [
                Number.parseFloat(e.lon),
                Number.parseFloat(e.lat)
            ], a = n.getView().getProjection(), i = f.transform(o, "EPSG:4326", a);
            let { bbox: l } = e;
            l && (l = f.transformExtent([
                parseFloat(l[2]),
                parseFloat(l[0]),
                parseFloat(l[3]),
                parseFloat(l[1])
            ], "EPSG:4326", a));
            const c = {
                formatted: t,
                details: s,
                original: r
            };
            if (this.clearResults(!0), !0 === this.options.preventDefault || !0 === this.options.preventMarker) this.Base.dispatchEvent({
                type: L,
                address: c,
                coordinate: i,
                bbox: l,
                place: e
            });
            else {
                const t = this.createFeature(i, c);
                this.Base.dispatchEvent({
                    type: L,
                    address: c,
                    feature: t,
                    coordinate: i,
                    bbox: l,
                    place: e
                });
            }
            !0 !== this.options.preventDefault && !0 !== this.options.preventPanning && (l ? n.getView().fit(l, {
                duration: 500
            }) : n.getView().animate({
                center: i,
                resolution: this.options.defaultFlyResolution,
                duration: 500
            }));
        }
        createFeature(e) {
            const t = new y.default(new m.default(e));
            return this.addLayer(), t.setStyle(this.options.featureStyle), t.setId(U("geocoder-ft-")), this.getSource().addFeature(t), t;
        }
        addressTemplate(e) {
            const t = [];
            return e.name && t.push([
                '<span class="',
                ce.road,
                '">{name}</span>'
            ].join("")), (e.road || e.building || e.house_number) && t.push([
                '<span class="',
                ce.road,
                '">{building} {road} {house_number}</span>'
            ].join("")), (e.city || e.town || e.village) && t.push([
                '<span class="',
                ce.city,
                '">{postcode} {city} {town} {village}</span>'
            ].join("")), (e.state || e.country) && t.push([
                '<span class="',
                ce.country,
                '">{state} {country}</span>'
            ].join("")), J(t.join("<br>"), e);
        }
        newProvider() {
            switch(this.options.provider){
                case A:
                    return new oe(this.options);
                case N:
                    return new ae;
                case R:
                    return new ne;
                case I:
                    return new ie;
                case P:
                    return new le;
                default:
                    return this.options.provider;
            }
        }
        expand() {
            z(this.els.input, ce.spin), Q(this.els.control, ce.glass.expanded), window.setTimeout(()=>this.els.input.focus(), 100), this.listenMapClick();
        }
        collapse() {
            this.els.input.value = "", this.els.input.blur(), Q(this.els.search, ce.hidden), z(this.els.control, ce.glass.expanded), K(this.els.result);
        }
        listenMapClick() {
            if (this.registeredListeners.mapClick) return;
            const e = this, t = this.Base.getMap().getTargetElement();
            this.registeredListeners.mapClick = !0, t.addEventListener("click", {
                handleEvent (s) {
                    t.removeEventListener(s.type, this, !1), e.registeredListeners.mapClick = !1;
                }
            }, !1);
        }
        clearResults(e) {
            e && this.options.targetType === T ? this.collapse() : K(this.els.result);
        }
        getSource() {
            return this.layer.getSource();
        }
        addLayer() {
            let e = !1;
            const t = this.Base.getMap();
            t.getLayers().forEach((t)=>{
                t === this.layer && (e = !0);
            }), e || t.addLayer(this.layer);
        }
    }
    class ue extends d.default {
        constructor(e = C, t){
            B("string" == typeof e, "@param `type` should be string!"), B(e === C || e === E, `@param 'type' should be '${C}'\n      or '${E}'!`);
            const s = {
                ...V,
                featureStyle: [
                    new u.default({
                        image: new p.default({
                            anchor: [
                                .5,
                                1
                            ],
                            src: 'data:image/svg+xml;charset=utf-8,<svg width="26" height="42" viewBox="0 0 26 42" xmlns="http://www.w3.org/2000/svg"><polygon points="1,18 14,42 25,18" fill="rgb(75,75,75)" /><ellipse cx="13" cy="13" rx="13" ry="13" fill="rgb(75,75,75)" /><ellipse cx="13" cy="14" rx="6" ry="6" fill="yellow" /></svg>'
                        })
                    })
                ],
                ...t
            };
            let r, n;
            const o = new te(s);
            if (e === C && (r = o.els.container), super({
                element: r,
                ...s
            }), !(this instanceof ue)) return new ue;
            this.options = s, this.container = r, e === C && (n = new de(this, o.els), this.layer = n.layer);
        }
        getLayer() {
            return this.layer;
        }
        getSource() {
            return this.getLayer().getSource();
        }
        setProvider(e) {
            this.options.provider = e;
        }
        setProviderKey(e) {
            this.options.key = e;
        }
    }
    return ue;
});

},{"d44e0263994d8518":"8KSMn","e7c81622ced83b7e":"gqpPW","f8b796a0e43051de":"ib4Ft","ad8d699790cf7c67":"7ga2c","81f5340139bc0735":"7zHxp","cdb3cbf620ffc78":"95T6m","7a530b3a437d556a":"iVSSP","1f8863aa812eebec":"gN0IK"}],"cLPMT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addBasemapLayersAndControls", ()=>addBasemapLayersAndControls);
var _group = require("ol/layer/Group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _olLayerswitcher = require("ol-layerswitcher");
var _olLayerswitcherDefault = parcelHelpers.interopDefault(_olLayerswitcher);
var _basemapTileLayers = require("../layers/basemapTileLayers");
var _urlstateManager = require("../state/URLStateManager");
function addBasemapLayersAndControls(map, azureLoginControl) {
    const layerSwitcher = new (0, _olLayerswitcherDefault.default)({
        tipLabel: "Basemaps",
        groupSelectStyle: "none"
    });
    const tileLayers = (0, _basemapTileLayers.createBasemapTileLayers)(azureLoginControl);
    // The main viewer drives basemap selection via ol-layerswitcher, which needs
    // `title` + `type: "base"`. With no basemap in the URL, all layers start
    // visible and the switcher keeps the last one (Orbis). If the URL pins a
    // basemap, show only that one so the switcher keeps it instead.
    const initial = (0, _urlstateManager.resolveInitialBasemap)(tileLayers.map(({ name })=>name), (0, _urlstateManager.getBasemapFromURL)());
    tileLayers.forEach(({ name, layer })=>{
        layer.set("title", name);
        layer.set("type", "base");
        layer.setVisible(initial ? name === initial : true);
    });
    (0, _urlstateManager.registerBasemapLayers)(tileLayers);
    map.addLayer(new (0, _groupDefault.default)({
        title: "Base maps",
        layers: tileLayers.map(({ layer })=>layer)
    }));
    map.addControl(layerSwitcher);
}

},{"ol/layer/Group":"6DIkJ","ol-layerswitcher":"hhkWj","../layers/basemapTileLayers":"3mhEo","../state/URLStateManager":"7Lluw","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hhkWj":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    module.exports = factory(require("2f1f65643b836f7d"), require("ca02aeb924cb46c7"), require("4d8e01a82b9017e0"));
})(this, function(Control, ol_Observable, LayerGroup) {
    'use strict';
    Control = 'default' in Control ? Control['default'] : Control;
    LayerGroup = 'default' in LayerGroup ? LayerGroup['default'] : LayerGroup;
    /**
 * @protected
 */ const CSS_PREFIX = 'layer-switcher-';
    /**
 * OpenLayers LayerSwitcher Control, displays a list of layers and groups
 * associated with a map which have a `title` property.
 *
 * To be shown in the LayerSwitcher panel layers must have a `title` property;
 * base map layers should have a `type` property set to `base`. Group layers
 * (`LayerGroup`) can be used to visually group layers together; a group
 * with a `fold` property set to either `'open'` or `'close'` will be displayed
 * with a toggle.
 *
 * See [BaseLayerOptions](#baselayeroptions) for a full list of LayerSwitcher
 * properties for layers (`TileLayer`, `ImageLayer`, `VectorTile` etc.) and
 * [GroupLayerOptions](#grouplayeroptions) for group layer (`LayerGroup`)
 * LayerSwitcher properties.
 *
 * Layer and group properties can either be set by adding extra properties
 * to their options when they are created or via their set method.
 *
 * Specify a `title` for a Layer by adding a `title` property to it's options object:
 * ```javascript
 * var lyr = new ol.layer.Tile({
 *   // Specify a title property which will be displayed by the layer switcher
 *   title: 'OpenStreetMap',
 *   visible: true,
 *   source: new ol.source.OSM()
 * })
 * ```
 *
 * Alternatively the properties can be set via the `set` method after a layer has been created:
 * ```javascript
 * var lyr = new ol.layer.Tile({
 *   visible: true,
 *   source: new ol.source.OSM()
 * })
 * // Specify a title property which will be displayed by the layer switcher
 * lyr.set('title', 'OpenStreetMap');
 * ```
 *
 * To create a LayerSwitcher and add it to a map, create a new instance then pass it to the map's [`addControl` method](https://openlayers.org/en/latest/apidoc/module-ol_Map-Map.html#addControl).
 * ```javascript
 * var layerSwitcher = new LayerSwitcher({
 *   reverse: true,
 *   groupSelectStyle: 'group'
 * });
 * map.addControl(layerSwitcher);
 * ```
 *
 * @constructor
 * @extends {ol/control/Control~Control}
 * @param opt_options LayerSwitcher options, see  [LayerSwitcher Options](#options) and [RenderOptions](#renderoptions) which LayerSwitcher `Options` extends for more details.
 */ class LayerSwitcher extends Control {
        constructor(opt_options){
            const options = Object.assign({}, opt_options);
            const element = document.createElement('div');
            super({
                element: element,
                target: options.target
            });
            this.activationMode = options.activationMode || 'mouseover';
            this.startActive = options.startActive === true;
            // TODO Next: Rename to showButtonContent
            this.label = options.label !== undefined ? options.label : '';
            // TODO Next: Rename to hideButtonContent
            this.collapseLabel = options.collapseLabel !== undefined ? options.collapseLabel : '\u00BB';
            // TODO Next: Rename to showButtonTitle
            this.tipLabel = options.tipLabel ? options.tipLabel : 'Legend';
            // TODO Next: Rename to hideButtonTitle
            this.collapseTipLabel = options.collapseTipLabel ? options.collapseTipLabel : 'Collapse legend';
            this.groupSelectStyle = LayerSwitcher.getGroupSelectStyle(options.groupSelectStyle);
            this.reverse = options.reverse !== false;
            this.mapListeners = [];
            this.hiddenClassName = 'ol-unselectable ol-control layer-switcher';
            if (LayerSwitcher.isTouchDevice_()) this.hiddenClassName += ' touch';
            this.shownClassName = 'shown';
            element.className = this.hiddenClassName;
            this.button = document.createElement('button');
            element.appendChild(this.button);
            this.panel = document.createElement('div');
            this.panel.className = 'panel';
            element.appendChild(this.panel);
            LayerSwitcher.enableTouchScroll_(this.panel);
            element.classList.add(CSS_PREFIX + 'group-select-style-' + this.groupSelectStyle);
            element.classList.add(CSS_PREFIX + 'activation-mode-' + this.activationMode);
            if (this.activationMode === 'click') {
                // TODO Next: Remove in favour of layer-switcher-activation-mode-click
                element.classList.add('activationModeClick');
                this.button.onclick = (e)=>{
                    const evt = e || window.event;
                    if (this.element.classList.contains(this.shownClassName)) this.hidePanel();
                    else this.showPanel();
                    evt.preventDefault();
                };
            } else {
                this.button.onmouseover = ()=>{
                    this.showPanel();
                };
                this.button.onclick = (e)=>{
                    const evt = e || window.event;
                    this.showPanel();
                    evt.preventDefault();
                };
                this.panel.onmouseout = (evt)=>{
                    if (!this.panel.contains(evt.relatedTarget)) this.hidePanel();
                };
            }
            this.updateButton();
        }
        /**
     * Set the map instance the control is associated with.
     * @param map The map instance.
     */ setMap(map) {
            // Clean up listeners associated with the previous map
            for(let i = 0; i < this.mapListeners.length; i++)ol_Observable.unByKey(this.mapListeners[i]);
            this.mapListeners.length = 0;
            // Wire up listeners etc. and store reference to new map
            super.setMap(map);
            if (map) {
                if (this.startActive) this.showPanel();
                else this.renderPanel();
                if (this.activationMode !== 'click') this.mapListeners.push(map.on('pointerdown', ()=>{
                    this.hidePanel();
                }));
            }
        }
        /**
     * Show the layer panel. Fires `'show'` event.
     * @fires LayerSwitcher#show
     */ showPanel() {
            if (!this.element.classList.contains(this.shownClassName)) {
                this.element.classList.add(this.shownClassName);
                this.updateButton();
                this.renderPanel();
            }
            /**
         * Event triggered after the panel has been shown.
         * Listen to the event via the `on` or `once` methods; for example:
         * ```js
         * var layerSwitcher = new LayerSwitcher();
         * map.addControl(layerSwitcher);
         *
         * layerSwitcher.on('show', evt => {
         *   console.log('show', evt);
         * });
         * @event LayerSwitcher#show
         */ this.dispatchEvent('show');
        }
        /**
     * Hide the layer panel. Fires `'hide'` event.
     * @fires LayerSwitcher#hide
     */ hidePanel() {
            if (this.element.classList.contains(this.shownClassName)) {
                this.element.classList.remove(this.shownClassName);
                this.updateButton();
            }
            /**
         * Event triggered after the panel has been hidden.
         * @event LayerSwitcher#hide
         */ this.dispatchEvent('hide');
        }
        /**
     * Update button text content and attributes based on current
     * state
     */ updateButton() {
            if (this.element.classList.contains(this.shownClassName)) {
                this.button.textContent = this.collapseLabel;
                this.button.setAttribute('title', this.collapseTipLabel);
                this.button.setAttribute('aria-label', this.collapseTipLabel);
            } else {
                this.button.textContent = this.label;
                this.button.setAttribute('title', this.tipLabel);
                this.button.setAttribute('aria-label', this.tipLabel);
            }
        }
        /**
     * Re-draw the layer panel to represent the current state of the layers.
     */ renderPanel() {
            this.dispatchEvent('render');
            LayerSwitcher.renderPanel(this.getMap(), this.panel, {
                groupSelectStyle: this.groupSelectStyle,
                reverse: this.reverse
            });
            this.dispatchEvent('rendercomplete');
        }
        /**
     * **_[static]_** - Re-draw the layer panel to represent the current state of the layers.
     * @param map The OpenLayers Map instance to render layers for
     * @param panel The DOM Element into which the layer tree will be rendered
     * @param options Options for panel, group, and layers
     */ static renderPanel(map, panel, options) {
            // Create the event.
            const render_event = new Event('render');
            // Dispatch the event.
            panel.dispatchEvent(render_event);
            options = options || {};
            options.groupSelectStyle = LayerSwitcher.getGroupSelectStyle(options.groupSelectStyle);
            LayerSwitcher.ensureTopVisibleBaseLayerShown(map, options.groupSelectStyle);
            while(panel.firstChild)panel.removeChild(panel.firstChild);
            // Reset indeterminate state for all layers and groups before
            // applying based on groupSelectStyle
            LayerSwitcher.forEachRecursive(map, function(l, _idx, _a) {
                l.set('indeterminate', false);
            });
            if (options.groupSelectStyle === 'children' || options.groupSelectStyle === 'none') // Set visibile and indeterminate state of groups based on
            // their children's visibility
            LayerSwitcher.setGroupVisibility(map);
            else if (options.groupSelectStyle === 'group') // Set child indetermiate state based on their parent's visibility
            LayerSwitcher.setChildVisibility(map);
            const ul = document.createElement('ul');
            panel.appendChild(ul);
            // passing two map arguments instead of lyr as we're passing the map as the root of the layers tree
            LayerSwitcher.renderLayers_(map, map, ul, options, function render(_changedLyr) {
                LayerSwitcher.renderPanel(map, panel, options);
            });
            // Create the event.
            const rendercomplete_event = new Event('rendercomplete');
            // Dispatch the event.
            panel.dispatchEvent(rendercomplete_event);
        }
        /**
     * **_[static]_** - Determine if a given layer group contains base layers
     * @param grp Group to test
     */ static isBaseGroup(grp) {
            if (grp instanceof LayerGroup) {
                const lyrs = grp.getLayers().getArray();
                return lyrs.length && lyrs[0].get('type') === 'base';
            } else return false;
        }
        static setGroupVisibility(map) {
            // Get a list of groups, with the deepest first
            const groups = LayerSwitcher.getGroupsAndLayers(map, function(l) {
                return l instanceof LayerGroup && !l.get('combine') && !LayerSwitcher.isBaseGroup(l);
            }).reverse();
            // console.log(groups.map(g => g.get('title')));
            groups.forEach(function(grp) {
                // TODO Can we use getLayersArray, is it public in the esm build?
                const descendantVisibility = grp.getLayersArray().map(function(l) {
                    const state = l.getVisible();
                    // console.log('>', l.get('title'), state);
                    return state;
                });
                // console.log(descendantVisibility);
                if (descendantVisibility.every(function(v) {
                    return v === true;
                })) {
                    grp.setVisible(true);
                    grp.set('indeterminate', false);
                } else if (descendantVisibility.every(function(v) {
                    return v === false;
                })) {
                    grp.setVisible(false);
                    grp.set('indeterminate', false);
                } else {
                    grp.setVisible(true);
                    grp.set('indeterminate', true);
                }
            });
        }
        static setChildVisibility(map) {
            // console.log('setChildVisibility');
            const groups = LayerSwitcher.getGroupsAndLayers(map, function(l) {
                return l instanceof LayerGroup && !l.get('combine') && !LayerSwitcher.isBaseGroup(l);
            });
            groups.forEach(function(grp) {
                const group = grp;
                // console.log(group.get('title'));
                const groupVisible = group.getVisible();
                const groupIndeterminate = group.get('indeterminate');
                group.getLayers().getArray().forEach(function(l) {
                    l.set('indeterminate', false);
                    if ((!groupVisible || groupIndeterminate) && l.getVisible()) l.set('indeterminate', true);
                });
            });
        }
        /**
     * Ensure only the top-most base layer is visible if more than one is visible.
     * @param map The map instance.
     * @param groupSelectStyle
     * @protected
     */ static ensureTopVisibleBaseLayerShown(map, groupSelectStyle) {
            let lastVisibleBaseLyr;
            LayerSwitcher.forEachRecursive(map, function(lyr, _idx, _arr) {
                if (lyr.get('type') === 'base' && lyr.getVisible()) lastVisibleBaseLyr = lyr;
            });
            if (lastVisibleBaseLyr) LayerSwitcher.setVisible_(map, lastVisibleBaseLyr, true, groupSelectStyle);
        }
        /**
     * **_[static]_** - Get an Array of all layers and groups displayed by the LayerSwitcher (has a `'title'` property)
     * contained by the specified map or layer group; optionally filtering via `filterFn`
     * @param grp The map or layer group for which layers are found.
     * @param filterFn Optional function used to filter the returned layers
     */ static getGroupsAndLayers(grp, filterFn) {
            const layers = [];
            filterFn = filterFn || function(_lyr, _idx, _arr) {
                return true;
            };
            LayerSwitcher.forEachRecursive(grp, function(lyr, idx, arr) {
                if (lyr.get('title')) {
                    if (filterFn(lyr, idx, arr)) layers.push(lyr);
                }
            });
            return layers;
        }
        /**
     * Toggle the visible state of a layer.
     * Takes care of hiding other layers in the same exclusive group if the layer
     * is toggle to visible.
     * @protected
     * @param map The map instance.
     * @param lyr layer whose visibility will be toggled.
     * @param visible Set whether the layer is shown
     * @param groupSelectStyle
     * @protected
     */ static setVisible_(map, lyr, visible, groupSelectStyle) {
            // console.log(lyr.get('title'), visible, groupSelectStyle);
            lyr.setVisible(visible);
            if (visible && lyr.get('type') === 'base') // Hide all other base layers regardless of grouping
            LayerSwitcher.forEachRecursive(map, function(l, _idx, _arr) {
                if (l != lyr && l.get('type') === 'base') l.setVisible(false);
            });
            if (lyr instanceof LayerGroup && !lyr.get('combine') && groupSelectStyle === 'children') lyr.getLayers().forEach((l)=>{
                LayerSwitcher.setVisible_(map, l, lyr.getVisible(), groupSelectStyle);
            });
        }
        /**
     * Render all layers that are children of a group.
     * @param map The map instance.
     * @param lyr Layer to be rendered (should have a title property).
     * @param idx Position in parent group list.
     * @param options Options for groups and layers
     * @protected
     */ static renderLayer_(map, lyr, idx, options, render) {
            const li = document.createElement('li');
            const lyrTitle = lyr.get('title');
            const checkboxId = LayerSwitcher.uuid();
            const label = document.createElement('label');
            if (lyr instanceof LayerGroup && !lyr.get('combine')) {
                const isBaseGroup = LayerSwitcher.isBaseGroup(lyr);
                li.classList.add('group');
                if (isBaseGroup) li.classList.add(CSS_PREFIX + 'base-group');
                // Group folding
                if (lyr.get('fold')) {
                    li.classList.add(CSS_PREFIX + 'fold');
                    li.classList.add(CSS_PREFIX + lyr.get('fold'));
                    const btn = document.createElement('button');
                    btn.onclick = function(e) {
                        const evt = e || window.event;
                        LayerSwitcher.toggleFold_(lyr, li);
                        evt.preventDefault();
                    };
                    li.appendChild(btn);
                }
                if (!isBaseGroup && options.groupSelectStyle != 'none') {
                    const input = document.createElement('input');
                    input.type = 'checkbox';
                    input.id = checkboxId;
                    input.checked = lyr.getVisible();
                    input.indeterminate = lyr.get('indeterminate');
                    input.onchange = function(e) {
                        const target = e.target;
                        LayerSwitcher.setVisible_(map, lyr, target.checked, options.groupSelectStyle);
                        render(lyr);
                    };
                    li.appendChild(input);
                    label.htmlFor = checkboxId;
                }
                label.innerHTML = lyrTitle;
                li.appendChild(label);
                const ul = document.createElement('ul');
                li.appendChild(ul);
                LayerSwitcher.renderLayers_(map, lyr, ul, options, render);
            } else {
                li.className = 'layer';
                const input = document.createElement('input');
                if (lyr.get('type') === 'base') input.type = 'radio';
                else input.type = 'checkbox';
                input.id = checkboxId;
                input.checked = lyr.get('visible');
                input.indeterminate = lyr.get('indeterminate');
                input.onchange = function(e) {
                    const target = e.target;
                    LayerSwitcher.setVisible_(map, lyr, target.checked, options.groupSelectStyle);
                    render(lyr);
                };
                li.appendChild(input);
                label.htmlFor = checkboxId;
                label.innerHTML = lyrTitle;
                const rsl = map.getView().getResolution();
                if (rsl >= lyr.getMaxResolution() || rsl < lyr.getMinResolution()) label.className += ' disabled';
                else if (lyr.getMinZoom && lyr.getMaxZoom) {
                    const zoom = map.getView().getZoom();
                    if (zoom <= lyr.getMinZoom() || zoom > lyr.getMaxZoom()) label.className += ' disabled';
                }
                li.appendChild(label);
            }
            return li;
        }
        /**
     * Render all layers that are children of a group.
     * @param map The map instance.
     * @param lyr Group layer whose children will be rendered.
     * @param elm DOM element that children will be appended to.
     * @param options Options for groups and layers
     * @protected
     */ static renderLayers_(map, lyr, elm, options, render) {
            let lyrs = lyr.getLayers().getArray().slice();
            if (options.reverse) lyrs = lyrs.reverse();
            for(let i = 0, l; i < lyrs.length; i++){
                l = lyrs[i];
                if (l.get('title')) elm.appendChild(LayerSwitcher.renderLayer_(map, l, i, options, render));
            }
        }
        /**
     * **_[static]_** - Call the supplied function for each layer in the passed layer group
     * recursing nested groups.
     * @param lyr The layer group to start iterating from.
     * @param fn Callback which will be called for each layer
     * found under `lyr`.
     */ static forEachRecursive(lyr, fn) {
            lyr.getLayers().forEach(function(lyr, idx, a) {
                fn(lyr, idx, a);
                if (lyr instanceof LayerGroup) LayerSwitcher.forEachRecursive(lyr, fn);
            });
        }
        /**
     * **_[static]_** - Generate a UUID
     * Adapted from http://stackoverflow.com/a/2117523/526860
     * @returns {String} UUID
     */ static uuid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
                return v.toString(16);
            });
        }
        /**
     * Apply workaround to enable scrolling of overflowing content within an
     * element. Adapted from https://gist.github.com/chrismbarr/4107472
     * @param elm Element on which to enable touch scrolling
     * @protected
     */ static enableTouchScroll_(elm) {
            if (LayerSwitcher.isTouchDevice_()) {
                let scrollStartPos = 0;
                elm.addEventListener('touchstart', function(event) {
                    scrollStartPos = this.scrollTop + event.touches[0].pageY;
                }, false);
                elm.addEventListener('touchmove', function(event) {
                    this.scrollTop = scrollStartPos - event.touches[0].pageY;
                }, false);
            }
        }
        /**
     * Determine if the current browser supports touch events. Adapted from
     * https://gist.github.com/chrismbarr/4107472
     * @returns {Boolean} True if client can have 'TouchEvent' event
     * @protected
     */ static isTouchDevice_() {
            try {
                document.createEvent('TouchEvent');
                return true;
            } catch (e) {
                return false;
            }
        }
        /**
     * Fold/unfold layer group
     * @param lyr Layer group to fold/unfold
     * @param li List item containing layer group
     * @protected
     */ static toggleFold_(lyr, li) {
            li.classList.remove(CSS_PREFIX + lyr.get('fold'));
            lyr.set('fold', lyr.get('fold') === 'open' ? 'close' : 'open');
            li.classList.add(CSS_PREFIX + lyr.get('fold'));
        }
        /**
     * If a valid groupSelectStyle value is not provided then return the default
     * @param groupSelectStyle The string to check for validity
     * @returns The value groupSelectStyle, if valid, the default otherwise
     * @protected
     */ static getGroupSelectStyle(groupSelectStyle) {
            return [
                'none',
                'children',
                'group'
            ].indexOf(groupSelectStyle) >= 0 ? groupSelectStyle : 'children';
        }
    }
    // Expose LayerSwitcher as ol.control.LayerSwitcher if using a full build of
    // OpenLayers
    if (window['ol'] && window['ol']['control']) window['ol']['control']['LayerSwitcher'] = LayerSwitcher;
    return LayerSwitcher;
});

},{"2f1f65643b836f7d":"8KSMn","ca02aeb924cb46c7":"jiDvm","4d8e01a82b9017e0":"6DIkJ"}],"73XNr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addWKTLayerAndControl", ()=>addWKTLayerAndControl);
var _handleURL = require("../handleURL");
var _wktinputControl = require("../controls/WKTInputControl");
var _wktlayer = require("../layers/WKTLayer");
var _urlstateManager = require("../state/URLStateManager");
function addWKTLayerAndControl(map, target, view, azureLoginControl) {
    const wktInputControl = new (0, _wktinputControl.WKTInputControl)({
        target: target
    });
    const wktLayer = (0, _wktlayer.getWKTLayer)(wktInputControl, view, azureLoginControl);
    map.addLayer(wktLayer);
    map.addControl(wktInputControl);
    (0, _handleURL.handleURLForWKT)(wktInputControl);
    // Restore wktToggle from URL (default is true; only stored when false)
    if (!(0, _urlstateManager.getWKTToggleFromURL)()) wktInputControl.set("wktToggle", false);
    (0, _urlstateManager.registerWKTControl)(wktInputControl);
    return [
        wktLayer,
        wktInputControl
    ];
}

},{"../handleURL":"53YIf","../controls/WKTInputControl":"6h6QW","../layers/WKTLayer":"1BLFu","../state/URLStateManager":"7Lluw","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6h6QW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WKTInputControl", ()=>WKTInputControl);
var _control = require("ol/control/Control");
var _controlDefault = parcelHelpers.interopDefault(_control);
class WKTInputControl extends (0, _controlDefault.default) {
    constructor(opt_options){
        const options = opt_options || {};
        const element = document.createElement("div");
        element.className = "wkt-input ol-unselectable";
        super({
            element: element,
            target: options.target
        });
        const this_ = this;
        this_.set("validWkt", true);
        // Textarea with Map It and the WKT layer checkbox beside it; the error on its own
        // line below. A fixed 4 rows, as on main: it never grows or moves.
        const row = document.createElement("div");
        row.className = "wkt-row";
        element.appendChild(row);
        const textarea = document.createElement("textarea");
        textarea.placeholder = "Enter WKT strings or boundary codes";
        textarea.rows = 4;
        row.appendChild(textarea);
        const side = document.createElement("div");
        side.className = "wkt-side";
        row.appendChild(side);
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.checked = true;
        checkbox.id = "wkt";
        checkbox.title = "Show the WKT layer";
        this_.set("wktToggle", checkbox.checked);
        checkbox.addEventListener("change", function() {
            this_.set("wktToggle", checkbox.checked);
        });
        const label = document.createElement("label");
        label.htmlFor = checkbox.id;
        const button = document.createElement("button");
        button.className = "caj-nav-btn";
        button.textContent = "Map It";
        button.addEventListener("click", function() {
            // Set before "wkt" so the WKTLayer's propertychange listener sees the
            // request to zoom to the feature extent. URL restoration never sets
            // this flag, so reloads preserve the URL's center/zoom instead.
            this_.set("zoomToExtent", true);
            this_.set("wkt", textarea.value);
        }, false);
        label.className = "wkt-layer-toggle";
        label.append(checkbox, " layer");
        side.appendChild(button);
        side.appendChild(label);
        // Error message element, on its own line under the box
        const errorMessage = document.createElement("span");
        errorMessage.className = "wkt-error-message";
        errorMessage.style.display = "none";
        element.appendChild(errorMessage);
        // listen to changes
        this.on("propertychange", (e)=>{
            // Only sync the textarea when the `wkt` property itself changed. Any
            // other propertychange (zoomToExtent / validWkt / errorMessage) would
            // otherwise clobber in-progress edits with the previously-mapped value.
            if (e.key === "wkt" && this_.get("wkt") !== undefined) textarea.value = this_.get("wkt");
            if (e.key === "wktToggle") checkbox.checked = this_.get("wktToggle") ?? true;
            if (this_.get("validWkt")) {
                textarea.classList.remove("error");
                errorMessage.style.display = "none";
                errorMessage.textContent = "";
            } else {
                textarea.classList.add("error");
                const error = this_.get("errorMessage");
                if (error) {
                    errorMessage.textContent = error;
                    errorMessage.style.display = "inline";
                }
            }
        });
    }
}

},{"ol/control/Control":"8KSMn","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1BLFu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getWKTLayer", ()=>getWKTLayer);
var _style = require("ol/style");
var _point = require("ol/geom/Point");
var _pointDefault = parcelHelpers.interopDefault(_point);
var _vector = require("ol/layer/Vector");
var _vectorDefault = parcelHelpers.interopDefault(_vector);
var _vector1 = require("ol/source/Vector");
var _vectorDefault1 = parcelHelpers.interopDefault(_vector1);
var _wkt = require("ol/format/WKT");
var _wktDefault = parcelHelpers.interopDefault(_wkt);
var _extent = require("ol/extent");
var _mortonTile = require("../util/mortonTile");
async function fetchBoundaryWKT(boundaryCode, idToken) {
    const url = `${"/boundary-geom-prod"}?country=${encodeURIComponent(boundaryCode)}`;
    const headers = idToken ? {
        Authorization: `Bearer ${idToken}`
    } : {};
    const response = await fetch(url, {
        headers
    });
    if (!response.ok) throw new Error(`Boundary code not found: ${boundaryCode}`);
    const wkt = await response.text();
    if (!wkt || wkt.trim().length === 0) throw new Error(`Boundary code returned empty result: ${boundaryCode}`);
    return wkt;
}
/**
 * Parse mixed input containing WKT strings and boundary codes
 * @param {string} input - Mixed input with WKT geometries and boundary codes
 * @returns {Object} - { wktStrings: string[], boundaryCodes: string[], mortonCodes: string[], valid: boolean, error: string }
 */ function parseInputTokens(input) {
    const result = {
        wktStrings: [],
        boundaryCodes: [],
        mortonCodes: [],
        valid: true,
        error: null
    };
    if (!input || input.trim().length === 0) return result;
    // Check for balanced parentheses first
    let balance = 0;
    for (let char of input){
        if (char === "(") balance++;
        if (char === ")") balance--;
        if (balance < 0) {
            result.valid = false;
            result.error = "Unbalanced parentheses: closing parenthesis without opening";
            return result;
        }
    }
    if (balance !== 0) {
        result.valid = false;
        result.error = "Unbalanced parentheses: unclosed parenthesis";
        return result;
    }
    // Find all parenthesis groups with their preceding text
    const segments = [];
    let i = 0;
    while(i < input.length){
        // Skip whitespace
        while(i < input.length && /\s/.test(input[i]))i++;
        if (i >= input.length) break;
        // Check if we're at the start of a potential WKT geometry
        const remainingText = input.substring(i);
        // Look for WKT type keywords (POINT, LINESTRING, POLYGON, MULTIPOINT, MULTILINESTRING, MULTIPOLYGON, GEOMETRYCOLLECTION)
        // with optional Z, M, or ZM modifiers
        const wktPattern = /^(POINT|LINESTRING|POLYGON|MULTIPOINT|MULTILINESTRING|MULTIPOLYGON|GEOMETRYCOLLECTION)(\s+Z|\s+M|\s+ZM)?\s*\(/i;
        const match = remainingText.match(wktPattern);
        if (match) {
            // This is a WKT geometry - find the matching closing parenthesis
            const startIdx = i;
            let parenDepth = 0;
            let foundStart = false;
            let endIdx = i;
            for(let j = i; j < input.length; j++){
                if (input[j] === "(") {
                    parenDepth++;
                    foundStart = true;
                } else if (input[j] === ")") {
                    parenDepth--;
                    if (foundStart && parenDepth === 0) {
                        endIdx = j + 1;
                        break;
                    }
                }
            }
            const wktString = input.substring(startIdx, endIdx).trim();
            if (wktString) segments.push({
                type: "wkt",
                value: wktString
            });
            i = endIdx;
        } else {
            // This is not a WKT geometry - treat as potential boundary code
            // Extract until next WKT geometry or end of string
            let nextWktStart = input.length;
            // Find the next WKT geometry start
            for(let j = i + 1; j < input.length; j++){
                const testText = input.substring(j);
                if (wktPattern.test(testText)) {
                    nextWktStart = j;
                    break;
                }
            }
            const tokenEnd = nextWktStart;
            const token = input.substring(i, tokenEnd).trim();
            if (token) {
                // Split by whitespace into individual codes; canonical Morton tile
                // codes are resolved to polygons, anything else stays a boundary code.
                const codes = token.split(/\s+/).filter((c)=>c.length > 0);
                codes.forEach((code)=>{
                    if ((0, _mortonTile.looksLikeMortonCode)(code)) segments.push({
                        type: "morton",
                        value: code
                    });
                    else segments.push({
                        type: "boundary",
                        value: code
                    });
                });
            }
            i = tokenEnd;
        }
    }
    // Separate WKT strings, Morton tile codes and boundary codes
    segments.forEach((seg)=>{
        if (seg.type === "wkt") result.wktStrings.push(seg.value);
        else if (seg.type === "morton") result.mortonCodes.push(seg.value);
        else result.boundaryCodes.push(seg.value);
    });
    return result;
}
/**
 * Convert WKT string to OpenLayers features
 * @param {string} wktString - WKT geometry string
 * @param {number} index - Feature index for labeling
 * @param {string} [boundaryCode] - Optional boundary code for label suffix
 * @returns {Feature} - OpenLayers feature
 */ function wktStringToFeature(wktString, index, boundaryCode) {
    const format = new (0, _wktDefault.default)();
    const feature = format.readFeature(wktString, {
        dataProjection: "EPSG:4326",
        featureProjection: "EPSG:3857"
    });
    const suffix = boundaryCode ? `: ${boundaryCode}` : "";
    feature.set("label", `${index}${suffix}`);
    return feature;
}
/**
 * Process mixed input (WKT strings and boundary codes) into features
 * @param {string} input - Mixed input string
 * @param {string} idToken - Authentication token for boundary service
 * @returns {Promise<Array>} - Array of OpenLayers features
 */ async function parseInputToFeatures(input, idToken) {
    const parsed = parseInputTokens(input);
    if (!parsed.valid) throw new Error(parsed.error);
    const features = [];
    let featureIndex = 0;
    // Process WKT strings
    for (const wktString of parsed.wktStrings)try {
        const feature = wktStringToFeature(wktString, featureIndex);
        features.push(feature);
        featureIndex++;
    } catch (err) {
        throw new Error(`Invalid WKT geometry: ${wktString.substring(0, 50)}... - ${err.message}`, {
            cause: err
        });
    }
    // Process Morton tile codes into tile polygons
    for (const code of parsed.mortonCodes)try {
        const feature = wktStringToFeature((0, _mortonTile.mortonWktFromCode)(code), featureIndex, code);
        feature.set("mortonCode", code);
        features.push(feature);
        featureIndex++;
    } catch (err) {
        throw new Error(`Invalid Morton tile code '${code}': ${err.message}`, {
            cause: err
        });
    }
    // Process boundary codes
    for (const boundaryCode of parsed.boundaryCodes)try {
        const wkt = await fetchBoundaryWKT(boundaryCode, idToken);
        // The boundary service might return multiple WKT strings
        const boundaryParsed = parseInputTokens(wkt);
        for (const wktString of boundaryParsed.wktStrings){
            const feature = wktStringToFeature(wktString, featureIndex, boundaryCode);
            feature.set("boundaryCode", boundaryCode);
            features.push(feature);
            featureIndex++;
        }
    } catch (err) {
        throw new Error(`Failed to fetch boundary code '${boundaryCode}': ${err.message}`, {
            cause: err
        });
    }
    return features;
}
function getWKTLayer(wktInputControl, view, azureLoginControl) {
    const vectorSource = new (0, _vectorDefault1.default)({});
    const styleFunction = function(feature) {
        const geometry = feature.getGeometry();
        const LINE_COLOR = "red";
        const FILL_COLOR = "white";
        const styles = [
            // linestring
            new (0, _style.Style)({
                stroke: new (0, _style.Stroke)({
                    color: LINE_COLOR,
                    width: 10
                })
            }),
            new (0, _style.Style)({
                stroke: new (0, _style.Stroke)({
                    color: FILL_COLOR,
                    width: 8
                })
            }),
            new (0, _style.Style)({
                image: new (0, _style.Circle)({
                    fill: new (0, _style.Fill)({
                        color: FILL_COLOR
                    }),
                    stroke: new (0, _style.Stroke)({
                        color: LINE_COLOR,
                        width: 1
                    }),
                    radius: 10
                })
            })
        ];
        if (feature.get("label") != undefined) styles.push(new (0, _style.Style)({
            text: new (0, _style.Text)({
                text: feature.get("label"),
                fill: new (0, _style.Fill)({
                    color: LINE_COLOR
                }),
                stroke: new (0, _style.Stroke)({
                    color: FILL_COLOR,
                    width: 3
                })
            })
        }));
        if (typeof geometry.forEachSegment === "function") geometry.forEachSegment(function(start, end) {
            const mid = [
                (start[0] + end[0]) / 2,
                (start[1] + end[1]) / 2
            ];
            const dx = end[0] - start[0];
            const dy = end[1] - start[1];
            const rotation = Math.atan2(dy, dx);
            // arrows
            styles.push(new (0, _style.Style)({
                geometry: new (0, _pointDefault.default)(mid),
                image: new (0, _style.Icon)({
                    src: "icon-arrow.png",
                    anchor: [
                        0.75,
                        0.5
                    ],
                    rotateWithView: true,
                    rotation: -rotation,
                    color: LINE_COLOR,
                    scale: [
                        0.5,
                        0.5
                    ]
                })
            }));
        });
        return styles;
    };
    const vectorLayer = new (0, _vectorDefault.default)({
        source: vectorSource,
        style: styleFunction
    });
    // Generation counter so stale async parses (e.g. a previous Map It whose
    // boundary-code fetch is still in flight) discard themselves when a newer
    // `wkt` value arrives.
    let wktRunId = 0;
    wktInputControl.on("propertychange", async (event)=>{
        // Only react to the keys we care about. Other propertychange events
        // (zoomToExtent / validWkt / errorMessage / anything the handler itself
        // sets) would otherwise re-enter this block with stale inputs.
        if (event.key === "wkt") {
            const input = event.target.get("wkt");
            if (input === undefined) return;
            const myRun = ++wktRunId;
            try {
                const idToken = azureLoginControl ? azureLoginControl.get("idToken") : null;
                // Parse input and fetch features (handles both WKT and boundary codes)
                const features = await parseInputToFeatures(input, idToken);
                // Bail if another `wkt` change started after us.
                if (myRun !== wktRunId) return;
                vectorSource.clear();
                vectorSource.addFeatures(features);
                // Only zoom to the WKT extent when the user explicitly clicked
                // "Map It". URL restoration sets "wkt" without the flag, so the
                // saved center/zoom in the URL is respected on reload.
                if (wktInputControl.get("zoomToExtent") === true) {
                    wktInputControl.set("zoomToExtent", false);
                    const extent = vectorLayer.getSource().getExtent();
                    if (!(0, _extent.isEmpty)(extent)) view.fit((0, _extent.buffer)(extent, (0, _extent.getHeight)(extent) * 0.2), {
                        maxZoom: 19
                    });
                }
                wktInputControl.set("validWkt", true);
                wktInputControl.set("errorMessage", null);
            } catch (err) {
                if (myRun !== wktRunId) return;
                console.error(err);
                wktInputControl.set("validWkt", false);
                wktInputControl.set("errorMessage", err.message);
            }
            return;
        }
        if (event.key === "wktToggle") vectorLayer.setVisible(event.target.get("wktToggle") === true);
    });
    return vectorLayer;
}

},{"ol/style":[["Circle","3Wl62","default"],["Fill","24G0i","default"],["Icon","ib4Ft","default"],["Stroke","cese4","default"],["Style","gqpPW","default"],["Text","118sC","default"]],"ol/geom/Point":"95T6m","ol/layer/Vector":"7ga2c","ol/source/Vector":"7zHxp","ol/format/WKT":"34shs","ol/extent":"MPjK5","../util/mortonTile":"2CSvZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2CSvZ":[function(require,module,exports,__globalThis) {
/**
 * TomTom Morton tile encode + decode (EPSG:4326).
 *
 * This is NOT Web Mercator. It's a simple linear partition of lon/lat:
 *   X: longitude [-180, +180] -> [0, 2^level]
 *   Y: latitude  [-90,  +90]  -> [0, 2^level]
 *
 * Encode pieces (MORTON_LEVEL_DIVISORS, HALF/QUARTER_CIRCLE_UNITS_MD,
 * mortonTileFromCoordinate, interlace, interlaceLong) are ported from
 * com.tomtom.maps.mortontile (MortonTile.fromCoordinate / Interlacer.interlace).
 *
 * Decode (uninterlace + bounds) is the verified inverse, ported from
 * com.tomtom.maps:morton-tile 7.4.
 */ // ---------- Morton Tile encode (ported from com.tomtom.maps.mortontile) ----------
/**
 * MORTON_LEVEL_DIVISORS[i] = 3.6e9 / 2^i
 *
 * Java static initializer:
 *   for (int i = 0; i <= 32; ++i) {
 *       MORTON_LEVEL_DIVISORS[i] = 3.6e9 / (1L << i);
 *   }
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Parse a canonical TomTom Morton tile code.
 *
 * @param {string} code - Morton tile code in `M<level>:<hex>` format
 * @returns {{level: number, morton: bigint}} Parsed level and Morton code
 * @throws {Error} If `code` is not canonical or is out of range for its level
 */ parcelHelpers.export(exports, "parseMortonCode", ()=>parseMortonCode);
/**
 * Quick syntactic check for whether a token looks like a Morton tile code.
 *
 * @param {string} token - Candidate string
 * @returns {boolean} True when `token` has `M<level>:<hex>` shape
 */ parcelHelpers.export(exports, "looksLikeMortonCode", ()=>looksLikeMortonCode);
/**
 * Check whether a token is a valid Morton tile code.
 *
 * @param {string} token - Candidate string
 * @returns {boolean} True when `token` is a valid `M<level>:<hex>` code
 */ parcelHelpers.export(exports, "isMortonCode", ()=>isMortonCode);
/**
 * Encode a coordinate to a canonical TomTom Morton tile code.
 *
 * @param {number} lon - Longitude in degrees (EPSG:4326)
 * @param {number} lat - Latitude in degrees (EPSG:4326)
 * @param {number} level - Morton level
 * @returns {string} Morton tile code in `M<level>:<hex>` format
 */ parcelHelpers.export(exports, "mortonCodeFromCoordinate", ()=>mortonCodeFromCoordinate);
/**
 * Decode a canonical Morton tile code to its geographic bounds (EPSG:4326).
 *
 * @param {string} code - Morton tile code in `M<level>:<hex>` format
 * @returns {{minLon: number, minLat: number, maxLon: number, maxLat: number}}
 *   Tile bounds in degrees
 */ parcelHelpers.export(exports, "mortonBoundsFromCode", ()=>mortonBoundsFromCode);
/**
 * Decode a canonical Morton tile code to a closed lon/lat ring.
 *
 * @param {string} code - Morton tile code in `M<level>:<hex>` format
 * @returns {number[][]} Closed ring
 */ parcelHelpers.export(exports, "mortonRingFromCode", ()=>mortonRingFromCode);
/**
 * Decode a canonical Morton tile code to a WKT POLYGON string in EPSG:4326.
 *
 * @param {string} code - Morton tile code in `M<level>:<hex>` format
 * @returns {string} WKT POLYGON
 */ parcelHelpers.export(exports, "mortonWktFromCode", ()=>mortonWktFromCode);
const MORTON_LEVEL_DIVISORS = new Float64Array(33);
for(let i = 0; i <= 32; i++)// Java: (double)(1L << i) — use Math.pow to avoid 32-bit overflow at i >= 31
MORTON_LEVEL_DIVISORS[i] = 3.6e9 / Math.pow(2, i);
const HALF_CIRCLE_UNITS_MD = 1800000000; // 180° × 1e7
const QUARTER_CIRCLE_UNITS_MD = 900000000; // 90° × 1e7
const MORTON_CODE_PATTERN = /^M(\d+):([0-9a-f]+)$/i;
/**
 * Port of MortonTile.fromCoordinate(longitude, latitude, level).
 *
 * This is NOT Web Mercator. It's a simple linear partition:
 *   X: longitude  [-180, +180] → [0, 2^level]  (divisor = 3.6e9 / 2^level)
 *   Y: latitude   [-90,  +90]  → [0, 2^level]  (divisor = 3.6e9 / 2^(level+1))
 *
 * Note: Y uses MORTON_LEVEL_DIVISORS[level + 1] because the lat range (180°)
 * is half the lon range (360°), so needs double the divisor to get same tile count.
 *
 * @param {number} lon - Longitude in degrees
 * @param {number} lat - Latitude in degrees
 * @param {number} level - Morton level (23 for anchor IDs)
 * @returns {bigint} Morton code
 */ function mortonTileFromCoordinate(lon, lat, level) {
    level = assertMortonLevel(level);
    const xMd = Math.round(lon * 1e7);
    const yMd = Math.round(lat * 1e7);
    let tileX;
    if (xMd >= HALF_CIRCLE_UNITS_MD) // Boundary case: exactly +180°
    tileX = mortonMax(level);
    else tileX = Math.trunc((xMd + HALF_CIRCLE_UNITS_MD) / MORTON_LEVEL_DIVISORS[level]);
    let tileY;
    if (yMd >= QUARTER_CIRCLE_UNITS_MD) // Boundary case: exactly +90°
    tileY = mortonMax(level);
    else tileY = Math.trunc((yMd + QUARTER_CIRCLE_UNITS_MD) / MORTON_LEVEL_DIVISORS[level + 1]);
    return interlace(tileX, tileY);
}
// ---------- Interlacer (ported from com.tomtom.maps.mortontile.internal.Interlacer) ----------
/**
 * Port of Interlacer.interlace(int x, int y).
 *
 * Java: interlace((long)y << 32 | (long)x)
 * Then applies 5 rounds of swap-and-mask to interleave the bits.
 *
 * All operations use BigInt because JavaScript doesn't have 64-bit integers.
 */ function interlace(x, y) {
    // Pack y into upper 32 bits, x into lower 32 bits
    // Java: interlace(((long) y << 32) + (long) x)
    let raw = BigInt(y) << 32n | BigInt(x) & 0xffffffffn;
    return interlaceLong(raw);
}
/**
 * Port of Interlacer.interlace(long raw).
 *
 * Java swap-and-mask chain:
 *   swapAndMask(raw, 16, 0x00000000FFFF0000L)
 *   swapAndMask(..  , 8,  0x0000FF000000FF00L)
 *   swapAndMask(..  , 4,  0x00F000F000F000F0L)
 *   swapAndMask(..  , 2,  0x0C0C0C0C0C0C0C0CL)
 *   swapAndMask(..  , 1,  0x2222222222222222L)
 *
 * swapAndMask(val, shift, mask):
 *   changes = ((val >>> shift) ^ val) & mask
 *   return val ^ changes + (changes << shift)
 *
 * Note: Java operator precedence: ^ binds lower than +,
 * so "val ^ changes + (changes << shift)" = "val ^ (changes + (changes << shift))"
 */ function interlaceLong(raw) {
    const MASK_64 = 0xffffffffffffffffn;
    function swapAndMask(val, shift, mask) {
        val = val & MASK_64;
        // Java: long changes = (val >>> shift ^ val) & mask;
        // In Java >>> is unsigned right shift. For BigInt, we mask to 64 bits first.
        const shifted = val >> BigInt(shift) & MASK_64;
        const changes = (shifted ^ val) & mask;
        // Java: return val ^ changes + (changes << shift);
        // Java precedence: ^ has lower precedence than +
        // So this is: val ^ (changes + (changes << shift))
        const sum = changes + (changes << BigInt(shift) & MASK_64) & MASK_64;
        return (val ^ sum) & MASK_64;
    }
    let v = raw & MASK_64;
    v = swapAndMask(v, 16, 0x00000000ffff0000n);
    v = swapAndMask(v, 8, 0x0000ff000000ff00n);
    v = swapAndMask(v, 4, 0x00f000f000f000f0n);
    v = swapAndMask(v, 2, 0x0c0c0c0c0c0c0c0cn);
    v = swapAndMask(v, 1, 0x2222222222222222n);
    return v;
}
// ---------- Morton Tile decode (verified inverse, ported from morton-tile 7.4) ----------
const SCALE = 1e7;
const MASK_64 = 0xffffffffffffffffn;
/**
 * One swap-and-mask round, identical to the encode helper but reused for decode.
 *
 * @param {bigint} val - 64-bit value
 * @param {number} shift - Bit shift distance
 * @param {bigint} mask - Bit mask selecting the swap group
 * @returns {bigint} Transformed 64-bit value
 */ function swapAndMask(val, shift, mask) {
    val &= MASK_64;
    const changes = (val >> BigInt(shift) & MASK_64 ^ val) & mask;
    const sum = changes + (changes << BigInt(shift) & MASK_64) & MASK_64;
    return (val ^ sum) & MASK_64;
}
/**
 * Inverse of interlaceLong: de-interleaves the packed Morton code back into
 * tileX (lower 32 bits) and tileY (upper 32 bits).
 *
 * The swap-and-mask shifts ascend 1 -> 16 (the reverse order of interlace).
 *
 * @param {bigint} morton - Morton code
 * @returns {bigint} Packed value where tileY occupies the upper 32 bits
 */ function uninterlace(morton) {
    // shifts ASCEND 1->16 (reverse of interlace)
    let v = BigInt(morton) & MASK_64;
    v = swapAndMask(v, 1, 0x2222222222222222n);
    v = swapAndMask(v, 2, 0x0c0c0c0c0c0c0c0cn);
    v = swapAndMask(v, 4, 0x00f000f000f000f0n);
    v = swapAndMask(v, 8, 0x0000ff000000ff00n);
    v = swapAndMask(v, 16, 0x00000000ffff0000n);
    return v;
}
/**
 * Maximum tile index along one axis at a given level: 2^level - 1.
 *
 * @param {number} level - Morton level
 * @returns {number} Largest valid tile index
 */ function mortonMax(level) {
    return Number(2n ** BigInt(level) - 1n);
}
/**
 * Validate and normalize a TomTom Morton tile level.
 *
 * @param {number} level - Morton level
 * @returns {number} Normalized integer level
 * @throws {Error} If `level` is outside the supported library range
 */ function assertMortonLevel(level) {
    if (!Number.isInteger(level) || level < 0 || level > 31) throw new Error(`Morton level out of range (0-31): ${level}`);
    return level;
}
function maxMortonValueExclusive(level) {
    return 1n << 2n * BigInt(level);
}
function mortonBase4FromValue(morton, level) {
    // Level 0 is the single world tile; its quadkey is the empty string. Without
    // this, padStart(0) leaves "0" (length 1), which mortonBoundsFromBase4 would
    // misread as a level-1 tile and decode to the wrong (origin-corner) box.
    if (level === 0) return "";
    return morton.toString(4).padStart(level, "0");
}
function mortonHexWidth(level) {
    return Math.max(1, Math.ceil(level / 2));
}
function parseMortonCode(code) {
    if (typeof code !== "string") throw new Error(`Invalid Morton tile code: "${code}"`);
    const normalized = code.trim();
    const match = normalized.match(MORTON_CODE_PATTERN);
    if (!match) throw new Error(`Invalid Morton tile code: "${code}"`);
    const level = assertMortonLevel(Number(match[1]));
    const morton = BigInt(`0x${match[2]}`);
    if (morton >= maxMortonValueExclusive(level)) throw new Error(`Morton code out of range for level ${level}: ${match[2]}`);
    return {
        level,
        morton
    };
}
function looksLikeMortonCode(token) {
    return typeof token === "string" && MORTON_CODE_PATTERN.test(token.trim());
}
function isMortonCode(token) {
    try {
        parseMortonCode(token);
        return true;
    } catch  {
        return false;
    }
}
function mortonCodeFromCoordinate(lon, lat, level) {
    level = assertMortonLevel(level);
    const morton = mortonTileFromCoordinate(lon, lat, level);
    return `M${level}:${morton.toString(16).padStart(mortonHexWidth(level), "0")}`;
}
/**
 * Convert a canonical Morton tile code to the equivalent base-4 quadkey.
 *
 * @param {string} code - Morton tile code in `M<level>:<hex>` format
 * @returns {string} Base-4 quadkey, left-zero-padded to `level` characters
 */ function mortonBase4FromCode(code) {
    const { level, morton } = parseMortonCode(code);
    return mortonBase4FromValue(morton, level);
}
/**
 * Decode a base-4 Morton quadkey to its geographic bounds (EPSG:4326).
 *
 * Bounds use excludeBorder=true so adjacent tiles do not overlap: the max
 * edges are pulled in by one map unit, except at the +180/+90 world edge
 * where they snap to exactly 180 / 90.
 *
 * @param {string} base4 - Base-4 quadkey ("" means level 0, the whole world)
 * @returns {{minLon: number, minLat: number, maxLon: number, maxLat: number}}
 *   Tile bounds in degrees
 * @throws {Error} If `base4` is not a base-4 string or its level exceeds 31
 */ function mortonBoundsFromBase4(base4) {
    if (!/^[0-3]*$/.test(base4)) throw new Error(`Invalid Morton base-4 quadkey: "${base4}"`);
    const level = assertMortonLevel(base4.length); // "" => level 0
    // base4 string -> morton BigInt
    const morton = base4.split("").reduce((a, c)=>a * 4n + BigInt(c), 0n);
    const v = uninterlace(morton);
    const tileX = Number(v & 0xffffffffn);
    const tileY = Number(v >> 32n);
    const max = mortonMax(level);
    const minLon = Math.ceil(tileX * MORTON_LEVEL_DIVISORS[level] - HALF_CIRCLE_UNITS_MD) / SCALE;
    const minLat = Math.ceil(tileY * MORTON_LEVEL_DIVISORS[level + 1] - QUARTER_CIRCLE_UNITS_MD) / SCALE;
    const maxLon = tileX === max ? 180 : Math.ceil((tileX + 1) * MORTON_LEVEL_DIVISORS[level] - HALF_CIRCLE_UNITS_MD - 1) / SCALE;
    const maxLat = tileY === max ? 90 : Math.ceil((tileY + 1) * MORTON_LEVEL_DIVISORS[level + 1] - QUARTER_CIRCLE_UNITS_MD - 1) / SCALE;
    return {
        minLon,
        minLat,
        maxLon,
        maxLat
    };
}
function mortonBoundsFromCode(code) {
    return mortonBoundsFromBase4(mortonBase4FromCode(code));
}
/**
 * Decode a base-4 Morton quadkey to a closed lon/lat ring suitable for a polygon.
 *
 * @param {string} base4 - Base-4 quadkey
 * @returns {number[][]} Closed ring:
 *   [[minLon,minLat],[maxLon,minLat],[maxLon,maxLat],[minLon,maxLat],[minLon,minLat]]
 */ function mortonRingFromBase4(base4) {
    const { minLon, minLat, maxLon, maxLat } = mortonBoundsFromBase4(base4);
    return [
        [
            minLon,
            minLat
        ],
        [
            maxLon,
            minLat
        ],
        [
            maxLon,
            maxLat
        ],
        [
            minLon,
            maxLat
        ],
        [
            minLon,
            minLat
        ]
    ];
}
function mortonRingFromCode(code) {
    return mortonRingFromBase4(mortonBase4FromCode(code));
}
function mortonWktFromCode(code) {
    const ring = mortonRingFromCode(code).map(([lon, lat])=>`${lon} ${lat}`).join(", ");
    return `POLYGON ((${ring}))`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"e6A2s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultStyleNormal", ()=>getDefaultStyleNormal);
parcelHelpers.export(exports, "getDefaultStyleClick", ()=>getDefaultStyleClick);
parcelHelpers.export(exports, "getDefaultStyleHover", ()=>getDefaultStyleHover);
parcelHelpers.export(exports, "getDefaultColorStyle", ()=>getDefaultColorStyle);
var _style = require("ol/style");
function getDefaultStyleNormal(feature) {
    return getDefaultColorStyle(feature);
}
function getDefaultStyleClick(feature) {
    return getDefaultColorStyle(feature, true, false);
}
function getDefaultStyleHover(feature) {
    return getDefaultColorStyle(feature, false, true);
}
function getDefaultColorStyle(feature, click, hover) {
    let color, width, backgroundColor, backgroundWidth;
    color = "grey";
    backgroundColor = "white";
    width = 2;
    backgroundWidth = 4;
    if (hover || click) return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: backgroundColor,
                width: backgroundWidth
            })
        }),
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width
            })
        })
    ];
    return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: width
            })
        })
    ];
}

},{"ol/style":[["Stroke","cese4","default"],["Style","gqpPW","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8WCJV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCrosslinkStyleNormal", ()=>getCrosslinkStyleNormal);
parcelHelpers.export(exports, "getCrosslinkStyleClick", ()=>getCrosslinkStyleClick);
parcelHelpers.export(exports, "getCrosslinkStyleHover", ()=>getCrosslinkStyleHover);
parcelHelpers.export(exports, "getCrosslinkStyleSDSelected", ()=>getCrosslinkStyleSDSelected);
parcelHelpers.export(exports, "getCrosslinkStyleSDDeselected", ()=>getCrosslinkStyleSDDeselected);
parcelHelpers.export(exports, "getCrosslinkStyleHDSelected", ()=>getCrosslinkStyleHDSelected);
parcelHelpers.export(exports, "getCrosslinkStyleHDDeselected", ()=>getCrosslinkStyleHDDeselected);
parcelHelpers.export(exports, "isSD", ()=>isSD);
var _style = require("ol/style");
// Lighter resting colours for the sub-sections of a way NOT covered by any
// crosslink relation. CrosslinkCoverageHandler precomputes those sub-sections
// as `crosslinkUncoveredGeoms`; we overlay them on top of the normal colour.
const SD_UNCOVERED_COLOR = "#90ee90"; // lightgreen
const HD_UNCOVERED_COLOR = "#add8e6"; // lightblue
// This way's section that pairs with a crosslink relation whose role overshoots
// the PARTNER member's length (road overshoots → lane segment red, and vice
// versa). A data error, drawn on top in red (CrosslinkCoverageHandler
// precomputes the segments as `crosslinkOutOfBoundsGeoms`).
const OUT_OF_BOUNDS_COLOR = "red";
const LINE_WIDTH = 3;
function getCrosslinkStyleNormal(feature) {
    return getCrosslinkColorStyle(feature);
}
function getCrosslinkStyleClick(feature) {
    return getCrosslinkColorStyle(feature, true, false);
}
function getCrosslinkStyleHover(feature) {
    return getCrosslinkColorStyle(feature, false, true);
}
function getCrosslinkStyleSDSelected() {
    return getCrosslinkStyleSD(true);
}
function getCrosslinkStyleSDDeselected(click, hover) {
    return getCrosslinkStyleSD(false, click, hover);
}
function getCrosslinkStyleHDSelected() {
    return getCrosslinkStyleHD(true);
}
function getCrosslinkStyleHDDeselected() {
    return getCrosslinkStyleHD(false);
}
function isSD(feature) {
    return feature.getId().startsWith("6:");
}
function isHDLaneLine(feature) {
    const hdMapKeys = feature.getKeys().filter((key)=>key.endsWith("-hdmap"));
    if (hdMapKeys.length === 0) return false;
    return [
        "lane_center_line",
        "lane_trajectory_line"
    ].includes(feature.get(hdMapKeys[0]));
}
function getCrosslinkColorStyle(feature, click, hover) {
    const crosslinkType = feature.get("type");
    if (crosslinkType === "ORBIS_RELATION") return [];
    const sd = isSD(feature);
    if (!sd && !isHDLaneLine(feature)) return [];
    const styles = sd ? getCrosslinkStyleSD(false, click, hover) : getCrosslinkStyleHD(false);
    // In the resting state (not hovering/clicking), shade the sub-sections that
    // no crosslink relation covers in a lighter colour, drawn over the base line.
    if (!click && !hover) {
        const uncoveredGeoms = feature.get("crosslinkUncoveredGeoms");
        if (uncoveredGeoms) {
            const lighter = sd ? SD_UNCOVERED_COLOR : HD_UNCOVERED_COLOR;
            uncoveredGeoms.forEach((geometry)=>{
                styles.push(new (0, _style.Style)({
                    geometry: geometry,
                    stroke: new (0, _style.Stroke)({
                        color: lighter,
                        width: LINE_WIDTH
                    }),
                    zIndex: 2
                }));
            });
        }
    }
    // Partner-overshoot segment in red — always shown (even on hover/click) so
    // the data error stays visible, and on top of everything.
    const outOfBoundsGeoms = feature.get("crosslinkOutOfBoundsGeoms");
    if (outOfBoundsGeoms) outOfBoundsGeoms.forEach((geometry)=>{
        styles.push(new (0, _style.Style)({
            geometry: geometry,
            stroke: new (0, _style.Stroke)({
                color: OUT_OF_BOUNDS_COLOR,
                width: LINE_WIDTH + 1
            }),
            zIndex: 12
        }));
    });
    return styles;
}
function getCrosslinkStyleSD(selected, click, hover) {
    let color = "green";
    let zIndex = 1;
    if (selected) {
        color = "green";
        zIndex = 10;
    } else if (click) color = "orange";
    else if (hover) color = "green";
    return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: LINE_WIDTH
            }),
            zIndex: zIndex
        })
    ];
}
function getCrosslinkStyleHD(selected) {
    let color = "blue";
    let zIndex = 1;
    if (selected) {
        color = "red";
        zIndex = 10;
    }
    return [
        new (0, _style.Style)({
            stroke: new (0, _style.Stroke)({
                color: color,
                width: LINE_WIDTH
            }),
            zIndex: zIndex
        })
    ];
}

},{"ol/style":[["Stroke","cese4","default"],["Style","gqpPW","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"jYIV7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCrosslinkInteractions", ()=>getCrosslinkInteractions);
var _select = require("ol/interaction/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _condition = require("ol/events/condition");
var _crosslink = require("../style/crosslink");
var _crosslinkRelations = require("../crosslinkRelations");
function getCrosslinkInteractions(layer, control) {
    const clickSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.click),
        style: function(feature) {
            return (0, _crosslink.getCrosslinkStyleClick)(feature);
        }
    });
    clickSelect.on("select", function(e) {
        const clickedFeatures = e.target.getFeatures().getArray();
        const position = e.mapBrowserEvent && e.mapBrowserEvent.coordinate;
        if (clickedFeatures.length === 0 || position === undefined) {
            control.set("selectedFeatures", undefined);
            return;
        }
        // Show the crosslink relation(s) under the cursor — not the clicked line's
        // own tags — since that's what's useful for analyzing the SD↔HD match.
        const allFeatures = layer.getSource().getFeatures();
        const relations = [
            ...new Set(clickedFeatures.flatMap((feature)=>(0, _crosslinkRelations.findCrosslinkRelationsAt)(feature, allFeatures, (0, _crosslinkRelations.distanceAlongFeatureCm)(feature, position))))
        ];
        control.set("selectedFeatures", relations.length > 0 ? relations : undefined);
    });
    clickSelect.on("select", function(e) {
        const allFeatures = layer.getSource().getFeatures();
        e.deselected.flatMap((selectedFeature)=>findSDFeatures(selectedFeature, allFeatures)).forEach((sdFeature)=>{
            sdFeature.setStyle((0, _crosslink.getCrosslinkStyleSDDeselected)());
        });
        e.selected.flatMap((selectedFeature)=>findSDFeatures(selectedFeature, allFeatures)).forEach((sdFeature)=>{
            sdFeature.setStyle((0, _crosslink.getCrosslinkStyleSDSelected)());
        });
    });
    return [
        clickSelect,
        new (0, _selectDefault.default)({
            layers: [
                layer
            ],
            condition: (0, _condition.pointerMove),
            style: function(feature) {
                return (0, _crosslink.getCrosslinkStyleHover)(feature);
            }
        })
    ];
}
function findSDFeatures(selectedFeature, features) {
    return features.filter((feature)=>feature.getId() === selectedFeature.get("relation-member-1-id"));
}

},{"ol/interaction/Select":"1uL1O","ol/events/condition":"2tMOf","../style/crosslink":"8WCJV","../crosslinkRelations":"gH9IJ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gH9IJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Distance (cm, on the GK plane) of a map position projected onto a feature's
// line geometry — the linear-reference offset of the cursor along the feature.
parcelHelpers.export(exports, "distanceAlongFeatureCm", ()=>distanceAlongFeatureCm);
// Crosslink relation features in `allFeatures` that reference `feature` and
// are active at `distanceAtFeatureCm` along it — i.e. the relations under the
// cursor.
parcelHelpers.export(exports, "findCrosslinkRelationsAt", ()=>findCrosslinkRelationsAt);
var _helpers = require("@turf/helpers");
var _nearestPointOnLine = require("@turf/nearest-point-on-line");
var _nearestPointOnLineDefault = parcelHelpers.interopDefault(_nearestPointOnLine);
var _orbisLrSdk = require("@orbis-lr-sdk/orbis-lr-sdk");
var _util = require("../util");
function distanceAlongFeatureCm(feature, position) {
    const latLonGeometry = (0, _util.toLatLon)((0, _helpers.lineString)(feature.getGeometry().getCoordinates()).geometry);
    const closestPointLatLon = (0, _nearestPointOnLineDefault.default)(latLonGeometry, (0, _util.toLatLon)((0, _helpers.point)(position).geometry));
    return (0, _util.distanceAlongCm)(latLonGeometry, closestPointLatLon);
}
function findCrosslinkRelationsAt(feature, allFeatures, distanceAtFeatureCm) {
    const featureId = feature.getId();
    return allFeatures.filter((relation)=>{
        const memberIdKeys = memberIdKeysOf(relation);
        if (memberIdKeys.length === 0) return false;
        return memberIdKeys.filter((memberIdKey)=>relation.get(memberIdKey) === featureId).map((memberIdKey)=>relation.get(memberIdKey.replace("-id", "-role"))).some((role)=>roleInvolvedAt(role, distanceAtFeatureCm));
    });
}
// Whether a relation member's role covers `distanceCm` along the member. A
// plain role (no `=`, no LR) means the member is involved along its whole
// geometry — e.g. a lane fully covered by the crosslink has role "lane" — so it
// matches at any distance. An LR-ed role matches only where its value is
// defined.
function roleInvolvedAt(role, distanceCm) {
    if (typeof role !== "string") return false;
    if (!role.includes("=")) return true;
    const [tagKey, tagValue] = role.split("=", 2);
    return roleValueAt(tagKey, tagValue, distanceCm) !== undefined;
}
// ValueAtProducer.getValueAt throws on step chains when queried before the
// first breakpoint (e.g. distance 0) — it can't build a segment there. Treat a
// throw as "no value at this distance" so a cursor at the start of a line, or
// any unparseable role, doesn't crash the hover/click handlers.
function roleValueAt(tagKey, tagValue, distanceCm) {
    try {
        return (0, _orbisLrSdk.ValueAtProducer).getValueAt(tagKey, tagValue, distanceCm, (0, _orbisLrSdk.InterpolationSpecType).ROLE);
    } catch  {
        return undefined;
    }
}
function memberIdKeysOf(relation) {
    return relation.getKeys().filter((key)=>key.startsWith("relation-member-") && key.endsWith("-id"));
}

},{"@turf/helpers":"ityOQ","@turf/nearest-point-on-line":"bwWlY","@orbis-lr-sdk/orbis-lr-sdk":"04bfk","../util":"4IC9E","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hMgEt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHDMapInteractions", ()=>getHDMapInteractions);
var _select = require("ol/interaction/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _condition = require("ol/events/condition");
var _hdmap = require("../style/hdmap");
function getHDMapInteractions(layer, control) {
    const clickSelect = new (0, _selectDefault.default)({
        layers: [
            layer
        ],
        condition: (0, _condition.click),
        style: function(feature, resolution) {
            return (0, _hdmap.getHDMapStyleClick)(feature, resolution);
        }
    });
    clickSelect.on("select", function(e) {
        if (e.target.getFeatures().getLength() > 0) control.set("selectedFeatures", Array.from(e.target.getFeatures().getArray())); // create new array so that the event gets triggered
        else control.set("selectedFeatures", undefined);
    });
    return [
        clickSelect,
        new (0, _selectDefault.default)({
            layers: [
                layer
            ],
            condition: (0, _condition.pointerMove),
            style: function(feature, resolution) {
                return (0, _hdmap.getHDMapStyleHover)(feature, resolution);
            }
        })
    ];
}

},{"ol/interaction/Select":"1uL1O","ol/events/condition":"2tMOf","../style/hdmap":"B4rqX","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ghYyc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VectorFeatureControl", ()=>VectorFeatureControl);
var _control = require("ol/control/Control");
var _controlDefault = parcelHelpers.interopDefault(_control);
var _selectWidthMjs = require("./selectWidth.mjs");
var _entryGlueJs = require("../featureinfo/entryGlue.js");
class VectorFeatureControl extends (0, _controlDefault.default) {
    constructor(opt_options){
        const options = opt_options || {};
        const div = document.createElement("div");
        div.className = "vector-feature-layer-row";
        super({
            element: div,
            target: options.target
        });
        const this_ = this;
        const random = Math.floor(Math.random() * 10000);
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.className = "vector-feature-checkbox";
        checkbox.id = "vector-feature-input-" + random;
        checkbox.checked = false;
        checkbox.addEventListener("change", function() {
            this_.set("vectorToggle", checkbox.checked);
        });
        this._checkbox = checkbox;
        const label = document.createElement("label");
        label.htmlFor = checkbox.id;
        label.className = "vector-feature-text";
        label.innerText = options.layer_name;
        const statusIndicator = document.createElement("span");
        statusIndicator.className = "vector-feature-status";
        // Optional view dropdown: rows whose flavours share one WFS (`options.views`,
        // [{ id, label }]) switch style through `view` instead of being separate rows.
        let viewSelect = null;
        if (options.views) {
            viewSelect = document.createElement("select");
            viewSelect.className = "vector-feature-view-select";
            viewSelect.title = "View";
            options.views.forEach(({ id, label })=>{
                viewSelect.appendChild(new Option(label, id));
            });
            viewSelect.addEventListener("change", function() {
                this_.set("view", viewSelect.value);
                fitViewSelect();
            });
            // Re-measure once the web font is in: the first measurement may use the fallback.
            document.fonts?.ready.then(()=>fitViewSelect());
        }
        // The closed dropdown is as wide as the selected text, right-aligned in the
        // header (margin-left: auto); the open list stays the browser's own.
        let measureContext;
        function fitViewSelect() {
            if (!viewSelect || !viewSelect.isConnected) return;
            const option = viewSelect.options[viewSelect.selectedIndex];
            if (!option) return;
            const style = getComputedStyle(viewSelect);
            measureContext ??= document.createElement("canvas").getContext("2d");
            measureContext.font = `${style.fontStyle} ${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
            const width = measureContext.measureText(option.text).width;
            viewSelect.style.width = `${(0, _selectWidthMjs.selectWidthPx)(width, style)}px`;
        }
        const errorMessage = document.createElement("div");
        errorMessage.className = "vector-feature-error-message";
        const attributes = document.createElement("table");
        attributes.className = "ol-selectable vector-feature-attributes-list";
        (0, _entryGlueJs.installEntryEvents)(attributes);
        // The selection the attributes were last built from: entries are rebuilt only
        // when it changes, not on every loading/active toggle (keeps open expands open).
        let renderedSelection;
        // Header line: checkbox + label (+ revision icon appended by RevisionControl)
        const header = document.createElement("div");
        header.className = "vector-feature-header";
        div.appendChild(header);
        header.appendChild(checkbox);
        header.appendChild(label);
        header.appendChild(statusIndicator);
        if (viewSelect) header.appendChild(viewSelect);
        div.appendChild(errorMessage);
        div.append(attributes);
        // Expose so RevisionControl can append its icon into the header
        // and its panel between the header and the attributes table.
        this.headerEl = header;
        this.bodyEl = div;
        this.on("propertychange", ()=>{
            // roles
            if (this_.get("enabled") == false) {
                div.style.display = "none";
                checkbox.checked = false;
            } else div.style.display = "block";
            // loading / error status
            if (this_.get("loading") === true) {
                statusIndicator.className = "vector-feature-status vector-feature-status--loading";
                statusIndicator.title = "Loading\u2026";
                errorMessage.textContent = "";
                errorMessage.style.display = "none";
            } else if (this_.get("loadError") === true) {
                statusIndicator.className = "vector-feature-status vector-feature-status--error";
                statusIndicator.title = "Loading failed";
                const reason = this_.get("loadErrorReason");
                errorMessage.textContent = reason ? `Failed to load: ${reason}` : "Failed to load";
                errorMessage.style.display = "block";
            } else {
                statusIndicator.className = "vector-feature-status";
                statusIndicator.title = "";
                errorMessage.textContent = "";
                errorMessage.style.display = "none";
            }
            // attributes
            if (this_.get("vectorToggle") == false) // unset selected feature if disabled
            this_.set("selectedFeatures", undefined);
            const selectedFeatures = this_.get("selectedFeatures");
            if (selectedFeatures !== renderedSelection) {
                renderedSelection = selectedFeatures;
                attributes.replaceChildren();
                const colGroup = document.createElement("colgroup");
                const colLabel = document.createElement("col");
                colLabel.classList.add("label");
                const colValue = document.createElement("col");
                colValue.classList.add("value");
                colGroup.appendChild(colLabel);
                colGroup.appendChild(colValue);
                attributes.appendChild(colGroup);
                if (selectedFeatures !== undefined) {
                    attributes.style = "display: table;";
                    const sorted = Array.from(selectedFeatures).sort((f1, f2)=>{
                        if (f2.get(options.sort_field)) return f2.get(options.sort_field).localeCompare(f1.get(options.sort_field));
                    });
                    (0, _entryGlueJs.renderSelectedFeatures)(this_, sorted, {
                        rowName: options.layer_name,
                        headerField: options.header_field,
                        source: this_.layer?.getSource()
                    }).forEach((entry)=>attributes.append(entry));
                } else {
                    attributes.style = "display: block;";
                    (0, _entryGlueJs.releaseEntries)(this_);
                }
            }
            // sync checkbox with vectorToggle property
            checkbox.checked = !!this_.get("vectorToggle");
            const view = this_.get("view");
            if (viewSelect && view && viewSelect.value !== view) viewSelect.value = view;
            // Cheap, and the select is only in the document once the control is placed.
            fitViewSelect();
            // active
            if (this_.get("active")) {
                div.classList.add("layer-active");
                div.classList.remove("layer-inactive");
            } else {
                div.classList.remove("layer-active");
                div.classList.add("layer-inactive");
            }
        });
    }
    setToggle(value) {
        this.set("vectorToggle", value);
    }
}

},{"ol/control/Control":"8KSMn","./selectWidth.mjs":"22qPA","../featureinfo/entryGlue.js":"e5kaS","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"22qPA":[function(require,module,exports,__globalThis) {
// A <select> is as wide as its longest option, so a short choice ("Lane lines") sits
// in a box sized for the longest one. Sized to the selected text instead; the open
// list stays the browser's own. (CSS field-sizing: content would do this, but Safari
// does not support it.)
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {number} textWidth measured width of the selected option's text
 * @param {Partial<CSSStyleDeclaration>} style the select's computed style
 */ parcelHelpers.export(exports, "selectWidthPx", ()=>selectWidthPx);
const SIDES = [
    "paddingLeft",
    "paddingRight",
    "borderLeftWidth",
    "borderRightWidth"
];
// Covers sub-pixel rounding and a web font that loads after the measurement.
const SLACK_PX = 2;
function selectWidthPx(textWidth, style) {
    const sides = SIDES.reduce((sum, key)=>sum + (parseFloat(style[key]) || 0), 0);
    return Math.ceil(textWidth + sides) + SLACK_PX;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"e5kaS":[function(require,module,exports,__globalThis) {
// OL side of the sidebar entry: features in, entry DOM out, entries registered so the
// other rows, the hover and the drawer can find them. The pure modules do the work.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "entryRegistry", ()=>entryRegistry);
/** Called by the drawer to follow the last clicked entry. */ parcelHelpers.export(exports, "onEntriesChanged", ()=>onEntriesChanged);
/** Forget a row's entries (its selection changed or was cleared). */ parcelHelpers.export(exports, "releaseEntries", ()=>releaseEntries);
/**
 * @param {import("../controls/VectorFeatureControl").VectorFeatureControl} control
 * @param {import("ol/Feature").default[]} features in sidebar order
 * @param {{rowName: string, headerField?: string, source?: import("ol/source/Vector").default}} options
 * @returns {HTMLElement[]} one `tbody.fe-entry` per feature
 */ parcelHelpers.export(exports, "renderSelectedFeatures", ()=>renderSelectedFeatures);
/** Copy buttons, member hover and the pointer tooltip, once per attributes container. */ parcelHelpers.export(exports, "installEntryEvents", ()=>installEntryEvents);
/** Called by the drawer to follow the hover position. */ parcelHelpers.export(exports, "onLiveCursor", ()=>onLiveCursor);
/**
 * @param {import("ol/Feature").default|null} feature the closest hovered line, or null
 * @param {number} [distanceCm] position along it
 */ parcelHelpers.export(exports, "moveLiveCursor", ()=>moveLiveCursor);
/**
 * Bar and profile hover, sidebar → map: the position under the pointer moves the live
 * cursor (sidebar and drawer, as a map hover does) and is drawn on the map with the
 * range of the section or band under it. A lanes stretch row draws its range.
 * @param {Element} root
 * @param {(node: Element) => object|undefined} entryOf the entry a node belongs to
 */ parcelHelpers.export(exports, "installTrackHover", ()=>installTrackHover);
/** @param {Set<string>} featureIds ids of the features under the pointer */ parcelHelpers.export(exports, "markMemberRows", ()=>markMemberRows);
var _curvature = require("../layers/style/curvature");
var _featureWktMjs = require("../util/featureWkt.mjs");
var _cajViewMjs = require("./cajView.mjs");
var _copyTextMjs = require("./copyText.mjs");
var _entryRegistryMjs = require("./entryRegistry.mjs");
var _featureModelMjs = require("./featureModel.mjs");
var _laneViewMjs = require("./laneView.mjs");
var _cursorDomMjs = require("./cursorDom.mjs");
var _liveCursorMjs = require("./liveCursor.mjs");
var _lmRestrictionViewMjs = require("./lmRestrictionView.mjs");
var _memberHoverJs = require("./memberHover.js");
var _pointerTipJs = require("./pointerTip.js");
var _renderEntryMjs = require("./renderEntry.mjs");
var _renderViewsMjs = require("./renderViews.mjs");
var _trackHoverMjs = require("./trackHover.mjs");
const entryRegistry = (0, _entryRegistryMjs.createEntryRegistry)();
const entriesByControl = new WeakMap();
let clickCounter = 0;
let stampOpen = false;
// One stamp per click: a map click selects in several rows within one task.
function clickStamp() {
    if (!stampOpen) {
        clickCounter++;
        stampOpen = true;
        queueMicrotask(()=>stampOpen = false);
    }
    return clickCounter;
}
function modelOfFeature(feature) {
    const length = feature.get("lengthCm");
    return (0, _featureModelMjs.buildFeatureModel)({
        id: String(feature.getId() ?? ""),
        properties: feature.getProperties(),
        geometryType: feature.getGeometry()?.getType(),
        lengthCm: Number.isFinite(length) ? length : null
    });
}
// A CaJ arc is our drawing of a relation: show the relation. The arc's own properties
// (type, relation-id, its copy of curvature_at_junction) are drawing bookkeeping.
function arcRelation(feature, source) {
    const relationId = (0, _cajViewMjs.relationIdForArc)(feature.getProperties());
    return relationId && source ? source.getFeatureById(relationId) : null;
}
function viewsOf(model) {
    const views = [];
    const used = [];
    const lanes = (0, _laneViewMjs.buildLaneView)(model);
    if (lanes) {
        views.push((0, _renderViewsMjs.renderLaneView)(document, lanes));
        used.push(...lanes.usedTags);
    }
    const lm = (0, _lmRestrictionViewMjs.buildLmRestrictionView)(model);
    if (lm) {
        views.push((0, _renderViewsMjs.renderLmView)(document, lm));
        used.push(...lm.usedTags);
    }
    const caj = (0, _cajViewMjs.buildCajView)(model);
    if (caj) {
        const derived = (0, _curvature.curvatureAtJunctionKeyValues)(caj.value).slice(1);
        views.push((0, _renderViewsMjs.renderCajView)(document, caj, derived));
        used.push(...caj.usedTags);
    }
    return {
        views,
        viewTagKeys: new Set(used.map((t)=>t.rawKey)),
        laneView: lanes
    };
}
const entriesListeners = [];
function onEntriesChanged(listener) {
    entriesListeners.push(listener);
}
function refreshAlsoLines() {
    entryRegistry.entries().forEach((entry)=>{
        const row = entry.element.querySelector(".fe-also");
        if (!row) return;
        const rows = entryRegistry.alsoSelectedIn(entry.featureId, entry.rowName);
        row.style.display = rows.length ? "" : "none";
        row.querySelector(".fe-alsorows").textContent = rows.join(", ");
    });
    entriesListeners.forEach((listener)=>listener());
}
function releaseEntries(control) {
    (entriesByControl.get(control) ?? []).forEach((e)=>entryRegistry.remove(e));
    entriesByControl.delete(control);
    refreshAlsoLines();
}
function renderSelectedFeatures(control, features, options) {
    const { rowName, headerField, source } = options;
    (entriesByControl.get(control) ?? []).forEach((e)=>entryRegistry.remove(e));
    const clickedAt = clickStamp();
    const created = features.map((feature)=>{
        const relation = arcRelation(feature, source);
        const shown = relation ?? feature;
        const model = modelOfFeature(shown);
        const { views, viewTagKeys, laneView } = viewsOf(model);
        const missingMemberIds = new Set(model.members.filter((m)=>!(0, _memberHoverJs.lookupMember)(m.id, source)).map((m)=>m.id));
        const element = (0, _renderEntryMjs.renderFeatureEntry)(document, model, {
            headerText: headerField ? String(shown.get(headerField)) : undefined,
            wkt: (0, _featureWktMjs.sourceWkt)(shown),
            alsoIn: entryRegistry.alsoSelectedIn(model.id, rowName),
            views,
            viewTagKeys,
            missingMemberIds
        });
        const entry = {
            rowName,
            featureId: model.id,
            memberIds: model.members.map((m)=>m.id),
            clickedAt,
            element,
            model,
            laneView,
            feature: shown,
            source
        };
        entryRegistry.add(entry);
        return entry;
    });
    entriesByControl.set(control, created);
    refreshAlsoLines();
    return created.map((e)=>e.element);
}
function installEntryEvents(container) {
    (0, _pointerTipJs.installPointerTip)(container);
    installTrackHover(container, (node)=>entryRegistry.entries().find((e)=>e.element.contains(node)));
    let hoveredRow = null;
    container.addEventListener("mouseover", (event)=>{
        const row = event.target instanceof Element ? event.target.closest("tr[data-member], tr.fe-head") : null;
        if (row === hoveredRow) return;
        hoveredRow = row;
        const entry = row && entryRegistry.entries().find((e)=>e.element.contains(row));
        if (!entry || entry.model.members.length === 0) {
            (0, _memberHoverJs.clearMemberHover)();
            return;
        }
        (0, _memberHoverJs.showMemberHover)(entry, row.classList.contains("fe-head") ? null : Number(row.dataset.index));
    });
    container.addEventListener("mouseleave", ()=>{
        hoveredRow = null;
        (0, _memberHoverJs.clearMemberHover)();
    });
    container.addEventListener("click", (event)=>{
        const button = event.target instanceof Element && event.target.closest("[data-copy]");
        if (!button) return;
        navigator.clipboard?.writeText(button.dataset.copy).then(()=>{
            button.classList.add("fe-copied");
            setTimeout(()=>button.classList.remove("fe-copied"), 900);
        });
    });
    container.addEventListener("dblclick", selectWholeValue);
    copyContainers.add(container);
    if (copyContainers.size === 1) document.addEventListener("copy", copyEntrySelection);
}
// Double-click: the whole key, value, id or range under the pointer, no blank around.
const SELECT_UNIT = ".fe-id, .fe-key, .fe-item, .fe-value, .fe-range, .fe-slot, .fe-lsv, .fe-mono, .v, td, th";
function selectWholeValue(event) {
    const unit = event.target instanceof Element && event.target.closest(SELECT_UNIT);
    if (!unit || unit.closest("button, summary, textarea, input")) return;
    const walker = document.createTreeWalker(unit, NodeFilter.SHOW_TEXT, {
        acceptNode: (node)=>node.parentElement?.closest("button, summary") ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
    });
    const texts = [];
    while(walker.nextNode())texts.push(walker.currentNode);
    const bounds = (0, _copyTextMjs.trimmedBounds)(texts.map((t)=>t.data));
    if (!bounds) return;
    const range = document.createRange();
    range.setStart(texts[bounds.start[0]], bounds.start[1]);
    range.setEnd(texts[bounds.end[0]], bounds.end[1]);
    const selection = document.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
}
// Copy: a key and its value on one line, tab-separated; buttons and expand labels out.
const copyContainers = new Set();
function copyEntrySelection(event) {
    const selection = document.getSelection();
    if (!selection || selection.isCollapsed || selection.rangeCount === 0) return;
    const range = selection.getRangeAt(0);
    const inEntries = [
        ...copyContainers
    ].some((c)=>c.contains(range.commonAncestorContainer));
    if (!inEntries) return;
    const text = (0, _copyTextMjs.plainTextOf)(range.cloneContents());
    if (!text) return;
    event.clipboardData.setData("text/plain", text);
    event.preventDefault();
}
let cursorEntries = [];
const cursorListeners = [];
function onLiveCursor(listener) {
    cursorListeners.push(listener);
}
function moveLiveCursor(feature, distanceCm) {
    const entries = feature ? entryRegistry.entries().filter((e)=>e.feature === feature) : [];
    cursorEntries.filter((e)=>!entries.includes(e)).forEach((e)=>(0, _cursorDomMjs.clearCursor)(e.element));
    cursorEntries = entries;
    entries.forEach((e)=>(0, _cursorDomMjs.applyCursor)(e.element, (0, _liveCursorMjs.cursorTargets)(e.model, e.laneView, distanceCm)));
    cursorListeners.forEach((listener)=>listener(feature, distanceCm));
}
function installTrackHover(root, entryOf) {
    let active = false;
    const clear = ()=>{
        if (!active) return;
        active = false;
        moveLiveCursor(null);
        (0, _memberHoverJs.clearPositionHover)();
    };
    root.addEventListener("mousemove", (event)=>{
        // A drag is a text selection: nothing follows the pointer meanwhile.
        if (event.buttons) {
            clear();
            return;
        }
        const target = event.target instanceof Element ? event.target : null;
        const track = target?.closest((0, _trackHoverMjs.TRACK_SELECTOR));
        const stretch = !track && target?.closest(".fe-ls");
        const entry = (track || stretch) && entryOf(track || stretch);
        if (!entry) {
            clear();
            return;
        }
        active = true;
        if (stretch) {
            moveLiveCursor(null);
            (0, _memberHoverJs.showPositionHover)(entry.feature, null, (0, _trackHoverMjs.rangeOf)(stretch.dataset));
            return;
        }
        const ranged = target.closest((0, _trackHoverMjs.RANGE_SELECTOR));
        const cm = (0, _trackHoverMjs.trackPosition)(track.getBoundingClientRect(), event.clientX, Number(track.dataset.axis));
        moveLiveCursor(entry.feature, cm);
        (0, _memberHoverJs.showPositionHover)(entry.feature, cm, ranged && track.contains(ranged) ? (0, _trackHoverMjs.rangeOf)(ranged.dataset) : null);
    });
    root.addEventListener("mouseleave", clear);
}
// Member hover, map → sidebar: rows of open entries whose member is under the pointer.
let hotRows = [];
let hotKey = "";
function markMemberRows(featureIds) {
    const key = [
        ...featureIds
    ].sort().join("\n");
    if (key === hotKey) return;
    hotKey = key;
    hotRows.forEach((row)=>row.classList.remove("fe-hot"));
    hotRows = [];
    if (featureIds.size === 0) return;
    entryRegistry.entries().forEach((entry)=>{
        if (!entry.memberIds.some((id)=>featureIds.has(id))) return;
        entry.element.querySelectorAll("tr[data-member]").forEach((row)=>{
            if (!featureIds.has(row.dataset.member)) return;
            row.classList.add("fe-hot");
            hotRows.push(row);
        });
    });
}

},{"../layers/style/curvature":"dM5mO","../util/featureWkt.mjs":"gxnaa","./cajView.mjs":"t6Ls2","./copyText.mjs":"fk74m","./entryRegistry.mjs":"cpgjt","./featureModel.mjs":"9MLBf","./laneView.mjs":"hgFLe","./cursorDom.mjs":"b1nMV","./liveCursor.mjs":"g5LeK","./lmRestrictionView.mjs":"35TbM","./memberHover.js":"lBCTO","./pointerTip.js":"gZzC1","./renderEntry.mjs":"hvAxO","./renderViews.mjs":"k5moz","./trackHover.mjs":"iCvis","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"t6Ls2":[function(require,module,exports,__globalThis) {
// The curvature-at-junction view of a CaJ relation: the value and meta_full_curvature
// as a profile; the members are in the entry's members table. The derived rows (NDS
// curvature, radius, max speed) come from layers/style/curvature.js in the glue.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {Record<string, unknown>} properties of a feature the CaJ arc handler made
 * @returns {string|undefined} the id of the relation the arc was drawn from
 */ parcelHelpers.export(exports, "relationIdForArc", ()=>relationIdForArc);
/**
 * @param {import("./featureModel.mjs").FeatureModel} model
 */ parcelHelpers.export(exports, "buildCajView", ()=>buildCajView);
var _lrValuesMjs = require("./lrValues.mjs");
const ARC_TYPES = new Set([
    "curvature-arc",
    "curvature-arc-dummy"
]);
function relationIdForArc(properties) {
    if (!ARC_TYPES.has(properties?.type)) return undefined;
    const id = properties["relation-id"];
    return id === undefined || id === null ? undefined : String(id);
}
function buildCajView(model) {
    const tags = model.groups.flatMap((g)=>g.tags);
    const value = tags.find((t)=>(0, _lrValuesMjs.baseKey)(t.key) === "curvature_at_junction");
    if (!value) return null;
    // Only a chain the profile can draw is the view's; else it stays in its group.
    const full = tags.find((t)=>(0, _lrValuesMjs.baseKey)(t.key) === "meta_full_curvature" && t.sections && t.lr === "linear");
    return {
        value: String(value.value),
        fullCurvature: full ? full.sections : null,
        usedTags: full ? [
            value,
            full
        ] : [
            value
        ]
    };
}

},{"./lrValues.mjs":"CS5r3","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"CS5r3":[function(require,module,exports,__globalThis) {
// LR chain values as the sidebar reads them: `a-b#v;…` (step), `a#v;…` (bare offsets:
// linear points, spots, or step sections whose end is the next start). Pure, so the
// node tests reach it. The LR SDK stays the authority for values at a position; this
// only exposes the sections so they can be listed and drawn.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Split on `separator`, where a backslash before it makes it a literal character.
 * @param {string} text
 * @param {string} separator one character
 * @returns {string[]}
 */ parcelHelpers.export(exports, "splitUnescaped", ()=>splitUnescaped);
/**
 * @param {string} key
 * @returns {"step"|"linear"|"spot"|null}
 */ parcelHelpers.export(exports, "lrKindOfKey", ()=>lrKindOfKey);
/**
 * @param {string} key
 * @returns {string} the key without its `:step` / `:linear` / `:spot` suffix
 */ parcelHelpers.export(exports, "baseKey", ()=>baseKey);
/**
 * Sections of an LR chain, or null when any `;` part is not `start[-[end]]#value`.
 * A bare offset (`1100#x`) and an empty end (`1000-#no`) give `endCm: null`.
 * @param {unknown} value
 * @returns {{startCm: number, endCm: number|null, value: string}[]|null}
 */ parcelHelpers.export(exports, "parseLrChain", ()=>parseLrChain);
const SECTION = /^(\d+)(?:-(\d*))?#(.*)$/s;
const LR_SUFFIX = /:(step|linear|spot)$/;
function splitUnescaped(text, separator) {
    const parts = [];
    let current = "";
    for(let i = 0; i < text.length; i++){
        const char = text[i];
        if (char === "\\" && text[i + 1] === separator) {
            current += separator;
            i++;
        } else if (char === separator) {
            parts.push(current);
            current = "";
        } else current += char;
    }
    parts.push(current);
    return parts;
}
function lrKindOfKey(key) {
    const match = LR_SUFFIX.exec(key);
    return match ? match[1] : null;
}
function baseKey(key) {
    return key.replace(LR_SUFFIX, "");
}
function parseLrChain(value) {
    if (typeof value !== "string" || value === "") return null;
    const sections = [];
    for (const part of splitUnescaped(value, ";")){
        const match = SECTION.exec(part);
        if (!match) return null;
        sections.push({
            startCm: Number(match[1]),
            endCm: match[2] ? Number(match[2]) : null,
            value: match[3]
        });
    }
    return sections;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fk74m":[function(require,module,exports,__globalThis) {
// Copying from the sidebar entries: the text a selection should put on the clipboard
// (a key and its value on one line, tab-separated, as table cells are; buttons and
// expand labels left out), and the bounds a double-click selects (no blank around).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** @returns {string} the clipboard text of a node or a selection's cloned fragment */ parcelHelpers.export(exports, "plainTextOf", ()=>plainTextOf);
/**
 * @param {string[]} texts consecutive text node contents
 * @returns {{start: [number, number], end: [number, number]}|null} first non-blank
 *   character and the offset after the last one, as [text index, offset]
 */ parcelHelpers.export(exports, "trimmedBounds", ()=>trimmedBounds);
const BLOCK = new Set([
    "DIV",
    "TABLE",
    "TBODY",
    "THEAD",
    "TFOOT",
    "TR",
    "TD",
    "TH",
    "P",
    "PRE",
    "DETAILS",
    "UL",
    "OL",
    "LI",
    "SECTION"
]);
const SKIPPED = new Set([
    "BUTTON",
    "SUMMARY",
    "TEXTAREA",
    "INPUT",
    "SCRIPT"
]);
// Drawings, axis labels and counts: the section lists hold the data.
const SKIPPED_CLASSES = [
    "fe-bar",
    "fe-profile",
    "fe-ticks",
    "fe-ylab",
    "fe-count"
];
const kids = (node)=>[
        ...node.childNodes ?? node.children ?? []
    ];
const hasClass = (node, name)=>typeof node.className === "string" && node.className.split(/\s+/).includes(name);
const isRow = (node)=>node.tagName === "TR" || hasClass(node, "kv");
// Not copied: controls, hidden rows (`also selected in` when empty), closed expands,
// drawings.
const skipped = (node)=>SKIPPED.has(node.tagName) || node.style?.display === "none" || node.tagName === "DETAILS" && node.getAttribute("open") === null || SKIPPED_CLASSES.some((name)=>hasClass(node, name));
// Slot cells copy as the tagged `a|b|c` value; a blank slot (shown `·`) is empty.
const slotText = (node)=>kids(node).filter((cell)=>cell.nodeType === 1).map((cell)=>kids(cell).some((k)=>k.nodeType === 1 && hasClass(k, "fe-blank")) ? "" : cell.textContent.trim()).join("|");
// Collapses blanks but keeps the tab between a key and its value.
const clean = (text)=>text.replace(/[^\S\t]+/g, " ").trim();
function linesOf(node) {
    if (node.nodeType === 3) return [
        node.textContent
    ];
    if (node.nodeType !== 1 && node.nodeType !== 11) return [];
    if (node.nodeType === 1 && skipped(node)) return [];
    if (node.nodeType === 1 && node.tagName === "PRE") return node.textContent.split("\n");
    if (node.nodeType === 1 && hasClass(node, "fe-slots")) return [
        slotText(node)
    ];
    if (node.nodeType === 1 && isRow(node)) {
        const cells = kids(node).filter((c)=>c.nodeType === 1).map((c)=>linesOf(c).map(clean).filter(Boolean));
        if (cells.every((c)=>c.length <= 1)) return [
            cells.flat().filter(Boolean).join("\t")
        ];
        return cells.flat();
    }
    const lines = [];
    let current = "";
    kids(node).forEach((child)=>{
        const block = child.nodeType === 1 && (BLOCK.has(child.tagName) || isRow(child));
        const childLines = linesOf(child);
        if (!block && childLines.length <= 1) {
            current += childLines[0] ?? "";
            return;
        }
        lines.push(current, ...childLines);
        current = "";
    });
    lines.push(current);
    return lines;
}
function plainTextOf(node) {
    return linesOf(node).map(clean).filter(Boolean).join("\n");
}
function trimmedBounds(texts) {
    const start = texts.findIndex((t)=>/\S/.test(t));
    if (start < 0) return null;
    let end = texts.length - 1;
    while(!/\S/.test(texts[end]))end--;
    return {
        start: [
            start,
            texts[start].search(/\S/)
        ],
        end: [
            end,
            texts[end].replace(/\s+$/, "").length
        ]
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"cpgjt":[function(require,module,exports,__globalThis) {
// The open sidebar entries across all rows: one registry serves "also selected in",
// map → member row marking, the live cursor and the drawer's last clicked entry.
/**
 * @typedef {{rowName: string, featureId: string, memberIds: string[],
 *   clickedAt: number, element?: unknown, model?: object}} Entry
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createEntryRegistry", ()=>createEntryRegistry);
function createEntryRegistry() {
    const entries = new Set();
    return {
        add: (entry)=>entries.add(entry),
        remove: (entry)=>entries.delete(entry),
        entries: ()=>[
                ...entries
            ],
        alsoSelectedIn: (featureId, rowName)=>[
                ...new Set([
                    ...entries
                ].filter((e)=>e.featureId === featureId && e.rowName !== rowName).map((e)=>e.rowName))
            ]
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9MLBf":[function(require,module,exports,__globalThis) {
// One feature's properties as the sidebar entry shows them: tags grouped by key prefix
// (layer id, `orbis`, `osm` or none) with the revision once per group, the viewer's own
// properties apart, and relation members. Pure, so the node tests reach it.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NO_PREFIX_LABEL", ()=>NO_PREFIX_LABEL);
/**
 * @param {{id: string, properties: Record<string, unknown>, geometryType: string,
 *   lengthCm: number|null|undefined}} input
 */ parcelHelpers.export(exports, "buildFeatureModel", ()=>buildFeatureModel);
var _lrValuesMjs = require("./lrValues.mjs");
var _membersMjs = require("./members.mjs");
// Set by viewer code (layers, addfeature handlers), not by the WFS.
const VIEWER_KEYS = [
    "lengthCm",
    "laneRoadClass",
    "overlap-offset",
    "overlap-start-node",
    "overlap-end-node",
    "is-relation",
    "relation-id",
    "curvature_at_junction",
    "crosslinkUncoveredGeoms",
    "crosslinkOutOfBoundsGeoms",
    "source-feature-id",
    "nonInteractive"
];
const VIEWER = new Set(VIEWER_KEYS);
const NO_PREFIX_LABEL = "no prefix";
// Internal flags of the viewer's own drawing: not shown (the raw box still has them).
const VIEWER_HIDDEN = new Set([
    "is-relation",
    "relation-id",
    "overlap-offset",
    "overlap-start-node",
    "overlap-end-node",
    "crosslinkUncoveredGeoms",
    "crosslinkOutOfBoundsGeoms",
    "source-feature-id",
    "nonInteractive"
]);
// Linear chains whose key carries no `:linear` suffix.
const LINEAR_WITHOUT_SUFFIX = new Set([
    "meta_full_curvature"
]);
// A prefix is a layer id or a source name; it never holds a `:`.
const PREFIXED = /^([^-:]+)-(.+)$/;
const NUMERIC = /^\d+$/;
const isSkipped = (key)=>key === "geometry" || key === "type" || key === "meta-uuid" || key.startsWith("revision-") || key.startsWith("relation-member-");
function splitPrefix(rawKey) {
    const match = PREFIXED.exec(rawKey);
    return match ? {
        prefix: match[1],
        key: match[2]
    } : {
        prefix: "",
        key: rawKey
    };
}
/** `revision-<layer>-<key>` keys by their key part. */ function indexRevisions(properties) {
    const byKeyPart = new Map();
    Object.keys(properties).forEach((key)=>{
        if (!key.startsWith("revision-")) return;
        const match = PREFIXED.exec(key.slice(9));
        if (!match) return;
        const [, layer, keyPart] = match;
        if (!byKeyPart.has(keyPart)) byKeyPart.set(keyPart, []);
        byKeyPart.get(keyPart).push({
            layer,
            revKey: key
        });
    });
    return byKeyPart;
}
function mostFrequent(values) {
    const counts = new Map();
    values.forEach((v)=>counts.set(v, (counts.get(v) ?? 0) + 1));
    let best;
    counts.forEach((count, value)=>{
        if (best === undefined || count > counts.get(best)) best = value;
    });
    return best;
}
function buildFeatureModel({ id, properties, geometryType, lengthCm }) {
    const props = properties ?? {};
    const revisionsByKeyPart = indexRevisions(props);
    const groups = [];
    const groupByPrefix = new Map();
    const viewer = [];
    const revisionLayerOf = new Map();
    Object.entries(props).forEach(([rawKey, value])=>{
        if (VIEWER.has(rawKey)) {
            if (VIEWER_HIDDEN.has(rawKey)) return;
            viewer.push({
                key: rawKey,
                rawKey,
                value,
                revision: undefined,
                lr: null,
                sections: null
            });
            return;
        }
        if (isSkipped(rawKey)) return;
        const { prefix, key } = splitPrefix(rawKey);
        // WFSLayer renames a sectioned tag to `<key>:step`; its revision may keep the old key.
        let revision = props[`revision-${rawKey}`] ?? props[`revision-${rawKey.replace(/:step$/, "")}`];
        let revisionLayer = NUMERIC.test(prefix) ? prefix : null;
        if (revision === undefined && !NUMERIC.test(prefix)) {
            // orbis-/osm-/unprefixed keys: the revision sits under the layer that wrote it.
            const candidates = revisionsByKeyPart.get(key) ?? [];
            if (candidates.length === 1) {
                revision = props[candidates[0].revKey];
                revisionLayer = candidates[0].layer;
            }
        }
        const lr = (0, _lrValuesMjs.lrKindOfKey)(rawKey) ?? (LINEAR_WITHOUT_SUFFIX.has((0, _lrValuesMjs.baseKey)(key)) ? "linear" : null);
        const tag = {
            key,
            rawKey,
            value,
            revision: revision === undefined ? undefined : String(revision),
            lr,
            sections: lr ? (0, _lrValuesMjs.parseLrChain)(value) : null
        };
        if (!groupByPrefix.has(prefix)) {
            const group = {
                prefix,
                revisionLayer: null,
                revision: undefined,
                tags: []
            };
            groupByPrefix.set(prefix, group);
            groups.push(group);
        }
        const group = groupByPrefix.get(prefix);
        group.tags.push(tag);
        revisionLayerOf.set(tag, revisionLayer);
    });
    groups.forEach((group)=>{
        group.revision = mostFrequent(group.tags.map((t)=>t.revision).filter((r)=>r !== undefined));
        if (!NUMERIC.test(group.prefix) && group.revision !== undefined) {
            const tag = group.tags.find((t)=>t.revision === group.revision);
            group.revisionLayer = revisionLayerOf.get(tag);
        }
    });
    const tagKeys = new Set(groups.flatMap((g)=>g.tags.map((t)=>t.key)));
    const orphanRevisions = [];
    revisionsByKeyPart.forEach((entries, keyPart)=>{
        if (!tagKeys.has(keyPart)) entries.forEach((e)=>orphanRevisions.push(e.revKey));
    });
    const order = Object.keys(props);
    orphanRevisions.sort((a, b)=>order.indexOf(a) - order.indexOf(b));
    return {
        id,
        type: props.type === undefined ? undefined : String(props.type),
        geometryType,
        lengthCm: Number.isFinite(lengthCm) ? lengthCm : null,
        groups,
        viewer,
        members: (0, _membersMjs.parseMembers)(props),
        orphanRevisions,
        properties: props
    };
}

},{"./lrValues.mjs":"CS5r3","./members.mjs":"9FahE","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9FahE":[function(require,module,exports,__globalThis) {
// Relation members from the flat `relation-member-<n>-*` properties gss-wfs writes.
// Roles with a range keep the role as tagged (`road:step=1900-13594`); the range is
// read out next to it. Other members carry `lr-start` (+ `lr-end`) / `lr-type`.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {Record<string, unknown>} properties
 * @returns {{index: number, id: string, role: string, roleName: string,
 *   lr: {type: "step"|"linear"|"spot", startCm: number, endCm: number|null}|null}[]}
 */ parcelHelpers.export(exports, "parseMembers", ()=>parseMembers);
const MEMBER_KEY = /^relation-member-(\d+)-(id|role|lr-start|lr-end|lr-type)$/;
const ROLE_RANGE = /^(\d+)(?:-(\d*))?$/;
const LR_TYPES = {
    step: "step",
    linear: "linear",
    spot: "spot"
};
/**
 * `name:kind=a-b;c-d` → {roleName, lr}; anything else is a plain role name.
 * @param {string} role
 */ function parseRole(role) {
    const match = /^([^:=]+):(step|linear|spot)=(.*)$/.exec(role);
    if (!match) return {
        roleName: role,
        lr: null
    };
    const ranges = [];
    for (const part of match[3].split(";")){
        const range = ROLE_RANGE.exec(part);
        if (!range) return {
            roleName: match[1],
            lr: null
        };
        ranges.push({
            startCm: Number(range[1]),
            endCm: range[2] ? Number(range[2]) : null
        });
    }
    const lr = {
        type: match[2],
        ...ranges[0]
    };
    // Only the multi-range case needs the list; one range is the lr itself.
    if (ranges.length > 1) lr.ranges = ranges;
    return {
        roleName: match[1],
        lr
    };
}
function parseMembers(properties) {
    const byIndex = new Map();
    Object.entries(properties).forEach(([key, value])=>{
        const match = MEMBER_KEY.exec(key);
        if (!match) return;
        const index = Number(match[1]);
        if (!byIndex.has(index)) byIndex.set(index, {});
        byIndex.get(index)[match[2]] = value;
    });
    return [
        ...byIndex.keys()
    ].sort((a, b)=>a - b).map((index)=>{
        const raw = byIndex.get(index);
        const role = raw.role === undefined ? "" : String(raw.role);
        const parsed = parseRole(role);
        const lrType = LR_TYPES[String(raw["lr-type"] ?? "").toLowerCase()];
        const start = Number(raw["lr-start"]);
        const end = Number(raw["lr-end"]);
        const hasEnd = raw["lr-end"] !== undefined && Number.isFinite(end);
        const lr = parsed.lr ?? (raw["lr-start"] !== undefined && Number.isFinite(start) ? {
            type: lrType ?? (hasEnd ? "step" : "spot"),
            startCm: start,
            endCm: hasEnd ? end : null
        } : null);
        return {
            index,
            id: raw.id === undefined ? "" : String(raw.id),
            role,
            roleName: parsed.roleName,
            lr
        };
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hgFLe":[function(require,module,exports,__globalThis) {
// The lanes and lane-restriction view of an RM or OSMLR way (Orbis spec 12.18):
// per stretch, the slots with direction and dividers, then one row per known slot
// key, and the restriction class per slot as the map colours it.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {import("./featureModel.mjs").FeatureModel} model
 * @returns {{stretches: object[], usedTags: object[]}|null}
 */ parcelHelpers.export(exports, "buildLaneView", ()=>buildLaneView);
var _restrictionClassMjs = require("../layers/style/util/restrictionClass.mjs");
var _lrValuesMjs = require("./lrValues.mjs");
var _slotsMjs = require("./slots.mjs");
var _stretchesMjs = require("./stretches.mjs");
const LANE_DRAWN_KEYS = [
    "lanes:direction",
    "divider:lanes"
];
const LANE_ROW_KEYS = /^(turn:lanes|exit_entrance:lanes|lanes:direction:conditional|turn:lanes:conditional|lanes:vehicle_access:(bus|hgv|motorcar|taxi)(:conditional)?|hov:lanes(:conditional)?|hov:minimum:lanes(:conditional)?|hov:clean_fuel:lanes(:conditional)?|toll:lanes(:conditional)?|toll:hov:lanes(:conditional)?)$/;
const ACCESS_MODES = [
    "bus",
    "hgv",
    "motorcar",
    "taxi"
];
const ACCESS_KEYS = ACCESS_MODES.map((m)=>`lanes:vehicle_access:${m}`);
const ACCESS_FIELDS = {
    bus: "rm_vehicleAccessBus",
    hgv: "rm_vehicleAccessHgv",
    motorcar: "rm_vehicleAccessMotorcar",
    taxi: "rm_vehicleAccessTaxi"
};
// Row order; each plain key before its :conditional form.
const ROW_ORDER = [
    "turn:lanes",
    "exit_entrance:lanes",
    "lanes:direction",
    ...ACCESS_KEYS,
    "hov:lanes",
    "hov:minimum:lanes",
    "hov:clean_fuel:lanes",
    "toll:lanes",
    "toll:hov:lanes"
].flatMap((key)=>key === "lanes:direction" ? [
        `${key}:conditional`
    ] : [
        key,
        `${key}:conditional`
    ]);
const pad = (slots, length)=>Array.from({
        length
    }, (_, i)=>slots[i] ?? "");
function buildLaneView(model) {
    const tagsByKey = new Map();
    model.groups.forEach((group)=>group.tags.forEach((tag)=>{
            const key = (0, _lrValuesMjs.baseKey)(tag.key);
            const known = LANE_DRAWN_KEYS.includes(key) || LANE_ROW_KEYS.test(key) || (0, _slotsMjs.isLaneCountKey)(key);
            if (known && !tagsByKey.has(key) && (0, _stretchesMjs.tagSections)(tag)) tagsByKey.set(key, tag);
        }));
    const shown = [
        ...tagsByKey.keys()
    ].filter((key)=>!(0, _slotsMjs.isLaneCountKey)(key));
    if (shown.length === 0) return null;
    const hasAccess = [
        ...tagsByKey.keys()
    ].some((key)=>key.startsWith("lanes:vehicle_access:"));
    const rowKeys = ROW_ORDER.filter((key)=>tagsByKey.has(key) || hasAccess && ACCESS_KEYS.includes(key));
    const sectionsByKey = Object.fromEntries([
        ...tagsByKey
    ].map(([key, tag])=>[
            key,
            (0, _stretchesMjs.tagSections)(tag)
        ]));
    const stretches = (0, _stretchesMjs.buildStretches)(sectionsByKey, model.lengthCm).map(({ startCm, endCm, values })=>{
        const slotsOf = (key)=>values[key] === undefined ? null : (0, _slotsMjs.splitSlots)(values[key]);
        const direction = slotsOf("lanes:direction");
        const dividers = slotsOf("divider:lanes");
        const rowSlots = rowKeys.map((key)=>[
                key,
                slotsOf(key)
            ]);
        const slotCount = Math.max(Number(values["lanes"]) || 0, direction ? direction.length : 0, dividers ? dividers.length + 1 : 0, ...rowSlots.map(([, slots])=>slots ? slots.length : 0));
        const rows = rowSlots.filter(([key, slots])=>slots || ACCESS_KEYS.includes(key)).map(([key, slots])=>({
                key,
                tagged: tagsByKey.has(key),
                slots: pad(slots ?? [], slotCount)
            }));
        const counts = {};
        [
            "forward",
            "backward",
            "both_ways",
            "reversible"
        ].forEach((name)=>{
            const value = values[`lanes:${name}`];
            if (value !== undefined) counts[name] = value;
        });
        const accessSlots = ACCESS_MODES.map((mode)=>pad(slotsOf(`lanes:vehicle_access:${mode}`) ?? [], slotCount));
        const classes = hasAccess ? Array.from({
            length: slotCount
        }, (_, i)=>(0, _restrictionClassMjs.accessClassOf)((0, _restrictionClassMjs.rmLaneAccess)(Object.fromEntries(ACCESS_MODES.map((mode, m)=>[
                    ACCESS_FIELDS[mode],
                    accessSlots[m][i]
                ]))))) : null;
        return {
            startCm,
            endCm,
            slotCount,
            lanes: values["lanes"],
            counts,
            direction: direction && pad(direction, slotCount),
            dividers: dividers && pad(dividers, Math.max(slotCount - 1, 0)),
            rows,
            classes
        };
    });
    return {
        stretches,
        usedTags: [
            ...tagsByKey.values()
        ]
    };
}

},{"../layers/style/util/restrictionClass.mjs":"bWcVG","./lrValues.mjs":"CS5r3","./slots.mjs":"ghqtd","./stretches.mjs":"6pBLw","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bWcVG":[function(require,module,exports,__globalThis) {
// What the "Restrictions" styling knows about one LM lane, one RM/OSMLR way, or one
// LR section of either: which modes are shut out (an access class) and whether it is
// an HOV lane (an HOV state). Both models are first read into the neutral model of
// tomtom-internal/orbis-lane-road-mapping-lib — per mode open / closed / unknown —
// so the same restriction gets the same class, and so the same stroke, from LM,
// RM and OSMLR. Pure, so the node tests reach it; util/restrictionStrokes.js draws it.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * One LM lane's access per mode, as the lib's LmRestrictions reads it. LM `yes` means
 * ALLOWED — an exception under a more general `no` — never "reserved for": the
 * Bay Area HOV lane is motor_vehicle=no + motorcar/bus/taxi=yes, i.e. no trucks. A
 * token other than yes/no (blank, a raw LR chain on styleBySection's fallback) states
 * nothing: a readable statement above it stands, and a mode with none is "unknown".
 * @param {Record<string, string|undefined>} tags — as returned by extractTags()
 * @returns {Record<string, "open"|"closed"|"unknown">}
 */ parcelHelpers.export(exports, "lmAccess", ()=>lmAccess);
/**
 * One RM/OSMLR lane's access per mode, from that lane's own slot values.
 * @param {Record<string, string|undefined>} slot — one value per lane list, as laneSlots() gives
 * @returns {Record<string, "open"|"closed"|"unknown">}
 */ parcelHelpers.export(exports, "rmLaneAccess", ()=>rmLaneAccess);
/**
 * Every lane's access, as many lanes as the longest access list. A raw LR chain is
 * not split into lanes (splitLaneList), so on styleBySection's fallback it says
 * nothing rather than painting the whole way from one stretch.
 * @param {Record<string, string|undefined>} tags — as returned by extractTags()
 * @returns {Array<Record<string, "open"|"closed"|"unknown">>}
 */ parcelHelpers.export(exports, "rmSlotAccess", ()=>rmSlotAccess);
/**
 * @param {Record<string, string>} access — from lmAccess / rmLaneAccess
 * @returns {string|null} a key of ACCESS_CLASS_COLORS; null when nothing is closed
 */ parcelHelpers.export(exports, "accessClassOf", ()=>accessClassOf);
parcelHelpers.export(exports, "ACCESS_CLASS_COLORS", ()=>ACCESS_CLASS_COLORS);
/**
 * @param {Record<string, string>|undefined} access
 * @returns {string|null}
 */ parcelHelpers.export(exports, "accessColorOf", ()=>accessColorOf);
/**
 * The lane a per-way stroke speaks for: the one shutting out the most modes, ties
 * broken by RANK. The Lanes view is where the other lanes show.
 * @param {Array<Record<string, string>>} accesses
 * @returns {Record<string, string>|undefined} undefined for no lanes
 */ parcelHelpers.export(exports, "mostRestrictive", ()=>mostRestrictive);
/**
 * @param {Record<string, string|undefined>} tags — as returned by extractTags()
 * @returns {"active"|"conditional"|"empty"|null} active: some lane is HOV; conditional:
 *   some lane is HOV during a posted window; empty: an HOV tag is present but no lane
 *   is HOV (`|||`, `no|no`) — drawn so "tagged, says nothing" is visible; null: untagged
 */ parcelHelpers.export(exports, "hovState", ()=>hovState);
/**
 * LM `hov_lane` takes only `yes` (the lib's Hov). Any other value reads like RM's
 * `no|no` — an HOV tag that marks no HOV lane. LM has no time-conditional form.
 * @param {Record<string, string|undefined>} tags — as returned by extractTags()
 * @returns {"active"|"empty"|null}
 */ parcelHelpers.export(exports, "lmHovState", ()=>lmHovState);
/**
 * An RM/OSMLR way: its most restrictive lane's access colour, plus its HOV state.
 * @param {Record<string, string|undefined>} tags
 * @returns {{access: string|null, hov: string|null}|null} null when neither applies
 */ parcelHelpers.export(exports, "classifyRmRestriction", ()=>classifyRmRestriction);
/**
 * An LM lane: its access colour, plus its HOV state.
 * @param {Record<string, string|undefined>} tags
 * @returns {{access: string|null, hov: string|null}|null} null when neither applies
 */ parcelHelpers.export(exports, "classifyLmRestriction", ()=>classifyLmRestriction);
var _conditionalValuesMjs = require("./conditionalValues.mjs");
var _laneListsMjs = require("./laneLists.mjs");
var _stepSectionsMjs = require("./stepSections.mjs");
// The modes both models can state (the lib's Mode). Alphabetical, which is what the
// closed-set keys of CLASS_BY_CLOSED are joined in.
const MODES = [
    "bus",
    "hgv",
    "motorcar",
    "taxi"
];
const tagged = (value)=>value !== undefined && value !== null;
// LM tokens onto those modes, MOST GENERAL FIRST (the lib's Mode.COVERED_BY_TOKEN):
// a specific statement overwrites the general one above it, so motor_vehicle=no +
// bus=yes is a bus lane whatever order the tags arrive in. psv is retired by the
// producer but read, as the lib reads it.
const LM_HIERARCHY = [
    [
        "vehicleRestrictionMotorVehicle",
        MODES
    ],
    [
        "vehicleRestrictionPSV",
        [
            "bus",
            "taxi"
        ]
    ],
    [
        "vehicleRestrictionBus",
        [
            "bus"
        ]
    ],
    [
        "vehicleRestrictionHGV",
        [
            "hgv"
        ]
    ],
    [
        "vehicleRestrictionMotorcar",
        [
            "motorcar"
        ]
    ],
    [
        "vehicleRestrictionTaxi",
        [
            "taxi"
        ]
    ]
];
function lmAccess(tags) {
    const read = {};
    const unreadable = new Set();
    LM_HIERARCHY.forEach(([field, modes])=>{
        const token = tags[field];
        if (!tagged(token)) return;
        const state = token === "no" ? "closed" : token === "yes" ? "open" : null;
        modes.forEach((mode)=>{
            if (state) read[mode] = state;
            else unreadable.add(mode);
        });
    });
    return Object.fromEntries(MODES.map((mode)=>[
            mode,
            read[mode] ?? (unreadable.has(mode) ? "unknown" : "open")
        ]));
}
const RM_ACCESS_FIELDS = {
    bus: "rm_vehicleAccessBus",
    hgv: "rm_vehicleAccessHgv",
    motorcar: "rm_vehicleAccessMotorcar",
    taxi: "rm_vehicleAccessTaxi"
};
// RM writes only `no`; permission is written by omission, a blank slot or no list at
// all (the lib's RmRestrictions). Any other token is "unknown".
const rmTokenAccess = (token)=>!token ? "open" : token === "no" ? "closed" : "unknown";
function rmLaneAccess(slot) {
    return Object.fromEntries(MODES.map((mode)=>[
            mode,
            rmTokenAccess(slot[RM_ACCESS_FIELDS[mode]])
        ]));
}
function rmSlotAccess(tags) {
    const lists = MODES.map((mode)=>(0, _laneListsMjs.splitLaneList)(tags[RM_ACCESS_FIELDS[mode]]));
    const lanes = Math.max(0, ...lists.map((list)=>list.length));
    return Array.from({
        length: lanes
    }, (_, lane)=>Object.fromEntries(MODES.map((mode, i)=>[
                mode,
                rmTokenAccess(lists[i][lane])
            ])));
}
// Classes are named by the closed set. "unknown" never counts as closed: a statement
// nobody could read must not colour a lane.
const CLASS_BY_CLOSED = {
    hgv: "noTrucks",
    "bus,hgv": "noBusNoTruck",
    "hgv,motorcar": "taxiAndBus",
    "hgv,motorcar,taxi": "busOnly",
    "bus,hgv,motorcar": "taxiOnly",
    "bus,motorcar,taxi": "trucksOnly",
    "bus,hgv,motorcar,taxi": "closed"
};
const closedModes = (access)=>MODES.filter((m)=>access[m] === "closed");
function accessClassOf(access) {
    const closed = closedModes(access);
    if (closed.length === 0) return null;
    return CLASS_BY_CLOSED[closed.join(",")] ?? "other";
}
const ACCESS_CLASS_COLORS = {
    busOnly: "maroon",
    taxiAndBus: "blue",
    taxiOnly: "yellow",
    noTrucks: "purple",
    // Not CSS "brown", which is too close to maroon.
    noBusNoTruck: "#008080",
    trucksOnly: "#795548",
    closed: "darkgrey",
    // Every closed set the palette doesn't name: restricted — read the info panel.
    other: "darkgrey"
};
function accessColorOf(access) {
    const cls = access ? accessClassOf(access) : null;
    return cls ? ACCESS_CLASS_COLORS[cls] : null;
}
// Tie-break between lanes that shut out as many modes.
const RANK = [
    "closed",
    "busOnly",
    "taxiOnly",
    "trucksOnly",
    "taxiAndBus",
    "noBusNoTruck",
    "noTrucks",
    "other"
];
function outranks(a, b) {
    const byCount = closedModes(a).length - closedModes(b).length;
    if (byCount !== 0) return byCount > 0;
    const rank = (access)=>RANK.indexOf(accessClassOf(access) ?? "other");
    return rank(a) < rank(b);
}
function mostRestrictive(accesses) {
    return accesses.reduce((best, access)=>!best || outranks(access, best) ? access : best, undefined);
}
// The values that mark an RM HOV lane: `designated` in the OSM-normalized layers, `yes`
// in the RM ones and in every conditional. Same set as the Lanes view's classifyLane.
const HOV_LANE_VALUES = [
    "yes",
    "designated"
];
// One entry per lane. A raw LR chain only reaches here on styleBySection's
// whole-feature fallback; its offsets are peeled off so each slot is still compared
// exactly instead of `"0-1000#yes"` failing to equal "yes".
function slots(value) {
    const text = String(value);
    const body = (0, _stepSectionsMjs.isOffsetSectionedValue)(text) ? text.replace(/(^|;)\s*\d+(?:-\d*)?#/g, "|") // "500#", "0-1000#", "1000-#"
     : text;
    return body.split("|").map((slot)=>slot.trim());
}
function hovState(tags) {
    const lanes = tags.rm_hovLanes;
    const conditional = tags.rm_hovLanesConditional;
    if (!tagged(lanes) && !tagged(conditional)) return null;
    if (tagged(lanes) && slots(lanes).some((s)=>HOV_LANE_VALUES.includes(s))) return "active";
    if (tagged(conditional) && slots(conditional).some((s)=>HOV_LANE_VALUES.includes((0, _conditionalValuesMjs.splitConditionalValue)(s)?.value))) return "conditional";
    return "empty";
}
function lmHovState(tags) {
    if (!tagged(tags.hovLane)) return null;
    return slots(tags.hovLane).includes("yes") ? "active" : "empty";
}
// Plain JSON: styleBySection merges neighbouring sections by JSON.stringify.
const restriction = (access, hov)=>access || hov ? {
        access,
        hov
    } : null;
function classifyRmRestriction(tags) {
    return restriction(accessColorOf(mostRestrictive(rmSlotAccess(tags))), hovState(tags));
}
function classifyLmRestriction(tags) {
    return restriction(accessColorOf(lmAccess(tags)), lmHovState(tags));
}

},{"./conditionalValues.mjs":"adIen","./laneLists.mjs":"fzyYi","./stepSections.mjs":"bZM8z","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"adIen":[function(require,module,exports,__globalThis) {
// Pure helpers for #Conditional tag values — `<value> @ (<condition>)`, as carried
// by the new-Lanes-spec keys `hov:lanes:conditional` and
// `hov:minimum:lanes:conditional` (per-lane pipe lists whose SLOTS are conditional
// values, e.g. `yes @ (Mo-Fr 05:00-09:00,15:00-19:00)|||`).
//
// No OpenLayers imports so this is unit-testable with `node --test`. The split
// helpers work on one SLOT at a time — splitting the pipe list into slots is
// laneLists' splitLaneList's job, and a time domain never contains `|`, so the two
// splits cannot interfere.
//
// The time-domain evaluator covers the "sharp" subset the Orbis spec recommends and
// the SDLR data actually uses: weekday lists/ranges plus hh:mm-hh:mm ranges,
// multiple rules separated by `;`. Anything it does not understand (months, public
// holidays, fuzzy domains like "dusk-dawn", `off` exclusions) makes parseTimeDomain
// return null — callers must then say "conditional, window not evaluated" rather
// than guessing.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Split one conditional slot value into its base value and its condition.
 * `"yes @ (Mo-Fr 05:00-09:00)"` → `{ value: "yes", condition: "Mo-Fr 05:00-09:00" }`.
 * A plain value without `@` comes back as `{ value, condition: undefined }`, so
 * callers can feed either encoding through the same path.
 * @param {unknown} raw
 * @returns {{value: string, condition: string|undefined}|undefined} undefined for
 *   empty/blank slots ("nothing said about this lane")
 */ parcelHelpers.export(exports, "splitConditionalValue", ()=>splitConditionalValue);
/**
 * Is this whole tag value (a pipe list of slots) conditional in at least one slot?
 * Works on unsplit values so per-way styles can test cheaply.
 * @param {unknown} raw
 * @returns {boolean}
 */ parcelHelpers.export(exports, "hasConditionalSlot", ()=>hasConditionalSlot);
/**
 * Parse a sharp time domain into evaluatable rules.
 *
 * Supported per `;`-separated rule: an optional weekday part (`Mo-Fr`, `Mo,We,Fr`,
 * `Sa-Su` including week wrap `Fr-Mo`) and an optional list of `hh:mm-hh:mm`
 * ranges (overnight ranges like `22:00-06:00` wrap midnight). A rule with only
 * days means all day; only times means every day.
 * @param {string|undefined} condition
 * @returns {{days: boolean[], ranges: {fromMin: number, toMin: number}[]}[]|null}
 *   null when any part of the condition is outside the supported grammar —
 *   callers must treat that as "cannot evaluate", not as never/always.
 */ parcelHelpers.export(exports, "parseTimeDomain", ()=>parseTimeDomain);
/**
 * Evaluate parsed rules at a Date, in that Date's LOCAL time. The restriction's
 * clock times are local to the ROAD, so evaluating at the viewer's clock is only
 * meaningful when the viewer and the road share a timezone — callers must label
 * the result with the timezone they evaluated in.
 * @param {ReturnType<typeof parseTimeDomain>} rules
 * @param {Date} date
 * @returns {boolean|null} null when rules is null (unsupported grammar)
 */ parcelHelpers.export(exports, "isActiveAt", ()=>isActiveAt);
const DAY_NAMES = [
    "Su",
    "Mo",
    "Tu",
    "We",
    "Th",
    "Fr",
    "Sa"
];
// `<value> @ (<condition>)` — the value must be non-empty and the condition sits in
// parentheses per the spec's syntax for conditional restrictions. The spec also
// allows multiple `;`-separated <value> @ <condition> pairs in one tag value; in a
// per-lane slot that form is rare and a `;` there is equally a step-section
// separator, so this parser handles exactly one pair and callers treat anything
// else as opaque.
const CONDITIONAL_VALUE = /^\s*([^@]*?)\s*@\s*\(\s*(.*?)\s*\)\s*$/;
function splitConditionalValue(raw) {
    if (raw === undefined || raw === null) return undefined;
    const text = String(raw).trim();
    if (text === "") return undefined;
    const match = CONDITIONAL_VALUE.exec(text);
    if (match && match[1] !== "") return {
        value: match[1],
        condition: match[2]
    };
    return {
        value: text,
        condition: undefined
    };
}
function hasConditionalSlot(raw) {
    if (typeof raw !== "string") return false;
    return raw.split("|").some((slot)=>splitConditionalValue(slot)?.condition !== undefined);
}
function parseTimeDomain(condition) {
    if (typeof condition !== "string" || condition.trim() === "") return null;
    const rules = [];
    for (const ruleText of condition.split(";")){
        const tokens = ruleText.trim().split(/\s+/).filter(Boolean);
        if (tokens.length === 0) return null;
        const days = new Array(7).fill(false);
        let sawDays = false;
        const ranges = [];
        for (const token of tokens){
            if (parseDayToken(token, days)) sawDays = true;
            else if (!parseTimeToken(token, ranges)) return null;
        }
        if (!sawDays) days.fill(true);
        rules.push({
            days,
            ranges
        });
    }
    return rules.length > 0 ? rules : null;
}
// `Mo-Fr`, `Sa`, `Mo,We,Fr`, `Fr-Mo` (wrapping). Returns false when the token is
// not a day expression at all; throws nothing.
function parseDayToken(token, days) {
    const parts = token.split(",");
    const parsed = [];
    for (const part of parts){
        const range = part.split("-");
        if (range.length > 2) return false;
        const from = DAY_NAMES.indexOf(range[0]);
        const to = range.length === 2 ? DAY_NAMES.indexOf(range[1]) : from;
        if (from < 0 || to < 0) return false;
        parsed.push([
            from,
            to
        ]);
    }
    for (const [from, to] of parsed)for(let d = from;; d = (d + 1) % 7){
        days[d] = true;
        if (d === to) break;
    }
    return true;
}
// `05:00-09:00,15:00-19:00` — one token can carry several comma-separated ranges.
// `24:00` is accepted as an end ("until midnight"). Returns false on anything else.
function parseTimeToken(token, ranges) {
    const parts = token.split(",");
    const parsed = [];
    for (const part of parts){
        const match = /^(\d{1,2}):(\d{2})-(\d{1,2}):(\d{2})$/.exec(part);
        if (!match) return false;
        const fromMin = Number(match[1]) * 60 + Number(match[2]);
        const toMin = Number(match[3]) * 60 + Number(match[4]);
        if (Number(match[1]) > 24 || Number(match[3]) > 24 || Number(match[2]) > 59 || Number(match[4]) > 59 || fromMin > 1440 || toMin > 1440) return false;
        parsed.push({
            fromMin,
            toMin
        });
    }
    ranges.push(...parsed);
    return true;
}
function isActiveAt(rules, date) {
    if (!rules) return null;
    const day = date.getDay();
    const minutes = date.getHours() * 60 + date.getMinutes();
    const previousDay = (day + 6) % 7;
    for (const rule of rules){
        if (rule.ranges.length === 0) {
            if (rule.days[day]) return true;
            continue;
        }
        for (const { fromMin, toMin } of rule.ranges)if (fromMin <= toMin) {
            if (rule.days[day] && minutes >= fromMin && minutes < toMin) return true;
        } else {
            // Overnight range: the stretch before midnight belongs to the rule's day,
            // the stretch after midnight to the following day.
            if (rule.days[day] && minutes >= fromMin) return true;
            if (rule.days[previousDay] && minutes < toMin) return true;
        }
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fzyYi":[function(require,module,exports,__globalThis) {
// Per-lane pipe lists (`no||no`). Pure, so the node tests reach it — both the band
// maths in laneBands.js and the classifier in restrictionClass.mjs split lists here.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Split a per-lane pipe list into one entry per lane. A blank slot is meaningful —
 * "allowed" for an access tag, "not applicable" for hov — so empty entries are
 * kept, including trailing ones ("no|" is two lanes, not one).
 * @param {string|undefined} value
 * @returns {string[]} one entry per lane; [] when there is no value at all
 */ parcelHelpers.export(exports, "splitLaneList", ()=>splitLaneList);
var _stepSectionsMjs = require("./stepSections.mjs");
function splitLaneList(value) {
    if (value === undefined || value === null || value === "") return [];
    // Whitespace-only is nothing, not one blank lane. `" "` used to come back as
    // `[""]`, and since a length of 1 beats the `lanes=N` tier it overrode a correct
    // count with 1. A lone `"|"` survives this — that IS two unspecified lanes.
    if (String(value).trim() === "") return [];
    // A value that is still an LR chain is not a per-lane list, and must not be split
    // into one. styleBySection normally resolves step tags to scalars before classify()
    // sees them, but its whole-feature fallbacks — non-LineString geometry, zero
    // lengthCm, an undecodable chain — pass the RAW tags through. A per-lane step value
    // nests the pipe list inside the step value (`0-1000#yes||yes`), so splitting it
    // yields a slot that is exactly "yes" and the whole way renders as restricted, and a
    // lane count invented from wherever the pipes happened to fall. Exact-match slot
    // comparison does not protect against this; only refusing to split does.
    if ((0, _stepSectionsMjs.isOffsetSectionedValue)(value)) return [];
    return String(value).split("|").map((entry)=>entry.trim());
}

},{"./stepSections.mjs":"bZM8z","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bZM8z":[function(require,module,exports,__globalThis) {
// Pure helpers for LR *step* tags — values like "0-1000#yes;5000-7000#no",
// where each `startCm-endCm#value` section applies to one stretch of the
// feature's own geometry. No OpenLayers / orbis-lr-sdk imports so this is
// unit-testable with `node --test`; the decoding + geometry slicing adapter
// lives next door in `stepSections.js`.
//
// A step tag differs from a `:linear` one in that the value does NOT
// interpolate between offsets — it holds constant over each section and is
// simply absent outside them. "Absent" is meaningful (no restriction there),
// so a gap must render as the unrestricted style, not as the previous value.
// First section of a step chain: "<start>-<end>#" with an optionally omitted
// end ("1000-#no" = from 1000cm to the end of the geometry).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Does this tag value carry per-section offsets, as opposed to a plain scalar
 * ("yes") that applies to the whole feature?
 * @param {unknown} value
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isStepEncodedValue", ()=>isStepEncodedValue);
/**
 * Like isStepEncodedValue, but also accepts the bare-offset form above.
 *
 * Kept separate because that form is **ambiguous on value shape alone**:
 * `1234#yes` is equally the encoding of a `:spot` tag (at 1234cm) and of a
 * `:linear` chain's first point, and gss-wfs strips the `:step` / `:spot`
 * suffix when it decodes, so the key can't disambiguate either. Use this only
 * where the caller knows its tags are step-encoded enumerations — the two
 * lane-restriction styles, whose tags are yes/no. `isStepEncodedValue` stays
 * the conservative test for anything that runs across every layer's tags.
 * @param {unknown} value
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isOffsetSectionedValue", ()=>isOffsetSectionedValue);
/**
 * Close every bare-offset section ("500#3", decoded with no end) at the start of
 * the element after it — what the SDK's getEndDistanceOfOffset does. Left open,
 * each offset would run to the end of the line, so in "0#2;500#3" the first
 * section would cover everything and win on every lookup. A trailing offset stays
 * open: it does run to the end. Explicit ranges are untouched.
 * @param {{startCm: number, endCm: number|null|undefined, value: string}[]} sections
 *   in chain order
 */ parcelHelpers.export(exports, "closeOffsetSections", ()=>closeOffsetSections);
/**
 * Clamp decoded sections onto a geometry of `lengthCm`, dropping the empty
 * ones. An `endCm` of null/undefined/Infinity means "to the end of the
 * geometry" — the LR spec allows the end to be omitted.
 * @param {{startCm: number, endCm: number|null|undefined, value: string}[]} sections
 * @param {number} lengthCm
 */ parcelHelpers.export(exports, "clampSections", ()=>clampSections);
/**
 * The value covering `cm`, or undefined where no section covers it. Sections
 * are half-open [startCm, endCm) so touching sections don't both claim their
 * shared breakpoint.
 * @param {{startCm: number, endCm: number, value: string}[]} sections
 * @param {number} cm
 */ parcelHelpers.export(exports, "valueAtCm", ()=>valueAtCm);
/**
 * Cut [0, lengthCm] at every section boundary of every tag, then resolve each
 * resulting interval to one value per tag. The result is the smallest set of
 * stretches over which *all* the given tags are constant — i.e. exactly the
 * stretches that can be drawn as a single uniformly-styled piece of line.
 *
 * @param {Record<string, {startCm: number, endCm: number|null, value: string}[]>} sectionsByTag
 *   Decoded sections per tag name. Tags that aren't step-encoded are simply
 *   left out by the caller and stay whole-feature values.
 * @param {number} lengthCm
 * @returns {{startCm: number, endCm: number, values: Record<string, string|undefined>}[]}
 */ parcelHelpers.export(exports, "resolveSections", ()=>resolveSections);
/**
 * Collapse neighbouring intervals whose styling key is identical, so a tag
 * that changes without changing the rendered colour doesn't fragment the line.
 * @template {{startCm: number, endCm: number}} T
 * @param {T[]} intervals
 * @param {(interval: T) => string} keyOf
 * @returns {(T & {key: string})[]}
 */ parcelHelpers.export(exports, "mergeAdjacent", ()=>mergeAdjacent);
const STEP_CHAIN_START = /^\d+-\d*#/;
// A single open-ended section can also be written with no range at all —
// "27432#yes" means "from 274.32m to the end of the line". Real HDLR data does
// this: layer 88259 pairs `psv:step=0-27432#yes` with `bus:step=27432#yes`.
const OFFSET_CHAIN_START = /^\d+[-#]/;
function isStepEncodedValue(value) {
    return typeof value === "string" && STEP_CHAIN_START.test(value);
}
function isOffsetSectionedValue(value) {
    return typeof value === "string" && OFFSET_CHAIN_START.test(value);
}
function closeOffsetSections(sections) {
    return sections.map((section, i)=>{
        const next = sections[i + 1];
        const open = section.endCm === null || section.endCm === undefined;
        return open && next && next.startCm > section.startCm ? {
            ...section,
            endCm: next.startCm
        } : section;
    });
}
function clampSections(sections, lengthCm) {
    if (!(lengthCm > 0)) return [];
    return sections.map((section)=>({
            startCm: Math.max(0, Math.min(section.startCm, lengthCm)),
            endCm: section.endCm === null || section.endCm === undefined || !Number.isFinite(section.endCm) ? lengthCm : Math.max(0, Math.min(section.endCm, lengthCm)),
            value: section.value
        })).filter((section)=>section.endCm > section.startCm);
}
function valueAtCm(sections, cm) {
    const hit = sections.find((section)=>cm >= section.startCm && cm < section.endCm);
    return hit === undefined ? undefined : hit.value;
}
// Sub-centimetre slivers are invisible and would only multiply the styles OL
// has to render, so intervals shorter than this are dropped.
const MIN_SECTION_CM = 1;
function resolveSections(sectionsByTag, lengthCm) {
    const names = Object.keys(sectionsByTag);
    if (names.length === 0 || !(lengthCm > 0)) return [];
    const clamped = {};
    const breakpoints = new Set([
        0,
        lengthCm
    ]);
    names.forEach((name)=>{
        clamped[name] = clampSections(sectionsByTag[name], lengthCm);
        clamped[name].forEach((section)=>{
            breakpoints.add(section.startCm);
            breakpoints.add(section.endCm);
        });
    });
    const ordered = Array.from(breakpoints).sort((a, b)=>a - b);
    const intervals = [];
    for(let i = 1; i < ordered.length; i++){
        const startCm = ordered[i - 1];
        const endCm = ordered[i];
        if (endCm - startCm < MIN_SECTION_CM) continue;
        // Sample at the midpoint: it is inside the interval whatever the
        // half-open/closed convention at the shared breakpoints.
        const midCm = (startCm + endCm) / 2;
        const values = {};
        names.forEach((name)=>{
            values[name] = valueAtCm(clamped[name], midCm);
        });
        intervals.push({
            startCm,
            endCm,
            values
        });
    }
    return intervals;
}
function mergeAdjacent(intervals, keyOf) {
    const merged = [];
    intervals.forEach((interval)=>{
        const key = keyOf(interval);
        const previous = merged[merged.length - 1];
        if (previous && previous.key === key) {
            previous.endCm = interval.endCm;
            return;
        }
        merged.push({
            ...interval,
            key
        });
    });
    return merged;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ghqtd":[function(require,module,exports,__globalThis) {
// Per-lane slot lists (`no||yes`), told apart by key, not by value:
// `source_identifier:internal = ttom-sd|2024.03.007` holds a `|` and is no slot list.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** @param {string} key a key without its layer prefix */ parcelHelpers.export(exports, "isLaneCountKey", ()=>isLaneCountKey);
/** @param {string} key a key without its layer prefix */ parcelHelpers.export(exports, "isSlotKey", ()=>isSlotKey);
/**
 * @param {string} value
 * @returns {string[]} one entry per slot, blanks kept
 */ parcelHelpers.export(exports, "splitSlots", ()=>splitSlots);
var _lrValuesMjs = require("./lrValues.mjs");
const COUNT_KEYS = new Set([
    "lanes",
    "lanes:forward",
    "lanes:backward",
    "lanes:both_ways",
    "lanes:reversible"
]);
function isLaneCountKey(key) {
    return COUNT_KEYS.has((0, _lrValuesMjs.baseKey)(key));
}
function isSlotKey(key) {
    const base = (0, _lrValuesMjs.baseKey)(key);
    if (base.startsWith("feedback:") || base.startsWith("meta:")) return false;
    return !COUNT_KEYS.has(base) && base.split(":").includes("lanes");
}
function splitSlots(value) {
    return String(value).split("|").map((slot)=>slot.trim());
}

},{"./lrValues.mjs":"CS5r3","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6pBLw":[function(require,module,exports,__globalThis) {
// Stretches of a feature over which a set of tags is constant, the same cut the
// map's styleBySection makes, so a view's tables line up with what the map draws.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A tag's value as sections: its LR sections, or one open section from 0 for a
 * whole-way value. Null for an LR key whose value does not parse.
 * @param {{lr: string|null, sections: object[]|null, value: unknown}} tag
 */ parcelHelpers.export(exports, "tagSections", ()=>tagSections);
/**
 * @param {Record<string, {startCm: number, endCm: number|null, value: string}[]>} sectionsByName
 * @param {number|null} lengthCm
 * @returns {{startCm: number, endCm: number, values: Record<string, string|undefined>}[]}
 *   adjacent identical stretches merged, stretches where nothing is tagged dropped
 */ parcelHelpers.export(exports, "buildStretches", ()=>buildStretches);
var _stepSectionsMjs = require("../layers/style/util/stepSections.mjs");
var _positionsMjs = require("./positions.mjs");
function tagSections(tag) {
    if (tag.lr) return tag.sections;
    if (tag.value === null || tag.value === undefined) return null;
    return [
        {
            startCm: 0,
            endCm: null,
            value: String(tag.value)
        }
    ];
}
function buildStretches(sectionsByName, lengthCm) {
    const end = (0, _positionsMjs.axisEndCm)(lengthCm, Object.values(sectionsByName).flat());
    const closed = Object.fromEntries(Object.entries(sectionsByName).map(([name, sections])=>[
            name,
            (0, _stepSectionsMjs.closeOffsetSections)(sections)
        ]));
    return (0, _stepSectionsMjs.mergeAdjacent)((0, _stepSectionsMjs.resolveSections)(closed, end), (interval)=>JSON.stringify(interval.values)).filter((s)=>Object.values(s.values).some((v)=>v !== undefined)).map(({ startCm, endCm, values })=>({
            startCm,
            endCm,
            values
        }));
}

},{"../layers/style/util/stepSections.mjs":"bZM8z","./positions.mjs":"gc1cv","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gc1cv":[function(require,module,exports,__globalThis) {
// Where along a feature each LR section or point sits, for the sidebar's bars,
// profiles, tooltips and live cursor. Pure, so the node tests reach it. The hover
// box keeps the LR SDK's value; these give the range it comes from.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The axis a feature's sections are drawn on: its length, or the largest offset
 * when there is no length (or a section runs past it). Never 0.
 * @param {number|null} lengthCm
 * @param {{startCm: number, endCm: number|null}[]} sections
 */ parcelHelpers.export(exports, "axisEndCm", ()=>axisEndCm);
/**
 * Step sections closed onto the axis: bare offsets end at the next start, open
 * ends at the axis end.
 */ parcelHelpers.export(exports, "closedStepSections", ()=>closedStepSections);
/**
 * @returns {{value: string, startCm: number, endCm: number}|undefined}
 */ parcelHelpers.export(exports, "stepValueAt", ()=>stepValueAt);
parcelHelpers.export(exports, "isProfilePoint", ()=>isProfilePoint);
/**
 * A linear chain as points to interpolate, plus bands for sections that do not
 * interpolate (an explicit range, or a value like `multiple`).
 * @param {{startCm: number, endCm: number|null, value: string}[]} sections
 * @param {number|null} lengthCm
 */ parcelHelpers.export(exports, "buildProfile", ()=>buildProfile);
/**
 * @returns {{value: number|string, startCm: number, endCm: number,
 *   interpolated: boolean}|undefined}
 */ parcelHelpers.export(exports, "profileValueAt", ()=>profileValueAt);
var _stepSectionsMjs = require("../layers/style/util/stepSections.mjs");
function axisEndCm(lengthCm, sections) {
    const offsets = sections.flatMap((s)=>Number.isFinite(s.endCm) ? [
            s.startCm,
            s.endCm
        ] : [
            s.startCm
        ]);
    return Math.max(lengthCm ?? 0, ...offsets) || 1;
}
function closedStepSections(sections, lengthCm) {
    return (0, _stepSectionsMjs.clampSections)((0, _stepSectionsMjs.closeOffsetSections)(sections), axisEndCm(lengthCm, sections));
}
function stepValueAt(sections, lengthCm, cm) {
    return closedStepSections(sections, lengthCm).find((s)=>cm >= s.startCm && cm < s.endCm);
}
const isProfilePoint = (section)=>section.endCm === null && section.value.trim() !== "" && Number.isFinite(Number(section.value));
function buildProfile(sections, lengthCm) {
    const end = axisEndCm(lengthCm, sections);
    const points = [];
    const bands = [];
    sections.forEach((s, i)=>{
        if (isProfilePoint(s)) {
            points.push({
                cm: s.startCm,
                value: Number(s.value)
            });
            return;
        }
        const next = sections.slice(i + 1).find((n)=>n.startCm > s.startCm);
        bands.push({
            startCm: s.startCm,
            endCm: s.endCm ?? (next ? next.startCm : end),
            value: s.value
        });
    });
    const values = points.map((p)=>p.value);
    return {
        points,
        bands,
        min: Math.min(0, ...values),
        max: Math.max(0, ...values),
        axisEndCm: end
    };
}
function profileValueAt(profile, cm) {
    const band = profile.bands.find((b)=>cm >= b.startCm && cm < b.endCm);
    if (band) return {
        value: band.value,
        startCm: band.startCm,
        endCm: band.endCm,
        interpolated: false
    };
    const { points } = profile;
    if (points.length === 0 || cm < points[0].cm) return undefined;
    const at = points.find((p)=>p.cm === cm);
    if (at) return {
        value: at.value,
        startCm: cm,
        endCm: cm,
        interpolated: false
    };
    const nextIndex = points.findIndex((p)=>p.cm > cm);
    if (nextIndex === -1) {
        const last = points[points.length - 1];
        return {
            value: last.value,
            startCm: last.cm,
            endCm: profile.axisEndCm,
            interpolated: false
        };
    }
    const a = points[nextIndex - 1];
    const b = points[nextIndex];
    return {
        value: a.value + (b.value - a.value) * (cm - a.cm) / (b.cm - a.cm),
        startCm: a.cm,
        endCm: b.cm,
        interpolated: true
    };
}

},{"../layers/style/util/stepSections.mjs":"bZM8z","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"b1nMV":[function(require,module,exports,__globalThis) {
// Live cursor on an entry's DOM: move the cursor line on each bar and profile, bold
// the section or point pair under it, mark the lanes stretch. Nothing is re-rendered.
/**
 * @param {Element} element a `tbody.fe-entry`
 * @param {ReturnType<import("./liveCursor.mjs").cursorTargets>} targets
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyCursor", ()=>applyCursor);
/** @param {Element} element */ parcelHelpers.export(exports, "clearCursor", ()=>clearCursor);
function applyCursor(element, targets) {
    const blocks = new Map([
        ...element.querySelectorAll("tr.fe-lrblock")
    ].map((b)=>[
            b.dataset.rawKey,
            b
        ]));
    targets.tags.forEach((t)=>{
        const block = blocks.get(t.rawKey);
        if (!block) return;
        const track = block.querySelector(".fe-bar, .fe-profile");
        if (track) {
            let cursor = [
                ...track.children
            ].find((c)=>c.classList.contains("fe-cursor"));
            if (!cursor) {
                cursor = element.ownerDocument.createElement("i");
                cursor.className = "fe-cursor";
                track.append(cursor);
            }
            cursor.style.display = "";
            cursor.style.left = `${t.percent}%`;
        }
        block.querySelectorAll(".fe-at").forEach((n)=>n.classList.remove("fe-at"));
        [
            t.activeIndex,
            t.nextIndex
        ].filter((i)=>i >= 0).forEach((i)=>block.querySelectorAll(`[data-index="${i}"]`).forEach((n)=>n.classList.add("fe-at")));
    });
    element.querySelectorAll(".fe-ls").forEach((n)=>n.classList.toggle("fe-at", Number(n.dataset.index) === targets.laneStretch));
}
function clearCursor(element) {
    element.querySelectorAll(".fe-cursor").forEach((c)=>c.style.display = "none");
    element.querySelectorAll(".fe-at").forEach((n)=>n.classList.remove("fe-at"));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"g5LeK":[function(require,module,exports,__globalThis) {
// Where the hover position falls in an open entry: per LR tag, the cursor's place on
// its bar or profile and the section (or point pair) under it; the lanes view stretch.
// The glue only moves elements and toggles classes from this.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {import("./featureModel.mjs").FeatureModel} model
 * @param {{stretches: {startCm: number, endCm: number}[]}|null} laneView
 * @param {number} cm
 * @returns {{tags: {rawKey: string, percent: number, activeIndex: number,
 *   nextIndex: number}[], laneStretch: number}}
 */ parcelHelpers.export(exports, "cursorTargets", ()=>cursorTargets);
var _positionsMjs = require("./positions.mjs");
function stepIndexAt(sections, axis, cm) {
    return sections.findIndex((s, i)=>{
        const next = sections.slice(i + 1).find((n)=>n.startCm > s.startCm);
        const end = s.endCm ?? (next ? next.startCm : axis);
        return cm >= s.startCm && cm < end;
    });
}
function profileIndicesAt(sections, lengthCm, cm) {
    const at = (0, _positionsMjs.profileValueAt)((0, _positionsMjs.buildProfile)(sections, lengthCm), cm);
    if (!at) return [
        -1,
        -1
    ];
    const pointIndex = (pointCm)=>sections.findIndex((s)=>(0, _positionsMjs.isProfilePoint)(s) && s.startCm === pointCm);
    if (typeof at.value === "string") {
        const band = sections.findIndex((s)=>!(0, _positionsMjs.isProfilePoint)(s) && s.startCm === at.startCm && s.value === at.value);
        return [
            band,
            -1
        ];
    }
    if (!at.interpolated) return [
        pointIndex(at.startCm),
        -1
    ];
    return [
        pointIndex(at.startCm),
        pointIndex(at.endCm)
    ];
}
function cursorTargets(model, laneView, cm) {
    const tags = model.groups.flatMap((g)=>g.tags).filter((t)=>t.sections).map((t)=>{
        const axis = (0, _positionsMjs.axisEndCm)(model.lengthCm, t.sections);
        const percent = Math.min(Math.max(cm / axis * 100, 0), 100);
        let indices = [
            -1,
            -1
        ];
        if (t.lr === "step") indices = [
            stepIndexAt(t.sections, axis, cm),
            -1
        ];
        if (t.lr === "linear") indices = profileIndicesAt(t.sections, model.lengthCm, cm);
        return {
            rawKey: t.rawKey,
            percent,
            activeIndex: indices[0],
            nextIndex: indices[1]
        };
    });
    const laneStretch = laneView ? laneView.stretches.findIndex((s)=>cm >= s.startCm && cm < s.endCm) : -1;
    return {
        tags,
        laneStretch
    };
}

},{"./positions.mjs":"gc1cv","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"35TbM":[function(require,module,exports,__globalThis) {
// The LM lane-restriction view (Orbis spec 12.18, `vehicle_restriction:<mode>` and
// `hov_lane*`): per mode what is tagged and the result, read with lmAccess so the
// table agrees with the map's colour.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LM_HIERARCHY", ()=>LM_HIERARCHY);
/**
 * @param {import("./featureModel.mjs").FeatureModel} model
 */ parcelHelpers.export(exports, "buildLmRestrictionView", ()=>buildLmRestrictionView);
var _restrictionClassMjs = require("../layers/style/util/restrictionClass.mjs");
var _lrValuesMjs = require("./lrValues.mjs");
var _stretchesMjs = require("./stretches.mjs");
const LM_HIERARCHY = [
    "motor_vehicle",
    "psv",
    "bus",
    "hgv",
    "motorcar",
    "taxi"
];
const FIELDS = {
    motor_vehicle: "vehicleRestrictionMotorVehicle",
    psv: "vehicleRestrictionPSV",
    bus: "vehicleRestrictionBus",
    hgv: "vehicleRestrictionHGV",
    motorcar: "vehicleRestrictionMotorcar",
    taxi: "vehicleRestrictionTaxi"
};
const MODES = [
    "bus",
    "hgv",
    "motorcar",
    "taxi"
];
const HOV_KEYS = [
    "hov_lane",
    "hov_lane:conditional",
    "hov_lane:minimum",
    "hov_lane:minimum:conditional",
    "hov_lane:clean_fuel",
    "hov_lane:clean_fuel:conditional"
];
const tokenKey = (token)=>`vehicle_restriction:${token}`;
function buildLmRestrictionView(model) {
    const viewKeys = [
        ...LM_HIERARCHY.map(tokenKey),
        ...HOV_KEYS
    ];
    const tagsByKey = new Map();
    model.groups.forEach((group)=>group.tags.forEach((tag)=>{
            const key = (0, _lrValuesMjs.baseKey)(tag.key);
            if (viewKeys.includes(key) && !tagsByKey.has(key) && (0, _stretchesMjs.tagSections)(tag)) tagsByKey.set(key, tag);
        }));
    if (tagsByKey.size === 0) return null;
    const sectionsByKey = Object.fromEntries([
        ...tagsByKey
    ].map(([key, tag])=>[
            key,
            (0, _stretchesMjs.tagSections)(tag)
        ]));
    const stretches = (0, _stretchesMjs.buildStretches)(sectionsByKey, model.lengthCm).map(({ startCm, endCm, values })=>{
        const tokenValue = (token)=>values[tokenKey(token)];
        const access = (0, _restrictionClassMjs.lmAccess)(Object.fromEntries(LM_HIERARCHY.map((token)=>[
                FIELDS[token],
                tokenValue(token)
            ])));
        const modes = MODES.map((mode)=>({
                mode,
                tagged: tokenValue(mode),
                result: access[mode]
            }));
        return {
            startCm,
            endCm,
            modes,
            general: [
                "motor_vehicle",
                "psv"
            ].filter((token)=>tokenValue(token) !== undefined).map((token)=>({
                    token,
                    value: tokenValue(token)
                })),
            hov: HOV_KEYS.filter((key)=>values[key] !== undefined).map((key)=>({
                    key,
                    value: values[key]
                })),
            className: (0, _restrictionClassMjs.accessClassOf)(access)
        };
    });
    return {
        stretches,
        usedTags: [
            ...tagsByKey.values()
        ]
    };
}

},{"../layers/style/util/restrictionClass.mjs":"bWcVG","./lrValues.mjs":"CS5r3","./stretches.mjs":"6pBLw","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"lBCTO":[function(require,module,exports,__globalThis) {
// Member hover, sidebar → map: hovering a member row (or the relation's header row)
// draws that member on the map. Crosslink relations get the map hover's own drawing
// (all ranges, no cursor), plus an orange halo round the hovered member (lane or
// road); CaJ along_* members only their SPOT point; any other member the whole
// feature or its role's range. The bar/profile position hover draws
// on a layer of its own, so the member rows' clearing never wipes it.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Main viewer only; without it members are looked up in the row's own source. */ parcelHelpers.export(exports, "installMemberHover", ()=>installMemberHover);
/** The member's feature: the relation's own source, then other visible layers. */ parcelHelpers.export(exports, "lookupMember", ()=>lookupMember);
/**
 * @param {{model: object, feature: Feature, source: object}} entry a registry entry
 * @param {number|null} memberIndex the hovered member row, or null for the header row
 */ parcelHelpers.export(exports, "showMemberHover", ()=>showMemberHover);
parcelHelpers.export(exports, "clearMemberHover", ()=>clearMemberHover);
/**
 * Bar/profile hover, sidebar → map: the range under the pointer and the point at `cm`.
 * @param {Feature} feature the entry's feature (a LineString, or nothing is drawn)
 * @param {number|null} cm
 * @param {{startCm: number, endCm: number}|null} range
 */ parcelHelpers.export(exports, "showPositionHover", ()=>showPositionHover);
parcelHelpers.export(exports, "clearPositionHover", ()=>clearPositionHover);
var _feature = require("ol/Feature");
var _featureDefault = parcelHelpers.interopDefault(_feature);
var _point = require("ol/geom/Point");
var _pointDefault = parcelHelpers.interopDefault(_point);
var _crosslinkHoverLayer = require("../layers/CrosslinkHoverLayer");
var _memberHoverLayer = require("../layers/MemberHoverLayer");
var _crosslinkDrawing = require("../layers/featureinfohandlers/crosslinkDrawing");
var _crosslinkPairingMjs = require("../layers/featureinfohandlers/crosslinkPairing.mjs");
var _util = require("../util");
var _lrValuesMjs = require("./lrValues.mjs");
var _memberLookupMjs = require("./memberLookup.mjs");
let state = null;
function installMemberHover(map) {
    const memberLayer = (0, _memberHoverLayer.addMemberHoverLayer)(map);
    const crosslinkLayer = (0, _crosslinkHoverLayer.addCrosslinkHoverLayer)(map);
    const positionLayer = (0, _memberHoverLayer.addMemberHoverLayer)(map);
    state = {
        map,
        own: [
            memberLayer,
            crosslinkLayer,
            positionLayer
        ],
        memberSource: memberLayer.getSource(),
        crosslinkSource: crosslinkLayer.getSource(),
        positionSource: positionLayer.getSource()
    };
}
function otherSources() {
    if (!state) return [];
    return state.map.getAllLayers().filter((layer)=>!state.own.includes(layer) && typeof layer.getSource()?.getFeatureById === "function").map((layer)=>({
            source: layer.getSource(),
            visible: layer.getVisible()
        }));
}
function lookupMember(id, ownSource) {
    return (0, _memberLookupMjs.findMemberFeature)(id, ownSource ?? null, otherSources());
}
const isCrosslink = (model)=>model.groups.some((g)=>g.tags.some((t)=>(0, _lrValuesMjs.baseKey)(t.key) === "type" && t.value === "crosslink"));
function highlight(feature, plan, { halo = false } = {}) {
    const geometry = feature.getGeometry();
    const line = geometry.getType() === "LineString";
    let shapes = [
        geometry.clone()
    ];
    if (line && plan.kind === "range") shapes = plan.ranges.map((r)=>(0, _util.sliceOlLineByCm)(geometry, r.startCm, r.endCm ?? Infinity));
    if (line && plan.kind === "spot") shapes = [
        new (0, _pointDefault.default)(geometry.getCoordinateAt(plan.fraction))
    ];
    shapes.forEach((shape)=>state.memberSource.addFeature(new (0, _featureDefault.default)({
            geometry: shape,
            nonInteractive: true,
            halo
        })));
}
function drawCrosslink(entry) {
    const [a, b] = entry.model.members;
    const featureA = lookupMember(a.id, entry.source);
    const featureB = lookupMember(b.id, entry.source);
    if (!featureA || !featureB) return false;
    const rangesA = (0, _util.getRoleRangesCm)(a.role);
    const rangesB = (0, _util.getRoleRangesCm)(b.role);
    const paired = (0, _crosslinkPairingMjs.pairCrosslinkRanges)(rangesA, rangesB, -1);
    (0, _crosslinkDrawing.drawCrosslinkRelation)(state.crosslinkSource, {
        relation: entry.feature,
        featureA,
        featureB,
        rangesA: paired.hovered,
        rangesB: paired.other,
        outOfBounds: (0, _crosslinkPairingMjs.rangesOvershoot)(rangesA, featureA.get("lengthCm")) || (0, _crosslinkPairingMjs.rangesOvershoot)(rangesB, featureB.get("lengthCm"))
    });
    return true;
}
function showMemberHover(entry, memberIndex) {
    if (!state) return;
    clearMemberHover();
    const { members } = entry.model;
    const crosslink = isCrosslink(entry.model) && members.length >= 2 && drawCrosslink(entry);
    if (crosslink && memberIndex === null) return;
    members.filter((m)=>memberIndex === null || m.index === memberIndex).forEach((m)=>{
        const feature = lookupMember(m.id, entry.source);
        if (!feature) return;
        const length = feature.get("lengthCm");
        highlight(feature, (0, _memberLookupMjs.memberHighlightPlan)(m, Number.isFinite(length) ? length : null), {
            halo: crosslink
        });
    });
}
function clearMemberHover() {
    if (!state) return;
    state.memberSource.clear();
    state.crosslinkSource.clear();
}
function showPositionHover(feature, cm, range) {
    if (!state) return;
    state.positionSource.clear();
    const geometry = feature?.getGeometry();
    if (geometry?.getType() !== "LineString") return;
    const add = (shape)=>state.positionSource.addFeature(new (0, _featureDefault.default)({
            geometry: shape,
            nonInteractive: true
        }));
    if (range) add((0, _util.sliceOlLineByCm)(geometry, range.startCm, range.endCm));
    if (cm !== null) add(new (0, _pointDefault.default)((0, _util.sliceOlLineByCm)(geometry, cm, cm).getFirstCoordinate()));
}
function clearPositionHover() {
    state?.positionSource.clear();
}

},{"ol/Feature":"iVSSP","ol/geom/Point":"95T6m","../layers/CrosslinkHoverLayer":"aqJPu","../layers/MemberHoverLayer":"fUWc5","../layers/featureinfohandlers/crosslinkDrawing":"6WML0","../layers/featureinfohandlers/crosslinkPairing.mjs":"4M27b","../util":"4IC9E","./lrValues.mjs":"CS5r3","./memberLookup.mjs":"k620V","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"aqJPu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addCrosslinkHoverLayer", ()=>addCrosslinkHoverLayer);
var _style = require("ol/style");
var _vector = require("ol/layer/Vector");
var _vectorDefault = parcelHelpers.interopDefault(_vector);
var _vector1 = require("ol/source/Vector");
var _vectorDefault1 = parcelHelpers.interopDefault(_vector1);
var _crosslink = require("./style/crosslink");
function addCrosslinkHoverLayer(map) {
    const vectorSource = new (0, _vectorDefault1.default)({});
    const styleFunction = function(feature) {
        const geometryType = feature.getGeometry().getType();
        // Endpoint markers carry a Point geometry + a markerColor; handle them
        // before isSD(), which assumes a line feature with an id.
        if (geometryType === "Point") return new (0, _style.Style)({
            image: new (0, _style.Circle)({
                radius: 6,
                fill: new (0, _style.Fill)({
                    color: feature.get("markerColor")
                }),
                stroke: new (0, _style.Stroke)({
                    color: "white",
                    width: 2
                })
            }),
            zIndex: 20
        });
        // The connecting ribbon between the matched road and lane sections —
        // semi-transparent fill drawn behind the section lines. Turns red when the
        // relation is out-of-bounds (a member's role runs past its own length).
        if (geometryType === "Polygon") {
            const outOfBounds = feature.get("outOfBounds");
            return new (0, _style.Style)({
                fill: new (0, _style.Fill)({
                    color: outOfBounds ? "rgba(255, 0, 0, 0.3)" : "rgba(0, 90, 255, 0.3)"
                }),
                stroke: new (0, _style.Stroke)({
                    color: outOfBounds ? "rgba(220, 0, 0, 0.7)" : "rgba(0, 70, 220, 0.7)",
                    width: 1
                }),
                zIndex: 5
            });
        }
        // Outer stroke matches the segment's own colour (road green / lane blue);
        // inner stroke is the matching lighter shade.
        let LINE_COLOR;
        let FILL_COLOR;
        if ((0, _crosslink.isSD)(feature)) {
            LINE_COLOR = "green";
            FILL_COLOR = "#c8f5c8"; // light green
        } else {
            LINE_COLOR = "blue";
            FILL_COLOR = "#d4ecfb"; // light blue
        }
        const styles = [
            // linestring
            new (0, _style.Style)({
                stroke: new (0, _style.Stroke)({
                    color: LINE_COLOR,
                    width: 7
                }),
                zIndex: 12
            }),
            new (0, _style.Style)({
                stroke: new (0, _style.Stroke)({
                    color: FILL_COLOR,
                    width: 5
                }),
                zIndex: 13
            })
        ];
        return styles;
    };
    const vectorLayer = new (0, _vectorDefault.default)({
        source: vectorSource,
        style: styleFunction
    });
    vectorLayer.setZIndex(100);
    map.addLayer(vectorLayer);
    map.on("click", function() {
        vectorSource.clear();
    });
    return vectorLayer;
}

},{"ol/style":[["Circle","3Wl62","default"],["Fill","24G0i","default"],["Stroke","cese4","default"],["Style","gqpPW","default"]],"ol/layer/Vector":"7ga2c","ol/source/Vector":"7zHxp","./style/crosslink":"8WCJV","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fUWc5":[function(require,module,exports,__globalThis) {
// The sidebar's member hover draws the member (or its role's range, or a SPOT point)
// here. An overlay like the other hover layers (zIndex 100), cleared on map click.
// A crosslink member gets a wide halo instead: added before the crosslink hover
// layer, so the ribbon's own colours stay on top with orange either side.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addMemberHoverLayer", ()=>addMemberHoverLayer);
var _vector = require("ol/layer/Vector");
var _vectorDefault = parcelHelpers.interopDefault(_vector);
var _vector1 = require("ol/source/Vector");
var _vectorDefault1 = parcelHelpers.interopDefault(_vector1);
var _style = require("ol/style");
const MEMBER_HOVER_COLOR = "#ff8f00";
const lineStyle = [
    new (0, _style.Style)({
        stroke: new (0, _style.Stroke)({
            color: "white",
            width: 11
        })
    }),
    new (0, _style.Style)({
        stroke: new (0, _style.Stroke)({
            color: MEMBER_HOVER_COLOR,
            width: 7
        })
    })
];
// Light and narrow: 2px of soft orange either side of the ribbon's 7px line.
const haloStyle = new (0, _style.Style)({
    stroke: new (0, _style.Stroke)({
        color: "rgba(255, 143, 0, 0.45)",
        width: 11
    })
});
const pointStyle = new (0, _style.Style)({
    image: new (0, _style.Circle)({
        radius: 7,
        fill: new (0, _style.Fill)({
            color: MEMBER_HOVER_COLOR
        }),
        stroke: new (0, _style.Stroke)({
            color: "white",
            width: 2
        })
    })
});
function addMemberHoverLayer(map) {
    const source = new (0, _vectorDefault1.default)({});
    const layer = new (0, _vectorDefault.default)({
        source,
        style: (feature)=>{
            if (feature.getGeometry().getType() === "Point") return pointStyle;
            return feature.get("halo") ? haloStyle : lineStyle;
        }
    });
    layer.setZIndex(100);
    map.addLayer(layer);
    map.on("click", ()=>source.clear());
    return layer;
}

},{"ol/layer/Vector":"7ga2c","ol/source/Vector":"7zHxp","ol/style":[["Circle","3Wl62","default"],["Fill","24G0i","default"],["Stroke","cese4","default"],["Style","gqpPW","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6WML0":[function(require,module,exports,__globalThis) {
// Draws one crosslink relation into the CrosslinkHoverLayer source: both members'
// sections, a ribbon between them (red when out of bounds) and endpoint markers.
// Used by the map hover (CrosslinkLayerHandler) and the sidebar member hover.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CROSSLINK_MATCH_START_COLOR", ()=>CROSSLINK_MATCH_START_COLOR);
parcelHelpers.export(exports, "CROSSLINK_MATCH_END_COLOR", ()=>CROSSLINK_MATCH_END_COLOR);
/**
 * @param {import("ol/source/Vector").default} vizSource
 * @param {{relation: Feature, featureA: Feature, featureB: Feature,
 *   rangesA: {startCm: number, endCm: number}[], rangesB: {startCm: number, endCm: number}[],
 *   outOfBounds: boolean}} drawing `[]` ranges draw the whole member
 */ parcelHelpers.export(exports, "drawCrosslinkRelation", ()=>drawCrosslinkRelation);
var _feature = require("ol/Feature");
var _featureDefault = parcelHelpers.interopDefault(_feature);
var _point = require("ol/geom/Point");
var _pointDefault = parcelHelpers.interopDefault(_point);
var _polygon = require("ol/geom/Polygon");
var _polygonDefault = parcelHelpers.interopDefault(_polygon);
var _util = require("../../util");
const CROSSLINK_MATCH_START_COLOR = "#ffd400"; // lower-cm end of the match
const CROSSLINK_MATCH_END_COLOR = "#7c4dff"; // higher-cm end of the match
// Unique suffix per drawn feature so the viz source never sees duplicate ids
// (OpenLayers throws on those) while keeping the original id prefix —
// CrosslinkHoverLayer's isSD() only inspects the leading "6:".
let sectionIndex = 0;
function addSections(vizSource, srcFeature, ranges) {
    const geometries = ranges.length === 0 ? [
        srcFeature.getGeometry().clone()
    ] : ranges.map((range)=>(0, _util.sliceOlLineByCm)(srcFeature.getGeometry(), range.startCm, range.endCm));
    geometries.forEach((geometry)=>{
        const sectionFeature = new (0, _featureDefault.default)({
            geometry
        });
        sectionFeature.setId(`${srcFeature.getId()}#${sectionIndex++}`);
        vizSource.addFeature(sectionFeature);
    });
    return geometries;
}
function addMarker(vizSource, coordinate, color) {
    const marker = new (0, _featureDefault.default)({
        geometry: new (0, _pointDefault.default)(coordinate)
    });
    marker.set("markerColor", color);
    marker.setId(`crosslink-marker#${sectionIndex++}`);
    vizSource.addFeature(marker);
}
// Mark the matching ends of the road and lane sections. `opposite` (from the
// relation's direction tag) decides which end pairs with which.
function addEndpointMarkers(vizSource, geomA, geomB, opposite) {
    addMarker(vizSource, firstCoord(geomA), CROSSLINK_MATCH_START_COLOR);
    addMarker(vizSource, opposite ? lastCoord(geomB) : firstCoord(geomB), CROSSLINK_MATCH_START_COLOR);
    addMarker(vizSource, lastCoord(geomA), CROSSLINK_MATCH_END_COLOR);
    addMarker(vizSource, opposite ? firstCoord(geomB) : lastCoord(geomB), CROSSLINK_MATCH_END_COLOR);
}
// Semi-transparent ribbon spanning the gap between the matched road and lane
// sections — a visual cue of what maps to what. The ring walks A start→end, then
// B back toward A's start: for `same` direction that means B reversed
// (end→start); for `opposite`, B as-is.
function addConnectingPolygon(vizSource, geomA, geomB, opposite, outOfBounds) {
    const a = geomA.getCoordinates();
    const b = geomB.getCoordinates();
    const ring = opposite ? [
        ...a,
        ...b
    ] : [
        ...a,
        ...b.slice().reverse()
    ];
    ring.push(ring[0]);
    const polygon = new (0, _featureDefault.default)({
        geometry: new (0, _polygonDefault.default)([
            ring
        ])
    });
    polygon.setId(`crosslink-polygon#${sectionIndex++}`);
    // Flags an out-of-bounds relation so the hover layer paints the ribbon red
    // instead of blue (CrosslinkHoverLayer reads this).
    polygon.set("outOfBounds", outOfBounds === true);
    vizSource.addFeature(polygon);
}
function drawCrosslinkRelation(vizSource, { relation, featureA, featureB, rangesA, rangesB, outOfBounds }) {
    const geomA = addSections(vizSource, featureA, rangesA)[0];
    const geomB = addSections(vizSource, featureB, rangesB)[0];
    if (geomA === undefined || geomB === undefined) return;
    const opposite = isOpposite(getDirectionTag(relation), firstCoord(geomA), lastCoord(geomA), firstCoord(geomB), lastCoord(geomB));
    addConnectingPolygon(vizSource, geomA, geomB, opposite, outOfBounds);
    addEndpointMarkers(vizSource, geomA, geomB, opposite);
}
function firstCoord(geometry) {
    return geometry.getCoordinates()[0];
}
function lastCoord(geometry) {
    const coordinates = geometry.getCoordinates();
    return coordinates[coordinates.length - 1];
}
// The crosslink relation's mandatory `direction` tag (same|opposite). Falls
// back to a prefixed/namespaced key (e.g. "<layerId>-direction", ":direction")
// in case the WFS export renames it.
function getDirectionTag(relation) {
    const direct = relation.get("direction");
    if (direct !== undefined) return direct;
    const key = relation.getKeys().find((candidate)=>/(^|[-:])direction$/.test(candidate));
    return key ? relation.get(key) : undefined;
}
// Whether the two sections run in opposite directions. Prefer the crosslink
// `direction` tag; if it's missing/unknown, infer from geometry by choosing the
// endpoint pairing with the shorter total distance.
function isOpposite(direction, aStart, aEnd, bStart, bEnd) {
    const normalized = typeof direction === "string" ? direction.toLowerCase() : direction;
    if (normalized === "same") return false;
    if (normalized === "opposite") return true;
    const sameCost = distance(aStart, bStart) + distance(aEnd, bEnd);
    const oppositeCost = distance(aStart, bEnd) + distance(aEnd, bStart);
    return oppositeCost < sameCost;
}
function distance(a, b) {
    return Math.hypot(a[0] - b[0], a[1] - b[1]);
}

},{"ol/Feature":"iVSSP","ol/geom/Point":"95T6m","ol/geom/Polygon":"3zws5","../../util":"4IC9E","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4M27b":[function(require,module,exports,__globalThis) {
// Which sections of a crosslink relation's two members are drawn together. Pure, so
// the node tests pin the rules the hover has always used; the member hover in the
// sidebar uses them too (with no cursor, so every range).
/**
 * @typedef {{startCm: number, endCm: number}} Range
 * @param {Range[]} hoveredRanges the hovered member's role ranges
 * @param {Range[]} otherRanges the other member's role ranges
 * @param {number} cursorIndex the hovered range under the cursor, or -1
 * @returns {{hovered: Range[], other: Range[]}} `[]` means the whole geometry
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pairCrosslinkRanges", ()=>pairCrosslinkRanges);
/**
 * Whether any range ends past the member's own length — the relation is then
 * out-of-bounds on that member. Open-ended ranges (Infinity end) mean "till the
 * end of the segment" by design, so they don't count.
 */ parcelHelpers.export(exports, "rangesOvershoot", ()=>rangesOvershoot);
function pairCrosslinkRanges(hoveredRanges, otherRanges, cursorIndex) {
    let other;
    if (otherRanges.length === 0) other = []; // no decodable range → whole geometry
    else if (otherRanges.length === 1) other = otherRanges;
    else if (cursorIndex >= 0 && cursorIndex < otherRanges.length) // The hovered member's range index maps to the same index on the other one.
    other = [
        otherRanges[cursorIndex]
    ];
    else other = otherRanges; // can't pair → fall back to all sections
    const hovered = cursorIndex >= 0 ? [
        hoveredRanges[cursorIndex]
    ] : hoveredRanges;
    return {
        hovered,
        other
    };
}
function rangesOvershoot(ranges, lengthCm) {
    return lengthCm > 0 && ranges.some((range)=>Number.isFinite(range.endCm) && range.endCm > lengthCm);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"k620V":[function(require,module,exports,__globalThis) {
// Finding a relation member's feature and what to highlight of it. Pure: sources are
// anything with getFeatureById, features anything with getGeometry.
/**
 * The relation's own source first (a relation layer's response carries its members'
 * parent ways and nodes), then the other visible vector sources. A feature without
 * geometry counts as not found.
 * @param {string} id
 * @param {{getFeatureById(id: string): unknown}|null} ownSource
 * @param {{source: {getFeatureById(id: string): unknown}, visible: boolean}[]} otherSources
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findMemberFeature", ()=>findMemberFeature);
/**
 * @param {{lr: {type: string, startCm: number, endCm: number|null}|null}} member
 * @param {number|null} lengthCm the member feature's length
 * @returns {{kind: "whole"}|
 *   {kind: "range", ranges: {startCm: number, endCm: number|null}[]}|
 *   {kind: "spot", fraction: number}} a multi-range role keeps every range
 */ parcelHelpers.export(exports, "memberHighlightPlan", ()=>memberHighlightPlan);
function findMemberFeature(id, ownSource, otherSources) {
    const usable = (feature)=>feature && feature.getGeometry() ? feature : undefined;
    const own = ownSource ? usable(ownSource.getFeatureById(id)) : undefined;
    if (own) return own;
    for (const { source, visible } of otherSources){
        if (!visible) continue;
        const found = usable(source.getFeatureById(id));
        if (found) return found;
    }
    return undefined;
}
function memberHighlightPlan(member, lengthCm) {
    const lr = member.lr;
    if (!lr) return {
        kind: "whole"
    };
    if (lr.type === "spot") {
        if (!(lengthCm > 0)) return {
            kind: "whole"
        };
        return {
            kind: "spot",
            fraction: Math.min(Math.max(lr.startCm / lengthCm, 0), 1)
        };
    }
    const ranges = lr.ranges ?? [
        {
            startCm: lr.startCm,
            endCm: lr.endCm
        }
    ];
    return {
        kind: "range",
        ranges
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gZzC1":[function(require,module,exports,__globalThis) {
// One small tooltip at the pointer for the sidebar entries: an element's `data-tip`,
// or the value under the pointer on a profile.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "installPointerTip", ()=>installPointerTip);
var _lrValuesMjs = require("./lrValues.mjs");
var _positionsMjs = require("./positions.mjs");
const round = (v)=>typeof v === "number" ? Math.round(v * 100) / 100 : v;
function profileTip(plot, clientX) {
    const sections = (0, _lrValuesMjs.parseLrChain)(plot.dataset.chain);
    if (!sections) return null;
    const length = plot.dataset.length === "" ? null : Number(plot.dataset.length);
    const profile = (0, _positionsMjs.buildProfile)(sections, length);
    const rect = plot.getBoundingClientRect();
    const fraction = Math.min(Math.max((clientX - rect.left) / rect.width, 0), 1);
    const cm = Math.round(fraction * profile.axisEndCm);
    const at = (0, _positionsMjs.profileValueAt)(profile, cm);
    if (!at) return `${cm} cm: before the first point`;
    const range = at.startCm === at.endCm ? `at ${at.startCm}` : `${at.interpolated ? "between " : ""}${at.startCm}\u{2013}${at.endCm}`;
    return `${round(at.value)} \xb7 ${range} \xb7 ${cm} cm`;
}
// One tooltip element for every row and the drawer.
let sharedTip = null;
function tipElement() {
    if (!sharedTip) {
        sharedTip = document.createElement("div");
        sharedTip.className = "fe-tip";
        sharedTip.style.display = "none";
        document.body.appendChild(sharedTip);
    }
    return sharedTip;
}
function installPointerTip(root) {
    if (root.dataset.feTip) return;
    root.dataset.feTip = "1";
    const tip = tipElement();
    root.addEventListener("mousemove", (event)=>{
        if (event.buttons) {
            // Drag-selecting text: no tooltip over what is being selected.
            tip.style.display = "none";
            return;
        }
        const target = event.target instanceof Element ? event.target : null;
        const band = target && target.closest("[data-tip]");
        const plot = !band && target && target.closest(".fe-profile");
        const text = band ? band.dataset.tip : plot ? profileTip(plot, event.clientX) : null;
        if (!text) {
            tip.style.display = "none";
            return;
        }
        tip.textContent = text;
        tip.style.display = "block";
        tip.style.left = `${event.clientX + 12}px`;
        tip.style.top = `${event.clientY + 14}px`;
    });
    root.addEventListener("mouseleave", ()=>{
        tip.style.display = "none";
    });
}

},{"./lrValues.mjs":"CS5r3","./positions.mjs":"gc1cv","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hvAxO":[function(require,module,exports,__globalThis) {
// The sidebar entry for one selected feature (spec section 5): header with the whole
// id, type line, wkt, "also selected in", feature views, tag groups by prefix, the
// viewer's own properties, members, and the raw box. A `tbody`, so entries sit in the
// row's attributes table with its column widths.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {Document} doc
 * @param {import("./featureModel.mjs").FeatureModel} model
 * @param {{headerText?: string, wkt: string|null, alsoIn: string[],
 *   views: Node[], viewTagKeys: Set<string>, missingMemberIds?: Set<string>}} options
 */ parcelHelpers.export(exports, "renderFeatureEntry", ()=>renderFeatureEntry);
var _featureModelMjs = require("./featureModel.mjs");
var _renderValuesMjs = require("./renderValues.mjs");
var _positionsMjs = require("./positions.mjs");
var _slotsMjs = require("./slots.mjs");
// One line per tag: the key, then the value right-flush; the value moves under the
// key when both do not fit (style.css `.kv`).
function row(doc, label, value, className) {
    const tr = (0, _renderValuesMjs.el)(doc, "tr", className);
    const td = (0, _renderValuesMjs.el)(doc, "td", "fe-kvcell");
    td.colSpan = 2;
    const kv = (0, _renderValuesMjs.el)(doc, "div", "kv");
    const k = (0, _renderValuesMjs.el)(doc, "span", "k");
    k.append(...Array.isArray(label) ? label : [
        label
    ]);
    const v = (0, _renderValuesMjs.el)(doc, "span", "v");
    v.append(value);
    kv.append(k, v);
    td.append(kv);
    tr.append(td);
    return tr;
}
/** A key that wraps only after its `:`. */ function keySpan(doc, key) {
    const span = (0, _renderValuesMjs.el)(doc, "span", "fe-key");
    String(key).split(/(?<=:)/).forEach((part, i)=>{
        if (i > 0) span.append(doc.createElement("wbr"));
        span.append(part);
    });
    return span;
}
function wideRow(doc, node, className) {
    const tr = (0, _renderValuesMjs.el)(doc, "tr", className);
    const td = (0, _renderValuesMjs.el)(doc, "td", "fe-wide");
    td.colSpan = 2;
    td.append(node);
    tr.append(td);
    return tr;
}
function groupHeader(doc, name, revisionText, className = "fe-group") {
    const tr = (0, _renderValuesMjs.el)(doc, "tr", className);
    tr.append((0, _renderValuesMjs.el)(doc, "td", "fe-gname", name));
    tr.append((0, _renderValuesMjs.el)(doc, "td", "fe-grev", revisionText));
    return tr;
}
function revisionText(group) {
    if (group.revision === undefined) return "";
    const layer = group.revisionLayer && group.revisionLayer !== group.prefix ? ` (layer ${group.revisionLayer})` : "";
    return `rev ${group.revision}${layer}`;
}
function countText(tag) {
    const n = tag.sections.length;
    if (tag.lr === "spot") return `${n} spot${n === 1 ? "" : "s"}`;
    if (tag.lr === "linear") return tag.sections.every((s)=>s.endCm === null) ? `${n} points` : `${n} entries`;
    return `${n} section${n === 1 ? "" : "s"}`;
}
function lrBlock(doc, tag, lengthCm) {
    if (tag.lr === "spot") return (0, _renderValuesMjs.renderSpotList)(doc, tag);
    if (tag.lr === "linear") {
        const profile = (0, _positionsMjs.buildProfile)(tag.sections, lengthCm);
        if (profile.points.length > 0 || (0, _renderValuesMjs.isCurvatureKey)(tag.key)) return (0, _renderValuesMjs.renderProfile)(doc, tag, lengthCm);
    }
    return (0, _renderValuesMjs.renderStepBlock)(doc, tag, lengthCm);
}
function tagRows(doc, tag, group, lengthCm) {
    const label = [
        keySpan(doc, tag.key)
    ];
    if (tag.revision !== undefined && tag.revision !== group.revision) label.push(" ", (0, _renderValuesMjs.el)(doc, "span", "fe-rev", `rev ${tag.revision}`));
    if (tag.sections) {
        const keyRow = (0, _renderValuesMjs.el)(doc, "tr", "fe-lrkey");
        const td = (0, _renderValuesMjs.el)(doc, "td", "fe-keycell");
        td.colSpan = 2;
        td.append(...label, " ", (0, _renderValuesMjs.el)(doc, "span", "fe-count", countText(tag)), " ");
        td.append((0, _renderValuesMjs.renderRawInline)(doc, tag));
        keyRow.append(td);
        const block = wideRow(doc, lrBlock(doc, tag, lengthCm), "fe-lrblock");
        block.dataset.rawKey = tag.rawKey;
        return [
            keyRow,
            block
        ];
    }
    if (tag.lr) // An LR key whose value does not parse: as tagged, whole.
    return [
        row(doc, label, (0, _renderValuesMjs.el)(doc, "span", "fe-value", (0, _renderValuesMjs.valueText)(tag.value)))
    ];
    if ((0, _slotsMjs.isSlotKey)(tag.key) && typeof tag.value === "string") {
        label.push(" ", (0, _renderValuesMjs.renderRawInline)(doc, tag));
        return [
            row(doc, label, (0, _renderValuesMjs.renderSlotCells)(doc, tag.value))
        ];
    }
    return [
        row(doc, label, (0, _renderValuesMjs.renderPlainValue)(doc, tag.value))
    ];
}
function lrText(lr) {
    if (!lr) return "";
    const ranges = lr.ranges ?? [
        lr
    ];
    const text = ranges.map((r)=>r.endCm !== null ? `${r.startCm}\u{2013}${r.endCm}` : lr.type === "spot" ? `${r.startCm}` : `${r.startCm}\u{2013}end`).join(", ");
    return `${lr.type} ${text} cm`;
}
// Two lines per member: `# role · range`, then the whole id. Ids stay on one line and
// a sidebar is too narrow for them next to the other columns.
function membersTable(doc, members, missingMemberIds) {
    const table = (0, _renderValuesMjs.el)(doc, "table", "fe-members");
    members.forEach((m)=>{
        const missing = missingMemberIds.has(m.id);
        const tr = (0, _renderValuesMjs.el)(doc, "tr", missing ? "fe-member fe-missing" : "fe-member");
        if (!missing) tr.dataset.member = m.id;
        tr.dataset.index = String(m.index);
        tr.append((0, _renderValuesMjs.el)(doc, "td", "fe-num", m.index));
        const td = (0, _renderValuesMjs.el)(doc, "td");
        const head = (0, _renderValuesMjs.el)(doc, "div", undefined, m.roleName || "(no role)");
        const lr = lrText(m.lr);
        const note = [
            lr,
            missing ? "not loaded" : ""
        ].filter(Boolean).join(" \xb7 ");
        if (note) head.append(" ", (0, _renderValuesMjs.el)(doc, "span", "fe-lr", note));
        const id = (0, _renderValuesMjs.el)(doc, "div", "fe-scroll");
        id.append((0, _renderValuesMjs.el)(doc, "span", "fe-id", m.id), (0, _renderValuesMjs.copyButton)(doc, m.id));
        td.append(head, id);
        tr.append(td);
        table.append(tr);
    });
    return table;
}
function renderFeatureEntry(doc, model, options) {
    const { headerText, wkt, alsoIn = [], views = [], viewTagKeys = new Set(), missingMemberIds = new Set() } = options;
    const root = (0, _renderValuesMjs.el)(doc, "tbody", "fe-entry");
    root.dataset.featureId = model.id;
    const head = (0, _renderValuesMjs.el)(doc, "tr", "fe-head");
    const th = (0, _renderValuesMjs.el)(doc, "th");
    th.colSpan = 2;
    const title = headerText ?? model.id;
    th.append((0, _renderValuesMjs.el)(doc, "span", "fe-id", title), (0, _renderValuesMjs.copyButton)(doc, title));
    head.append(th);
    root.append(head);
    const typeParts = [
        model.type,
        model.geometryType,
        model.lengthCm !== null ? `${model.lengthCm} cm` : undefined
    ].filter(Boolean);
    if (typeParts.length) root.append(row(doc, "type", (0, _renderValuesMjs.el)(doc, "span", undefined, typeParts.join(" \xb7 "))));
    if (wkt) {
        const input = (0, _renderValuesMjs.el)(doc, "input");
        input.disabled = true;
        input.value = wkt;
        root.append(row(doc, "wkt", input, "fe-wktrow"));
    }
    // Always present, hidden when empty: the glue refreshes it as other rows select.
    const also = row(doc, "also selected in", (0, _renderValuesMjs.el)(doc, "span", "fe-alsorows", alsoIn.join(", ")), "fe-also");
    if (!alsoIn.length) also.style.display = "none";
    root.append(also);
    views.forEach((view)=>root.append(wideRow(doc, view, "fe-viewrow")));
    model.groups.forEach((group)=>{
        root.append(groupHeader(doc, group.prefix || (0, _featureModelMjs.NO_PREFIX_LABEL), revisionText(group)));
        group.tags.filter((t)=>!viewTagKeys.has(t.rawKey)).forEach((tag)=>root.append(...tagRows(doc, tag, group, model.lengthCm)));
    });
    if (model.viewer.length) {
        root.append(groupHeader(doc, "viewer", ""));
        model.viewer.forEach((tag)=>root.append(row(doc, keySpan(doc, tag.key), (0, _renderValuesMjs.renderPlainValue)(doc, tag.value))));
    }
    if (model.members.length) {
        root.append(groupHeader(doc, `members (${model.members.length})`, "", "fe-mhead"));
        root.append(wideRow(doc, membersTable(doc, model.members, missingMemberIds)));
    }
    root.append(wideRow(doc, (0, _renderValuesMjs.renderRawBox)(doc, model.properties), "fe-rawrow"));
    return root;
}

},{"./featureModel.mjs":"9MLBf","./renderValues.mjs":"jzrm4","./positions.mjs":"gc1cv","./slots.mjs":"ghqtd","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"jzrm4":[function(require,module,exports,__globalThis) {
// DOM for one value by its shape: plain (lists, conditionals), slot cells, step bar
// with its sections, linear profile with its points, raw expands. `doc` is injected
// (the page's document, or the fake one in tests); text goes in with textContent only.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "el", ()=>el);
/** @returns {string} a value as one line of text, as tagged */ parcelHelpers.export(exports, "valueText", ()=>valueText);
/**
 * A whole-way value: `;` list one item per line, `value @ (window)` with the window
 * on its own line, null as `null`, objects as a nested table.
 */ parcelHelpers.export(exports, "renderPlainValue", ()=>renderPlainValue);
/** One cell per `|` slot; a blank slot shows `·`. */ parcelHelpers.export(exports, "renderSlotCells", ()=>renderSlotCells);
/** A step tag: a thin bar along the way, then one line per section (unless `list` is false). */ parcelHelpers.export(exports, "renderStepBlock", ()=>renderStepBlock);
/** A spot tag: one line per offset. */ parcelHelpers.export(exports, "renderSpotList", ()=>renderSpotList);
parcelHelpers.export(exports, "isCurvatureKey", ()=>isCurvatureKey);
/** A linear tag: profile with a y axis (max, 0, min), bands hatched, then every point (unless `points` is false). */ parcelHelpers.export(exports, "renderProfile", ()=>renderProfile);
/** `raw` expand next to one LR or slot key. */ parcelHelpers.export(exports, "renderRawInline", ()=>renderRawInline);
/** `raw (n)` expand under a view: the tags it shows, one `key=value` per line. */ parcelHelpers.export(exports, "renderViewRaw", ()=>renderViewRaw);
/** Every property as `key=value` in the original order, read-only, copyable. */ parcelHelpers.export(exports, "renderRawBox", ()=>renderRawBox);
parcelHelpers.export(exports, "copyButton", ()=>copyButton);
var _lrValuesMjs = require("./lrValues.mjs");
var _positionsMjs = require("./positions.mjs");
var _slotsMjs = require("./slots.mjs");
const SVG_NS = "http://www.w3.org/2000/svg";
const SHADES = 8;
// A segment or band gets a text label only when it is this wide.
const LABEL_MIN_PERCENT = 12;
function el(doc, tagName, className, text) {
    const node = doc.createElement(tagName);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = String(text);
    return node;
}
function svgEl(doc, tagName, attributes) {
    const node = doc.createElementNS(SVG_NS, tagName);
    Object.entries(attributes).forEach(([k, v])=>node.setAttribute(k, v));
    return node;
}
function valueText(value) {
    if (value === null) return "null";
    if (value === undefined) return "";
    if (typeof value === "object") return JSON.stringify(value);
    return String(value);
}
const percent = (cm, axis)=>`${cm / axis * 100}%`;
/** `;` outside parentheses: a conditional's window may hold `;` between its rules. */ function splitList(text) {
    const parts = [];
    let depth = 0;
    let current = "";
    for(let i = 0; i < text.length; i++){
        const char = text[i];
        if (char === "\\" && text[i + 1] === ";") {
            current += ";";
            i++;
            continue;
        }
        if (char === "(") depth++;
        if (char === ")") depth = Math.max(0, depth - 1);
        if (char === ";" && depth === 0) {
            parts.push(current.trim());
            current = "";
            continue;
        }
        current += char;
    }
    parts.push(current.trim());
    return parts;
}
const CONDITIONAL = /^(.*?)\s*@\s*\((.*)\)\s*$/s;
function appendItem(doc, parent, text) {
    const match = CONDITIONAL.exec(text);
    if (!match || match[1] === "") {
        parent.append(text);
        return;
    }
    parent.append(match[1]);
    parent.append(el(doc, "div", "fe-when", `@ (${match[2]})`));
}
function renderPlainValue(doc, value) {
    if (value !== null && typeof value === "object") {
        const table = el(doc, "table", "ol-selectable vector-feature-subattributes-list");
        Object.entries(value).forEach(([key, sub])=>{
            const tr = el(doc, "tr");
            tr.append(el(doc, "td", "label", key));
            const td = el(doc, "td", "value");
            td.append(renderPlainValue(doc, sub));
            tr.append(td);
            table.append(tr);
        });
        return table;
    }
    const text = valueText(value);
    const items = typeof value === "string" ? splitList(text) : [
        text
    ];
    if (items.length === 1 && !CONDITIONAL.test(text)) return el(doc, "span", "fe-value", text);
    const node = el(doc, "div", "fe-value fe-list");
    items.forEach((item)=>{
        const line = el(doc, "div", "fe-item");
        appendItem(doc, line, item);
        node.append(line);
    });
    return node;
}
function renderSlotCells(doc, value) {
    const node = el(doc, "div", "fe-slots");
    String(value).split("|").forEach((slot, i)=>{
        const text = slot.trim();
        const cell = el(doc, "span", "fe-slot");
        cell.dataset.tip = `slot ${i + 1}: ${text === "" ? "(blank)" : text}`;
        cell.append(text === "" ? el(doc, "span", "fe-blank", "\xb7") : text);
        node.append(cell);
    });
    return node;
}
function shadeIndex(values) {
    const distinct = [
        ...new Set(values)
    ];
    return (value)=>distinct.indexOf(value) % SHADES;
}
function sectionEndText(sections, i, lengthCm) {
    const s = sections[i];
    if (s.endCm !== null) return s.endCm;
    const next = sections.slice(i + 1).find((n)=>n.startCm > s.startCm);
    if (next) return next.startCm;
    return lengthCm ?? "end";
}
function renderStepBlock(doc, tag, lengthCm, { list: withList = true } = {}) {
    const node = el(doc, "div", "fe-step");
    const axis = (0, _positionsMjs.axisEndCm)(lengthCm, tag.sections);
    const bar = el(doc, "div", "fe-bar");
    bar.dataset.axis = String(axis);
    const closed = (0, _positionsMjs.closedStepSections)(tag.sections, lengthCm);
    const shade = shadeIndex(closed.map((s)=>s.value));
    closed.forEach((s)=>{
        const seg = el(doc, "span", `fe-seg fe-shade-${shade(s.value)}`);
        seg.style.left = percent(s.startCm, axis);
        seg.style.width = percent(s.endCm - s.startCm, axis);
        seg.dataset.tip = s.value;
        seg.dataset.start = String(s.startCm);
        seg.dataset.end = String(s.endCm);
        if ((s.endCm - s.startCm) / axis * 100 > LABEL_MIN_PERCENT) seg.textContent = s.value;
        bar.append(seg);
    });
    node.append(bar);
    if (!withList) return node;
    const slots = (0, _slotsMjs.isSlotKey)(tag.key);
    const list = el(doc, "table", "fe-sections");
    tag.sections.forEach((s, i)=>{
        const tr = el(doc, "tr", "fe-sec");
        tr.dataset.index = String(i);
        tr.append(el(doc, "td", "fe-range", `${s.startCm}\u{2013}${sectionEndText(tag.sections, i, lengthCm)}`));
        const td = el(doc, "td");
        td.append(slots ? renderSlotCells(doc, s.value) : renderPlainValue(doc, s.value));
        tr.append(td);
        list.append(tr);
    });
    node.append(list);
    return node;
}
function renderSpotList(doc, tag) {
    const list = el(doc, "table", "fe-sections");
    tag.sections.forEach((s, i)=>{
        const tr = el(doc, "tr", "fe-sec");
        tr.dataset.index = String(i);
        tr.append(el(doc, "td", "fe-range", `at ${s.startCm}`));
        const td = el(doc, "td");
        td.append(renderPlainValue(doc, s.value));
        tr.append(td);
        list.append(tr);
    });
    return list;
}
const isCurvatureKey = (key)=>{
    const base = (0, _lrValuesMjs.baseKey)(key);
    return base === "curvature" || base === "meta_full_curvature";
};
function profileHint(profile) {
    if (!profile.bands.length) return "";
    return `hatched: ${[
        ...new Set(profile.bands.map((b)=>b.value))
    ].join(", ")}`;
}
function renderProfile(doc, tag, lengthCm, { points: withPoints = true } = {}) {
    const profile = (0, _positionsMjs.buildProfile)(tag.sections, lengthCm);
    const axis = profile.axisEndCm;
    const W = 400;
    const H = 56;
    const span = profile.max - profile.min || 1;
    const x = (cm)=>cm / axis * W;
    const y = (v)=>3 + (1 - (v - profile.min) / span) * (H - 6);
    const node = el(doc, "div", "fe-prof");
    const grid = el(doc, "div", "fe-profgrid");
    const ylab = el(doc, "div", "fe-ylab");
    const ticks = [
        ...new Set([
            profile.max,
            0,
            profile.min
        ])
    ];
    // Gridlines at every tick; a label only where it does not overlap one already
    // placed (0 first, so a min of -7 under a max of 126 does not print over it).
    const placed = [];
    [
        0,
        profile.max,
        profile.min
    ].forEach((v)=>{
        const top = y(v);
        if (placed.some((p)=>Math.abs(p - top) < 10)) return;
        placed.push(top);
        const label = el(doc, "span", undefined, v);
        label.style.top = `${top / H * 100}%`;
        ylab.append(label);
    });
    const plot = el(doc, "div", "fe-profile");
    plot.dataset.axis = String(axis);
    // The pointer tooltip re-reads the chain to give the value under the pointer.
    plot.dataset.chain = valueText(tag.value);
    plot.dataset.length = lengthCm === null || lengthCm === undefined ? "" : String(lengthCm);
    const svg = svgEl(doc, "svg", {
        viewBox: `0 0 ${W} ${H}`,
        preserveAspectRatio: "none"
    });
    ticks.forEach((v)=>svg.append(svgEl(doc, "line", {
            x1: 0,
            x2: W,
            y1: y(v),
            y2: y(v),
            class: v === 0 ? "fe-zero" : "fe-grid"
        })));
    // A band (`multiple`, or a ranged section) breaks the line.
    const runs = [
        []
    ];
    tag.sections.forEach((s)=>{
        if ((0, _positionsMjs.isProfilePoint)(s)) runs[runs.length - 1].push({
            cm: s.startCm,
            value: Number(s.value)
        });
        else runs.push([]);
    });
    runs.filter((run)=>run.length > 0).forEach((run)=>svg.append(svgEl(doc, "polyline", {
            points: run.map((p)=>`${x(p.cm)},${y(p.value)}`).join(" "),
            class: "fe-line"
        })));
    plot.append(svg);
    profile.bands.forEach((b)=>{
        const band = el(doc, "div", "fe-band");
        band.style.left = percent(b.startCm, axis);
        band.style.width = percent(b.endCm - b.startCm, axis);
        band.dataset.tip = `${b.startCm}\u{2013}${b.endCm}: ${b.value}`;
        band.dataset.start = String(b.startCm);
        band.dataset.end = String(b.endCm);
        if ((b.endCm - b.startCm) / axis * 100 > LABEL_MIN_PERCENT) band.textContent = b.value;
        plot.append(band);
    });
    grid.append(ylab, plot);
    node.append(grid);
    const foot = el(doc, "div", "fe-ticks");
    foot.append(el(doc, "span", undefined, "0"));
    foot.append(el(doc, "span", undefined, `${axis} cm`));
    node.append(foot);
    const hint = profileHint(profile);
    if (hint) node.append(el(doc, "div", "fe-hint", hint));
    if (!withPoints) return node;
    const points = el(doc, "div", "fe-points");
    let band = 0;
    tag.sections.forEach((s, i)=>{
        const pt = el(doc, "span", "fe-pt");
        pt.dataset.index = String(i);
        const b = (0, _positionsMjs.isProfilePoint)(s) ? null : profile.bands[band++];
        pt.append(el(doc, "b", undefined, b ? `${b.startCm}\u{2013}${b.endCm}` : s.startCm), ` ${s.value}`);
        points.append(pt);
    });
    node.append(points);
    return node;
}
function renderRawInline(doc, tag) {
    const details = el(doc, "details", "fe-raw");
    details.append(el(doc, "summary", undefined, "raw"));
    details.append(el(doc, "pre", "fe-rawtext", `${tag.rawKey}=${valueText(tag.value)}`));
    return details;
}
function renderViewRaw(doc, tags) {
    const details = el(doc, "details", "fe-raw");
    details.append(el(doc, "summary", undefined, `raw (${tags.length})`));
    details.append(el(doc, "pre", "fe-rawtext", tags.map((t)=>`${t.rawKey}=${valueText(t.value)}`).join("\n")));
    return details;
}
function renderRawBox(doc, properties) {
    const entries = Object.entries(properties).filter(([k])=>k !== "geometry");
    const lines = entries.map(([k, v])=>`${k}=${valueText(v)}`).join("\n");
    const details = el(doc, "details", "fe-rawbox");
    details.append(el(doc, "summary", undefined, `raw (${entries.length})`));
    const area = el(doc, "textarea", "fe-rawtext", lines);
    area.readOnly = true;
    area.setAttribute("readonly", "");
    area.setAttribute("rows", String(Math.min(14, Math.max(entries.length, 1))));
    details.append(area);
    details.append(copyButton(doc, lines, "copy all"));
    return details;
}
function copyButton(doc, text, label = "copy") {
    const button = el(doc, "button", "fe-copy", label);
    button.type = "button";
    button.dataset.copy = text;
    return button;
}

},{"./lrValues.mjs":"CS5r3","./positions.mjs":"gc1cv","./slots.mjs":"ghqtd","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"k5moz":[function(require,module,exports,__globalThis) {
// DOM for the feature views: lanes (RM, OSMLR), LM lane restrictions, CaJ. Glyphs and
// line styles are labelled conventions; values are shown as tagged and on hover.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @param {Document} doc
 * @param {{stretches: object[], usedTags: object[]}} view from buildLaneView
 */ parcelHelpers.export(exports, "renderLaneView", ()=>renderLaneView);
/**
 * @param {Document} doc
 * @param {{stretches: object[], usedTags: object[]}} view from buildLmRestrictionView
 */ parcelHelpers.export(exports, "renderLmView", ()=>renderLmView);
/**
 * @param {Document} doc
 * @param {object} view from buildCajView
 * @param {[string, unknown][]} derivedRows from curvatureAtJunctionKeyValues
 */ parcelHelpers.export(exports, "renderCajView", ()=>renderCajView);
var _restrictionClassMjs = require("../layers/style/util/restrictionClass.mjs");
var _lrValuesMjs = require("./lrValues.mjs");
var _renderValuesMjs = require("./renderValues.mjs");
const DIR_GLYPH = {
    forward: "\u2191",
    backward: "\u2193",
    both_ways: "\u2195",
    reversible: "\u21C5"
};
const TURN_GLYPH = {
    through: "\u2191",
    left: "\u21B0",
    right: "\u21B1",
    slight_left: "\u2196",
    slight_right: "\u2197",
    sharp_left: "\u2199",
    sharp_right: "\u2198",
    reverse: "\u21B6",
    merge_to_left: "\u21D6",
    merge_to_right: "\u21D7",
    merge: "\u21D1",
    none: "\xb7"
};
const DIVIDERS = [
    "none",
    "solid",
    "double_solid",
    "long_dash",
    "short_dash"
];
const DIVIDER_WORD = {
    none: "gap = none",
    solid: "solid",
    double_solid: "double = double_solid",
    long_dash: "dashed = long_dash",
    short_dash: "dotted = short_dash"
};
const CLASS_LABEL = {
    busOnly: "bus only",
    taxiAndBus: "taxi and bus",
    taxiOnly: "taxi only",
    noTrucks: "no trucks",
    noBusNoTruck: "no bus, no trucks",
    trucksOnly: "trucks only",
    closed: "closed",
    other: "other"
};
const CONDITIONAL = /^(.*?)\s*@\s*\((.*)\)\s*$/s;
const dividerClass = (value)=>value === undefined || value === "" ? "fe-div-untagged" : DIVIDERS.includes(value) ? `fe-div-${value}` : "fe-div-other";
/** Colour key and label of a restriction class, as the map names and colours it. */ function renderClassKey(doc, className) {
    const node = (0, _renderValuesMjs.el)(doc, "span", "fe-class");
    if (!className) {
        node.append((0, _renderValuesMjs.el)(doc, "span", "fe-muted", "open"));
        return node;
    }
    const key = (0, _renderValuesMjs.el)(doc, "span", "fe-ckey");
    key.style.background = (0, _restrictionClassMjs.ACCESS_CLASS_COLORS)[className];
    node.append(key, CLASS_LABEL[className] ?? className);
    return node;
}
function stretchHeader(doc, s) {
    const head = (0, _renderValuesMjs.el)(doc, "div", "fe-lsh");
    const n = s.lanes ?? s.slotCount;
    const unit = s.lanes !== undefined ? "lane" : "slot";
    head.append((0, _renderValuesMjs.el)(doc, "span", "fe-mono", `${s.startCm}\u{2013}${s.endCm}`), ` \xb7 ${n} ${unit}${Number(n) === 1 ? "" : "s"}`);
    const counts = Object.entries(s.counts).map(([name, v])=>`${name} ${v}`);
    if (counts.length) head.append((0, _renderValuesMjs.el)(doc, "div", "fe-muted", counts.join(", ")));
    return head;
}
function renderLaneView(doc, view) {
    const node = (0, _renderValuesMjs.el)(doc, "div", "fe-lanes");
    node.append((0, _renderValuesMjs.el)(doc, "div", "fe-vtitle", "lanes"));
    const usedKeys = new Set(view.usedTags.map((t)=>t.key.replace(/:step$/, "")));
    const drawn = [
        "lanes:direction",
        "divider:lanes"
    ].filter((k)=>usedKeys.has(k));
    const seenDir = new Set();
    const seenDiv = new Set();
    const windows = new Set();
    let hasAccess = false;
    view.stretches.forEach((s, index)=>{
        const n = s.slotCount;
        const grid = (0, _renderValuesMjs.el)(doc, "div", "fe-ls");
        grid.dataset.index = String(index);
        grid.dataset.start = String(s.startCm);
        grid.dataset.end = String(s.endCm);
        grid.style.gridTemplateColumns = `136px repeat(${n}, ${n >= 6 ? 40 : 46}px)`;
        grid.append(stretchHeader(doc, s));
        for(let i = 0; i < n; i++)grid.append((0, _renderValuesMjs.el)(doc, "div", "fe-lsn", i + 1));
        if (drawn.length) {
            const top = (0, _renderValuesMjs.el)(doc, "div", "fe-ltop");
            const label = (0, _renderValuesMjs.el)(doc, "div", "fe-lsl");
            drawn.forEach((k)=>label.append((0, _renderValuesMjs.el)(doc, "span", undefined, k)));
            top.append(label);
            for(let i = 0; i < n; i++){
                const dir = s.direction ? s.direction[i] : undefined;
                const div = i > 0 ? s.dividers ? s.dividers[i - 1] : undefined : null;
                if (dir) seenDir.add(dir);
                if (div) seenDiv.add(div);
                const cell = (0, _renderValuesMjs.el)(doc, "div", "fe-lc", dir ? DIR_GLYPH[dir] ?? "?" : "");
                if (div !== null) cell.classList.add(dividerClass(div));
                const tip = [
                    `slot ${i + 1}`
                ];
                if (s.direction) tip.push(`lanes:direction ${dir || "(blank)"}`);
                if (div !== null && s.dividers) tip.push(`divider:lanes ${i}|${i + 1} ${div || "(blank)"}`);
                cell.dataset.tip = tip.join(" \xb7 ");
                top.append(cell);
            }
            grid.append(top);
        }
        s.rows.forEach((r)=>{
            const row = (0, _renderValuesMjs.el)(doc, "div", "fe-lrow");
            const label = (0, _renderValuesMjs.el)(doc, "div", r.tagged ? "fe-lsl" : "fe-lsl fe-muted", r.key);
            label.dataset.tip = r.tagged ? r.key : `${r.key} (not tagged)`;
            row.append(label);
            if (r.key.startsWith("lanes:vehicle_access:")) hasAccess = true;
            r.slots.forEach((value, i)=>{
                const cell = (0, _renderValuesMjs.el)(doc, "div", "fe-lsv");
                cell.dataset.tip = `slot ${i + 1} \xb7 ${r.key} ${value || "(blank)"}`;
                if (value === "") cell.append((0, _renderValuesMjs.el)(doc, "span", "fe-blank", "\xb7"));
                else if (r.key === "turn:lanes") {
                    const glyphs = (0, _lrValuesMjs.splitUnescaped)(value, ";").map((t)=>TURN_GLYPH[t] ?? "?").join("");
                    const backward = s.direction && s.direction[i] === "backward";
                    cell.append((0, _renderValuesMjs.el)(doc, "span", backward ? "fe-rot" : undefined, glyphs));
                } else {
                    const match = CONDITIONAL.exec(value);
                    if (match && match[1] !== "") {
                        windows.add(match[2]);
                        cell.textContent = `${match[1]} @`;
                    } else cell.textContent = value;
                }
                row.append(cell);
            });
            grid.append(row);
        });
        if (s.classes) {
            const row = (0, _renderValuesMjs.el)(doc, "div", "fe-lrow");
            row.append((0, _renderValuesMjs.el)(doc, "div", "fe-lsl", "class"));
            s.classes.forEach((c)=>{
                const cell = (0, _renderValuesMjs.el)(doc, "div", "fe-lsv fe-cls");
                cell.append(renderClassKey(doc, c));
                row.append(cell);
            });
            grid.append(row);
        }
        node.append(grid);
    });
    const legend = [];
    if (seenDir.size) legend.push([
        ...seenDir
    ].map((d)=>`${DIR_GLYPH[d] ?? "?"} ${d}`).join(", "));
    if (seenDiv.size) legend.push("divider:lanes: " + [
        ...seenDiv
    ].map((d)=>DIVIDER_WORD[d] ?? `blue-grey = ${d}`).join(", "));
    windows.forEach((w)=>legend.push(`@ (${w})`));
    if (hasAccess) legend.push("\xb7 blank");
    if (legend.length) node.append((0, _renderValuesMjs.el)(doc, "div", "fe-legend", legend.join(" \xb7 ")));
    node.append((0, _renderValuesMjs.renderViewRaw)(doc, view.usedTags));
    return node;
}
function cells(doc, tr, texts, tagName = "td") {
    texts.forEach((t)=>tr.append(typeof t === "string" ? (0, _renderValuesMjs.el)(doc, tagName, undefined, t) : t));
}
function renderLmView(doc, view) {
    const node = (0, _renderValuesMjs.el)(doc, "div", "fe-lmview");
    node.append((0, _renderValuesMjs.el)(doc, "div", "fe-vtitle", "lane restrictions"));
    view.stretches.forEach((s)=>{
        if (view.stretches.length > 1) node.append((0, _renderValuesMjs.el)(doc, "div", "fe-mono fe-muted", `${s.startCm}\u{2013}${s.endCm}`));
        const table = (0, _renderValuesMjs.el)(doc, "table", "fe-matrix");
        const head = (0, _renderValuesMjs.el)(doc, "tr");
        cells(doc, head, [
            "vehicle_restriction",
            "tagged",
            "result"
        ], "th");
        table.append(head);
        s.general.forEach(({ token, value })=>{
            const tr = (0, _renderValuesMjs.el)(doc, "tr");
            cells(doc, tr, [
                token,
                value,
                ""
            ]);
            table.append(tr);
        });
        s.modes.forEach((m)=>{
            const tr = (0, _renderValuesMjs.el)(doc, "tr");
            const tagged = (0, _renderValuesMjs.el)(doc, "td");
            tagged.append(m.tagged === undefined ? (0, _renderValuesMjs.el)(doc, "span", "fe-blank", "\xb7") : m.tagged);
            cells(doc, tr, [
                m.mode,
                tagged,
                m.result
            ]);
            table.append(tr);
        });
        s.hov.forEach(({ key, value })=>{
            const tr = (0, _renderValuesMjs.el)(doc, "tr");
            const td = (0, _renderValuesMjs.el)(doc, "td");
            td.colSpan = 2;
            td.append((0, _renderValuesMjs.renderPlainValue)(doc, value));
            cells(doc, tr, [
                key,
                td
            ]);
            table.append(tr);
        });
        const classRow = (0, _renderValuesMjs.el)(doc, "tr", "fe-clsrow");
        const td = (0, _renderValuesMjs.el)(doc, "td");
        td.colSpan = 2;
        td.append(renderClassKey(doc, s.className));
        cells(doc, classRow, [
            "class",
            td
        ]);
        table.append(classRow);
        node.append(table);
    });
    node.append((0, _renderValuesMjs.renderViewRaw)(doc, view.usedTags));
    return node;
}
function renderCajView(doc, view, derivedRows) {
    const node = (0, _renderValuesMjs.el)(doc, "div", "fe-cajview");
    node.append((0, _renderValuesMjs.el)(doc, "div", "fe-vtitle", "curvature at junction"));
    const table = (0, _renderValuesMjs.el)(doc, "table", "fe-matrix");
    const add = (label, value)=>{
        const tr = (0, _renderValuesMjs.el)(doc, "tr");
        tr.append((0, _renderValuesMjs.el)(doc, "td", "label", label));
        tr.append(typeof value === "object" ? value : (0, _renderValuesMjs.el)(doc, "td", undefined, value));
        table.append(tr);
    };
    add("curvature_at_junction", view.value);
    derivedRows.forEach(([label, value])=>add(label, String(value)));
    node.append(table);
    const full = view.usedTags.find((t)=>t.sections && t.lr === "linear");
    if (full && view.fullCurvature) {
        node.append((0, _renderValuesMjs.el)(doc, "div", "fe-muted", "meta_full_curvature"));
        // Measured along the manoeuvre, not one way: the axis runs to its last point.
        node.append((0, _renderValuesMjs.renderProfile)(doc, full, null));
        // Raw only for what the view redraws: the profile's chain.
        node.append((0, _renderValuesMjs.renderViewRaw)(doc, [
            full
        ]));
    }
    return node;
}

},{"../layers/style/util/restrictionClass.mjs":"bWcVG","./lrValues.mjs":"CS5r3","./renderValues.mjs":"jzrm4","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"iCvis":[function(require,module,exports,__globalThis) {
// Sidebar → map position hover: the pointer on a step bar, a profile or the drawer's
// lanes plot as a distance along the way, and the range of the section, band or
// lane stretch under it (their `data-start` / `data-end`).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TRACK_SELECTOR", ()=>TRACK_SELECTOR);
parcelHelpers.export(exports, "RANGE_SELECTOR", ()=>RANGE_SELECTOR);
/**
 * @param {{left: number, width: number}} rect the track's box
 * @param {number} clientX
 * @param {number} axisCm the track's `data-axis`
 * @returns {number} cm along the way, clamped to the track
 */ parcelHelpers.export(exports, "trackPosition", ()=>trackPosition);
/** @returns {{startCm: number, endCm: number}|null} from a `data-start`/`data-end` dataset */ parcelHelpers.export(exports, "rangeOf", ()=>rangeOf);
const TRACK_SELECTOR = ".fe-bar, .fe-profile, .fe-dlplot";
const RANGE_SELECTOR = "[data-start][data-end]";
function trackPosition(rect, clientX, axisCm) {
    if (!(rect.width > 0)) return 0;
    const fraction = Math.min(Math.max((clientX - rect.left) / rect.width, 0), 1);
    return Math.round(fraction * axisCm);
}
function rangeOf(dataset) {
    const startCm = Number(dataset?.start);
    const endCm = Number(dataset?.end);
    if (dataset?.start === undefined || dataset?.end === undefined) return null;
    if (!Number.isFinite(startCm) || !Number.isFinite(endCm)) return null;
    return {
        startCm,
        endCm
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"jE3Kv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * If `addFeatureHandlers` includes curvatureLinearHandler, injects a small
 * toggle button into the layer row's header letting the user disable the
 * client-side curvature line reconstruction without hiding the underlying
 * layer.
 *
 * Returns the (possibly wrapped) handlers array to pass to the layer/source
 * factory, and a `bindLayer(layer)` callback that must be called once the
 * layer exists — disabling removes already-reconstructed features from the
 * source, re-enabling re-runs the reconstruction over currently loaded ones.
 */ parcelHelpers.export(exports, "withCurvatureReconstructionToggle", ()=>withCurvatureReconstructionToggle);
var _curvatureLinearHandler = require("./CurvatureLinearHandler");
function withCurvatureReconstructionToggle(addFeatureHandlers, headerEl) {
    if (!addFeatureHandlers.includes((0, _curvatureLinearHandler.curvatureLinearHandler))) return {
        addFeatureHandlers,
        bindLayer: ()=>{}
    };
    const toggleBtn = document.createElement("button");
    toggleBtn.type = "button";
    toggleBtn.className = "curvature-reconstruction-toggle-btn";
    toggleBtn.textContent = "\u223F";
    headerEl.appendChild(toggleBtn);
    let enabled = false;
    const updateTitle = ()=>{
        toggleBtn.title = enabled ? "Curvature line reconstruction is on \u2014 click to disable" : "Curvature line reconstruction is off \u2014 click to enable";
    };
    updateTitle();
    const wrappedHandlers = addFeatureHandlers.map((handler)=>handler === (0, _curvatureLinearHandler.curvatureLinearHandler) ? (event)=>{
            if (enabled) handler(event);
        } : handler);
    const bindLayer = (layer)=>{
        toggleBtn.addEventListener("click", ()=>{
            enabled = !enabled;
            toggleBtn.classList.toggle("curvature-reconstruction-toggle-btn--on", enabled);
            updateTitle();
            const vectorSource = layer.getSource();
            if (enabled) (0, _curvatureLinearHandler.curvatureLinearHandler)({
                target: vectorSource
            });
            else vectorSource.getFeatures().filter((feature)=>feature.get("type") === (0, _curvatureLinearHandler.CURVATURE_LINEAR_RECONSTRUCTED_TYPE)).forEach((feature)=>vectorSource.removeFeature(feature));
        });
    };
    return {
        addFeatureHandlers: wrappedHandlers,
        bindLayer
    };
}

},{"./CurvatureLinearHandler":"1rcYN","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"kFPww":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addFGBLayerAndControl", ()=>addFGBLayerAndControl);
parcelHelpers.export(exports, "getPreviousMonthsUrls", ()=>getPreviousMonthsUrls);
parcelHelpers.export(exports, "enableIfAccessible", ()=>enableIfAccessible);
parcelHelpers.export(exports, "customizeFeatureId", ()=>customizeFeatureId);
parcelHelpers.export(exports, "concatenateFeatureFields", ()=>concatenateFeatureFields);
var _vectorFeatureControl = require("../controls/VectorFeatureControl");
var _fgblayer = require("../layers/FGBLayer");
var _hoverLayer = require("../layers/HoverLayer");
var _curvatureReconstructionToggle = require("../layers/addfeaturehandlers/curvatureReconstructionToggle");
var _urlstateManager = require("../state/URLStateManager");
var _layerSlugMjs = require("./layerSlug.mjs");
function addFGBLayerAndControl({ layerName, slug, target, map, getInteractions, sortField, urls, style, featureInfoControl, transformFeature, minZoom = 17, settingConfigurationFn = function() {}, hoverStyleFunctions, addFeatureHandlers = [] }) {
    // `slug` is the layer's URL identity and is deliberately NOT derived from
    // layerName — see config/layerSlug.mjs for why.
    (0, _layerSlugMjs.assertSlug)(slug, layerName);
    const control = new (0, _vectorFeatureControl.VectorFeatureControl)({
        layer_name: layerName,
        target: target,
        sort_field: sortField,
        header_field: sortField
    });
    // Restore layer visibility from URL. Re-applies when `enabled` becomes true,
    // because `enableIfAccessible` may reset the checkbox before confirming access.
    const shouldRestoreToggle = (0, _urlstateManager.getLayersFromURL)().includes(slug);
    if (shouldRestoreToggle) control.setToggle(true);
    (0, _urlstateManager.registerLayerControl)(slug, control);
    const { addFeatureHandlers: resolvedAddFeatureHandlers, bindLayer } = (0, _curvatureReconstructionToggle.withCurvatureReconstructionToggle)(addFeatureHandlers, control.headerEl);
    settingConfigurationFn(control, urls);
    const layer = (0, _fgblayer.getFGBLayer)(control, urls, style, transformFeature, minZoom, resolvedAddFeatureHandlers);
    // The sidebar entry looks up CaJ arc relations and members in the row's source.
    control.layer = layer;
    bindLayer(layer);
    map.addControl(control);
    map.addLayer(layer);
    hoverStyleFunctions.forEach((hoverStyleFunction)=>{
        const hoverLayer = (0, _hoverLayer.getHoverLayer)(hoverStyleFunction);
        map.addLayer(hoverLayer);
        featureInfoControl.addHoverLayerForLayer(hoverLayer, layer);
    });
    getInteractions(layer, control).forEach((interaction)=>map.addInteraction(interaction));
    map.on("moveend", function() {
        control.set("zoom", map.getView().getZoom());
    });
}
function getPreviousMonthsUrls(prefix, amountOfMonthsBack) {
    return Array.from({
        length: amountOfMonthsBack
    }, (x, i)=>{
        const today = new Date();
        today.setDate(Math.min(today.getDate(), 28));
        today.setMonth(today.getMonth() - i);
        return (prefix + "YYYY-MM.fgb").replace("YYYY", today.getFullYear()).replace("MM", String(today.getMonth() + 1).padStart(2, "0"));
    });
}
function enableIfAccessible(vectorFeatureControl, urls) {
    // Probe each URL by validating just its header. This doubles as the
    // accessibility check (a 401/403 rejects) and, crucially, avoids driving the
    // flatgeobuf reader into `calcTreeSize`'s synchronous infinite loop on a
    // malformed/empty file — which would freeze the tab here, at startup, before
    // any user interaction. See validateFgbHeader in FGBLayer.js.
    const promises = urls.map((url)=>(0, _fgblayer.validateFgbHeader)(url));
    Promise.any(promises).then(()=>{
        vectorFeatureControl.set("enabled", true);
    }).catch(()=>{
        vectorFeatureControl.set("enabled", false);
    });
}
function customizeFeatureId(featureIdFn) {
    return function(feature) {
        feature.setId(featureIdFn(feature));
        return feature;
    };
}
function concatenateFeatureFields(fields) {
    return function(feature) {
        return fields.map((field)=>feature.get(field)).join("-");
    };
}

},{"../controls/VectorFeatureControl":"ghYyc","../layers/FGBLayer":"5mNyT","../layers/HoverLayer":"3Tely","../layers/addfeaturehandlers/curvatureReconstructionToggle":"jE3Kv","../state/URLStateManager":"7Lluw","./layerSlug.mjs":"86yOw","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5mNyT":[function(require,module,exports,__globalThis) {
// Everything from OpenLayers
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Some parameters used to render the dial and bearing used to show the direction of the sign.
// Global variables used to abort API calls because the user has changed the map.
// let abortController, signal;
/**
 * @param {VectorFeatureControl} vectorFeatureControl
 * @param {string[]} urls
 * @param {function} getStyleNormal
 * @param {function} transformFeature
 * @param {number} minZoom
 * @param {string} dataProjection
 * @returns
 */ parcelHelpers.export(exports, "getFGBLayer", ()=>getFGBLayer);
/**
 * Fetches and validates just the FlatGeobuf header via HTTP Range requests,
 * mirroring the checks the library's `HttpReader.open` performs — plus the one
 * it is missing: a finite, positive `featuresCount`. The library feeds the
 * parsed count straight into `calcTreeSize`, whose `do … while (1 !== l)` loop
 * never terminates for 0/NaN/negative counts, hanging the main thread.
 *
 * The byte offsets live in `fgbHeader.mjs`: flatgeobuf 4 parses the header
 * size-prefixed, so the header request has to start at the length prefix.
 *
 * Throws a descriptive Error (caught by the loader) instead of freezing.
 *
 * @param {string} url
 */ parcelHelpers.export(exports, "validateFgbHeader", ()=>validateFgbHeader);
var _vector = require("ol/source/Vector");
var _vectorDefault = parcelHelpers.interopDefault(_vector);
var _vector1 = require("ol/layer/Vector");
var _vectorDefault1 = parcelHelpers.interopDefault(_vector1);
var _point = require("ol/geom/Point");
var _pointDefault = parcelHelpers.interopDefault(_point);
var _ol = require("flatgeobuf/lib/mjs/ol");
var _loadingstrategy = require("ol/loadingstrategy");
var _featureWktMjs = require("../util/featureWkt.mjs");
var _fgbHeaderMjs = require("./fgbHeader.mjs");
function getFGBLayer(vectorFeatureControl, urls, getStyleNormal, transformFeature, minZoom = 17, addFeatureHandlers = [], dataProjection = "EPSG:4326") {
    const vectorSource = new (0, _vectorDefault.default)({
        minZoom: minZoom,
        strategy: (0, _loadingstrategy.bbox),
        loader: function(extent, resolution, projection, success, failure) {
            // Use flatgeobuf JavaScript API to iterate features as geojson.
            // Because we specify a bounding box, flatgeobuf will only fetch the relevant subset of data,
            // rather than the entire file.
            if (extent[0] == -Infinity) return;
            async function populate() {
                const rect = fgbBoundingBox(extent, projection.getCode());
                for (const url of urls)try {
                    // Pre-flight: validate the header before handing the URL to the
                    // flatgeobuf reader. A malformed/truncated/empty file whose header
                    // parses to featuresCount <= 0 (or NaN) makes the library's
                    // synchronous `calcTreeSize` loop forever on the main thread,
                    // freezing the whole tab — no error is thrown and the catch below
                    // never runs. Validating here turns that hang into a normal error.
                    await validateFgbHeader(url);
                    let iter = (0, _ol.deserialize)(url, {
                        rect
                    });
                    const features = [];
                    for await (let feature of iter){
                        // Keep the file's own coordinates for the WKT row before reprojecting.
                        const sourceGeometry = feature.getGeometry().clone();
                        feature.getGeometry().transform(dataProjection, projection.getCode());
                        feature.setProperties(flattenJsonProperties(feature.getProperties()));
                        const transformed = transformFeature(feature);
                        (0, _featureWktMjs.setSourceGeometry)(transformed, sourceGeometry);
                        features.push(transformed);
                    }
                    success(features);
                    vectorSource.addFeatures(features);
                } catch (err) {
                    if (err.message != "Not a FlatGeobuf file") console.error("Unable to fetch data for url " + url, err);
                    vectorFeatureControl.set("loadErrorReason", err.message ?? "Unknown error");
                    failure();
                }
            }
            populate();
        }
    });
    addFeatureHandlers.forEach((handler)=>{
        vectorSource.on("featuresloadend", handler);
    });
    vectorSource.on("featuresloadstart", ()=>{
        vectorFeatureControl.set("loading", true);
        vectorFeatureControl.set("loadError", false);
        vectorFeatureControl.set("loadErrorReason", null);
    });
    vectorSource.on("featuresloadend", ()=>{
        vectorFeatureControl.set("loading", false);
    });
    vectorSource.on("featuresloaderror", ()=>{
        vectorFeatureControl.set("loading", false);
        vectorFeatureControl.set("loadError", true);
    });
    const vectorLayer = new (0, _vectorDefault1.default)({
        source: vectorSource,
        minZoom: minZoom,
        zIndex: 8,
        visible: false,
        style: function(feature) {
            return getStyleNormal(feature);
        }
    });
    vectorFeatureControl.set("enabled", true);
    vectorFeatureControl.on("propertychange", function(e) {
        if (e.key !== "loading" && e.key !== "tooLarge" && e.key !== "loadError") propertyChangeHandler(vectorFeatureControl, vectorLayer);
        if (e.key === "zoom") {
            const zoom = e.target.get("zoom");
            if (zoom >= vectorLayer.getMinZoom() && zoom <= vectorLayer.getMaxZoom()) vectorFeatureControl.set("active", true);
            else vectorFeatureControl.set("active", false);
        }
    });
    return vectorLayer;
}
async function validateFgbHeader(url) {
    const getRange = async (start, length)=>{
        const res = await fetch(url, {
            headers: {
                Range: `bytes=${start}-${start + length - 1}`
            }
        });
        if (!res.ok && res.status !== 206) throw new Error(`HTTP ${res.status} fetching FlatGeobuf header`);
        return new Uint8Array(await res.arrayBuffer());
    };
    const headerLength = (0, _fgbHeaderMjs.parseFgbHeaderLength)(await getRange(0, (0, _fgbHeaderMjs.FGB_PREFIX_LEN)));
    const { start, length } = (0, _fgbHeaderMjs.fgbHeaderRange)(headerLength);
    const headerBytes = await getRange(start, length);
    if (headerBytes.byteLength < length) throw new Error("Truncated FlatGeobuf header");
    const featuresCount = (0, _fgbHeaderMjs.parseFgbFeaturesCount)(headerBytes);
    if (!Number.isFinite(featuresCount) || featuresCount <= 0) throw new Error(`Invalid FlatGeobuf: featuresCount=${featuresCount} (file empty or corrupt)`);
}
function fgbBoundingBox(extent, projectionCode) {
    const minPoint = new (0, _pointDefault.default)([
        extent[0],
        extent[1]
    ]);
    minPoint.transform(projectionCode, "EPSG:4326");
    const maxPoint = new (0, _pointDefault.default)([
        extent[2],
        extent[3]
    ]);
    maxPoint.transform(projectionCode, "EPSG:4326");
    return {
        minX: minPoint.getCoordinates()[0],
        minY: minPoint.getCoordinates()[1],
        maxX: maxPoint.getCoordinates()[0],
        maxY: maxPoint.getCoordinates()[1]
    };
}
function flattenJsonProperties(properties) {
    const newEntries = Object.entries(properties).map((entry)=>{
        try {
            return [
                entry[0],
                JSON.parse(entry[1])
            ];
        } catch  {
            return entry;
        }
    });
    return Object.fromEntries(newEntries);
}
/**
 * @param {VectorFeatureControl} vectorFeatureControl
 * @param {VectorLayer} vectorLayer
 */ function propertyChangeHandler(vectorFeatureControl, vectorLayer) {
    if (vectorFeatureControl.get("vectorToggle") === true) vectorLayer.setVisible(true);
    else // When vectorToggle is not set, the checkbox is not checked, and so the layer is made invisible.
    vectorLayer.setVisible(false);
}

},{"ol/source/Vector":"7zHxp","ol/layer/Vector":"7ga2c","ol/geom/Point":"95T6m","flatgeobuf/lib/mjs/ol":"ktbhl","ol/loadingstrategy":"6eznf","../util/featureWkt.mjs":"gxnaa","./fgbHeader.mjs":"2oVBi","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"ktbhl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serialize", ()=>serialize);
parcelHelpers.export(exports, "deserialize", ()=>deserialize);
parcelHelpers.export(exports, "createLoader", ()=>createLoader);
parcelHelpers.export(exports, "tileUrlFunction", ()=>tileUrlFunction);
parcelHelpers.export(exports, "createTileLoadFunction", ()=>createTileLoadFunction);
var _loadingstrategyJs = require("ol/loadingstrategy.js");
var _projJs = require("ol/proj.js");
var _featurecollectionJs = require("./generic/featurecollection.js");
var _genericJs = require("./generic.js");
var _featureJs = require("./ol/feature.js");
function serialize(features) {
    const bytes = (0, _featurecollectionJs.serialize)(features);
    return bytes;
}
function deserialize(input, options) {
    const opts = options ?? {};
    const ctx = {
        ...opts,
        fromFeature: (0, _featureJs.getFromFeatureFn)(opts)
    };
    if (typeof input === 'string' && !options?.rect && !options?.seekableZstd) throw new Error('Invalid input type or missing rect for URL input');
    return (0, _genericJs.deserialize)(input, ctx);
}
function extentToRect(extent, source, destination) {
    const [minX, minY, maxX, maxY] = source && destination && source !== destination ? (0, _projJs.transformExtent)(extent, source, destination) : extent;
    const rect = {
        minX,
        minY,
        maxX,
        maxY
    };
    return rect;
}
function createLoader(source, url, strategy = (0, _loadingstrategyJs.all), clear = false, options = {}) {
    return async (extent, _resolution, projection, success, failure)=>{
        try {
            if (clear) source.clear();
            options.dataProjection ??= 'EPSG:4326';
            options.featureProjection ??= projection.getCode();
            const features = [];
            let it;
            if (strategy === (0, _loadingstrategyJs.all) && !options.seekableZstd) {
                const response = await fetch(url, {
                    headers: options.headers
                });
                it = deserialize(response.body, options);
            } else {
                const rect = extentToRect(extent, options.featureProjection, options.dataProjection);
                it = deserialize(url, {
                    ...options,
                    rect
                });
            }
            for await (const feature of it){
                features.push(feature);
                source.addFeature(feature);
            }
            success?.(features);
            return features;
        } catch (e) {
            console.error(e);
            failure?.();
            return [];
        }
    };
}
const tileUrlFunction = (tileCoord)=>JSON.stringify(tileCoord);
function createTileLoadFunction(source, url, options = {}) {
    const projection = source.getProjection();
    options.dataProjection ??= 'EPSG:4326';
    options.featureProjection ??= projection?.getCode() ?? 'EPSG:3857';
    const tileLoadFunction = (tile)=>{
        const vectorTile = tile;
        const loader = async (extent)=>{
            const rect = extentToRect(extent, options.featureProjection, options.dataProjection);
            const it = deserialize(url, {
                ...options,
                rect
            });
            const features = [];
            for await (const feature of it)features.push(feature);
            vectorTile.setFeatures(features);
            return features;
        };
        vectorTile.setLoader(loader);
    };
    return tileLoadFunction;
}

},{"ol/loadingstrategy.js":"6eznf","ol/proj.js":"gN0IK","./generic/featurecollection.js":"eh4qT","./generic.js":"cG257","./ol/feature.js":"hoFfE","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"eh4qT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serialize", ()=>serialize);
parcelHelpers.export(exports, "deserialize", ()=>deserialize);
parcelHelpers.export(exports, "deserializeStream", ()=>deserializeStream);
parcelHelpers.export(exports, "deserializeFiltered", ()=>deserializeFiltered);
parcelHelpers.export(exports, "deserializeSeekableZstdSource", ()=>deserializeSeekableZstdSource);
parcelHelpers.export(exports, "buildHeader", ()=>buildHeader);
parcelHelpers.export(exports, "readMetadata", ()=>readMetadata);
parcelHelpers.export(exports, "mapColumn", ()=>mapColumn);
var _flatbuffers = require("flatbuffers");
var _sliceSource = require("slice-source");
var _sliceSourceDefault = parcelHelpers.interopDefault(_sliceSource);
var _arrayReaderJs = require("../array-reader.js");
var _constantsJs = require("../constants.js");
var _columnJs = require("../flat-geobuf/column.js");
var _columnTypeJs = require("../flat-geobuf/column-type.js");
var _crsJs = require("../flat-geobuf/crs.js");
var _featureJs = require("../flat-geobuf/feature.js");
var _headerJs = require("../flat-geobuf/header.js");
var _headerMetaJs = require("../header-meta.js");
var _httpReaderJs = require("../http-reader.js");
var _packedrtreeJs = require("../packedrtree.js");
var _featureJs1 = require("./feature.js");
var _geometryJs = require("./geometry.js");
var _headerJs1 = require("./header.js");
const browserWasmUrl = (()=>{
    if (typeof document === 'undefined') return undefined;
    const scriptSrc = document.currentScript?.getAttribute('src');
    return scriptSrc ? new URL('zstd.wasm', new URL(scriptSrc, document.baseURI)).href : undefined;
})();
function serialize(features) {
    const headerMeta = introspectHeaderMeta(features);
    const header = buildHeader(headerMeta);
    const featureBuffers = features.map((f)=>{
        if (!f.getGeometry) throw new Error('Missing getGeometry implementation');
        if (!f.getProperties) throw new Error('Missing getProperties implementation');
        return (0, _featureJs1.buildFeature)((0, _geometryJs.parseGeometry)(f.getGeometry(), headerMeta.geometryType), f.getProperties(), headerMeta);
    });
    const featuresLength = featureBuffers.map((f)=>f.length).reduce((a, b)=>a + b);
    const uint8 = new Uint8Array((0, _constantsJs.magicbytes).length + header.length + featuresLength);
    uint8.set(header, (0, _constantsJs.magicbytes).length);
    let offset = (0, _constantsJs.magicbytes).length + header.length;
    for (const feature of featureBuffers){
        uint8.set(feature, offset);
        offset += feature.length;
    }
    uint8.set((0, _constantsJs.magicbytes));
    return uint8;
}
async function* deserialize(input, ctx) {
    const { fromFeature, rect, headerMetaFn } = ctx;
    const bytes = input;
    if (!bytes.subarray(0, 3).every((v, i)=>(0, _constantsJs.magicbytes)[i] === v)) throw new Error('Not a FlatGeobuf file');
    if (rect) {
        const reader = (0, _arrayReaderJs.ArrayReader).open(bytes);
        for await (const feature of reader.selectBbox(rect))yield fromFeature(feature.id, feature.feature, reader.header);
        return;
    }
    const bb = new _flatbuffers.ByteBuffer(bytes);
    const headerLength = bb.readUint32((0, _constantsJs.magicbytes).length);
    bb.setPosition((0, _constantsJs.magicbytes).length);
    const headerMeta = (0, _headerMetaJs.fromByteBuffer)(bb);
    if (headerMetaFn) headerMetaFn(headerMeta);
    let offset = (0, _constantsJs.magicbytes).length + (0, _constantsJs.SIZE_PREFIX_LEN) + headerLength;
    const { indexNodeSize, featuresCount } = headerMeta;
    if (indexNodeSize > 0) offset += (0, _packedrtreeJs.calcTreeSize)(featuresCount, indexNodeSize);
    let id = 0;
    while(offset < bb.capacity()){
        const featureLength = bb.readUint32(offset);
        bb.setPosition(offset);
        const feature = (0, _featureJs.Feature).getSizePrefixedRootAsFeature(bb);
        yield fromFeature(id++, feature, headerMeta);
        offset += (0, _constantsJs.SIZE_PREFIX_LEN) + featureLength;
    }
}
async function* deserializeStream(input, ctx) {
    const { fromFeature, headerMetaFn } = ctx;
    const stream = input;
    const reader = (0, _sliceSourceDefault.default)(stream);
    const read = async (size)=>await reader.slice(size);
    let bytes = new Uint8Array(await read(8, 'magic bytes'));
    if (!bytes.subarray(0, 3).every((v, i)=>(0, _constantsJs.magicbytes)[i] === v)) throw new Error('Not a FlatGeobuf file');
    const headerLengthBytes = new Uint8Array(await read(4, 'header length'));
    let bb = new _flatbuffers.ByteBuffer(headerLengthBytes);
    const headerLength = bb.readUint32(0);
    const headerDataBytes = new Uint8Array(await read(headerLength, 'header data'));
    bytes = new Uint8Array(headerLengthBytes.length + headerDataBytes.length);
    bytes.set(headerLengthBytes);
    bytes.set(headerDataBytes, headerLengthBytes.length);
    bb = new _flatbuffers.ByteBuffer(bytes);
    const headerMeta = (0, _headerMetaJs.fromByteBuffer)(bb);
    if (headerMetaFn) headerMetaFn(headerMeta);
    const { indexNodeSize, featuresCount } = headerMeta;
    if (indexNodeSize > 0) {
        const treeSize = (0, _packedrtreeJs.calcTreeSize)(featuresCount, indexNodeSize);
        await read(treeSize, 'entire index, w/o rect');
    }
    let feature;
    let id = 0;
    while(feature = await readFeature(read, headerMeta, fromFeature, id++))yield feature;
}
async function* deserializeFiltered(input, ctx) {
    const { rect, fromFeature, headerMetaFn, nocache = false, headers = {} } = ctx;
    const url = input;
    if (!rect) throw new Error('The "rect" option is required');
    const reader = await (0, _httpReaderJs.HttpReader).open(url, nocache, headers);
    console.debug('opened reader');
    if (headerMetaFn) headerMetaFn(reader.header);
    for await (const feature of reader.selectBbox(rect))yield fromFeature(feature.id, feature.feature, reader.header);
}
async function* deserializeSeekableZstdSource(input, ctx) {
    const { rect, fromFeature, headerMetaFn, nocache = false, headers = {} } = ctx;
    const { SeekableZstdReader } = await require("8608f40db64a5040");
    const source = await SeekableZstdReader.open(input, nocache, headers, browserWasmUrl);
    if (rect) {
        const reader = await (0, _httpReaderJs.HttpReader).openSource(source, nocache, headers);
        if (headerMetaFn) headerMetaFn(reader.header);
        for await (const feature of reader.selectBbox(rect))yield fromFeature(feature.id, feature.feature, reader.header);
        return;
    }
    yield* deserializeStream(source.stream(), ctx);
}
async function readFeature(read, headerMeta, fromFeature, id) {
    let bytes = new Uint8Array(await read(4, 'feature length'));
    if (bytes.byteLength === 0) return;
    let bb = new _flatbuffers.ByteBuffer(bytes);
    const featureLength = bb.readUint32(0);
    bytes = new Uint8Array(await read(featureLength, 'feature data'));
    const bytesAligned = new Uint8Array(featureLength + 4);
    bytesAligned.set(bytes, 4);
    bb = new _flatbuffers.ByteBuffer(bytesAligned);
    const feature = (0, _featureJs.Feature).getSizePrefixedRootAsFeature(bb);
    return fromFeature(id, feature, headerMeta);
}
function buildColumn(builder, column) {
    const nameOffset = builder.createString(column.name);
    (0, _columnJs.Column).startColumn(builder);
    (0, _columnJs.Column).addName(builder, nameOffset);
    (0, _columnJs.Column).addType(builder, column.type);
    return (0, _columnJs.Column).endColumn(builder);
}
function buildHeader(header, crsCode = 0) {
    const builder = new _flatbuffers.Builder();
    let columnOffsets = 0;
    if (header.columns) columnOffsets = (0, _headerJs.Header).createColumnsVector(builder, header.columns.map((c)=>buildColumn(builder, c)));
    const nameOffset = builder.createString('L1');
    let crsOffset;
    if (crsCode) {
        (0, _crsJs.Crs).startCrs(builder);
        (0, _crsJs.Crs).addCode(builder, crsCode);
        crsOffset = (0, _crsJs.Crs).endCrs(builder);
    }
    (0, _headerJs.Header).startHeader(builder);
    if (crsOffset) (0, _headerJs.Header).addCrs(builder, crsOffset);
    (0, _headerJs.Header).addFeaturesCount(builder, BigInt(header.featuresCount));
    (0, _headerJs.Header).addGeometryType(builder, header.geometryType);
    (0, _headerJs.Header).addIndexNodeSize(builder, 0);
    if (columnOffsets) (0, _headerJs.Header).addColumns(builder, columnOffsets);
    (0, _headerJs.Header).addName(builder, nameOffset);
    const offset = (0, _headerJs.Header).endHeader(builder);
    builder.finishSizePrefixed(offset);
    return builder.asUint8Array();
}
async function readMetadata(url, nocache = false, headers = {}) {
    const assumedHeaderLength = 2024;
    const httpClient = new (0, _httpReaderJs.HttpRangeClient)(url, nocache, headers);
    let bytes = new Uint8Array(await httpClient.getRange(0, assumedHeaderLength, 'read metadata'));
    if (!bytes.subarray(0, 3).every((v, i)=>(0, _constantsJs.magicbytes)[i] === v)) throw new Error('Not a FlatGeobuf file');
    const headerLength = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength).getUint32((0, _constantsJs.magicbytes).length, true);
    if (headerLength > (0, _constantsJs.HEADER_MAX_BUFFER_SIZE) || headerLength < 8) throw new Error('Invalid header size');
    const headerEnd = (0, _constantsJs.magicbytes).length + (0, _constantsJs.SIZE_PREFIX_LEN) + headerLength;
    if (bytes.byteLength < headerEnd) bytes = new Uint8Array(await httpClient.getRange(0, headerEnd, 'read metadata'));
    const bb = new _flatbuffers.ByteBuffer(bytes);
    bb.setPosition((0, _constantsJs.magicbytes).length);
    return (0, _headerMetaJs.fromByteBuffer)(bb);
}
function valueToType(value) {
    if (typeof value === 'boolean') return (0, _columnTypeJs.ColumnType).Bool;
    if (typeof value === 'number') return (0, _columnTypeJs.ColumnType).Double;
    if (typeof value === 'string') return (0, _columnTypeJs.ColumnType).String;
    if (value === null) return (0, _columnTypeJs.ColumnType).String;
    if (value instanceof Uint8Array) return (0, _columnTypeJs.ColumnType).Binary;
    if (typeof value === 'object') return (0, _columnTypeJs.ColumnType).Json;
    throw new Error(`Unknown type (value '${value}')`);
}
function mapColumn(properties, k) {
    return {
        name: k,
        type: valueToType(properties[k]),
        title: null,
        description: null,
        width: -1,
        precision: -1,
        scale: -1,
        nullable: true,
        unique: false,
        primary_key: false
    };
}
function introspectHeaderMeta(features) {
    const sampleFeature = features[0];
    const properties = sampleFeature.getProperties ? sampleFeature.getProperties() : {};
    let columns = null;
    if (properties) columns = Object.keys(properties).filter((key)=>key !== 'geometry').map((k)=>mapColumn(properties, k));
    const geometryType = (0, _headerJs1.inferGeometryType)(features);
    const headerMeta = {
        geometryType,
        columns,
        envelope: null,
        featuresCount: features.length,
        indexNodeSize: 0,
        crs: null,
        title: null,
        description: null,
        metadata: null
    };
    return headerMeta;
}

},{"flatbuffers":"4oKPA","slice-source":"lsWGv","../array-reader.js":"fbc8C","../constants.js":"5WAfl","../flat-geobuf/column.js":"5dD9m","../flat-geobuf/column-type.js":"cK2R8","../flat-geobuf/crs.js":"6SSTl","../flat-geobuf/feature.js":"jNs3T","../flat-geobuf/header.js":"8H9JE","../header-meta.js":"eEB1R","../http-reader.js":"1drNw","../packedrtree.js":"JJHpi","./feature.js":"7W11D","./geometry.js":"d9Uo0","./header.js":"iP7qh","8608f40db64a5040":"aQ02q","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"4oKPA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FILE_IDENTIFIER_LENGTH", ()=>(0, _constantsJs.FILE_IDENTIFIER_LENGTH));
parcelHelpers.export(exports, "SIZEOF_INT", ()=>(0, _constantsJs.SIZEOF_INT));
parcelHelpers.export(exports, "SIZEOF_SHORT", ()=>(0, _constantsJs.SIZEOF_SHORT));
parcelHelpers.export(exports, "SIZE_PREFIX_LENGTH", ()=>(0, _constantsJs.SIZE_PREFIX_LENGTH));
parcelHelpers.export(exports, "float32", ()=>(0, _utilsJs.float32));
parcelHelpers.export(exports, "float64", ()=>(0, _utilsJs.float64));
parcelHelpers.export(exports, "int32", ()=>(0, _utilsJs.int32));
parcelHelpers.export(exports, "isLittleEndian", ()=>(0, _utilsJs.isLittleEndian));
parcelHelpers.export(exports, "Builder", ()=>(0, _builderJs.Builder));
parcelHelpers.export(exports, "ByteBuffer", ()=>(0, _byteBufferJs.ByteBuffer));
parcelHelpers.export(exports, "Encoding", ()=>(0, _encodingJs.Encoding));
var _constantsJs = require("./constants.js");
var _utilsJs = require("./utils.js");
var _builderJs = require("./builder.js");
var _byteBufferJs = require("./byte-buffer.js");
var _encodingJs = require("./encoding.js");

},{"./constants.js":"6yHPv","./utils.js":"6z1Dq","./builder.js":"q59gk","./byte-buffer.js":"im5oE","./encoding.js":"5g4kh","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6yHPv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SIZEOF_SHORT", ()=>SIZEOF_SHORT);
parcelHelpers.export(exports, "SIZEOF_INT", ()=>SIZEOF_INT);
parcelHelpers.export(exports, "FILE_IDENTIFIER_LENGTH", ()=>FILE_IDENTIFIER_LENGTH);
parcelHelpers.export(exports, "SIZE_PREFIX_LENGTH", ()=>SIZE_PREFIX_LENGTH);
const SIZEOF_SHORT = 2;
const SIZEOF_INT = 4;
const FILE_IDENTIFIER_LENGTH = 4;
const SIZE_PREFIX_LENGTH = 4;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6z1Dq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "int32", ()=>int32);
parcelHelpers.export(exports, "float32", ()=>float32);
parcelHelpers.export(exports, "float64", ()=>float64);
parcelHelpers.export(exports, "isLittleEndian", ()=>isLittleEndian);
const int32 = new Int32Array(2);
const float32 = new Float32Array(int32.buffer);
const float64 = new Float64Array(int32.buffer);
const isLittleEndian = new Uint16Array(new Uint8Array([
    1,
    0
]).buffer)[0] === 1;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"q59gk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Builder", ()=>Builder);
var _byteBufferJs = require("./byte-buffer.js");
var _constantsJs = require("./constants.js");
class Builder {
    /**
     * Create a FlatBufferBuilder.
     */ constructor(opt_initial_size){
        /** Minimum alignment encountered so far. */ this.minalign = 1;
        /** The vtable for the current table. */ this.vtable = null;
        /** The amount of fields we're actually using. */ this.vtable_in_use = 0;
        /** Whether we are currently serializing a table. */ this.isNested = false;
        /** Starting offset of the current struct/table. */ this.object_start = 0;
        /** List of offsets of all vtables. */ this.vtables = [];
        /** For the current vector being built. */ this.vector_num_elems = 0;
        /** False omits default values from the serialized data */ this.force_defaults = false;
        this.string_maps = null;
        this.text_encoder = new TextEncoder();
        let initial_size;
        if (!opt_initial_size) initial_size = 1024;
        else initial_size = opt_initial_size;
        /**
         * @type {ByteBuffer}
         * @private
         */ this.bb = (0, _byteBufferJs.ByteBuffer).allocate(initial_size);
        this.space = initial_size;
    }
    clear() {
        this.bb.clear();
        this.space = this.bb.capacity();
        this.minalign = 1;
        this.vtable = null;
        this.vtable_in_use = 0;
        this.isNested = false;
        this.object_start = 0;
        this.vtables = [];
        this.vector_num_elems = 0;
        this.force_defaults = false;
        this.string_maps = null;
    }
    /**
     * In order to save space, fields that are set to their default value
     * don't get serialized into the buffer. Forcing defaults provides a
     * way to manually disable this optimization.
     *
     * @param forceDefaults true always serializes default values
     */ forceDefaults(forceDefaults) {
        this.force_defaults = forceDefaults;
    }
    /**
     * Get the ByteBuffer representing the FlatBuffer. Only call this after you've
     * called finish(). The actual data starts at the ByteBuffer's current position,
     * not necessarily at 0.
     */ dataBuffer() {
        return this.bb;
    }
    /**
     * Get the bytes representing the FlatBuffer. Only call this after you've
     * called finish().
     */ asUint8Array() {
        return this.bb.bytes().subarray(this.bb.position(), this.bb.position() + this.offset());
    }
    /**
     * Prepare to write an element of `size` after `additional_bytes` have been
     * written, e.g. if you write a string, you need to align such the int length
     * field is aligned to 4 bytes, and the string data follows it directly. If all
     * you need to do is alignment, `additional_bytes` will be 0.
     *
     * @param size This is the of the new element to write
     * @param additional_bytes The padding size
     */ prep(size, additional_bytes) {
        // Track the biggest thing we've ever aligned to.
        if (size > this.minalign) this.minalign = size;
        // Find the amount of alignment needed such that `size` is properly
        // aligned after `additional_bytes`
        const align_size = ~(this.bb.capacity() - this.space + additional_bytes) + 1 & size - 1;
        // Reallocate the buffer if needed.
        while(this.space < align_size + size + additional_bytes){
            const old_buf_size = this.bb.capacity();
            this.bb = Builder.growByteBuffer(this.bb);
            this.space += this.bb.capacity() - old_buf_size;
        }
        this.pad(align_size);
    }
    pad(byte_size) {
        for(let i = 0; i < byte_size; i++)this.bb.writeInt8(--this.space, 0);
    }
    writeInt8(value) {
        this.bb.writeInt8(this.space -= 1, value);
    }
    writeInt16(value) {
        this.bb.writeInt16(this.space -= 2, value);
    }
    writeInt32(value) {
        this.bb.writeInt32(this.space -= 4, value);
    }
    writeInt64(value) {
        this.bb.writeInt64(this.space -= 8, value);
    }
    writeFloat32(value) {
        this.bb.writeFloat32(this.space -= 4, value);
    }
    writeFloat64(value) {
        this.bb.writeFloat64(this.space -= 8, value);
    }
    /**
     * Add an `int8` to the buffer, properly aligned, and grows the buffer (if necessary).
     * @param value The `int8` to add the buffer.
     */ addInt8(value) {
        this.prep(1, 0);
        this.writeInt8(value);
    }
    /**
     * Add an `int16` to the buffer, properly aligned, and grows the buffer (if necessary).
     * @param value The `int16` to add the buffer.
     */ addInt16(value) {
        this.prep(2, 0);
        this.writeInt16(value);
    }
    /**
     * Add an `int32` to the buffer, properly aligned, and grows the buffer (if necessary).
     * @param value The `int32` to add the buffer.
     */ addInt32(value) {
        this.prep(4, 0);
        this.writeInt32(value);
    }
    /**
     * Add an `int64` to the buffer, properly aligned, and grows the buffer (if necessary).
     * @param value The `int64` to add the buffer.
     */ addInt64(value) {
        this.prep(8, 0);
        this.writeInt64(value);
    }
    /**
     * Add a `float32` to the buffer, properly aligned, and grows the buffer (if necessary).
     * @param value The `float32` to add the buffer.
     */ addFloat32(value) {
        this.prep(4, 0);
        this.writeFloat32(value);
    }
    /**
     * Add a `float64` to the buffer, properly aligned, and grows the buffer (if necessary).
     * @param value The `float64` to add the buffer.
     */ addFloat64(value) {
        this.prep(8, 0);
        this.writeFloat64(value);
    }
    addFieldInt8(voffset, value, defaultValue) {
        if (this.force_defaults || value != defaultValue) {
            this.addInt8(value);
            this.slot(voffset);
        }
    }
    addFieldInt16(voffset, value, defaultValue) {
        if (this.force_defaults || value != defaultValue) {
            this.addInt16(value);
            this.slot(voffset);
        }
    }
    addFieldInt32(voffset, value, defaultValue) {
        if (this.force_defaults || value != defaultValue) {
            this.addInt32(value);
            this.slot(voffset);
        }
    }
    addFieldInt64(voffset, value, defaultValue) {
        if (this.force_defaults || value !== defaultValue) {
            this.addInt64(value);
            this.slot(voffset);
        }
    }
    addFieldFloat32(voffset, value, defaultValue) {
        if (this.force_defaults || value != defaultValue) {
            this.addFloat32(value);
            this.slot(voffset);
        }
    }
    addFieldFloat64(voffset, value, defaultValue) {
        if (this.force_defaults || value != defaultValue) {
            this.addFloat64(value);
            this.slot(voffset);
        }
    }
    addFieldOffset(voffset, value, defaultValue) {
        if (this.force_defaults || value != defaultValue) {
            this.addOffset(value);
            this.slot(voffset);
        }
    }
    /**
     * Structs are stored inline, so nothing additional is being added. `d` is always 0.
     */ addFieldStruct(voffset, value, defaultValue) {
        if (value != defaultValue) {
            this.nested(value);
            this.slot(voffset);
        }
    }
    /**
     * Structures are always stored inline, they need to be created right
     * where they're used.  You'll get this assertion failure if you
     * created it elsewhere.
     */ nested(obj) {
        if (obj != this.offset()) throw new TypeError('FlatBuffers: struct must be serialized inline.');
    }
    /**
     * Should not be creating any other object, string or vector
     * while an object is being constructed
     */ notNested() {
        if (this.isNested) throw new TypeError('FlatBuffers: object serialization must not be nested.');
    }
    /**
     * Set the current vtable at `voffset` to the current location in the buffer.
     */ slot(voffset) {
        if (this.vtable !== null) this.vtable[voffset] = this.offset();
    }
    /**
     * @returns Offset relative to the end of the buffer.
     */ offset() {
        return this.bb.capacity() - this.space;
    }
    /**
     * Doubles the size of the backing ByteBuffer and copies the old data towards
     * the end of the new buffer (since we build the buffer backwards).
     *
     * @param bb The current buffer with the existing data
     * @returns A new byte buffer with the old data copied
     * to it. The data is located at the end of the buffer.
     *
     * uint8Array.set() formally takes {Array<number>|ArrayBufferView}, so to pass
     * it a uint8Array we need to suppress the type check:
     * @suppress {checkTypes}
     */ static growByteBuffer(bb) {
        const old_buf_size = bb.capacity();
        // Ensure we don't grow beyond what fits in an int.
        if (old_buf_size & 0xc0000000) throw new Error('FlatBuffers: cannot grow buffer beyond 2 gigabytes.');
        const new_buf_size = old_buf_size << 1;
        const nbb = (0, _byteBufferJs.ByteBuffer).allocate(new_buf_size);
        nbb.setPosition(new_buf_size - old_buf_size);
        nbb.bytes().set(bb.bytes(), new_buf_size - old_buf_size);
        return nbb;
    }
    /**
     * Adds on offset, relative to where it will be written.
     *
     * @param offset The offset to add.
     */ addOffset(offset) {
        this.prep((0, _constantsJs.SIZEOF_INT), 0); // Ensure alignment is already done.
        this.writeInt32(this.offset() - offset + (0, _constantsJs.SIZEOF_INT));
    }
    /**
     * Start encoding a new object in the buffer.  Users will not usually need to
     * call this directly. The FlatBuffers compiler will generate helper methods
     * that call this method internally.
     */ startObject(numfields) {
        this.notNested();
        if (this.vtable == null) this.vtable = [];
        this.vtable_in_use = numfields;
        for(let i = 0; i < numfields; i++)this.vtable[i] = 0; // This will push additional elements as needed
        this.isNested = true;
        this.object_start = this.offset();
    }
    /**
     * Finish off writing the object that is under construction.
     *
     * @returns The offset to the object inside `dataBuffer`
     */ endObject() {
        if (this.vtable == null || !this.isNested) throw new Error('FlatBuffers: endObject called without startObject');
        this.addInt32(0);
        const vtableloc = this.offset();
        // Trim trailing zeroes.
        let i = this.vtable_in_use - 1;
        // eslint-disable-next-line no-empty
        for(; i >= 0 && this.vtable[i] == 0; i--);
        const trimmed_size = i + 1;
        // Write out the current vtable.
        for(; i >= 0; i--)// Offset relative to the start of the table.
        this.addInt16(this.vtable[i] != 0 ? vtableloc - this.vtable[i] : 0);
        const standard_fields = 2; // The fields below:
        this.addInt16(vtableloc - this.object_start);
        const len = (trimmed_size + standard_fields) * (0, _constantsJs.SIZEOF_SHORT);
        this.addInt16(len);
        // Search for an existing vtable that matches the current one.
        let existing_vtable = 0;
        const vt1 = this.space;
        outer_loop: for(i = 0; i < this.vtables.length; i++){
            const vt2 = this.bb.capacity() - this.vtables[i];
            if (len == this.bb.readInt16(vt2)) {
                for(let j = (0, _constantsJs.SIZEOF_SHORT); j < len; j += (0, _constantsJs.SIZEOF_SHORT)){
                    if (this.bb.readInt16(vt1 + j) != this.bb.readInt16(vt2 + j)) continue outer_loop;
                }
                existing_vtable = this.vtables[i];
                break;
            }
        }
        if (existing_vtable) {
            // Found a match:
            // Remove the current vtable.
            this.space = this.bb.capacity() - vtableloc;
            // Point table to existing vtable.
            this.bb.writeInt32(this.space, existing_vtable - vtableloc);
        } else {
            // No match:
            // Add the location of the current vtable to the list of vtables.
            this.vtables.push(this.offset());
            // Point table to current vtable.
            this.bb.writeInt32(this.bb.capacity() - vtableloc, this.offset() - vtableloc);
        }
        this.isNested = false;
        return vtableloc;
    }
    /**
     * Finalize a buffer, poiting to the given `root_table`.
     */ finish(root_table, opt_file_identifier, opt_size_prefix) {
        const size_prefix = opt_size_prefix ? (0, _constantsJs.SIZE_PREFIX_LENGTH) : 0;
        if (opt_file_identifier) {
            const file_identifier = opt_file_identifier;
            this.prep(this.minalign, (0, _constantsJs.SIZEOF_INT) + (0, _constantsJs.FILE_IDENTIFIER_LENGTH) + size_prefix);
            if (file_identifier.length != (0, _constantsJs.FILE_IDENTIFIER_LENGTH)) throw new TypeError('FlatBuffers: file identifier must be length ' + (0, _constantsJs.FILE_IDENTIFIER_LENGTH));
            for(let i = (0, _constantsJs.FILE_IDENTIFIER_LENGTH) - 1; i >= 0; i--)this.writeInt8(file_identifier.charCodeAt(i));
        }
        this.prep(this.minalign, (0, _constantsJs.SIZEOF_INT) + size_prefix);
        this.addOffset(root_table);
        if (size_prefix) this.addInt32(this.bb.capacity() - this.space);
        this.bb.setPosition(this.space);
    }
    /**
     * Finalize a size prefixed buffer, pointing to the given `root_table`.
     */ finishSizePrefixed(root_table, opt_file_identifier) {
        this.finish(root_table, opt_file_identifier, true);
    }
    /**
     * This checks a required field has been set in a given table that has
     * just been constructed.
     */ requiredField(table, field) {
        const table_start = this.bb.capacity() - table;
        const vtable_start = table_start - this.bb.readInt32(table_start);
        const ok = field < this.bb.readInt16(vtable_start) && this.bb.readInt16(vtable_start + field) != 0;
        // If this fails, the caller will show what field needs to be set.
        if (!ok) throw new TypeError('FlatBuffers: field ' + field + ' must be set');
    }
    /**
     * Start a new array/vector of objects.  Users usually will not call
     * this directly. The FlatBuffers compiler will create a start/end
     * method for vector types in generated code.
     *
     * @param elem_size The size of each element in the array
     * @param num_elems The number of elements in the array
     * @param alignment The alignment of the array
     */ startVector(elem_size, num_elems, alignment) {
        this.notNested();
        this.vector_num_elems = num_elems;
        this.prep((0, _constantsJs.SIZEOF_INT), elem_size * num_elems);
        this.prep(alignment, elem_size * num_elems); // Just in case alignment > int.
    }
    /**
     * Finish off the creation of an array and all its elements. The array must be
     * created with `startVector`.
     *
     * @returns The offset at which the newly created array
     * starts.
     */ endVector() {
        this.writeInt32(this.vector_num_elems);
        return this.offset();
    }
    /**
     * Encode the string `s` in the buffer using UTF-8. If the string passed has
     * already been seen, we return the offset of the already written string
     *
     * @param s The string to encode
     * @return The offset in the buffer where the encoded string starts
     */ createSharedString(s) {
        if (!s) return 0;
        if (!this.string_maps) this.string_maps = new Map();
        if (this.string_maps.has(s)) return this.string_maps.get(s);
        const offset = this.createString(s);
        this.string_maps.set(s, offset);
        return offset;
    }
    /**
     * Encode the string `s` in the buffer using UTF-8. If a Uint8Array is passed
     * instead of a string, it is assumed to contain valid UTF-8 encoded data.
     *
     * @param s The string to encode
     * @return The offset in the buffer where the encoded string starts
     */ createString(s) {
        if (s === null || s === undefined) return 0;
        let utf8;
        if (s instanceof Uint8Array) utf8 = s;
        else utf8 = this.text_encoder.encode(s);
        this.addInt8(0);
        this.startVector(1, utf8.length, 1);
        this.bb.setPosition(this.space -= utf8.length);
        this.bb.bytes().set(utf8, this.space);
        return this.endVector();
    }
    /**
     * Create a byte vector.
     *
     * @param v The bytes to add
     * @returns The offset in the buffer where the byte vector starts
     */ createByteVector(v) {
        if (v === null || v === undefined) return 0;
        this.startVector(1, v.length, 1);
        this.bb.setPosition(this.space -= v.length);
        this.bb.bytes().set(v, this.space);
        return this.endVector();
    }
    /**
     * A helper function to pack an object
     *
     * @returns offset of obj
     */ createObjectOffset(obj) {
        if (obj === null) return 0;
        if (typeof obj === 'string') return this.createString(obj);
        else return obj.pack(this);
    }
    /**
     * A helper function to pack a list of object
     *
     * @returns list of offsets of each non null object
     */ createObjectOffsetList(list) {
        const ret = [];
        for(let i = 0; i < list.length; ++i){
            const val = list[i];
            if (val !== null) ret.push(this.createObjectOffset(val));
            else throw new TypeError('FlatBuffers: Argument for createObjectOffsetList cannot contain null.');
        }
        return ret;
    }
    createStructOffsetList(list, startFunc) {
        startFunc(this, list.length);
        this.createObjectOffsetList(list.slice().reverse());
        return this.endVector();
    }
}

},{"./byte-buffer.js":"im5oE","./constants.js":"6yHPv","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"im5oE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ByteBuffer", ()=>ByteBuffer);
var _constantsJs = require("./constants.js");
var _encodingJs = require("./encoding.js");
var _utilsJs = require("./utils.js");
class ByteBuffer {
    /**
     * Create a new ByteBuffer with a given array of bytes (`Uint8Array`)
     */ constructor(bytes_){
        this.bytes_ = bytes_;
        this.position_ = 0;
        this.text_decoder_ = new TextDecoder();
    }
    /**
     * Create and allocate a new ByteBuffer with a given size.
     */ static allocate(byte_size) {
        return new ByteBuffer(new Uint8Array(byte_size));
    }
    clear() {
        this.position_ = 0;
    }
    /**
     * Get the underlying `Uint8Array`.
     */ bytes() {
        return this.bytes_;
    }
    /**
     * Get the buffer's position.
     */ position() {
        return this.position_;
    }
    /**
     * Set the buffer's position.
     */ setPosition(position) {
        this.position_ = position;
    }
    /**
     * Get the buffer's capacity.
     */ capacity() {
        return this.bytes_.length;
    }
    readInt8(offset) {
        return this.readUint8(offset) << 24 >> 24;
    }
    readUint8(offset) {
        return this.bytes_[offset];
    }
    readInt16(offset) {
        return this.readUint16(offset) << 16 >> 16;
    }
    readUint16(offset) {
        return this.bytes_[offset] | this.bytes_[offset + 1] << 8;
    }
    readInt32(offset) {
        return this.bytes_[offset] | this.bytes_[offset + 1] << 8 | this.bytes_[offset + 2] << 16 | this.bytes_[offset + 3] << 24;
    }
    readUint32(offset) {
        return this.readInt32(offset) >>> 0;
    }
    readInt64(offset) {
        return BigInt.asIntN(64, BigInt(this.readUint32(offset)) + (BigInt(this.readUint32(offset + 4)) << BigInt(32)));
    }
    readUint64(offset) {
        return BigInt.asUintN(64, BigInt(this.readUint32(offset)) + (BigInt(this.readUint32(offset + 4)) << BigInt(32)));
    }
    readFloat32(offset) {
        (0, _utilsJs.int32)[0] = this.readInt32(offset);
        return (0, _utilsJs.float32)[0];
    }
    readFloat64(offset) {
        (0, _utilsJs.int32)[(0, _utilsJs.isLittleEndian) ? 0 : 1] = this.readInt32(offset);
        (0, _utilsJs.int32)[(0, _utilsJs.isLittleEndian) ? 1 : 0] = this.readInt32(offset + 4);
        return (0, _utilsJs.float64)[0];
    }
    writeInt8(offset, value) {
        this.bytes_[offset] = value;
    }
    writeUint8(offset, value) {
        this.bytes_[offset] = value;
    }
    writeInt16(offset, value) {
        this.bytes_[offset] = value;
        this.bytes_[offset + 1] = value >> 8;
    }
    writeUint16(offset, value) {
        this.bytes_[offset] = value;
        this.bytes_[offset + 1] = value >> 8;
    }
    writeInt32(offset, value) {
        this.bytes_[offset] = value;
        this.bytes_[offset + 1] = value >> 8;
        this.bytes_[offset + 2] = value >> 16;
        this.bytes_[offset + 3] = value >> 24;
    }
    writeUint32(offset, value) {
        this.bytes_[offset] = value;
        this.bytes_[offset + 1] = value >> 8;
        this.bytes_[offset + 2] = value >> 16;
        this.bytes_[offset + 3] = value >> 24;
    }
    writeInt64(offset, value) {
        this.writeInt32(offset, Number(BigInt.asIntN(32, value)));
        this.writeInt32(offset + 4, Number(BigInt.asIntN(32, value >> BigInt(32))));
    }
    writeUint64(offset, value) {
        this.writeUint32(offset, Number(BigInt.asUintN(32, value)));
        this.writeUint32(offset + 4, Number(BigInt.asUintN(32, value >> BigInt(32))));
    }
    writeFloat32(offset, value) {
        (0, _utilsJs.float32)[0] = value;
        this.writeInt32(offset, (0, _utilsJs.int32)[0]);
    }
    writeFloat64(offset, value) {
        (0, _utilsJs.float64)[0] = value;
        this.writeInt32(offset, (0, _utilsJs.int32)[(0, _utilsJs.isLittleEndian) ? 0 : 1]);
        this.writeInt32(offset + 4, (0, _utilsJs.int32)[(0, _utilsJs.isLittleEndian) ? 1 : 0]);
    }
    /**
     * Return the file identifier.   Behavior is undefined for FlatBuffers whose
     * schema does not include a file_identifier (likely points at padding or the
     * start of a the root vtable).
     */ getBufferIdentifier() {
        if (this.bytes_.length < this.position_ + (0, _constantsJs.SIZEOF_INT) + (0, _constantsJs.FILE_IDENTIFIER_LENGTH)) throw new Error('FlatBuffers: ByteBuffer is too short to contain an identifier.');
        let result = '';
        for(let i = 0; i < (0, _constantsJs.FILE_IDENTIFIER_LENGTH); i++)result += String.fromCharCode(this.readInt8(this.position_ + (0, _constantsJs.SIZEOF_INT) + i));
        return result;
    }
    /**
     * Look up a field in the vtable, return an offset into the object, or 0 if the
     * field is not present.
     */ __offset(bb_pos, vtable_offset) {
        const vtable = bb_pos - this.readInt32(bb_pos);
        return vtable_offset < this.readInt16(vtable) ? this.readInt16(vtable + vtable_offset) : 0;
    }
    /**
     * Initialize any Table-derived type to point to the union at the given offset.
     */ __union(t, offset) {
        t.bb_pos = offset + this.readInt32(offset);
        t.bb = this;
        return t;
    }
    /**
     * Create a JavaScript string from UTF-8 data stored inside the FlatBuffer.
     * This allocates a new string and converts to wide chars upon each access.
     *
     * To avoid the conversion to string, pass Encoding.UTF8_BYTES as the
     * "optionalEncoding" argument. This is useful for avoiding conversion when
     * the data will just be packaged back up in another FlatBuffer later on.
     *
     * @param offset
     * @param opt_encoding Defaults to UTF16_STRING
     */ __string(offset, opt_encoding) {
        offset += this.readInt32(offset);
        const length = this.readInt32(offset);
        offset += (0, _constantsJs.SIZEOF_INT);
        const utf8bytes = this.bytes_.subarray(offset, offset + length);
        if (opt_encoding === (0, _encodingJs.Encoding).UTF8_BYTES) return utf8bytes;
        else return this.text_decoder_.decode(utf8bytes);
    }
    /**
     * Handle unions that can contain string as its member, if a Table-derived type then initialize it,
     * if a string then return a new one
     *
     * WARNING: strings are immutable in JS so we can't change the string that the user gave us, this
     * makes the behaviour of __union_with_string different compared to __union
     */ __union_with_string(o, offset) {
        if (typeof o === 'string') return this.__string(offset);
        return this.__union(o, offset);
    }
    /**
     * Retrieve the relative offset stored at "offset"
     */ __indirect(offset) {
        return offset + this.readInt32(offset);
    }
    /**
     * Get the start of data of a vector whose offset is stored at "offset" in this object.
     */ __vector(offset) {
        return offset + this.readInt32(offset) + (0, _constantsJs.SIZEOF_INT); // data starts after the length
    }
    /**
     * Get the length of a vector whose offset is stored at "offset" in this object.
     */ __vector_len(offset) {
        return this.readInt32(offset + this.readInt32(offset));
    }
    __has_identifier(ident) {
        if (ident.length != (0, _constantsJs.FILE_IDENTIFIER_LENGTH)) throw new Error('FlatBuffers: file identifier must be length ' + (0, _constantsJs.FILE_IDENTIFIER_LENGTH));
        for(let i = 0; i < (0, _constantsJs.FILE_IDENTIFIER_LENGTH); i++){
            if (ident.charCodeAt(i) != this.readInt8(this.position() + (0, _constantsJs.SIZEOF_INT) + i)) return false;
        }
        return true;
    }
    /**
     * A helper function for generating list for obj api
     */ createScalarList(listAccessor, listLength) {
        const ret = [];
        for(let i = 0; i < listLength; ++i){
            const val = listAccessor(i);
            if (val !== null) ret.push(val);
        }
        return ret;
    }
    /**
     * A helper function for generating list for obj api
     * @param listAccessor function that accepts an index and return data at that index
     * @param listLength listLength
     * @param res result list
     */ createObjList(listAccessor, listLength) {
        const ret = [];
        for(let i = 0; i < listLength; ++i){
            const val = listAccessor(i);
            if (val !== null) ret.push(val.unpack());
        }
        return ret;
    }
}

},{"./constants.js":"6yHPv","./encoding.js":"5g4kh","./utils.js":"6z1Dq","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5g4kh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Encoding", ()=>Encoding);
var Encoding;
(function(Encoding) {
    Encoding[Encoding["UTF8_BYTES"] = 1] = "UTF8_BYTES";
    Encoding[Encoding["UTF16_STRING"] = 2] = "UTF16_STRING";
})(Encoding || (Encoding = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"lsWGv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>slice);
var _empty = require("./empty");
var _emptyDefault = parcelHelpers.interopDefault(_empty);
var _cancel = require("./cancel");
var _cancelDefault = parcelHelpers.interopDefault(_cancel);
var _read = require("./read");
var _readDefault = parcelHelpers.interopDefault(_read);
var _slice = require("./slice");
var _sliceDefault = parcelHelpers.interopDefault(_slice);
function slice(source) {
    return typeof source.slice === "function" ? source : new SliceSource(typeof source.read === "function" ? source : source.getReader());
}
function SliceSource(source) {
    this._source = source;
    this._array = (0, _emptyDefault.default);
    this._index = 0;
}
SliceSource.prototype.read = (0, _readDefault.default);
SliceSource.prototype.slice = (0, _sliceDefault.default);
SliceSource.prototype.cancel = (0, _cancelDefault.default);

},{"./empty":"c0GuT","./cancel":"2TDkg","./read":"30VcB","./slice":"gob4C","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"c0GuT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = new Uint8Array(0);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2TDkg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this._source.cancel();
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"30VcB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var that = this, array = that._array.subarray(that._index);
        return that._source.read().then(function(result) {
            that._array = (0, _emptyDefault.default);
            that._index = 0;
            return result.done ? array.length > 0 ? {
                done: false,
                value: array
            } : {
                done: true,
                value: undefined
            } : {
                done: false,
                value: (0, _concatDefault.default)(array, result.value)
            };
        });
    });
var _concat = require("./concat");
var _concatDefault = parcelHelpers.interopDefault(_concat);
var _empty = require("./empty");
var _emptyDefault = parcelHelpers.interopDefault(_empty);

},{"./concat":"bNLI5","./empty":"c0GuT","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"bNLI5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>concat);
function concat(a, b) {
    if (!a.length) return b;
    if (!b.length) return a;
    var c = new Uint8Array(a.length + b.length);
    c.set(a);
    c.set(b, a.length);
    return c;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gob4C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(length) {
        if ((length |= 0) < 0) throw new Error("invalid length");
        var that = this, index = this._array.length - this._index;
        // If the request fits within the remaining buffer, resolve it immediately.
        if (this._index + length <= this._array.length) return Promise.resolve(this._array.subarray(this._index, this._index += length));
        // Otherwise, read chunks repeatedly until the request is fulfilled.
        var array = new Uint8Array(length);
        array.set(this._array.subarray(this._index));
        return function read() {
            return that._source.read().then(function(result) {
                // When done, it’s possible the request wasn’t fully fullfilled!
                // If so, the pre-allocated array is too big and needs slicing.
                if (result.done) {
                    that._array = (0, _emptyDefault.default);
                    that._index = 0;
                    return index > 0 ? array.subarray(0, index) : null;
                }
                // If this chunk fulfills the request, return the resulting array.
                if (index + result.value.length >= length) {
                    that._array = result.value;
                    that._index = length - index;
                    array.set(result.value.subarray(0, length - index), index);
                    return array;
                }
                // Otherwise copy this chunk into the array, then read the next chunk.
                array.set(result.value, index);
                index += result.value.length;
                return read();
            });
        }();
    });
var _empty = require("./empty");
var _emptyDefault = parcelHelpers.interopDefault(_empty);

},{"./empty":"c0GuT","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fbc8C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArrayReader", ()=>ArrayReader);
var _flatbuffers = require("flatbuffers");
var _constantsJs = require("./constants.js");
var _featureJs = require("./flat-geobuf/feature.js");
var _headerMetaJs = require("./header-meta.js");
var _packedrtreeJs = require("./packedrtree.js");
class ArrayReader {
    bytes;
    header;
    headerLength;
    indexLength;
    constructor(bytes, header, headerLength, indexLength){
        this.bytes = bytes;
        this.header = header;
        this.headerLength = headerLength;
        this.indexLength = indexLength;
    }
    static open(bytes) {
        if (!bytes.subarray(0, 3).every((v, i)=>(0, _constantsJs.magicbytes)[i] === v)) throw new Error('Not a FlatGeobuf file');
        const headerLength = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength).getUint32((0, _constantsJs.magicbytes).length, true);
        if (headerLength > (0, _constantsJs.HEADER_MAX_BUFFER_SIZE) || headerLength < 8) throw new Error('Invalid header size');
        const headerBytes = bytes.subarray((0, _constantsJs.magicbytes).length, (0, _constantsJs.magicbytes).length + (0, _constantsJs.SIZE_PREFIX_LEN) + headerLength);
        const bb = new _flatbuffers.ByteBuffer(headerBytes);
        const header = (0, _headerMetaJs.fromByteBuffer)(bb);
        const { featuresCount, indexNodeSize } = header;
        const indexLength = indexNodeSize > 0 ? (0, _packedrtreeJs.calcTreeSize)(featuresCount, indexNodeSize) : 0;
        return new ArrayReader(bytes, header, headerLength, indexLength);
    }
    async *selectBbox(rect) {
        if (this.header.indexNodeSize === 0) throw new Error('No index found, cannot read features filtered by bbox');
        const lengthBeforeTree = this.lengthBeforeTree();
        const readNode = async (offsetIntoTree, size)=>{
            const start = lengthBeforeTree + offsetIntoTree;
            return new Uint8Array(this.bytes.subarray(start, start + size)).buffer;
        };
        for await (const searchResult of (0, _packedrtreeJs.streamSearch)(this.header.featuresCount, this.header.indexNodeSize, rect, readNode)){
            const [featureOffset, featureIdx] = searchResult;
            const feature = this.readFeature(featureOffset);
            yield {
                id: featureIdx,
                feature
            };
        }
    }
    lengthBeforeTree() {
        return (0, _constantsJs.magicbytes).length + (0, _constantsJs.SIZE_PREFIX_LEN) + this.headerLength;
    }
    lengthBeforeFeatures() {
        return this.lengthBeforeTree() + this.indexLength;
    }
    readFeature(featureOffset) {
        const offset = featureOffset + this.lengthBeforeFeatures();
        const featureLength = new DataView(this.bytes.buffer, this.bytes.byteOffset, this.bytes.byteLength).getUint32(offset, true);
        const featureBytes = this.bytes.subarray(offset + 4, offset + 4 + featureLength);
        const bytesAligned = new Uint8Array(featureLength + (0, _constantsJs.SIZE_PREFIX_LEN));
        bytesAligned.set(featureBytes, (0, _constantsJs.SIZE_PREFIX_LEN));
        const bb = new _flatbuffers.ByteBuffer(bytesAligned);
        return (0, _featureJs.Feature).getSizePrefixedRootAsFeature(bb);
    }
}

},{"flatbuffers":"4oKPA","./constants.js":"5WAfl","./flat-geobuf/feature.js":"jNs3T","./header-meta.js":"eEB1R","./packedrtree.js":"JJHpi","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5WAfl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "magicbytes", ()=>magicbytes);
parcelHelpers.export(exports, "SIZE_PREFIX_LEN", ()=>SIZE_PREFIX_LEN);
parcelHelpers.export(exports, "HEADER_MAX_BUFFER_SIZE", ()=>HEADER_MAX_BUFFER_SIZE);
const magicbytes = new Uint8Array([
    0x66,
    0x67,
    0x62,
    0x03,
    0x66,
    0x67,
    0x62,
    0x00
]);
const SIZE_PREFIX_LEN = 4;
const HEADER_MAX_BUFFER_SIZE = 10485760;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"jNs3T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Feature", ()=>Feature);
var _flatbuffers = require("flatbuffers");
var _columnJs = require("../flat-geobuf/column.js");
var _geometryJs = require("../flat-geobuf/geometry.js");
class Feature {
    bb = null;
    bb_pos = 0;
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsFeature(bb, obj) {
        return (obj || new Feature()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsFeature(bb, obj) {
        bb.setPosition(bb.position() + _flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new Feature()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    geometry(obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new (0, _geometryJs.Geometry)()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    properties(index) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
    }
    propertiesLength() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    propertiesArray() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    columns(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? (obj || new (0, _columnJs.Column)()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    columnsLength() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    static startFeature(builder) {
        builder.startObject(3);
    }
    static addGeometry(builder, geometryOffset) {
        builder.addFieldOffset(0, geometryOffset, 0);
    }
    static addProperties(builder, propertiesOffset) {
        builder.addFieldOffset(1, propertiesOffset, 0);
    }
    static createPropertiesVector(builder, data) {
        builder.startVector(1, data.length, 1);
        for(let i = data.length - 1; i >= 0; i--)builder.addInt8(data[i]);
        return builder.endVector();
    }
    static startPropertiesVector(builder, numElems) {
        builder.startVector(1, numElems, 1);
    }
    static addColumns(builder, columnsOffset) {
        builder.addFieldOffset(2, columnsOffset, 0);
    }
    static createColumnsVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for(let i = data.length - 1; i >= 0; i--)builder.addOffset(data[i]);
        return builder.endVector();
    }
    static startColumnsVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static endFeature(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static finishFeatureBuffer(builder, offset) {
        builder.finish(offset);
    }
    static finishSizePrefixedFeatureBuffer(builder, offset) {
        builder.finish(offset, undefined, true);
    }
    static createFeature(builder, geometryOffset, propertiesOffset, columnsOffset) {
        Feature.startFeature(builder);
        Feature.addGeometry(builder, geometryOffset);
        Feature.addProperties(builder, propertiesOffset);
        Feature.addColumns(builder, columnsOffset);
        return Feature.endFeature(builder);
    }
}

},{"flatbuffers":"4oKPA","../flat-geobuf/column.js":"5dD9m","../flat-geobuf/geometry.js":"gVFcX","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5dD9m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Column", ()=>Column);
var _flatbuffers = require("flatbuffers");
var _columnTypeJs = require("../flat-geobuf/column-type.js");
class Column {
    bb = null;
    bb_pos = 0;
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsColumn(bb, obj) {
        return (obj || new Column()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsColumn(bb, obj) {
        bb.setPosition(bb.position() + _flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new Column()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    name(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    type() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : (0, _columnTypeJs.ColumnType).Byte;
    }
    title(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    description(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    width() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.readInt32(this.bb_pos + offset) : -1;
    }
    precision() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? this.bb.readInt32(this.bb_pos + offset) : -1;
    }
    scale() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? this.bb.readInt32(this.bb_pos + offset) : -1;
    }
    nullable() {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : true;
    }
    unique() {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    primaryKey() {
        const offset = this.bb.__offset(this.bb_pos, 22);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    metadata(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 24);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    static startColumn(builder) {
        builder.startObject(11);
    }
    static addName(builder, nameOffset) {
        builder.addFieldOffset(0, nameOffset, 0);
    }
    static addType(builder, type) {
        builder.addFieldInt8(1, type, (0, _columnTypeJs.ColumnType).Byte);
    }
    static addTitle(builder, titleOffset) {
        builder.addFieldOffset(2, titleOffset, 0);
    }
    static addDescription(builder, descriptionOffset) {
        builder.addFieldOffset(3, descriptionOffset, 0);
    }
    static addWidth(builder, width) {
        builder.addFieldInt32(4, width, -1);
    }
    static addPrecision(builder, precision) {
        builder.addFieldInt32(5, precision, -1);
    }
    static addScale(builder, scale) {
        builder.addFieldInt32(6, scale, -1);
    }
    static addNullable(builder, nullable) {
        builder.addFieldInt8(7, +nullable, 1);
    }
    static addUnique(builder, unique) {
        builder.addFieldInt8(8, +unique, 0);
    }
    static addPrimaryKey(builder, primaryKey) {
        builder.addFieldInt8(9, +primaryKey, 0);
    }
    static addMetadata(builder, metadataOffset) {
        builder.addFieldOffset(10, metadataOffset, 0);
    }
    static endColumn(builder) {
        const offset = builder.endObject();
        builder.requiredField(offset, 4);
        return offset;
    }
    static createColumn(builder, nameOffset, type, titleOffset, descriptionOffset, width, precision, scale, nullable, unique, primaryKey, metadataOffset) {
        Column.startColumn(builder);
        Column.addName(builder, nameOffset);
        Column.addType(builder, type);
        Column.addTitle(builder, titleOffset);
        Column.addDescription(builder, descriptionOffset);
        Column.addWidth(builder, width);
        Column.addPrecision(builder, precision);
        Column.addScale(builder, scale);
        Column.addNullable(builder, nullable);
        Column.addUnique(builder, unique);
        Column.addPrimaryKey(builder, primaryKey);
        Column.addMetadata(builder, metadataOffset);
        return Column.endColumn(builder);
    }
}

},{"flatbuffers":"4oKPA","../flat-geobuf/column-type.js":"cK2R8","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"cK2R8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColumnType", ()=>ColumnType);
var ColumnType;
(function(ColumnType) {
    ColumnType[ColumnType["Byte"] = 0] = "Byte";
    ColumnType[ColumnType["UByte"] = 1] = "UByte";
    ColumnType[ColumnType["Bool"] = 2] = "Bool";
    ColumnType[ColumnType["Short"] = 3] = "Short";
    ColumnType[ColumnType["UShort"] = 4] = "UShort";
    ColumnType[ColumnType["Int"] = 5] = "Int";
    ColumnType[ColumnType["UInt"] = 6] = "UInt";
    ColumnType[ColumnType["Long"] = 7] = "Long";
    ColumnType[ColumnType["ULong"] = 8] = "ULong";
    ColumnType[ColumnType["Float"] = 9] = "Float";
    ColumnType[ColumnType["Double"] = 10] = "Double";
    ColumnType[ColumnType["String"] = 11] = "String";
    ColumnType[ColumnType["Json"] = 12] = "Json";
    ColumnType[ColumnType["DateTime"] = 13] = "DateTime";
    ColumnType[ColumnType["Binary"] = 14] = "Binary";
})(ColumnType || (ColumnType = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gVFcX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Geometry", ()=>Geometry);
var _flatbuffers = require("flatbuffers");
var _geometryTypeJs = require("../flat-geobuf/geometry-type.js");
class Geometry {
    bb = null;
    bb_pos = 0;
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsGeometry(bb, obj) {
        return (obj || new Geometry()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsGeometry(bb, obj) {
        bb.setPosition(bb.position() + _flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new Geometry()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    ends(index) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
    }
    endsLength() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    endsArray() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    xy(index) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readFloat64(this.bb.__vector(this.bb_pos + offset) + index * 8) : 0;
    }
    xyLength() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    xyArray() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? new Float64Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    z(index) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readFloat64(this.bb.__vector(this.bb_pos + offset) + index * 8) : 0;
    }
    zLength() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    zArray() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? new Float64Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    m(index) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.readFloat64(this.bb.__vector(this.bb_pos + offset) + index * 8) : 0;
    }
    mLength() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    mArray() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? new Float64Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    t(index) {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.readFloat64(this.bb.__vector(this.bb_pos + offset) + index * 8) : 0;
    }
    tLength() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    tArray() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? new Float64Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    tm(index) {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? this.bb.readUint64(this.bb.__vector(this.bb_pos + offset) + index * 8) : BigInt(0);
    }
    tmLength() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    type() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : (0, _geometryTypeJs.GeometryType).Unknown;
    }
    parts(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? (obj || new Geometry()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    partsLength() {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    static startGeometry(builder) {
        builder.startObject(8);
    }
    static addEnds(builder, endsOffset) {
        builder.addFieldOffset(0, endsOffset, 0);
    }
    static createEndsVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for(let i = data.length - 1; i >= 0; i--)builder.addInt32(data[i]);
        return builder.endVector();
    }
    static startEndsVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addXy(builder, xyOffset) {
        builder.addFieldOffset(1, xyOffset, 0);
    }
    static createXyVector(builder, data) {
        builder.startVector(8, data.length, 8);
        for(let i = data.length - 1; i >= 0; i--)builder.addFloat64(data[i]);
        return builder.endVector();
    }
    static startXyVector(builder, numElems) {
        builder.startVector(8, numElems, 8);
    }
    static addZ(builder, zOffset) {
        builder.addFieldOffset(2, zOffset, 0);
    }
    static createZVector(builder, data) {
        builder.startVector(8, data.length, 8);
        for(let i = data.length - 1; i >= 0; i--)builder.addFloat64(data[i]);
        return builder.endVector();
    }
    static startZVector(builder, numElems) {
        builder.startVector(8, numElems, 8);
    }
    static addM(builder, mOffset) {
        builder.addFieldOffset(3, mOffset, 0);
    }
    static createMVector(builder, data) {
        builder.startVector(8, data.length, 8);
        for(let i = data.length - 1; i >= 0; i--)builder.addFloat64(data[i]);
        return builder.endVector();
    }
    static startMVector(builder, numElems) {
        builder.startVector(8, numElems, 8);
    }
    static addT(builder, tOffset) {
        builder.addFieldOffset(4, tOffset, 0);
    }
    static createTVector(builder, data) {
        builder.startVector(8, data.length, 8);
        for(let i = data.length - 1; i >= 0; i--)builder.addFloat64(data[i]);
        return builder.endVector();
    }
    static startTVector(builder, numElems) {
        builder.startVector(8, numElems, 8);
    }
    static addTm(builder, tmOffset) {
        builder.addFieldOffset(5, tmOffset, 0);
    }
    static createTmVector(builder, data) {
        builder.startVector(8, data.length, 8);
        for(let i = data.length - 1; i >= 0; i--)builder.addInt64(data[i]);
        return builder.endVector();
    }
    static startTmVector(builder, numElems) {
        builder.startVector(8, numElems, 8);
    }
    static addType(builder, type) {
        builder.addFieldInt8(6, type, (0, _geometryTypeJs.GeometryType).Unknown);
    }
    static addParts(builder, partsOffset) {
        builder.addFieldOffset(7, partsOffset, 0);
    }
    static createPartsVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for(let i = data.length - 1; i >= 0; i--)builder.addOffset(data[i]);
        return builder.endVector();
    }
    static startPartsVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static endGeometry(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createGeometry(builder, endsOffset, xyOffset, zOffset, mOffset, tOffset, tmOffset, type, partsOffset) {
        Geometry.startGeometry(builder);
        Geometry.addEnds(builder, endsOffset);
        Geometry.addXy(builder, xyOffset);
        Geometry.addZ(builder, zOffset);
        Geometry.addM(builder, mOffset);
        Geometry.addT(builder, tOffset);
        Geometry.addTm(builder, tmOffset);
        Geometry.addType(builder, type);
        Geometry.addParts(builder, partsOffset);
        return Geometry.endGeometry(builder);
    }
}

},{"flatbuffers":"4oKPA","../flat-geobuf/geometry-type.js":"99UDP","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"99UDP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GeometryType", ()=>GeometryType);
var GeometryType;
(function(GeometryType) {
    GeometryType[GeometryType["Unknown"] = 0] = "Unknown";
    GeometryType[GeometryType["Point"] = 1] = "Point";
    GeometryType[GeometryType["LineString"] = 2] = "LineString";
    GeometryType[GeometryType["Polygon"] = 3] = "Polygon";
    GeometryType[GeometryType["MultiPoint"] = 4] = "MultiPoint";
    GeometryType[GeometryType["MultiLineString"] = 5] = "MultiLineString";
    GeometryType[GeometryType["MultiPolygon"] = 6] = "MultiPolygon";
    GeometryType[GeometryType["GeometryCollection"] = 7] = "GeometryCollection";
    GeometryType[GeometryType["CircularString"] = 8] = "CircularString";
    GeometryType[GeometryType["CompoundCurve"] = 9] = "CompoundCurve";
    GeometryType[GeometryType["CurvePolygon"] = 10] = "CurvePolygon";
    GeometryType[GeometryType["MultiCurve"] = 11] = "MultiCurve";
    GeometryType[GeometryType["MultiSurface"] = 12] = "MultiSurface";
    GeometryType[GeometryType["Curve"] = 13] = "Curve";
    GeometryType[GeometryType["Surface"] = 14] = "Surface";
    GeometryType[GeometryType["PolyhedralSurface"] = 15] = "PolyhedralSurface";
    GeometryType[GeometryType["TIN"] = 16] = "TIN";
    GeometryType[GeometryType["Triangle"] = 17] = "Triangle";
})(GeometryType || (GeometryType = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"eEB1R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromByteBuffer", ()=>fromByteBuffer);
var _headerJs = require("./flat-geobuf/header.js");
function fromByteBuffer(bb) {
    const header = (0, _headerJs.Header).getSizePrefixedRootAsHeader(bb);
    const featuresCount = header.featuresCount();
    const indexNodeSize = header.indexNodeSize();
    const columns = [];
    for(let j = 0; j < header.columnsLength(); j++){
        const column = header.columns(j);
        if (!column) throw new Error('Column unexpectedly missing');
        if (!column.name()) throw new Error('Column name unexpectedly missing');
        columns.push({
            name: column.name(),
            type: column.type(),
            title: column.title(),
            description: column.description(),
            width: column.width(),
            precision: column.precision(),
            scale: column.scale(),
            nullable: column.nullable(),
            unique: column.unique(),
            primary_key: column.primaryKey()
        });
    }
    const crs = header.crs();
    const crsMeta = crs ? {
        org: crs.org(),
        code: crs.code(),
        name: crs.name(),
        description: crs.description(),
        wkt: crs.wkt(),
        code_string: crs.codeString()
    } : null;
    const headerMeta = {
        geometryType: header.geometryType(),
        columns: columns,
        envelope: header.envelopeLength() > 0 ? header.envelopeArray() : null,
        featuresCount: Number(featuresCount),
        indexNodeSize: indexNodeSize,
        crs: crsMeta,
        title: header.title(),
        description: header.description(),
        metadata: header.metadata()
    };
    return headerMeta;
}

},{"./flat-geobuf/header.js":"8H9JE","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"8H9JE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Header", ()=>Header);
var _flatbuffers = require("flatbuffers");
var _columnJs = require("../flat-geobuf/column.js");
var _crsJs = require("../flat-geobuf/crs.js");
var _geometryTypeJs = require("../flat-geobuf/geometry-type.js");
class Header {
    bb = null;
    bb_pos = 0;
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsHeader(bb, obj) {
        return (obj || new Header()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsHeader(bb, obj) {
        bb.setPosition(bb.position() + _flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new Header()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    name(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    envelope(index) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readFloat64(this.bb.__vector(this.bb_pos + offset) + index * 8) : 0;
    }
    envelopeLength() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    envelopeArray() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? new Float64Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    geometryType() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : (0, _geometryTypeJs.GeometryType).Unknown;
    }
    hasZ() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    hasM() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    hasT() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    hasTm() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    columns(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? (obj || new (0, _columnJs.Column)()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    columnsLength() {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    featuresCount() {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? this.bb.readUint64(this.bb_pos + offset) : BigInt('0');
    }
    indexNodeSize() {
        const offset = this.bb.__offset(this.bb_pos, 22);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : 16;
    }
    crs(obj) {
        const offset = this.bb.__offset(this.bb_pos, 24);
        return offset ? (obj || new (0, _crsJs.Crs)()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    title(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 26);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    description(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 28);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    metadata(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 30);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    static startHeader(builder) {
        builder.startObject(14);
    }
    static addName(builder, nameOffset) {
        builder.addFieldOffset(0, nameOffset, 0);
    }
    static addEnvelope(builder, envelopeOffset) {
        builder.addFieldOffset(1, envelopeOffset, 0);
    }
    static createEnvelopeVector(builder, data) {
        builder.startVector(8, data.length, 8);
        for(let i = data.length - 1; i >= 0; i--)builder.addFloat64(data[i]);
        return builder.endVector();
    }
    static startEnvelopeVector(builder, numElems) {
        builder.startVector(8, numElems, 8);
    }
    static addGeometryType(builder, geometryType) {
        builder.addFieldInt8(2, geometryType, (0, _geometryTypeJs.GeometryType).Unknown);
    }
    static addHasZ(builder, hasZ) {
        builder.addFieldInt8(3, +hasZ, 0);
    }
    static addHasM(builder, hasM) {
        builder.addFieldInt8(4, +hasM, 0);
    }
    static addHasT(builder, hasT) {
        builder.addFieldInt8(5, +hasT, 0);
    }
    static addHasTm(builder, hasTm) {
        builder.addFieldInt8(6, +hasTm, 0);
    }
    static addColumns(builder, columnsOffset) {
        builder.addFieldOffset(7, columnsOffset, 0);
    }
    static createColumnsVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for(let i = data.length - 1; i >= 0; i--)builder.addOffset(data[i]);
        return builder.endVector();
    }
    static startColumnsVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addFeaturesCount(builder, featuresCount) {
        builder.addFieldInt64(8, featuresCount, BigInt('0'));
    }
    static addIndexNodeSize(builder, indexNodeSize) {
        builder.addFieldInt16(9, indexNodeSize, 16);
    }
    static addCrs(builder, crsOffset) {
        builder.addFieldOffset(10, crsOffset, 0);
    }
    static addTitle(builder, titleOffset) {
        builder.addFieldOffset(11, titleOffset, 0);
    }
    static addDescription(builder, descriptionOffset) {
        builder.addFieldOffset(12, descriptionOffset, 0);
    }
    static addMetadata(builder, metadataOffset) {
        builder.addFieldOffset(13, metadataOffset, 0);
    }
    static endHeader(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static finishHeaderBuffer(builder, offset) {
        builder.finish(offset);
    }
    static finishSizePrefixedHeaderBuffer(builder, offset) {
        builder.finish(offset, undefined, true);
    }
}

},{"flatbuffers":"4oKPA","../flat-geobuf/column.js":"5dD9m","../flat-geobuf/crs.js":"6SSTl","../flat-geobuf/geometry-type.js":"99UDP","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"6SSTl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Crs", ()=>Crs);
var _flatbuffers = require("flatbuffers");
class Crs {
    bb = null;
    bb_pos = 0;
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsCrs(bb, obj) {
        return (obj || new Crs()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsCrs(bb, obj) {
        bb.setPosition(bb.position() + _flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new Crs()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    org(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    code() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readInt32(this.bb_pos + offset) : 0;
    }
    name(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    description(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    wkt(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    codeString(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    static startCrs(builder) {
        builder.startObject(6);
    }
    static addOrg(builder, orgOffset) {
        builder.addFieldOffset(0, orgOffset, 0);
    }
    static addCode(builder, code) {
        builder.addFieldInt32(1, code, 0);
    }
    static addName(builder, nameOffset) {
        builder.addFieldOffset(2, nameOffset, 0);
    }
    static addDescription(builder, descriptionOffset) {
        builder.addFieldOffset(3, descriptionOffset, 0);
    }
    static addWkt(builder, wktOffset) {
        builder.addFieldOffset(4, wktOffset, 0);
    }
    static addCodeString(builder, codeStringOffset) {
        builder.addFieldOffset(5, codeStringOffset, 0);
    }
    static endCrs(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createCrs(builder, orgOffset, code, nameOffset, descriptionOffset, wktOffset, codeStringOffset) {
        Crs.startCrs(builder);
        Crs.addOrg(builder, orgOffset);
        Crs.addCode(builder, code);
        Crs.addName(builder, nameOffset);
        Crs.addDescription(builder, descriptionOffset);
        Crs.addWkt(builder, wktOffset);
        Crs.addCodeString(builder, codeStringOffset);
        return Crs.endCrs(builder);
    }
}

},{"flatbuffers":"4oKPA","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"JJHpi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NODE_ITEM_BYTE_LEN", ()=>NODE_ITEM_BYTE_LEN);
parcelHelpers.export(exports, "NODE_ITEM_LEN", ()=>NODE_ITEM_LEN);
parcelHelpers.export(exports, "DEFAULT_NODE_SIZE", ()=>DEFAULT_NODE_SIZE);
parcelHelpers.export(exports, "calcTreeSize", ()=>calcTreeSize);
parcelHelpers.export(exports, "generateLevelBounds", ()=>generateLevelBounds);
parcelHelpers.export(exports, "streamSearch", ()=>streamSearch);
var _configJs = require("./config.js");
var _configJsDefault = parcelHelpers.interopDefault(_configJs);
const NODE_ITEM_BYTE_LEN = 40;
const NODE_ITEM_LEN = NODE_ITEM_BYTE_LEN;
const DEFAULT_NODE_SIZE = 16;
function calcTreeSize(numItems, nodeSize) {
    if (!Number.isInteger(numItems) || numItems < 1) throw new Error('Number of items must be greater than 0');
    nodeSize = Math.min(Math.max(+nodeSize, 2), 65535);
    let n = numItems;
    let numNodes = n;
    do {
        n = Math.ceil(n / nodeSize);
        numNodes += n;
    }while (n !== 1);
    return numNodes * NODE_ITEM_BYTE_LEN;
}
function generateLevelBounds(numItems, nodeSize) {
    if (nodeSize < 2) throw new Error('Node size must be at least 2');
    if (numItems === 0) throw new Error('Number of items must be greater than 0');
    let n = numItems;
    let numNodes = n;
    const levelNumNodes = [
        n
    ];
    do {
        n = Math.ceil(n / nodeSize);
        numNodes += n;
        levelNumNodes.push(n);
    }while (n !== 1);
    const levelOffsets = [];
    n = numNodes;
    for (const size of levelNumNodes){
        levelOffsets.push(n - size);
        n -= size;
    }
    const levelBounds = [];
    for(let i = 0; i < levelNumNodes.length; i++)levelBounds.push([
        levelOffsets[i],
        levelOffsets[i] + levelNumNodes[i]
    ]);
    return levelBounds;
}
async function* streamSearch(numItems, nodeSize, rect, readNode) {
    class NodeRange {
        _level;
        nodes;
        constructor(nodes, level){
            this._level = level;
            this.nodes = nodes;
        }
        level() {
            return this._level;
        }
        startNodeIdx() {
            return this.nodes[0];
        }
        endNodeIdx() {
            return this.nodes[1];
        }
        extendEndNodeIdx(newIdx) {
            console.assert(newIdx > this.nodes[1]);
            this.nodes[1] = newIdx;
        }
        toString() {
            return `[NodeRange level: ${this._level}, nodes: ${this.nodes[0]}-${this.nodes[1]}]`;
        }
    }
    const { minX, minY, maxX, maxY } = rect;
    console.debug(`tree items: ${numItems}, nodeSize: ${nodeSize}`);
    const levelBounds = generateLevelBounds(numItems, nodeSize);
    const firstLeafNodeIdx = levelBounds[0][0];
    const rootNodeRange = (()=>{
        const range = [
            0,
            1
        ];
        const level = levelBounds.length - 1;
        return new NodeRange(range, level);
    })();
    const queue = [
        rootNodeRange
    ];
    let queueHead = 0;
    console.debug(`starting stream search with queue: ${queue}, numItems: ${numItems}, nodeSize: ${nodeSize}, levelBounds: ${levelBounds}`);
    while(queueHead < queue.length){
        const nodeRange = queue[queueHead++];
        queue[queueHead - 1] = undefined;
        console.debug(`popped node: ${nodeRange}, queueLength: ${queue.length - queueHead}`);
        const nodeRangeStartIdx = nodeRange.startNodeIdx();
        const isLeafNode = nodeRangeStartIdx >= firstLeafNodeIdx;
        const [, levelBound] = levelBounds[nodeRange.level()];
        const searchEndIdx = Math.min(nodeRange.endNodeIdx() + nodeSize, levelBound);
        const nodeRangeEndIdx = (()=>{
            const nodeIdx = searchEndIdx;
            if (isLeafNode && nodeIdx < levelBound) return nodeIdx + 1;
            return nodeIdx;
        })();
        const numNodesInRange = nodeRangeEndIdx - nodeRangeStartIdx;
        const buffer = await readNode(nodeRangeStartIdx * NODE_ITEM_BYTE_LEN, numNodesInRange * NODE_ITEM_BYTE_LEN);
        const dataView = new DataView(buffer);
        for(let nodeIdx = nodeRangeStartIdx; nodeIdx < searchEndIdx; nodeIdx++){
            const nodeIdxInDataView = nodeIdx - nodeRangeStartIdx;
            const dataViewByteStart = nodeIdxInDataView * NODE_ITEM_BYTE_LEN;
            if (maxX < dataView.getFloat64(dataViewByteStart + 0, true)) continue;
            if (maxY < dataView.getFloat64(dataViewByteStart + 8, true)) continue;
            if (minX > dataView.getFloat64(dataViewByteStart + 16, true)) continue;
            if (minY > dataView.getFloat64(dataViewByteStart + 24, true)) continue;
            const offset = dataView.getBigUint64(dataViewByteStart + 32, true);
            if (isLeafNode) {
                const featureByteOffset = offset;
                const featureLength = (()=>{
                    if (nodeIdx < levelBounds[0][1] - 1) {
                        const nextPos = (nodeIdxInDataView + 1) * NODE_ITEM_BYTE_LEN;
                        const nextOffset = dataView.getBigUint64(nextPos + 32, true);
                        return nextOffset - featureByteOffset;
                    }
                    return null;
                })();
                const featureIdx = nodeIdx - firstLeafNodeIdx;
                yield [
                    Number(featureByteOffset),
                    featureIdx,
                    Number(featureLength)
                ];
                continue;
            }
            const firstChildNodeIdx = offset;
            const extraRequestThresholdNodes = (0, _configJsDefault.default).global.extraRequestThreshold() / NODE_ITEM_BYTE_LEN;
            const nearestNodeRange = queue.length > queueHead ? queue[queue.length - 1] : undefined;
            if (nearestNodeRange !== undefined && nearestNodeRange.level() === nodeRange.level() - 1 && firstChildNodeIdx < nearestNodeRange.endNodeIdx() + extraRequestThresholdNodes) {
                console.debug(`Merging "nodeRange" request into existing range: ${nearestNodeRange}, newEndNodeIdx: ${nearestNodeRange.endNodeIdx()} -> ${firstChildNodeIdx}`);
                nearestNodeRange.extendEndNodeIdx(Number(firstChildNodeIdx));
                continue;
            }
            const newNodeRange = (()=>{
                const level = nodeRange.level() - 1;
                const range = [
                    Number(firstChildNodeIdx),
                    Number(firstChildNodeIdx)
                ];
                return new NodeRange(range, level);
            })();
            if (nearestNodeRange !== undefined && nearestNodeRange.level() === newNodeRange.level()) console.debug(`Same level, but too far away. Pushing new request for nodeIdx: ${firstChildNodeIdx} rather than merging with distant ${nearestNodeRange}`);
            else console.debug(`Pushing new level for ${newNodeRange} onto queue with nearestNodeRange: ${nearestNodeRange} since there's not already a range for this level.`);
            queue.push(newNodeRange);
        }
    }
}

},{"./config.js":"5Kw8d","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"5Kw8d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class Config {
    static global = new Config();
    _extraRequestThreshold = 262144;
    extraRequestThreshold() {
        return this._extraRequestThreshold;
    }
    setExtraRequestThreshold(bytes) {
        if (bytes < 0) throw new Error('extraRequestThreshold cannot be negative');
        this._extraRequestThreshold = bytes;
    }
}
exports.default = Config;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1drNw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpReader", ()=>HttpReader);
parcelHelpers.export(exports, "HttpRangeClient", ()=>HttpRangeClient);
var _repeater = require("@repeaterjs/repeater");
var _flatbuffers = require("flatbuffers");
var _configJs = require("./config.js");
var _configJsDefault = parcelHelpers.interopDefault(_configJs);
var _constantsJs = require("./constants.js");
var _featureJs = require("./flat-geobuf/feature.js");
var _headerMetaJs = require("./header-meta.js");
var _packedrtreeJs = require("./packedrtree.js");
class HttpReader {
    headerClient;
    header;
    headerLength;
    indexLength;
    nocache;
    headers;
    constructor(headerClient, header, headerLength, indexLength, nocache, headers = {}){
        this.headerClient = headerClient;
        this.header = header;
        this.headerLength = headerLength;
        this.indexLength = indexLength;
        this.nocache = nocache;
        this.headers = headers;
    }
    static async open(url, nocache, headers = {}) {
        return HttpReader.openSource(new HttpRangeClient(url, nocache, headers), nocache, headers);
    }
    static async openSource(rangeClient, nocache = false, headers = {}) {
        const assumedHeaderLength = 2024;
        const headerClient = new BufferedHttpRangeClient(rangeClient, nocache, headers);
        const assumedIndexLength = (()=>{
            const assumedBranchingFactor = (0, _packedrtreeJs.DEFAULT_NODE_SIZE);
            const prefetchedLayers = 3;
            let result = 0;
            let i;
            for(i = 0; i < prefetchedLayers; i++){
                const layer_width = assumedBranchingFactor ** i * (0, _packedrtreeJs.NODE_ITEM_BYTE_LEN);
                result += layer_width;
            }
            return result;
        })();
        const minReqLength = assumedHeaderLength + assumedIndexLength;
        console.debug(`fetching header. minReqLength: ${minReqLength} (assumedHeaderLength: ${assumedHeaderLength}, assumedIndexLength: ${assumedIndexLength})`);
        {
            const bytes = new Uint8Array(await headerClient.getRange(0, 8, minReqLength, 'header'));
            if (!bytes.subarray(0, 3).every((v, i)=>(0, _constantsJs.magicbytes)[i] === v)) {
                console.error(`bytes: ${bytes} != ${(0, _constantsJs.magicbytes)}`);
                throw new Error('Not a FlatGeobuf file');
            }
            console.debug('magic bytes look good');
        }
        let headerLength;
        {
            const bytes = await headerClient.getRange(8, 4, minReqLength, 'header');
            headerLength = new DataView(bytes).getUint32(0, true);
            if (headerLength > (0, _constantsJs.HEADER_MAX_BUFFER_SIZE) || headerLength < 8) throw new Error('Invalid header size');
            console.debug(`headerLength: ${headerLength}`);
        }
        const bytes = await headerClient.getRange((0, _constantsJs.magicbytes).length, (0, _constantsJs.SIZE_PREFIX_LEN) + headerLength, (0, _constantsJs.SIZE_PREFIX_LEN) + headerLength + assumedIndexLength, 'header');
        const bb = new _flatbuffers.ByteBuffer(new Uint8Array(bytes));
        const header = (0, _headerMetaJs.fromByteBuffer)(bb);
        if (header.indexNodeSize === 0) throw new Error('No index found, cannot read features filtered by bbox');
        const indexLength = (0, _packedrtreeJs.calcTreeSize)(header.featuresCount, header.indexNodeSize);
        console.debug('completed: opening http reader');
        return new HttpReader(headerClient, header, headerLength, indexLength, nocache, headers);
    }
    async *selectBbox(rect) {
        const lengthBeforeTree = this.lengthBeforeTree();
        const bufferedClient = this.headerClient;
        const readNode = async (offsetIntoTree, size)=>{
            const minReqLength = 0;
            return bufferedClient.getRange(lengthBeforeTree + offsetIntoTree, size, minReqLength, 'index');
        };
        const batches = [];
        let currentBatch = [];
        for await (const searchResult of (0, _packedrtreeJs.streamSearch)(this.header.featuresCount, this.header.indexNodeSize, rect, readNode)){
            const [featureOffset, featureIdx] = searchResult;
            let [, , featureLength] = searchResult;
            if (!featureLength) {
                console.debug('final feature');
                featureLength = 4;
            }
            if (currentBatch.length === 0) {
                currentBatch.push([
                    featureOffset,
                    featureLength,
                    featureIdx
                ]);
                continue;
            }
            const prevFeature = currentBatch[currentBatch.length - 1];
            const gap = featureOffset - (prevFeature[0] + prevFeature[1]);
            if (gap > (0, _configJsDefault.default).global.extraRequestThreshold()) {
                console.debug(`Pushing new feature batch, since gap ${gap} was too large`);
                batches.push(currentBatch);
                currentBatch = [];
            }
            currentBatch.push([
                featureOffset,
                featureLength,
                featureIdx
            ]);
        }
        this.headerClient.logUsage('header+index');
        if (currentBatch.length > 0) batches.push(currentBatch);
        const promises = batches.flatMap((batch)=>this.readFeatureBatch(batch, this.nocache));
        yield* (0, _repeater.Repeater).merge(promises);
    }
    lengthBeforeTree() {
        return (0, _constantsJs.magicbytes).length + (0, _constantsJs.SIZE_PREFIX_LEN) + this.headerLength;
    }
    lengthBeforeFeatures() {
        return this.lengthBeforeTree() + this.indexLength;
    }
    buildFeatureClient(nocache) {
        return new BufferedHttpRangeClient(this.headerClient.httpClient, nocache, this.headers);
    }
    async *readFeatureBatch(batch, nocache) {
        const [firstFeatureOffset] = batch[0];
        const [lastFeatureOffset, lastFeatureLength] = batch[batch.length - 1];
        const batchStart = firstFeatureOffset;
        const batchEnd = lastFeatureOffset + lastFeatureLength;
        const batchSize = batchEnd - batchStart;
        const featureClient = this.buildFeatureClient(nocache);
        let minFeatureReqLength = batchSize;
        for (const [featureOffset, , featureIdx] of batch){
            const feature = await this.readFeature(featureClient, featureOffset, minFeatureReqLength);
            yield {
                id: featureIdx,
                feature
            };
            minFeatureReqLength = 0;
        }
        featureClient.logUsage('feature');
    }
    async readFeature(featureClient, featureOffset, minFeatureReqLength) {
        const offset = featureOffset + this.lengthBeforeFeatures();
        let featureLength;
        {
            const bytes = await featureClient.getRange(offset, 4, minFeatureReqLength, 'feature length');
            featureLength = new DataView(bytes).getUint32(0, true);
        }
        const byteBuffer = await featureClient.getRange(offset + 4, featureLength, minFeatureReqLength, 'feature data');
        const bytes = new Uint8Array(byteBuffer);
        const bytesAligned = new Uint8Array(featureLength + (0, _constantsJs.SIZE_PREFIX_LEN));
        bytesAligned.set(bytes, (0, _constantsJs.SIZE_PREFIX_LEN));
        const bb = new _flatbuffers.ByteBuffer(bytesAligned);
        return (0, _featureJs.Feature).getSizePrefixedRootAsFeature(bb);
    }
}
class BufferedHttpRangeClient {
    httpClient;
    bytesEverUsed = 0;
    bytesEverFetched = 0;
    buffer = new ArrayBuffer(0);
    head = 0;
    constructor(source, nocache, headers = {}){
        if (typeof source === 'string') this.httpClient = new HttpRangeClient(source, nocache, headers);
        else if ('getRange' in source) this.httpClient = source;
        else throw new Error('Unknown source');
    }
    async getRange(start, length, minReqLength, purpose) {
        this.bytesEverUsed += length;
        const start_i = start - this.head;
        const end_i = start_i + length;
        if (start_i >= 0 && end_i <= this.buffer.byteLength) return this.buffer.slice(start_i, end_i);
        const lengthToFetch = Math.max(length, minReqLength);
        this.bytesEverFetched += lengthToFetch;
        console.debug(`requesting for new Range: ${start}-${start + lengthToFetch - 1}`);
        this.buffer = await this.httpClient.getRange(start, lengthToFetch, purpose);
        this.head = start;
        return this.buffer.slice(0, length);
    }
    logUsage(purpose) {
        const category = purpose.split(' ')[0];
        const used = this.bytesEverUsed;
        const requested = this.bytesEverFetched;
        const efficiency = (100.0 * used / requested).toFixed(2);
        console.debug(`${category} bytes used/requested: ${used} / ${requested} = ${efficiency}%`);
    }
}
class HttpRangeClient {
    url;
    nocache;
    headers;
    requestsEverMade = 0;
    bytesEverRequested = 0;
    constructor(url, nocache, headers = {}){
        this.url = url;
        this.nocache = nocache;
        this.headers = headers;
    }
    async getRange(begin, length, purpose) {
        this.requestsEverMade += 1;
        this.bytesEverRequested += length;
        const range = `bytes=${begin}-${begin + length - 1}`;
        console.debug(`request: #${this.requestsEverMade}, purpose: ${purpose}), bytes: (this_request: ${length}, ever: ${this.bytesEverRequested}), Range: ${range}`);
        const headers = new Headers(this.headers);
        headers.set('Range', range);
        if (this.nocache) headers.set('Cache-Control', 'no-cache, no-store');
        const response = await fetch(this.url, {
            headers
        });
        if (!response.ok) throw new Error(`HTTP request failed: ${response.status} ${response.statusText}`);
        const arrayBuffer = await response.arrayBuffer();
        return arrayBuffer;
    }
}

},{"@repeaterjs/repeater":"JXidY","flatbuffers":"4oKPA","./config.js":"5Kw8d","./constants.js":"5WAfl","./flat-geobuf/feature.js":"jNs3T","./header-meta.js":"eEB1R","./packedrtree.js":"JJHpi","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"JXidY":[function(require,module,exports,__globalThis) {
/// <reference types="./index.d.ts" />
// src/index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DroppingBuffer", ()=>(0, _coreJs.DroppingBuffer));
parcelHelpers.export(exports, "FixedBuffer", ()=>(0, _coreJs.FixedBuffer));
parcelHelpers.export(exports, "MAX_QUEUE_LENGTH", ()=>(0, _coreJs.MAX_QUEUE_LENGTH));
parcelHelpers.export(exports, "Repeater", ()=>Repeater);
parcelHelpers.export(exports, "RepeaterOverflowError", ()=>(0, _coreJs.RepeaterOverflowError));
parcelHelpers.export(exports, "SlidingBuffer", ()=>(0, _coreJs.SlidingBuffer));
parcelHelpers.export(exports, "latest", ()=>(0, _combinatorsJs.latest));
parcelHelpers.export(exports, "merge", ()=>(0, _combinatorsJs.merge));
parcelHelpers.export(exports, "race", ()=>(0, _combinatorsJs.race));
parcelHelpers.export(exports, "zip", ()=>(0, _combinatorsJs.zip));
var _coreJs = require("./core.js");
var _combinatorsJs = require("./combinators.js");
var Repeater = class extends (0, _coreJs.Repeater) {
    static race = (0, _combinatorsJs.race);
    static merge = (0, _combinatorsJs.merge);
    static zip = (0, _combinatorsJs.zip);
    static latest = (0, _combinatorsJs.latest);
};

},{"./core.js":"de1Vk","./combinators.js":"gQHY3","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"de1Vk":[function(require,module,exports,__globalThis) {
/// <reference types="./core.d.ts" />
// src/core.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DroppingBuffer", ()=>DroppingBuffer);
parcelHelpers.export(exports, "FixedBuffer", ()=>FixedBuffer);
parcelHelpers.export(exports, "MAX_QUEUE_LENGTH", ()=>MAX_QUEUE_LENGTH);
parcelHelpers.export(exports, "Repeater", ()=>Repeater);
parcelHelpers.export(exports, "RepeaterOverflowError", ()=>RepeaterOverflowError);
parcelHelpers.export(exports, "SlidingBuffer", ()=>SlidingBuffer);
var RepeaterOverflowError = class extends Error {
    constructor(message){
        super(message);
        Object.defineProperty(this, "name", {
            value: "RepeaterOverflowError",
            enumerable: false
        });
        if (typeof Object.setPrototypeOf === "function") Object.setPrototypeOf(this, this.constructor.prototype);
        else this.__proto__ = this.constructor.prototype;
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, this.constructor);
    }
};
var FixedBuffer = class {
    // capacity
    _c;
    // queue
    _q;
    constructor(capacity){
        if (capacity < 0) throw new RangeError("Capacity may not be less than 0");
        this._c = capacity;
        this._q = [];
    }
    get empty() {
        return this._q.length === 0;
    }
    get full() {
        return this._q.length >= this._c;
    }
    add(value) {
        if (this.full) throw new Error("Buffer full");
        else this._q.push(value);
    }
    remove() {
        if (this.empty) throw new Error("Buffer empty");
        return this._q.shift();
    }
};
var SlidingBuffer = class {
    // capacity
    _c;
    // queue
    _q;
    constructor(capacity){
        if (capacity < 1) throw new RangeError("Capacity may not be less than 1");
        this._c = capacity;
        this._q = [];
    }
    get empty() {
        return this._q.length === 0;
    }
    get full() {
        return false;
    }
    add(value) {
        while(this._q.length >= this._c)this._q.shift();
        this._q.push(value);
    }
    remove() {
        if (this.empty) throw new Error("Buffer empty");
        return this._q.shift();
    }
};
var DroppingBuffer = class {
    // capacity
    _c;
    // queue
    _q;
    constructor(capacity){
        if (capacity < 1) throw new RangeError("Capacity may not be less than 1");
        this._c = capacity;
        this._q = [];
    }
    get empty() {
        return this._q.length === 0;
    }
    get full() {
        return false;
    }
    add(value) {
        if (this._q.length < this._c) this._q.push(value);
    }
    remove() {
        if (this.empty) throw new Error("Buffer empty");
        return this._q.shift();
    }
};
function swallow(value) {
    if (value != null && typeof value.then === "function") value.then(NOOP, NOOP);
}
var Initial = 0;
var Started = 1;
var Stopped = 2;
var Done = 3;
var Rejected = 4;
var MAX_QUEUE_LENGTH = 1024;
var NOOP = ()=>{};
function consumeExecution(r) {
    const err = r.err;
    const execution = Promise.resolve(r.execution).then((value)=>{
        if (err != null) throw err;
        return value;
    });
    r.err = void 0;
    r.execution = execution.then(()=>void 0, ()=>void 0);
    return r.pending === void 0 ? execution : r.pending.then(()=>execution);
}
function createIteration(r, value) {
    const done = r.state >= Done;
    return Promise.resolve(value).then((value2)=>{
        if (!done && r.state >= Rejected) return consumeExecution(r).then((value3)=>({
                value: value3,
                done: true
            }));
        return {
            value: value2,
            done
        };
    });
}
function stop(r, err) {
    if (r.state >= Stopped) return;
    r.state = Stopped;
    r.onnext();
    r.onstop();
    if (r.err == null) r.err = err;
    if (r.pushes.length === 0 && (typeof r.buffer === "undefined" || r.buffer.empty)) finish(r);
    else for (const push2 of r.pushes)push2.resolve();
}
function finish(r) {
    if (r.state >= Done) return;
    if (r.state < Stopped) stop(r);
    r.state = Done;
    r.buffer = void 0;
    for (const next of r.nexts){
        const execution = r.pending === void 0 ? consumeExecution(r) : r.pending.then(()=>consumeExecution(r));
        next.resolve(createIteration(r, execution));
    }
    r.pushes = [];
    r.nexts = [];
}
function reject(r) {
    if (r.state >= Rejected) return;
    if (r.state < Done) finish(r);
    r.state = Rejected;
}
function push(r, value) {
    swallow(value);
    if (r.pushes.length >= MAX_QUEUE_LENGTH) throw new RepeaterOverflowError(`No more than ${MAX_QUEUE_LENGTH} pending calls to push are allowed on a single repeater.`);
    else if (r.state >= Stopped) return Promise.resolve(void 0);
    let valueP = r.pending === void 0 ? Promise.resolve(value) : r.pending.then(()=>value);
    valueP = valueP.catch((err)=>{
        if (r.state < Stopped) r.err = err;
        reject(r);
        return void 0;
    });
    let nextP;
    if (r.nexts.length) {
        const next2 = r.nexts.shift();
        next2.resolve(createIteration(r, valueP));
        if (r.nexts.length) nextP = Promise.resolve(r.nexts[0].value);
        else if (typeof r.buffer !== "undefined" && !r.buffer.full) nextP = Promise.resolve(void 0);
        else nextP = new Promise((resolve)=>r.onnext = resolve);
    } else if (typeof r.buffer !== "undefined" && !r.buffer.full) {
        r.buffer.add(valueP);
        nextP = Promise.resolve(void 0);
    } else nextP = new Promise((resolve)=>r.pushes.push({
            resolve,
            value: valueP
        }));
    let floating = true;
    const next = Object.create(nextP);
    const unhandled = nextP.catch((err)=>{
        if (floating) throw err;
        return void 0;
    });
    next.then = (onfulfilled, onrejected)=>{
        floating = false;
        return Promise.prototype.then.call(nextP, onfulfilled, onrejected);
    };
    next.catch = (onrejected)=>{
        floating = false;
        return Promise.prototype.catch.call(nextP, onrejected);
    };
    next.finally = nextP.finally.bind(nextP);
    r.pending = valueP.then(()=>unhandled).catch((err)=>{
        r.err = err;
        reject(r);
    });
    return next;
}
function createStop(r) {
    const stopP = new Promise((resolve)=>r.onstop = ()=>resolve(void 0));
    return Object.assign(stop.bind(null, r), {
        then: stopP.then.bind(stopP),
        catch: stopP.catch.bind(stopP),
        finally: stopP.finally.bind(stopP)
    });
}
function execute(r) {
    if (r.state >= Started) return;
    r.state = Started;
    const push1 = push.bind(null, r);
    const stop1 = createStop(r);
    r.execution = new Promise((resolve)=>resolve(r.executor(push1, stop1)));
    r.execution.catch(()=>stop(r));
}
var records = /* @__PURE__ */ new WeakMap();
var Repeater = class {
    constructor(executor, buffer){
        records.set(this, {
            executor,
            buffer,
            err: void 0,
            state: Initial,
            pushes: [],
            nexts: [],
            pending: void 0,
            execution: void 0,
            onnext: NOOP,
            onstop: NOOP
        });
    }
    next(value) {
        swallow(value);
        const r = records.get(this);
        if (r === void 0) throw new Error("WeakMap error");
        if (r.nexts.length >= MAX_QUEUE_LENGTH) throw new RepeaterOverflowError(`No more than ${MAX_QUEUE_LENGTH} pending calls to next are allowed on a single repeater.`);
        if (r.state <= Initial) execute(r);
        r.onnext(value);
        if (typeof r.buffer !== "undefined" && !r.buffer.empty) {
            const result = createIteration(r, r.buffer.remove());
            if (r.pushes.length) {
                const push2 = r.pushes.shift();
                r.buffer.add(push2.value);
                r.onnext = push2.resolve;
            }
            return result;
        } else if (r.pushes.length) {
            const push2 = r.pushes.shift();
            r.onnext = push2.resolve;
            return createIteration(r, push2.value);
        } else if (r.state >= Stopped) {
            finish(r);
            return createIteration(r, consumeExecution(r));
        }
        return new Promise((resolve)=>r.nexts.push({
                resolve,
                value
            }));
    }
    return(value) {
        swallow(value);
        const r = records.get(this);
        if (r === void 0) throw new Error("WeakMap error");
        finish(r);
        r.execution = Promise.resolve(r.execution).then(()=>value);
        return createIteration(r, consumeExecution(r));
    }
    throw(err) {
        const r = records.get(this);
        if (r === void 0) throw new Error("WeakMap error");
        if (r.state <= Initial || r.state >= Stopped || typeof r.buffer !== "undefined" && !r.buffer.empty) {
            finish(r);
            if (r.err == null) r.err = err;
            return createIteration(r, consumeExecution(r));
        }
        return this.next(Promise.reject(err));
    }
    [Symbol.asyncIterator]() {
        return this;
    }
};
if (typeof Symbol.asyncDispose === "symbol") Repeater.prototype[Symbol.asyncDispose] = function() {
    return this.return();
};
if (typeof Symbol.dispose === "symbol") Repeater.prototype[Symbol.dispose] = function() {
    this.return();
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"gQHY3":[function(require,module,exports,__globalThis) {
/// <reference types="./combinators.d.ts" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "latest", ()=>latest);
parcelHelpers.export(exports, "merge", ()=>merge);
parcelHelpers.export(exports, "race", ()=>race);
parcelHelpers.export(exports, "zip", ()=>zip);
var _chunkRTTLBQUCJs = require("./_chunks/chunk-RTTLBQUC.js");
// src/combinators.ts
var _coreJs = require("./core.js");
function getIterators(values, options) {
    const iters = [];
    for (const value of values){
        if (value != null && typeof value[Symbol.asyncIterator] === "function") iters.push(value[Symbol.asyncIterator]());
        else if (value != null && typeof value[Symbol.iterator] === "function") iters.push(value[Symbol.iterator]());
        else iters.push(async function* valueToAsyncIterator() {
            if (options.yieldValues) yield value;
            if (options.returnValues) return value;
        }());
    }
    return iters;
}
function race(contenders) {
    const iters = getIterators(contenders, {
        returnValues: true
    });
    return new (0, _coreJs.Repeater)(async (push, stop)=>{
        if (!iters.length) {
            stop();
            return;
        }
        let finalIteration;
        try {
            while(true){
                const tagged = iters.map((iter)=>Promise.resolve(iter.next()).then((iteration2)=>{
                        if (iteration2.done) {
                            stop();
                            if (finalIteration === void 0) finalIteration = iteration2;
                        }
                        return iteration2;
                    }, (err)=>{
                        stop(err);
                        return void 0;
                    }));
                const iteration = await (0, _chunkRTTLBQUCJs.safeRace)([
                    ...tagged,
                    stop
                ]);
                if (iteration === void 0 || iteration.done) break;
                await push(iteration.value);
            }
            return finalIteration && finalIteration.value;
        } finally{
            stop();
            await (0, _chunkRTTLBQUCJs.safeRace)(iters.map((iter)=>iter.return && iter.return()));
        }
    });
}
function merge(contenders) {
    const iters = getIterators(contenders, {
        yieldValues: true
    });
    return new (0, _coreJs.Repeater)(async (push, stop)=>{
        if (!iters.length) {
            stop();
            return;
        }
        let finalIteration;
        try {
            await Promise.all(iters.map(async (iter)=>{
                try {
                    while(true){
                        let iteration;
                        try {
                            iteration = await (0, _chunkRTTLBQUCJs.safeRace)([
                                Promise.resolve(iter.next()),
                                stop
                            ]);
                        } catch (err) {
                            stop(err);
                            return;
                        }
                        if (iteration === void 0) return;
                        else if (iteration.done) {
                            finalIteration = iteration;
                            return;
                        }
                        await push(iteration.value);
                    }
                } finally{
                    iter.return && await iter.return();
                }
            }));
            return finalIteration && finalIteration.value;
        } finally{
            stop();
        }
    });
}
function zip(contenders) {
    const iters = getIterators(contenders, {
        returnValues: true
    });
    return new (0, _coreJs.Repeater)(async (push, stop)=>{
        if (!iters.length) {
            stop();
            return [];
        }
        try {
            while(true){
                let iterations;
                try {
                    iterations = await (0, _chunkRTTLBQUCJs.safeRace)([
                        Promise.all(iters.map((iter)=>iter.next())),
                        stop
                    ]);
                } catch (err) {
                    stop(err);
                    return;
                }
                if (iterations === void 0) return;
                const values = iterations.map((iteration)=>iteration.value);
                if (iterations.some((iteration)=>iteration.done)) return values;
                await push(values);
            }
        } finally{
            stop();
            await Promise.all(iters.map((iter)=>iter.return && iter.return()));
        }
    });
}
function latest(contenders) {
    const iters = getIterators(contenders, {
        yieldValues: true,
        returnValues: true
    });
    return new (0, _coreJs.Repeater)(async (push, stop)=>{
        if (!iters.length) {
            stop();
            return [];
        }
        try {
            let iterations;
            try {
                iterations = await (0, _chunkRTTLBQUCJs.safeRace)([
                    Promise.all(iters.map((iter)=>iter.next())),
                    stop
                ]);
            } catch (err) {
                stop(err);
                return;
            }
            if (iterations === void 0) return;
            const values = iterations.map((iteration)=>iteration.value);
            if (iterations.every((iteration)=>iteration.done)) return values;
            await push(values.slice());
            return await Promise.all(iters.map(async (iter, i)=>{
                if (iterations[i].done) return iterations[i].value;
                while(true){
                    let iteration;
                    try {
                        iteration = await (0, _chunkRTTLBQUCJs.safeRace)([
                            Promise.resolve(iter.next()),
                            stop
                        ]);
                    } catch (err) {
                        stop(err);
                        return iterations[i].value;
                    }
                    if (iteration === void 0) return iterations[i].value;
                    else if (iteration.done) return iteration.value;
                    values[i] = iteration.value;
                    await push(values.slice());
                }
            }));
        } finally{
            stop();
            await Promise.all(iters.map((iter)=>iter.return && iter.return()));
        }
    });
}

},{"./_chunks/chunk-RTTLBQUC.js":"16p8z","./core.js":"de1Vk","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"16p8z":[function(require,module,exports,__globalThis) {
// src/_utils.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "safeRace", ()=>safeRace);
function isPromiseLike(value) {
    return value != null && typeof value.then === "function";
}
function createRaceRecord(contender) {
    const deferreds = /* @__PURE__ */ new Set();
    const record = {
        deferreds,
        settled: false
    };
    Promise.resolve(contender).then((value)=>{
        for (const { resolve } of deferreds)resolve(value);
        deferreds.clear();
        record.settled = true;
    }, (err)=>{
        for (const { reject } of deferreds)reject(err);
        deferreds.clear();
        record.settled = true;
    });
    return record;
}
var wm = /* @__PURE__ */ new WeakMap();
function safeRace(contenders) {
    let deferred;
    const result = new Promise((resolve, reject)=>{
        deferred = {
            resolve,
            reject
        };
        for (const contender of contenders){
            if (!isPromiseLike(contender)) {
                Promise.resolve(contender).then(resolve, reject);
                continue;
            }
            let record = wm.get(contender);
            if (record === void 0) {
                record = createRaceRecord(contender);
                record.deferreds.add(deferred);
                wm.set(contender, record);
            } else if (record.settled) Promise.resolve(contender).then(resolve, reject);
            else record.deferreds.add(deferred);
        }
    });
    return result.finally(()=>{
        for (const contender of contenders)if (isPromiseLike(contender)) {
            const record = wm.get(contender);
            if (record) record.deferreds.delete(deferred);
        }
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"7W11D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromFeature", ()=>fromFeature);
parcelHelpers.export(exports, "buildFeature", ()=>buildFeature);
parcelHelpers.export(exports, "parseProperties", ()=>parseProperties);
var _flatbuffers = require("flatbuffers");
var _columnTypeJs = require("../flat-geobuf/column-type.js");
var _featureJs = require("../flat-geobuf/feature.js");
var _geometryJs = require("./geometry.js");
const textEncoder = new TextEncoder();
const textDecoder = new TextDecoder();
function fromFeature(id, feature, header, createGeometry, createFeature) {
    const columns = header.columns;
    const geometry = feature.geometry();
    const simpleGeometry = createGeometry(geometry, header.geometryType);
    const properties = parseProperties(feature, columns);
    return createFeature(id, simpleGeometry, properties);
}
function buildFeature(geometry, properties, header) {
    const columns = header.columns;
    const builder = new _flatbuffers.Builder();
    let offset = 0;
    let capacity = 1024;
    let bytes = new Uint8Array(capacity);
    let view = new DataView(bytes.buffer);
    const prep = (size)=>{
        if (offset + size < capacity) return;
        capacity = Math.max(capacity + size, capacity * 2);
        const newBytes = new Uint8Array(capacity);
        newBytes.set(bytes);
        bytes = newBytes;
        view = new DataView(bytes.buffer);
    };
    if (columns) for(let i = 0; i < columns.length; i++){
        const column = columns[i];
        const value = properties[column.name];
        if (value === null) continue;
        prep(2);
        view.setUint16(offset, i, true);
        offset += 2;
        switch(column.type){
            case (0, _columnTypeJs.ColumnType).Bool:
                prep(1);
                view.setUint8(offset, value);
                offset += 1;
                break;
            case (0, _columnTypeJs.ColumnType).Short:
                prep(2);
                view.setInt16(offset, value, true);
                offset += 2;
                break;
            case (0, _columnTypeJs.ColumnType).UShort:
                prep(2);
                view.setUint16(offset, value, true);
                offset += 2;
                break;
            case (0, _columnTypeJs.ColumnType).Int:
                prep(4);
                view.setInt32(offset, value, true);
                offset += 4;
                break;
            case (0, _columnTypeJs.ColumnType).UInt:
                prep(4);
                view.setUint32(offset, value, true);
                offset += 4;
                break;
            case (0, _columnTypeJs.ColumnType).Long:
                prep(8);
                view.setBigInt64(offset, BigInt(value), true);
                offset += 8;
                break;
            case (0, _columnTypeJs.ColumnType).Float:
                prep(4);
                view.setFloat32(offset, value, true);
                offset += 4;
                break;
            case (0, _columnTypeJs.ColumnType).Double:
                prep(8);
                view.setFloat64(offset, value, true);
                offset += 8;
                break;
            case (0, _columnTypeJs.ColumnType).DateTime:
            case (0, _columnTypeJs.ColumnType).String:
                {
                    const str = textEncoder.encode(value);
                    prep(4);
                    view.setUint32(offset, str.length, true);
                    offset += 4;
                    prep(str.length);
                    bytes.set(str, offset);
                    offset += str.length;
                    break;
                }
            case (0, _columnTypeJs.ColumnType).Json:
                {
                    const str = textEncoder.encode(JSON.stringify(value));
                    prep(4);
                    view.setUint32(offset, str.length, true);
                    offset += 4;
                    prep(str.length);
                    bytes.set(str, offset);
                    offset += str.length;
                    break;
                }
            case (0, _columnTypeJs.ColumnType).Binary:
                {
                    prep(4);
                    const blob = value;
                    view.setUint32(offset, blob.length, true);
                    offset += 4;
                    prep(blob.length);
                    bytes.set(blob, offset);
                    offset += blob.length;
                    break;
                }
            default:
                throw new Error(`Unknown type ${column.type}`);
        }
    }
    let propertiesOffset = 0;
    if (offset > 0) propertiesOffset = (0, _featureJs.Feature).createPropertiesVector(builder, bytes.slice(0, offset));
    const geometryOffset = (0, _geometryJs.buildGeometry)(builder, geometry);
    (0, _featureJs.Feature).startFeature(builder);
    (0, _featureJs.Feature).addGeometry(builder, geometryOffset);
    if (propertiesOffset) (0, _featureJs.Feature).addProperties(builder, propertiesOffset);
    const featureOffset = (0, _featureJs.Feature).endFeature(builder);
    builder.finishSizePrefixed(featureOffset);
    return builder.asUint8Array();
}
function parseProperties(feature, columns) {
    const properties = {};
    if (!columns || columns.length === 0) return properties;
    const array = feature.propertiesArray();
    if (!array) return properties;
    const view = new DataView(array.buffer, array.byteOffset);
    const length = feature.propertiesLength();
    let offset = 0;
    while(offset < length){
        const i = view.getUint16(offset, true);
        offset += 2;
        const column = columns[i];
        const name = column.name;
        switch(column.type){
            case (0, _columnTypeJs.ColumnType).Bool:
                properties[name] = !!view.getUint8(offset);
                offset += 1;
                break;
            case (0, _columnTypeJs.ColumnType).Byte:
                properties[name] = view.getInt8(offset);
                offset += 1;
                break;
            case (0, _columnTypeJs.ColumnType).UByte:
                properties[name] = view.getUint8(offset);
                offset += 1;
                break;
            case (0, _columnTypeJs.ColumnType).Short:
                properties[name] = view.getInt16(offset, true);
                offset += 2;
                break;
            case (0, _columnTypeJs.ColumnType).UShort:
                properties[name] = view.getUint16(offset, true);
                offset += 2;
                break;
            case (0, _columnTypeJs.ColumnType).Int:
                properties[name] = view.getInt32(offset, true);
                offset += 4;
                break;
            case (0, _columnTypeJs.ColumnType).UInt:
                properties[name] = view.getUint32(offset, true);
                offset += 4;
                break;
            case (0, _columnTypeJs.ColumnType).Long:
                properties[name] = Number(view.getBigInt64(offset, true));
                offset += 8;
                break;
            case (0, _columnTypeJs.ColumnType).ULong:
                properties[name] = Number(view.getBigUint64(offset, true));
                offset += 8;
                break;
            case (0, _columnTypeJs.ColumnType).Float:
                properties[name] = view.getFloat32(offset, true);
                offset += 4;
                break;
            case (0, _columnTypeJs.ColumnType).Double:
                properties[name] = view.getFloat64(offset, true);
                offset += 8;
                break;
            case (0, _columnTypeJs.ColumnType).DateTime:
            case (0, _columnTypeJs.ColumnType).String:
                {
                    const length = view.getUint32(offset, true);
                    offset += 4;
                    properties[name] = textDecoder.decode(array.subarray(offset, offset + length));
                    offset += length;
                    break;
                }
            case (0, _columnTypeJs.ColumnType).Json:
                {
                    const length = view.getUint32(offset, true);
                    offset += 4;
                    const str = textDecoder.decode(array.subarray(offset, offset + length));
                    properties[name] = JSON.parse(str);
                    offset += length;
                    break;
                }
            case (0, _columnTypeJs.ColumnType).Binary:
                {
                    const length = view.getUint32(offset, true);
                    offset += 4;
                    properties[name] = array.subarray(offset, offset + length);
                    offset += length;
                    break;
                }
            default:
                throw new Error(`Unknown type ${column.type}`);
        }
    }
    return properties;
}

},{"flatbuffers":"4oKPA","../flat-geobuf/column-type.js":"cK2R8","../flat-geobuf/feature.js":"jNs3T","./geometry.js":"d9Uo0","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"d9Uo0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildGeometry", ()=>buildGeometry);
parcelHelpers.export(exports, "flat", ()=>flat);
parcelHelpers.export(exports, "parseGeometry", ()=>parseGeometry);
parcelHelpers.export(exports, "pairFlatCoordinates", ()=>pairFlatCoordinates);
parcelHelpers.export(exports, "toGeometryType", ()=>toGeometryType);
var _geometryJs = require("../flat-geobuf/geometry.js");
var _geometryTypeJs = require("../flat-geobuf/geometry-type.js");
function buildGeometry(builder, parsedGeometry) {
    const { xy, z, m, ends, parts, type } = parsedGeometry;
    if (parts) {
        const partOffsets = parts.map((part)=>buildGeometry(builder, part));
        const partsOffset = (0, _geometryJs.Geometry).createPartsVector(builder, partOffsets);
        (0, _geometryJs.Geometry).startGeometry(builder);
        (0, _geometryJs.Geometry).addParts(builder, partsOffset);
        (0, _geometryJs.Geometry).addType(builder, type);
        return (0, _geometryJs.Geometry).endGeometry(builder);
    }
    const xyOffset = (0, _geometryJs.Geometry).createXyVector(builder, xy);
    let zOffset;
    if (z) zOffset = (0, _geometryJs.Geometry).createZVector(builder, z);
    let mOffset;
    if (m) mOffset = (0, _geometryJs.Geometry).createMVector(builder, m);
    let endsOffset;
    if (ends) endsOffset = (0, _geometryJs.Geometry).createEndsVector(builder, ends);
    (0, _geometryJs.Geometry).startGeometry(builder);
    if (endsOffset) (0, _geometryJs.Geometry).addEnds(builder, endsOffset);
    (0, _geometryJs.Geometry).addXy(builder, xyOffset);
    if (zOffset) (0, _geometryJs.Geometry).addZ(builder, zOffset);
    if (mOffset) (0, _geometryJs.Geometry).addM(builder, mOffset);
    (0, _geometryJs.Geometry).addType(builder, type);
    return (0, _geometryJs.Geometry).endGeometry(builder);
}
function flat(a, xy, z, m) {
    if (a.length === 0) return;
    if (Array.isArray(a[0])) for (const sa of a)flat(sa, xy, z, m);
    else {
        const coordinates = a;
        if (coordinates.length === 2) xy.push(coordinates[0], coordinates[1]);
        else {
            xy.push(coordinates[0], coordinates[1]);
            if (coordinates[2] !== null) z.push(coordinates[2]);
            if (coordinates.length > 3 && m) m.push(coordinates[3]);
        }
    }
}
function deinterleaveZ(flatCoordinates) {
    const cLength = flatCoordinates.length / 3;
    const xy = new Array(cLength * 2);
    const z = new Array(cLength);
    for(let i = 0, j = 0; i < flatCoordinates.length; i += 3, j++){
        xy[j * 2] = flatCoordinates[i];
        xy[j * 2 + 1] = flatCoordinates[i + 1];
        z[j] = flatCoordinates[i + 2];
    }
    return [
        xy,
        z
    ];
}
function deinterleaveZM(flatCoordinates) {
    const cLength = flatCoordinates.length / 4;
    const xy = new Array(cLength * 2);
    const z = new Array(cLength);
    const m = new Array(cLength);
    for(let i = 0, j = 0; i < flatCoordinates.length; i += 4, j++){
        xy[j * 2] = flatCoordinates[i];
        xy[j * 2 + 1] = flatCoordinates[i + 1];
        z[j] = flatCoordinates[i + 2];
        m[j] = flatCoordinates[i + 3];
    }
    return [
        xy,
        z,
        m
    ];
}
function parseGeometry(geometry, headerGeomType) {
    let flatCoordinates;
    let xy;
    let z;
    let m;
    let ends;
    let parts;
    let type = headerGeomType;
    if (type === (0, _geometryTypeJs.GeometryType).Unknown) type = toGeometryType(geometry.getType());
    let flatEnds;
    if (type === (0, _geometryTypeJs.GeometryType).MultiLineString) {
        if (geometry.getFlatCoordinates) flatCoordinates = geometry.getFlatCoordinates();
        flatEnds = geometry.getEnds();
    } else if (type === (0, _geometryTypeJs.GeometryType).Polygon) {
        if (geometry.getFlatCoordinates) flatCoordinates = geometry.getFlatCoordinates();
        flatEnds = geometry.getEnds();
    } else if (type === (0, _geometryTypeJs.GeometryType).MultiPolygon) {
        const mp = geometry;
        parts = mp.getPolygons().map((p)=>parseGeometry(p, (0, _geometryTypeJs.GeometryType).Polygon));
    } else if (geometry.getFlatCoordinates) flatCoordinates = geometry.getFlatCoordinates();
    const layout = geometry.getLayout?.() ?? 'XY';
    if (flatCoordinates) {
        if (layout === 'XY') xy = flatCoordinates;
        else if (layout === 'XYZ') [xy, z] = deinterleaveZ(flatCoordinates);
        else if (layout === 'XYM') [xy, m] = deinterleaveZ(flatCoordinates);
        else if (layout === 'XYZM') [xy, z, m] = deinterleaveZM(flatCoordinates);
    }
    if (flatEnds) {
        let endDivision = 2;
        if (layout === 'XYZ' || layout === 'XYM') endDivision = 3;
        else if (layout === 'XYZM') endDivision = 4;
        ends = flatEnds.map((e)=>e / endDivision);
    }
    return {
        xy,
        z,
        m,
        ends,
        type,
        parts
    };
}
function pairFlatCoordinates(xy, z, m) {
    const newArray = [];
    for(let i = 0; i < xy.length; i += 2){
        const a = [
            xy[i],
            xy[i + 1]
        ];
        if (z) a.push(z[i >> 1]);
        else if (m) a.push(null);
        if (m) a.push(m[i >> 1]);
        newArray.push(a);
    }
    return newArray;
}
function toGeometryType(name) {
    if (!name) return (0, _geometryTypeJs.GeometryType).Unknown;
    const type = (0, _geometryTypeJs.GeometryType)[name];
    return type;
}

},{"../flat-geobuf/geometry.js":"gVFcX","../flat-geobuf/geometry-type.js":"99UDP","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"iP7qh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inferGeometryType", ()=>inferGeometryType);
var _geometryTypeJs = require("../flat-geobuf/geometry-type.js");
var _geometryJs = require("../generic/geometry.js");
function featureGeomType(feature) {
    if (feature.getGeometry) return (0, _geometryJs.toGeometryType)(feature.getGeometry().getType());
    return (0, _geometryJs.toGeometryType)(feature.geometry.type);
}
function inferGeometryType(features) {
    let geometryType;
    for (const f of features){
        if (geometryType === (0, _geometryTypeJs.GeometryType).Unknown) break;
        const gtype = featureGeomType(f);
        if (geometryType === undefined) geometryType = gtype;
        else if (geometryType !== gtype) geometryType = (0, _geometryTypeJs.GeometryType).Unknown;
    }
    if (geometryType === undefined) throw new Error('Could not infer geometry type for collection of features.');
    return geometryType;
}

},{"../flat-geobuf/geometry-type.js":"99UDP","../generic/geometry.js":"d9Uo0","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"aQ02q":[function(require,module,exports,__globalThis) {
module.exports = import("bEIwQ").then(()=>module.bundle.root('5mZUP'));

},{}],"cG257":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColumnType", ()=>(0, _columnTypeJs.ColumnType));
parcelHelpers.export(exports, "GeometryType", ()=>(0, _geometryTypeJs.GeometryType));
parcelHelpers.export(exports, "parseProperties", ()=>(0, _featureJs.parseProperties));
parcelHelpers.export(exports, "serialize", ()=>(0, _featurecollectionJs.serialize));
parcelHelpers.export(exports, "deserialize", ()=>deserialize);
parcelHelpers.export(exports, "readMetadata", ()=>readMetadata);
var _featurecollectionJs = require("./generic/featurecollection.js");
var _columnTypeJs = require("./flat-geobuf/column-type.js");
var _geometryTypeJs = require("./flat-geobuf/geometry-type.js");
var _featureJs = require("./generic/feature.js");
function deserialize(input, ctx) {
    if (ctx.seekableZstd) {
        if (input instanceof ReadableStream) throw new Error('Seekable Zstandard input must be a byte array or URL');
        return (0, _featurecollectionJs.deserializeSeekableZstdSource)(input, ctx);
    }
    if (input instanceof Uint8Array) return (0, _featurecollectionJs.deserialize)(input, ctx);
    if (input instanceof ReadableStream) return (0, _featurecollectionJs.deserializeStream)(input, ctx);
    return (0, _featurecollectionJs.deserializeFiltered)(input, ctx);
}
function readMetadata(url, nocache = false, headers = {}) {
    return (0, _featurecollectionJs.readMetadata)(url, nocache, headers);
}

},{"./generic/featurecollection.js":"eh4qT","./flat-geobuf/column-type.js":"cK2R8","./flat-geobuf/geometry-type.js":"99UDP","./generic/feature.js":"7W11D","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"hoFfE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFromFeatureFn", ()=>getFromFeatureFn);
var _featureJs = require("ol/Feature.js");
var _featureJsDefault = parcelHelpers.interopDefault(_featureJs);
var _featureJs1 = require("ol/format/Feature.js");
var _featureJs2 = require("ol/render/Feature.js");
var _featureJsDefault1 = parcelHelpers.interopDefault(_featureJs2);
var _featureJs3 = require("../generic/feature.js");
var _geometryJs = require("./geometry.js");
function getCreateFeatureFn(dataProjection, featureProjection) {
    return function createFeature(id, geometry, properties) {
        const olFeature = new (0, _featureJsDefault.default)(geometry);
        if (featureProjection && dataProjection !== featureProjection) olFeature.getGeometry()?.transform(dataProjection, featureProjection);
        olFeature.setId(id);
        const feature = olFeature;
        if (properties && feature.setProperties) feature.setProperties(properties);
        return feature;
    };
}
function getCreateRenderFeatureFn(dataProjection, featureProjection) {
    return function createRenderFeature(id, geometry, properties) {
        const geometryType = geometry?.getType() === 'MultiPolygon' ? 'Polygon' : geometry?.getType();
        if (geometryType === 'GeometryCollection' || geometryType === 'Circle') throw new Error(`Unsupported geometry type: ${geometryType}`);
        const flatCoordinates = geometry?.getFlatCoordinates?.();
        const stride = geometry?.getLayout?.().length;
        if (!flatCoordinates || !stride) throw new Error(`Geometry without coordinates: ${geometry}`);
        const renderFeature = new (0, _featureJsDefault1.default)(geometryType, flatCoordinates, [
            flatCoordinates.length
        ], stride, properties || {}, id);
        return (0, _featureJs1.transformGeometryWithOptions)(renderFeature.enableSimplifyTransformed(), false, {
            dataProjection,
            featureProjection
        });
    };
}
function getFromFeatureFn(options) {
    const renderFeature = options.renderFeature ?? false;
    const dataProjection = options.dataProjection ?? 'EPSG:4326';
    const featureProjection = options.featureProjection;
    let createFeatureFn;
    if (renderFeature) createFeatureFn = getCreateRenderFeatureFn(dataProjection, featureProjection);
    else createFeatureFn = getCreateFeatureFn(dataProjection, featureProjection);
    return (id, feature, header)=>(0, _featureJs3.fromFeature)(id, feature, header, (0, _geometryJs.createGeometry), createFeatureFn);
}

},{"ol/Feature.js":"iVSSP","ol/format/Feature.js":"lq6wN","ol/render/Feature.js":"THre5","../generic/feature.js":"7W11D","./geometry.js":"56RTK","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"56RTK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createGeometry", ()=>createGeometry);
var _lineStringJs = require("ol/geom/LineString.js");
var _lineStringJsDefault = parcelHelpers.interopDefault(_lineStringJs);
var _multiLineStringJs = require("ol/geom/MultiLineString.js");
var _multiLineStringJsDefault = parcelHelpers.interopDefault(_multiLineStringJs);
var _multiPointJs = require("ol/geom/MultiPoint.js");
var _multiPointJsDefault = parcelHelpers.interopDefault(_multiPointJs);
var _multiPolygonJs = require("ol/geom/MultiPolygon.js");
var _multiPolygonJsDefault = parcelHelpers.interopDefault(_multiPolygonJs);
var _pointJs = require("ol/geom/Point.js");
var _pointJsDefault = parcelHelpers.interopDefault(_pointJs);
var _polygonJs = require("ol/geom/Polygon.js");
var _polygonJsDefault = parcelHelpers.interopDefault(_polygonJs);
var _geometryTypeJs = require("../flat-geobuf/geometry-type.js");
function interleaveZ(flatCoordinates, z) {
    const newFlatCoordinates = new Array(flatCoordinates.length + z.length);
    for(let i = 0, j = 0, k = 0; i < flatCoordinates.length; i += 2, j++){
        newFlatCoordinates[k++] = flatCoordinates[i];
        newFlatCoordinates[k++] = flatCoordinates[i + 1];
        newFlatCoordinates[k++] = z[j];
    }
    return newFlatCoordinates;
}
function interleaveZM(flatCoordinates, z, m) {
    const newFlatCoordinates = new Array(flatCoordinates.length + z.length + m.length);
    for(let i = 0, j = 0, k = 0; i < flatCoordinates.length; i += 2, j++){
        newFlatCoordinates[k++] = flatCoordinates[i];
        newFlatCoordinates[k++] = flatCoordinates[i + 1];
        newFlatCoordinates[k++] = z[j];
        newFlatCoordinates[k++] = m[j];
    }
    return newFlatCoordinates;
}
function createGeometry(geometry, headerGeomType) {
    let geomType;
    if (headerGeomType === (0, _geometryTypeJs.GeometryType).Unknown) geomType = geometry?.type();
    else geomType = headerGeomType;
    if (!geometry) return;
    const xyArray = geometry.xyArray();
    if (xyArray) {
        let flatCoordinates = Array.from(xyArray);
        const z = geometry.zArray();
        const m = geometry.mArray();
        const ends = geometry.endsArray();
        let layout = 'XY';
        let endsMultiplier = 2;
        if (z && m) {
            layout = 'XYZM';
            flatCoordinates = interleaveZM(flatCoordinates, Array.from(z), Array.from(m));
            endsMultiplier = 4;
        } else if (z) {
            layout = 'XYZ';
            flatCoordinates = interleaveZ(flatCoordinates, Array.from(z));
            endsMultiplier = 3;
        } else if (m) {
            layout = 'XYM';
            flatCoordinates = interleaveZ(flatCoordinates, Array.from(m));
            endsMultiplier = 3;
        }
        const olEnds = ends ? Array.from(ends.map((e)=>e * endsMultiplier)) : [
            flatCoordinates.length
        ];
        switch(geomType){
            case (0, _geometryTypeJs.GeometryType).Point:
                return new (0, _pointJsDefault.default)(flatCoordinates);
            case (0, _geometryTypeJs.GeometryType).MultiPoint:
                return new (0, _multiPointJsDefault.default)(flatCoordinates, layout);
            case (0, _geometryTypeJs.GeometryType).LineString:
                return new (0, _lineStringJsDefault.default)(flatCoordinates, layout);
            case (0, _geometryTypeJs.GeometryType).MultiLineString:
                return new (0, _multiLineStringJsDefault.default)(flatCoordinates, layout, olEnds);
            case (0, _geometryTypeJs.GeometryType).Polygon:
                return new (0, _polygonJsDefault.default)(flatCoordinates, layout, olEnds);
        }
    }
    if (geomType === (0, _geometryTypeJs.GeometryType).MultiPolygon) {
        const partsLength = geometry.partsLength();
        const polygons = new Array(partsLength);
        for(let i = 0; i < partsLength; i++)polygons[i] = createGeometry(geometry.parts(i), (0, _geometryTypeJs.GeometryType).Polygon);
        return new (0, _multiPolygonJsDefault.default)(polygons);
    }
    throw new Error('Unknown type');
}

},{"ol/geom/LineString.js":"223qD","ol/geom/MultiLineString.js":"5Cre5","ol/geom/MultiPoint.js":"jiQtb","ol/geom/MultiPolygon.js":"6i4VN","ol/geom/Point.js":"95T6m","ol/geom/Polygon.js":"3zws5","../flat-geobuf/geometry-type.js":"99UDP","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2oVBi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FGB_PREFIX_LEN", ()=>FGB_PREFIX_LEN);
/**
 * Validates the magic bytes and returns the header length from the first
 * `FGB_PREFIX_LEN` bytes of a file.
 *
 * @param {Uint8Array} prefix
 * @returns {number}
 */ parcelHelpers.export(exports, "parseFgbHeaderLength", ()=>parseFgbHeaderLength);
/**
 * The byte range to request for a header `fromByteBuffer` can parse: the
 * size prefix plus the header.
 *
 * @param {number} headerLength
 * @returns {{start: number, length: number}}
 */ parcelHelpers.export(exports, "fgbHeaderRange", ()=>fgbHeaderRange);
/**
 * @param {Uint8Array} sizePrefixedHeader the bytes of `fgbHeaderRange`
 * @returns {number}
 */ parcelHelpers.export(exports, "parseFgbFeaturesCount", ()=>parseFgbFeaturesCount);
var _flatbuffers = require("flatbuffers");
var _headerMetaJs = require("flatgeobuf/lib/mjs/header-meta.js");
var _constantsJs = require("flatgeobuf/lib/mjs/constants.js");
const FGB_PREFIX_LEN = (0, _constantsJs.magicbytes).length + (0, _constantsJs.SIZE_PREFIX_LEN);
function parseFgbHeaderLength(prefix) {
    if (prefix.byteLength < FGB_PREFIX_LEN) throw new Error("Not a FlatGeobuf file");
    if (!prefix.subarray(0, 3).every((b, i)=>(0, _constantsJs.magicbytes)[i] === b)) throw new Error("Not a FlatGeobuf file");
    const headerLength = new DataView(prefix.buffer, prefix.byteOffset + (0, _constantsJs.magicbytes).length, (0, _constantsJs.SIZE_PREFIX_LEN)).getUint32(0, true);
    if (headerLength > (0, _constantsJs.HEADER_MAX_BUFFER_SIZE) || headerLength < 8) throw new Error("Invalid header size");
    return headerLength;
}
function fgbHeaderRange(headerLength) {
    return {
        start: (0, _constantsJs.magicbytes).length,
        length: (0, _constantsJs.SIZE_PREFIX_LEN) + headerLength
    };
}
function parseFgbFeaturesCount(sizePrefixedHeader) {
    return (0, _headerMetaJs.fromByteBuffer)(new _flatbuffers.ByteBuffer(sizePrefixedHeader)).featuresCount;
}

},{"flatbuffers":"4oKPA","flatgeobuf/lib/mjs/header-meta.js":"eEB1R","flatgeobuf/lib/mjs/constants.js":"5WAfl","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"fKb2O":[function(require,module,exports,__globalThis) {
// Colours for the Orbis Lane `lane_function` values (bicycle, drivable, entrance,
// exit, parking, shoulder). The tag is multi-valued (`drivable;entrance`), and
// `drivable` is the spec's default, so it only shows when nothing more specific
// is there: an entrance lane that is also drivable reads as an entrance lane.
//
// Shoulder is grey, not white: the old style drew it white on a white casing,
// which made shoulders invisible.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNKNOWN_LANE_FUNCTION_COLOR", ()=>UNKNOWN_LANE_FUNCTION_COLOR);
/**
 * @param {string|undefined} laneFunction raw tag value, `;`-separated
 * @returns {string[]} one colour per function, most specific first; at least one
 */ parcelHelpers.export(exports, "laneFunctionColors", ()=>laneFunctionColors);
parcelHelpers.export(exports, "BASEMAP_LAYER_ID", ()=>BASEMAP_LAYER_ID);
parcelHelpers.export(exports, "LANE_FUNCTION_LAYER_ID", ()=>LANE_FUNCTION_LAYER_ID);
/**
 * lane_function as tagged by one layer, read by its full key so the basemap's
 * value and 38434's can't stand in for each other.
 * @param {{get: (key: string) => any}} feature
 * @param {string} layerId
 */ parcelHelpers.export(exports, "getLaneFunctionOf", ()=>getLaneFunctionOf);
/**
 * @typedef {"agree"|"refined"|"disagree"|"basemap-missing"|"layer-missing"|"none"} LaneFunctionStatus
 */ /**
 * Compares the two `lane_function` values, order-insensitively
 * (`entrance;drivable` agrees with `drivable;entrance`).
 * @param {string|undefined} basemapValue `29351-lane_function`
 * @param {string|undefined} layerValue `38434-lane_function`
 * @returns {{status: LaneFunctionStatus, label: string|undefined}}
 *   label is undefined when the two agree or 38434 refines the basemap
 */ parcelHelpers.export(exports, "compareLaneFunction", ()=>compareLaneFunction);
const LANE_FUNCTION_COLORS = {
    drivable: "#43a047",
    entrance: "#1e88e5",
    exit: "#8e24aa",
    shoulder: "#9e9e9e",
    parking: "#6d4c41",
    bicycle: "#00acc1"
};
const UNKNOWN_LANE_FUNCTION_COLOR = "#d81b60";
function laneFunctionColors(laneFunction) {
    const values = (laneFunction ?? "").split(";").map((v)=>v.trim()).filter((v)=>v !== "");
    const specific = values.filter((v)=>v !== "drivable");
    if (specific.length === 0) return [
        LANE_FUNCTION_COLORS.drivable
    ];
    return [
        ...new Set(specific.map((v)=>LANE_FUNCTION_COLORS[v] ?? UNKNOWN_LANE_FUNCTION_COLOR))
    ];
}
const BASEMAP_LAYER_ID = "29351";
const LANE_FUNCTION_LAYER_ID = "38434";
function getLaneFunctionOf(feature, layerId) {
    const key = `${layerId}-lane_function`;
    return feature.get(key) ?? feature.get(key + ":step");
}
function functionSet(laneFunction) {
    if (laneFunction === undefined || laneFunction === null) return undefined;
    const values = String(laneFunction).split(";").map((v)=>v.trim()).filter((v)=>v !== "");
    return values.length === 0 ? undefined : [
        ...new Set(values)
    ].sort();
}
function compareLaneFunction(basemapValue, layerValue) {
    const basemap = functionSet(basemapValue);
    const layer = functionSet(layerValue);
    if (basemap === undefined && layer === undefined) return {
        status: "none",
        label: "no lane_function"
    };
    if (basemap === undefined) return {
        status: "basemap-missing",
        label: `no ${BASEMAP_LAYER_ID}`
    };
    if (layer === undefined) return {
        status: "layer-missing",
        label: `no ${LANE_FUNCTION_LAYER_ID}`
    };
    if (basemap.join(";") === layer.join(";")) return {
        status: "agree",
        label: undefined
    };
    // 38434 keeping every basemap function and adding some (drivable ->
    // drivable;entrance) is a fine-tune of the basemap, not a contradiction.
    if (basemap.every((v)=>layer.includes(v))) return {
        status: "refined",
        label: undefined
    };
    return {
        status: "disagree",
        label: `${BASEMAP_LAYER_ID} \u{2260} ${LANE_FUNCTION_LAYER_ID}`
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"i6xk4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addFeatureInfoControl", ()=>addFeatureInfoControl);
var _featureInfoControl = require("../controls/FeatureInfoControl");
var _entryGlueJs = require("../featureinfo/entryGlue.js");
var _hoverOverControlsMjs = require("../util/hoverOverControls.mjs");
function addFeatureInfoControl(map) {
    const featureInfoControl = new (0, _featureInfoControl.FeatureInfoControl)();
    map.addControl(featureInfoControl);
    map.on("singleclick", function() {
        const allHoverLayers = featureInfoControl.getAllHoverLayers();
        allHoverLayers.forEach((hoverLayer)=>hoverLayer.getSource().clear());
        featureInfoControl.unset("selectedFeaturesAndLayers");
    });
    // Onto the sidebar, drawer or hover box: the moves below stop at the canvas check,
    // so the last hover would stay drawn.
    const clear = ()=>{
        featureInfoControl.clearHover();
        (0, _entryGlueJs.markMemberRows)(new Set());
    };
    (0, _hoverOverControlsMjs.onPointerOntoControls)(map, clear);
    // Out of the window: no further pointermove would clear the last hover.
    map.getViewport().addEventListener("pointerleave", clear);
    map.on("pointermove", function(e) {
        const featuresAtPixel = [];
        if (e.originalEvent.target.tagName !== "CANVAS") return;
        const allHoverLayers = featureInfoControl.getAllHoverLayers();
        map.forEachFeatureAtPixel(e.pixel, (feature, layer)=>{
            if (feature.get("nonInteractive")) return;
            featuresAtPixel.push({
                feature: feature,
                layer: layer
            });
        }, {
            layerFilter: (layer)=>!allHoverLayers.includes(layer)
        });
        // Position silently, then the selection: one hover update per move, at the new
        // position (setProperties fired two, the first at the old position).
        featureInfoControl.set("position", e.coordinate, true);
        featureInfoControl.set("selectedFeaturesAndLayers", featuresAtPixel);
        // Mark sidebar member rows of the features under the pointer, in every row.
        (0, _entryGlueJs.markMemberRows)(new Set(featuresAtPixel.map(({ feature })=>String(feature.getId()))));
    });
    return featureInfoControl;
}

},{"../controls/FeatureInfoControl":"1o8a6","../featureinfo/entryGlue.js":"e5kaS","../util/hoverOverControls.mjs":"9qan7","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"1o8a6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FeatureInfoControl", ()=>FeatureInfoControl);
var _control = require("ol/control/Control");
var _controlDefault = parcelHelpers.interopDefault(_control);
var _util = require("../util");
var _curvature = require("../layers/style/curvature");
var _helpers = require("@turf/helpers");
var _turf = require("@turf/turf");
var _nearestPointOnLine = require("@turf/nearest-point-on-line");
var _nearestPointOnLineDefault = parcelHelpers.interopDefault(_nearestPointOnLine);
var _geom = require("ol/geom");
var _orbisLrSdk = require("@orbis-lr-sdk/orbis-lr-sdk");
var _hoverLayer = require("../layers/HoverLayer");
var _laneListsMjs = require("../layers/style/util/laneLists.mjs");
var _laneFunctionMjs = require("../layers/style/util/laneFunction.mjs");
var _conditionalValuesMjs = require("../layers/style/util/conditionalValues.mjs");
var _entryGlueJs = require("../featureinfo/entryGlue.js");
var _featureModelMjs = require("../featureinfo/featureModel.mjs");
var _hoverRowsMjs = require("../featureinfo/hoverRows.mjs");
var _renderValuesMjs = require("../featureinfo/renderValues.mjs");
var _curvatureSpeedMjs = require("../layers/style/util/curvatureSpeed.mjs");
var _hoverClearMjs = require("../featureinfo/hoverClear.mjs");
// Skips the redraw an empty source's clear() would still trigger on every move.
const clearSource = (source)=>{
    if (!source.isEmpty()) source.clear();
};
// The hover box rebuilds on every pointermove, the model only when the feature did:
// feature.set() does not bump the revision, so handlers adding properties (lengthCm,
// relation-id, …) are caught by the key count.
const hoverModels = new WeakMap();
function hoverModelOf(feature) {
    const cached = hoverModels.get(feature);
    const keyCount = feature.getKeys().length;
    if (cached && cached.revision === feature.getRevision() && cached.keyCount === keyCount) return cached.model;
    const length = feature.get("lengthCm");
    const model = (0, _featureModelMjs.buildFeatureModel)({
        id: String(feature.getId() ?? ""),
        properties: feature.getProperties(),
        geometryType: feature.getGeometry()?.getType(),
        lengthCm: Number.isFinite(length) ? length : null
    });
    hoverModels.set(feature, {
        revision: feature.getRevision(),
        keyCount,
        model
    });
    return model;
}
class FeatureInfoControl extends (0, _controlDefault.default) {
    constructor(){
        const div = document.createElement("div");
        super({
            element: div
        });
        const this_ = this;
        this.handlersForLayers = [];
        this.hoverLayersForLayers = [];
        div.id = "feature-info";
        div.className = "ol-unselectable";
        this.attributesTable = document.createElement("table");
        this.attributesTable.className = "ol-selectable feature-info-list";
        div.append(this.attributesTable);
        // listen to changes
        this.on("propertychange", ()=>{
            // roles
            const selectedFeaturesAndLayers = this_.get("selectedFeaturesAndLayers");
            // Only what is under the pointer stays drawn; the loop below redraws it.
            this_.clearHoverDrawings(selectedFeaturesAndLayers ?? []);
            if (selectedFeaturesAndLayers === undefined) {
                this.element.style.display = "none";
                (0, _entryGlueJs.moveLiveCursor)(null);
                return;
            }
            const selectedFeatures = selectedFeaturesAndLayers.map((featureAndLayer)=>featureAndLayer.feature);
            const position = this_.get("position");
            const fcdSpeeds = this_.get("fcdSpeeds");
            this.showValuesAtPosition(position, selectedFeatures, fcdSpeeds);
            selectedFeaturesAndLayers.forEach((featureAndLayer)=>{
                const feature = featureAndLayer.feature;
                const layer = featureAndLayer.layer;
                this_.getHandlersForLayer(layer).forEach((handler)=>handler(feature, layer, position));
                const hoverLayers = this_.getHoverLayersForLayer(layer);
                if (hoverLayers.length === 0) return;
                // Only a line gets a tangent: a polygon under the pointer keeps the line's.
                const built = (0, _hoverLayer.buildTangentFeature)(feature, position);
                if (!built) return;
                const keyValuesAt = this.getKeyValuesAt(feature, (0, _util.distanceAlongCm)(built.latLonGeometry, built.closestPointLatLon));
                keyValuesAt.forEach(([k, v])=>built.tangent.set(k, v));
                hoverLayers.forEach((hoverLayer)=>{
                    clearSource(hoverLayer.getSource());
                    hoverLayer.getSource().addFeature(built.tangent);
                });
            });
        });
    }
    getHandlersForLayer(layer) {
        return this.handlersForLayers.filter((layerAndHandler)=>layerAndHandler.layer === layer).map((layerAndHandler)=>layerAndHandler.handler);
    }
    getHoverLayersForLayer(layer) {
        return this.hoverLayersForLayers.filter((layerAndHoverLayer)=>layerAndHoverLayer.layer === layer).map((layerAndHoverLayer)=>layerAndHoverLayer.hoverLayer);
    }
    getAllHoverLayers() {
        return this.hoverLayersForLayers.map((layerAndHoverLayer)=>layerAndHoverLayer.hoverLayer);
    }
    /** Tangent layers of layers with no hovered line, and every handler's drawing. */ clearHoverDrawings(hovered) {
        const lines = hovered.map(({ feature, layer })=>({
                layer,
                line: feature.getGeometry()?.getType() === "LineString"
            }));
        (0, _hoverClearMjs.staleHoverLayers)(this.hoverLayersForLayers, lines).forEach((layer)=>clearSource(layer.getSource()));
        this.handlersForLayers.forEach(({ handler })=>handler.clear?.());
    }
    /** The pointer left the map (onto a control): drop every hover drawing and the box. */ clearHover() {
        this.clearHoverDrawings([]);
        this.unset("selectedFeaturesAndLayers");
    }
    addHandlerForLayer(handler, layer) {
        this.handlersForLayers.push({
            layer: layer,
            handler: handler
        });
    }
    addHoverLayerForLayer(hoverLayer, layer) {
        this.hoverLayersForLayers.push({
            layer: layer,
            hoverLayer: hoverLayer
        });
    }
    showValuesAtPosition(position, selectedFeatures, fcdSpeeds) {
        const hasFcd = fcdSpeeds && Object.keys(fcdSpeeds).length > 0;
        const closestFeature = position !== undefined && selectedFeatures !== undefined ? this.findClosestLineFeature(selectedFeatures, position) : null;
        if (!closestFeature) {
            (0, _entryGlueJs.moveLiveCursor)(null);
            if (!hasFcd) {
                this.element.style.display = "none";
                return;
            }
            this.refreshAttributes(null, null, [], fcdSpeeds);
            return;
        }
        const latLonGeometry = (0, _util.toLatLon)((0, _helpers.lineString)(closestFeature.getGeometry().getCoordinates()).geometry);
        const closestPointLatLon = (0, _nearestPointOnLineDefault.default)(latLonGeometry, (0, _util.toLatLon)((0, _helpers.point)(position).geometry));
        const distanceAtFeatureCm = (0, _util.distanceAlongCm)(latLonGeometry, closestPointLatLon);
        (0, _entryGlueJs.moveLiveCursor)(closestFeature, distanceAtFeatureCm);
        const keyValuesAt = this.getKeyValuesAt(closestFeature, distanceAtFeatureCm);
        this.refreshAttributes(closestFeature, distanceAtFeatureCm, keyValuesAt, fcdSpeeds);
    }
    findClosestLineFeature(selectedFeatures, position) {
        const latLonEventPoint = (0, _util.toLatLon)((0, _helpers.point)(position).geometry);
        return Array.from(selectedFeatures).filter((feature)=>feature.getGeometry() instanceof (0, _geom.LineString)).sort((f1, f2)=>(0, _turf.pointToLineDistance)(latLonEventPoint, (0, _helpers.lineString)(f1.getGeometry().getCoordinates()).geometry) - (0, _turf.pointToLineDistance)(latLonEventPoint, (0, _helpers.lineString)(f2.getGeometry().getCoordinates()).geometry))[0];
    }
    refreshAttributes(feature, distanceAtFeatureCm, keyValuesAt, fcdSpeeds) {
        this.attributesTable.innerHTML = "";
        const colGroup = document.createElement("colgroup");
        const colLabel = document.createElement("col");
        colLabel.classList.add("label");
        const colValue = document.createElement("col");
        colValue.classList.add("value");
        colGroup.appendChild(colLabel);
        colGroup.appendChild(colValue);
        this.attributesTable.appendChild(colGroup);
        this.element.style.display = "block";
        this.attributesTable.style = "display: table;";
        if (feature) {
            const view = (0, _hoverRowsMjs.hoverView)(hoverModelOf(feature), distanceAtFeatureCm, keyValuesAt);
            const idRow = (0, _util.rowHeader)(view.id);
            idRow.firstChild.className = "fe-hid";
            this.attributesTable.append(idRow);
            this.attributesTable.append((0, _util.rowHeader)(view.positionText));
            view.groups.forEach((group)=>{
                const groupRow = (0, _util.rowHeader)(group.prefix || (0, _featureModelMjs.NO_PREFIX_LABEL));
                groupRow.firstChild.className = "fe-hg";
                this.attributesTable.append(groupRow);
                group.rows.forEach(({ key, value, rangeText })=>{
                    const cell = document.createElement("span");
                    cell.textContent = (0, _renderValuesMjs.valueText)(value);
                    if (rangeText) {
                        const range = document.createElement("span");
                        range.className = "fe-hs";
                        range.textContent = rangeText;
                        cell.append(" ", range);
                    }
                    this.attributesTable.append((0, _util.row)(key, cell));
                });
            });
            view.derived.forEach(([key, value])=>this.attributesTable.append((0, _util.row)(key, (0, _renderValuesMjs.valueText)(value))));
            this.attributesTable.append((0, _util.rowHint)("click feature to see all tags"));
        }
        if (fcdSpeeds && Object.keys(fcdSpeeds).length > 0) {
            this.attributesTable.append((0, _util.rowHeader)("FCD speed at cursor"));
            Object.keys(fcdSpeeds).map((id)=>Number(id)).sort((a, b)=>a - b).forEach((id)=>{
                const arrow = document.createElement("span");
                arrow.textContent = "\u2191";
                arrow.style.display = "inline-block";
                arrow.style.transform = `rotate(${(0, _hoverRowsMjs.fcdHeadingDeg)(id)}deg)`;
                this.attributesTable.append((0, _util.row)(arrow, fcdSpeeds[id] + " km/h"));
            });
        }
    }
    getKeyValuesAt(feature, distanceAtFeatureCm) {
        const keyValuesAt = feature.getKeys().filter((key)=>key !== "geometry").filter((key)=>key !== "type").filter((key)=>key !== "lengthCm").filter((key)=>key !== "meta-uuid").filter((key)=>!key.startsWith("revision-")).filter((key)=>{
            const value = feature.get(key);
            return new (0, _orbisLrSdk.LRChainEncoded)(key, value?.toString() ?? "").isLrEncoded();
        }).map((key)=>{
            const value = feature.get(key);
            const valueAt = (0, _orbisLrSdk.ValueAtProducer).getValueAt(key, value?.toString(), distanceAtFeatureCm);
            return [
                key,
                valueAt
            ];
        });
        // Append derived radius and max speed for LR-encoded curvature
        const curvatureEntry = keyValuesAt.find(([key])=>key.endsWith("-curvature:linear") || key.endsWith("-curvature"));
        if (curvatureEntry) {
            const curvature = Number(curvatureEntry[1]);
            if (curvature !== 0 && !isNaN(curvature)) {
                const radius = 10000 / Math.abs(curvature);
                keyValuesAt.push([
                    (0, _curvatureSpeedMjs.NDS_CURVATURE_LABEL),
                    (0, _curvature.orbisCurvatureToNds)(curvature)
                ]);
                keyValuesAt.push([
                    (0, _curvatureSpeedMjs.RADIUS_LABEL),
                    Math.round(radius) + " m"
                ]);
                keyValuesAt.push([
                    (0, _curvatureSpeedMjs.MAX_SPEED_LABEL),
                    (0, _curvature.maxSpeedDisplayFromCurvature)(curvature)
                ]);
            }
        }
        // Append curvature_at_junction (plain numeric, not LR-encoded) + derived values
        keyValuesAt.push(...(0, _curvature.curvatureAtJunctionKeyValues)(feature.get("curvature_at_junction")));
        // Append the LM lane's road class, derived from its road area by
        // laneRoadClassHandler (a plain value, so the LR filter above drops it).
        const laneRoadClass = feature.get("laneRoadClass");
        if (laneRoadClass !== undefined) keyValuesAt.push([
            "road class (road area)",
            laneRoadClass
        ]);
        // The basemap and lane-function layers each tag lane_function; say whether they
        // agree, as the LM Lane Function view does on the map.
        const basemapLaneFunction = (0, _laneFunctionMjs.getLaneFunctionOf)(feature, (0, _laneFunctionMjs.BASEMAP_LAYER_ID));
        const layerLaneFunction = (0, _laneFunctionMjs.getLaneFunctionOf)(feature, (0, _laneFunctionMjs.LANE_FUNCTION_LAYER_ID));
        if (basemapLaneFunction !== undefined || layerLaneFunction !== undefined) {
            const { status } = (0, _laneFunctionMjs.compareLaneFunction)(basemapLaneFunction, layerLaneFunction);
            keyValuesAt.push([
                "lane_function check",
                `${(0, _laneFunctionMjs.BASEMAP_LAYER_ID)}: ${basemapLaneFunction ?? "\u2013"}, ${(0, _laneFunctionMjs.LANE_FUNCTION_LAYER_ID)}: ${layerLaneFunction ?? "\u2013"} (${status})`
            ]);
        }
        // Append readable per-lane rows for #Conditional HOV. Read from the FEATURE, not
        // from keyValuesAt: whether the raw row survived the isLrEncoded filter is the
        // SDK's call, but the derived summary must not depend on it.
        keyValuesAt.push(...hovConditionalKeyValues(feature, distanceAtFeatureCm));
        return keyValuesAt;
    }
}
// The position-resolved value of the first feature key containing `part` (the
// step-sectioned variant carries a `:step` suffix, so a contains-test finds both).
function conditionalValueAt(feature, part, distanceAtFeatureCm) {
    const key = feature.getKeys().filter((key)=>!key.startsWith("revision-")).find((key)=>key.includes(part));
    if (!key) return undefined;
    return (0, _orbisLrSdk.ValueAtProducer).getValueAt(key, feature.get(key)?.toString(), distanceAtFeatureCm);
}
// One row per HOV lane: its time window, the minimum occupancy, and — when the
// window parses — whether it is active at the browser's clock. The window is written
// in the ROAD's local time, so the row names the timezone it was evaluated in
// instead of pretending the two clocks agree.
function hovConditionalKeyValues(feature, distanceAtFeatureCm) {
    const lanesValue = conditionalValueAt(feature, "-hov:lanes:conditional", distanceAtFeatureCm);
    if (lanesValue === undefined) return [];
    const minimumsValue = conditionalValueAt(feature, "-hov:minimum:lanes:conditional", distanceAtFeatureCm);
    const lanes = (0, _laneListsMjs.splitLaneList)(lanesValue);
    const minimums = (0, _laneListsMjs.splitLaneList)(minimumsValue);
    const now = new Date();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const rows = [];
    lanes.forEach((slot, index)=>{
        const parsed = (0, _conditionalValuesMjs.splitConditionalValue)(slot);
        if (!parsed) return;
        const minimum = (0, _conditionalValuesMjs.splitConditionalValue)(minimums[index] ?? "");
        let text = parsed.condition ?? "always";
        if (minimum?.value) text += ` \xb7 min occupancy ${minimum.value}`;
        const active = (0, _conditionalValuesMjs.isActiveAt)((0, _conditionalValuesMjs.parseTimeDomain)(parsed.condition), now);
        if (active !== null) text += ` \xb7 active now (${timeZone}): ${active ? "yes" : "no"}`;
        rows.push([
            `HOV window, lane ${index + 1} of ${lanes.length}`,
            text
        ]);
    });
    return rows;
}

},{"ol/control/Control":"8KSMn","../util":"4IC9E","../layers/style/curvature":"dM5mO","@turf/helpers":"ityOQ","@turf/turf":"jMUNq","@turf/nearest-point-on-line":"bwWlY","ol/geom":[["LineString","223qD","default"]],"@orbis-lr-sdk/orbis-lr-sdk":"04bfk","../layers/HoverLayer":"3Tely","../layers/style/util/laneLists.mjs":"fzyYi","../layers/style/util/laneFunction.mjs":"fKb2O","../layers/style/util/conditionalValues.mjs":"adIen","../featureinfo/entryGlue.js":"e5kaS","../featureinfo/featureModel.mjs":"9MLBf","../featureinfo/hoverRows.mjs":"2VHKF","../featureinfo/renderValues.mjs":"jzrm4","../layers/style/util/curvatureSpeed.mjs":"9kySC","../featureinfo/hoverClear.mjs":"chhLq","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"jMUNq":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>index_default);
parcelHelpers.export(exports, "pointToLineDistance", ()=>pointToLineDistance);
var _helpers = require("@turf/helpers");
var _nearestPointOnLine = require("@turf/nearest-point-on-line");
var _invariant = require("@turf/invariant");
var _meta = require("@turf/meta");
var _rhumbDistance = require("@turf/rhumb-distance");
function pointToLineDistance(pt, line, options = {}) {
    var _a, _b;
    const method = (_a = options.method) != null ? _a : "geodesic";
    const units = (_b = options.units) != null ? _b : "kilometers";
    if (!pt) throw new Error("pt is required");
    if (Array.isArray(pt)) pt = (0, _helpers.point)(pt);
    else if (pt.type === "Point") pt = (0, _helpers.feature)(pt);
    else (0, _invariant.featureOf)(pt, "Point", "point");
    if (!line) throw new Error("line is required");
    if (Array.isArray(line)) line = (0, _helpers.lineString)(line);
    else if (line.type === "LineString") line = (0, _helpers.feature)(line);
    else (0, _invariant.featureOf)(line, "LineString", "line");
    let distance = Infinity;
    const p = pt.geometry.coordinates;
    (0, _meta.segmentEach)(line, (segment)=>{
        if (segment) {
            const a = segment.geometry.coordinates[0];
            const b = segment.geometry.coordinates[1];
            const d = distanceToSegment(p, a, b, {
                method
            });
            if (d < distance) distance = d;
        }
    });
    return (0, _helpers.convertLength)(distance, "degrees", units);
}
function distanceToSegment(p, a, b, options) {
    if (options.method === "geodesic") {
        const nearest = (0, _nearestPointOnLine.nearestPointOnLine)((0, _helpers.lineString)([
            a,
            b
        ]).geometry, p, {
            units: "degrees"
        });
        return nearest.properties.pointDistance;
    }
    const v = [
        b[0] - a[0],
        b[1] - a[1]
    ];
    const w = [
        p[0] - a[0],
        p[1] - a[1]
    ];
    const c1 = dot(w, v);
    if (c1 <= 0) return (0, _rhumbDistance.rhumbDistance)(p, a, {
        units: "degrees"
    });
    const c2 = dot(v, v);
    if (c2 <= c1) return (0, _rhumbDistance.rhumbDistance)(p, b, {
        units: "degrees"
    });
    const b2 = c1 / c2;
    const Pb = [
        a[0] + b2 * v[0],
        a[1] + b2 * v[1]
    ];
    return (0, _rhumbDistance.rhumbDistance)(p, Pb, {
        units: "degrees"
    });
}
function dot(u, v) {
    return u[0] * v[0] + u[1] * v[1];
}
var index_default = pointToLineDistance;

},{"@turf/helpers":"ityOQ","@turf/nearest-point-on-line":"bwWlY","@turf/invariant":"8Sv4q","@turf/meta":"7ABec","@turf/rhumb-distance":"302tZ","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"302tZ":[function(require,module,exports,__globalThis) {
// index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>index_default);
parcelHelpers.export(exports, "rhumbDistance", ()=>rhumbDistance);
var _helpers = require("@turf/helpers");
var _invariant = require("@turf/invariant");
function rhumbDistance(from, to, options = {}) {
    const origin = (0, _invariant.getCoord)(from);
    const destination = (0, _invariant.getCoord)(to);
    destination[0] += destination[0] - origin[0] > 180 ? -360 : origin[0] - destination[0] > 180 ? 360 : 0;
    const distanceInMeters = calculateRhumbDistance(origin, destination);
    const distance = (0, _helpers.convertLength)(distanceInMeters, "meters", options.units);
    return distance;
}
function calculateRhumbDistance(origin, destination, radius) {
    radius = radius === void 0 ? (0, _helpers.earthRadius) : Number(radius);
    const R = radius;
    const phi1 = origin[1] * Math.PI / 180;
    const phi2 = destination[1] * Math.PI / 180;
    const DeltaPhi = phi2 - phi1;
    let DeltaLambda = Math.abs(destination[0] - origin[0]) * Math.PI / 180;
    if (DeltaLambda > Math.PI) DeltaLambda -= 2 * Math.PI;
    const DeltaPsi = Math.log(Math.tan(phi2 / 2 + Math.PI / 4) / Math.tan(phi1 / 2 + Math.PI / 4));
    const q = Math.abs(DeltaPsi) > 1e-11 ? DeltaPhi / DeltaPsi : Math.cos(phi1);
    const delta = Math.sqrt(DeltaPhi * DeltaPhi + q * q * DeltaLambda * DeltaLambda);
    const dist = delta * R;
    return dist;
}
var index_default = rhumbDistance;

},{"@turf/helpers":"ityOQ","@turf/invariant":"8Sv4q","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"2VHKF":[function(require,module,exports,__globalThis) {
// The hover box's rows. Values stay the LR SDK's (FeatureInfoControl.getKeyValuesAt,
// whose output the hover styles also read); this groups them by key prefix and adds
// the section or point pair each comes from.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fcdHeadingDeg", ()=>fcdHeadingDeg);
/**
 * @param {import("./featureModel.mjs").FeatureModel} model
 * @param {number} cm position along the feature
 * @param {[string, unknown][]} keyValuesAt from FeatureInfoControl.getKeyValuesAt
 */ parcelHelpers.export(exports, "hoverView", ()=>hoverView);
var _positionsMjs = require("./positions.mjs");
var _renderValuesMjs = require("./renderValues.mjs");
var _curvatureSpeedMjs = require("../layers/style/util/curvatureSpeed.mjs");
const CURVATURE_DERIVED = new Set([
    (0, _curvatureSpeedMjs.NDS_CURVATURE_LABEL),
    (0, _curvatureSpeedMjs.RADIUS_LABEL),
    (0, _curvatureSpeedMjs.MAX_SPEED_LABEL)
]);
const fcdHeadingDeg = (directionId)=>(directionId - 1) * 30;
function rangeAt(tag, lengthCm, cm) {
    if (!tag.sections || tag.lr === "spot") return {
        rangeText: ""
    };
    if (tag.lr === "linear") {
        const at = (0, _positionsMjs.profileValueAt)((0, _positionsMjs.buildProfile)(tag.sections, lengthCm), cm);
        if (!at) return {
            rangeText: ""
        };
        // Only a non-numeric band (`multiple`) replaces the SDK's value; a numeric
        // ranged section is a value like any other.
        const band = typeof at.value === "string" && !Number.isFinite(Number(at.value));
        const rangeText = at.startCm === at.endCm ? `at ${at.startCm}` : `${at.interpolated ? "between " : ""}${at.startCm}\u{2013}${at.endCm}`;
        return {
            rangeText,
            band: band ? at.value : undefined
        };
    }
    const at = (0, _positionsMjs.stepValueAt)(tag.sections, lengthCm, cm);
    return {
        rangeText: at ? `${at.startCm}\u{2013}${at.endCm}` : ""
    };
}
function hoverView(model, cm, keyValuesAt) {
    const tagByRawKey = new Map(model.groups.flatMap((g)=>g.tags.map((t)=>[
                t.rawKey,
                {
                    tag: t,
                    group: g
                }
            ])));
    const rowsByGroup = new Map();
    const derived = [];
    let inBand = false;
    keyValuesAt.forEach(([key, value])=>{
        const hit = tagByRawKey.get(key);
        if (!hit) {
            derived.push([
                key,
                value
            ]);
            return;
        }
        const { rangeText, band } = rangeAt(hit.tag, model.lengthCm, cm);
        if (band !== undefined && (0, _renderValuesMjs.isCurvatureKey)(hit.tag.key)) inBand = true;
        if (!rowsByGroup.has(hit.group)) rowsByGroup.set(hit.group, []);
        rowsByGroup.get(hit.group).push({
            key: hit.tag.key,
            value: band ?? value,
            rangeText
        });
    });
    return {
        id: model.id,
        positionText: model.lengthCm === null ? `position ${cm} cm` : `position ${cm} / ${model.lengthCm} cm`,
        groups: model.groups.filter((g)=>rowsByGroup.has(g)).map((g)=>({
                prefix: g.prefix,
                rows: rowsByGroup.get(g)
            })),
        // Inside a curvature `multiple` stretch there is no curvature to derive from.
        derived: inBand ? derived.filter(([key])=>!CURVATURE_DERIVED.has(key)) : derived
    };
}

},{"./positions.mjs":"gc1cv","./renderValues.mjs":"jzrm4","../layers/style/util/curvatureSpeed.mjs":"9kySC","@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"chhLq":[function(require,module,exports,__globalThis) {
// Hover drawings show only what is under the pointer: on each hover update the
// tangent hover layers of layers with no hovered line are cleared (only lines get a
// tangent; the hovered ones redraw theirs).
/**
 * @param {{layer: object, hoverLayer: object}[]} pairs FeatureInfoControl's hover layers per layer
 * @param {{layer: object, line: boolean}[]} hovered the features under the pointer:
 *   their layer and whether they are a LineString
 * @returns {object[]} the hover layers to clear
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "staleHoverLayers", ()=>staleHoverLayers);
function staleHoverLayers(pairs, hovered) {
    const layers = new Set(hovered.filter((h)=>h.line).map((h)=>h.layer));
    return pairs.filter((p)=>!layers.has(p.layer)).map((p)=>p.hoverLayer);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}],"9qan7":[function(require,module,exports,__globalThis) {
// OL hands pointer moves over its controls (sidebar, drawer, hover box) to the map too,
// so every `pointerMove` Select would hover features hidden behind them. Over a
// control, hit-tests get a pixel off the map; the coordinate stays the pointer's.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Register before any other pointermove listener: map listeners run in order. */ parcelHelpers.export(exports, "ignoreHoverOverControls", ()=>ignoreHoverOverControls);
/**
 * Calls `clear` once each time the pointer moves from the map onto a control, for
 * hover drawings that only redraw while the pointer is over the map.
 */ parcelHelpers.export(exports, "onPointerOntoControls", ()=>onPointerOntoControls);
const OFF_MAP_PIXEL = [
    -100000,
    -100000
];
function ignoreHoverOverControls(map) {
    const controls = map.getOverlayContainerStopEvent();
    map.on("pointermove", (e)=>{
        if (!controls.contains(e.originalEvent.target)) return;
        // Cache the real coordinate first: it is computed lazily from the pixel.
        e.coordinate;
        e.pixel = OFF_MAP_PIXEL;
    });
}
function onPointerOntoControls(map, clear) {
    const controls = map.getOverlayContainerStopEvent();
    let onMap = false;
    map.on("pointermove", (e)=>{
        if (!controls.contains(e.originalEvent.target)) {
            onMap = true;
            return;
        }
        if (!onMap) return;
        onMap = false;
        clear();
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"t8gd7"}]},[], null, "parcelRequire05b1", {})

//# sourceMappingURL=open-maps-restriction-wkt-viewer.0178049b.js.map
